import { GraphQLClient } from 'graphql-request';
import { GraphQLClientRequestHeaders } from 'graphql-request/build/cjs/types';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigDecimal: { input: any; output: any; }
  Dashboard: { input: any; output: any; }
  Datafield: { input: any; output: any; }
  Datatype: { input: any; output: any; }
  Domain: { input: any; output: any; }
  Instant: { input: any; output: any; }
  Json: { input: any; output: any; }
  LocalDate: { input: any; output: any; }
  LocalDateTime: { input: any; output: any; }
  Long: { input: any; output: any; }
  Page: { input: any; output: any; }
  Unit: { input: any; output: any; }
};

/** Aliases can be used for custom translations/names. The combination of domain and key is always unique. In other words, the key is unique within a single domain. */
export type Alias = {
  __typename?: 'Alias';
  domain: Scalars['Domain']['output'];
  key: Scalars['String']['output'];
  /** Per language there must be not more than one entry, otherwise it is not defined which one will be used */
  translations: Array<AliasTranslation>;
  /** The type of the alias. Can be used to tag/differentiate different kind of aliases. */
  type: Scalars['String']['output'];
};

/** Aliases can be used for custom translations/names. The combination of domain and key is always unique. In other words, the key is unique within a single domain. */
export type AliasInput = {
  domain: Scalars['Domain']['input'];
  key: Scalars['String']['input'];
  /** Per language there must be not more than one entry, otherwise it is not defined which one will be used */
  translations: Array<AliasTranslationInput>;
  /** The type of the alias. Can be used to tag/differentiate different kind of aliases. */
  type: Scalars['String']['input'];
};

export type AliasTranslation = {
  __typename?: 'AliasTranslation';
  language: Language;
  text: Scalars['String']['output'];
};

export type AliasTranslationInput = {
  language: Language;
  text: Scalars['String']['input'];
};

export enum ApiMasterDataType {
  Application = 'APPLICATION',
  /** @deprecated No longer used */
  Attritionprediction = 'ATTRITIONPREDICTION',
  Cohort = 'COHORT',
  /** @deprecated No longer used */
  Emaildomain = 'EMAILDOMAIN',
  Employee = 'EMPLOYEE',
  Evaluation = 'EVALUATION',
  Financialmetrics = 'FINANCIALMETRICS',
  Interview = 'INTERVIEW',
  Job = 'JOB',
  JoinersView = 'JOINERS_VIEW',
  /** @deprecated No longer used */
  Managerenps = 'MANAGERENPS',
  Offer = 'OFFER',
  /** @deprecated No longer used */
  Onachatmetrics = 'ONACHATMETRICS',
  /** @deprecated No longer used */
  Onaemailmetrics = 'ONAEMAILMETRICS',
  Payroll = 'PAYROLL',
  Questionanswer = 'QUESTIONANSWER',
  Recruiterjobs = 'RECRUITERJOBS',
  Timeandattendancemonthly = 'TIMEANDATTENDANCEMONTHLY'
}

export type AssignedPermission = {
  __typename?: 'AssignedPermission';
  debugSummary: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  permission: Permission;
  roleId: Scalars['ID']['output'];
};

export type AssignedPermissionsForRole = {
  __typename?: 'AssignedPermissionsForRole';
  permissions: Array<AssignedPermission>;
  roleId: Scalars['ID']['output'];
};

export type AssumeRole = {
  __typename?: 'AssumeRole';
  domain: Maybe<Scalars['Domain']['output']>;
  excludedRoles: Array<Scalars['ID']['output']>;
  roles: Maybe<Array<Scalars['ID']['output']>>;
};

export type AssumeRoleInput = {
  domain: InputMaybe<Scalars['Domain']['input']>;
  excludedRoles: Array<Scalars['ID']['input']>;
  roles: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Allows to specify a subset of AssumeRole permissions that can be created / granted */
export type AssumeRoleTemplate = {
  __typename?: 'AssumeRoleTemplate';
  /** The allowed set of roles that can be chosen and set for the role to be assumable. Will usually be null to allow for all roles, but is restricted by the forbiddenRoles */
  allowedRoles: Maybe<Array<Scalars['ID']['output']>>;
  /** The domain that are allowed to be set or null if any domain is allowed. Should only be null for panalyt super admin */
  domain: Maybe<Scalars['Domain']['output']>;
  /** Restricts the allowedRoles. E.g. if allowedRoles is null (so all roles are allowed) and forbiddenRoles is [roleA, roleB], then a newly granted AssumeRole-permission will be rejected if it does not have [roleA, roleB] in the excludedRoles field */
  forbiddenRoles: Array<Scalars['ID']['output']>;
};

/** Allows to specify a subset of AssumeRole permissions that can be created / granted */
export type AssumeRoleTemplateInput = {
  /** The allowed set of roles that can be chosen and set for the role to be assumable. Will usually be null to allow for all roles, but is restricted by the forbiddenRoles */
  allowedRoles: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The domain that are allowed to be set or null if any domain is allowed. Should only be null for panalyt super admin */
  domain: InputMaybe<Scalars['Domain']['input']>;
  /** Restricts the allowedRoles. E.g. if allowedRoles is null (so all roles are allowed) and forbiddenRoles is [roleA, roleB], then a newly granted AssumeRole-permission will be rejected if it does not have [roleA, roleB] in the excludedRoles field */
  forbiddenRoles: Array<Scalars['ID']['input']>;
};

export enum AuthenticationMethod {
  Saml = 'SAML',
  Sso = 'SSO',
  UsernamePassword = 'UsernamePassword'
}

export type AvailableDataVersion = {
  __typename?: 'AvailableDataVersion';
  calendarMonth: Scalars['LocalDate']['output'];
  calendarYear: Scalars['Int']['output'];
  financialQuarter: Quarter;
  financialYear: Scalars['Int']['output'];
};

export type AvailableDataVersionsForDataType = {
  __typename?: 'AvailableDataVersionsForDataType';
  dataType: ApiMasterDataType;
  timePoints: Array<AvailableDataVersion>;
};

export type AvailableTimerangesInterpolated = {
  __typename?: 'AvailableTimerangesInterpolated';
  calendarYearMonthly: Maybe<Array<Scalars['LocalDate']['output']>>;
  calendarYearYearly: Maybe<Array<Scalars['Int']['output']>>;
  financialYearQuarterly: Maybe<Array<Quarter>>;
  financialYearYearly: Maybe<Array<Scalars['Int']['output']>>;
};

export type AvailableTimerangesInterpolatedForDataType = {
  __typename?: 'AvailableTimerangesInterpolatedForDataType';
  availableTimerange: AvailableTimerangesInterpolated;
  dataType: ApiMasterDataType;
};

export type BigDecimalValue = {
  __typename?: 'BigDecimalValue';
  value: Scalars['BigDecimal']['output'];
};

export type BooleanValue = {
  __typename?: 'BooleanValue';
  value: Scalars['Boolean']['output'];
};

export type ByFieldSegment = {
  __typename?: 'ByFieldSegment';
  dataField: Scalars['Datafield']['output'];
  dataType: Scalars['Datatype']['output'];
  value: Maybe<ResponseValue>;
};

export enum CacheBehaviour {
  DefaultCacheBehaviour = 'DefaultCacheBehaviour',
  DontSkipCacheBehaviour = 'DontSkipCacheBehaviour',
  SkipCacheBehaviour = 'SkipCacheBehaviour'
}

export type CalendarYearMonthlySegment = {
  __typename?: 'CalendarYearMonthlySegment';
  date: Scalars['LocalDate']['output'];
};

export type CalendarYearMonthlyTimeSelection = {
  __typename?: 'CalendarYearMonthlyTimeSelection';
  end: Scalars['LocalDate']['output'];
  start: Scalars['LocalDate']['output'];
};

export type CalendarYearMonthlyTimeSelectionInput = {
  end: Scalars['LocalDate']['input'];
  start: Scalars['LocalDate']['input'];
};

export type CalendarYearQuarterlySegment = {
  __typename?: 'CalendarYearQuarterlySegment';
  quarter: Quarter;
};

export type CalendarYearQuarterlyTimeSelection = {
  __typename?: 'CalendarYearQuarterlyTimeSelection';
  end: Quarter;
  start: Quarter;
};

export type CalendarYearQuarterlyTimeSelectionInput = {
  end: QuarterInput;
  start: QuarterInput;
};

/** This is equivalent to SingleValueTimeSegment and just renamed to be consistent */
export type CalendarYearSingleValueByMonthsSegment = {
  __typename?: 'CalendarYearSingleValueByMonthsSegment';
  end: Scalars['LocalDate']['output'];
  start: Scalars['LocalDate']['output'];
};

export type CalendarYearSingleValueByYearsSegment = {
  __typename?: 'CalendarYearSingleValueByYearsSegment';
  end: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
};

export type CalendarYearYearlySegment = {
  __typename?: 'CalendarYearYearlySegment';
  year: Scalars['Int']['output'];
};

export type CalendarYearYearlyTimeSelection = {
  __typename?: 'CalendarYearYearlyTimeSelection';
  end: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
};

export type CalendarYearYearlyTimeSelectionInput = {
  end: Scalars['Int']['input'];
  start: Scalars['Int']['input'];
};

/** Contains basic/useful but incomplete information about a changelog event */
export type ChangelogEventInfo = {
  __typename?: 'ChangelogEventInfo';
  domain: Maybe<Scalars['Domain']['output']>;
  eventInfo: Maybe<Scalars['String']['output']>;
  eventType: Maybe<Scalars['String']['output']>;
  requester: Maybe<Scalars['String']['output']>;
  ts: Scalars['Instant']['output'];
};

export type ChappiCategorizationResponse = {
  __typename?: 'ChappiCategorizationResponse';
  debugString: Scalars['String']['output'];
  questionCategory: Scalars['String']['output'];
};

export type ChappiCauseInvestigationResponse = {
  __typename?: 'ChappiCauseInvestigationResponse';
  debugString: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ChappiCommonFilters = {
  __typename?: 'ChappiCommonFilters';
  sql: Scalars['String']['output'];
};

export type ChappiConversation = {
  __typename?: 'ChappiConversation';
  createdAt: Scalars['Instant']['output'];
  domainScope: Maybe<Scalars['Domain']['output']>;
  id: Scalars['ID']['output'];
  initialCreator: Scalars['String']['output'];
  initiatingRole: Maybe<Role>;
  initiatingRoleId: Scalars['ID']['output'];
  messages: Array<ChappiMessage>;
};

export type ChappiConversationAndFirstResponse = {
  __typename?: 'ChappiConversationAndFirstResponse';
  conversation: ChappiConversation;
  firstResponse: Array<ChappiResponse>;
};

export enum ChappiConversationSortField {
  CreationDate = 'CreationDate',
  DomainScope = 'DomainScope',
  InitiatingRoleId = 'InitiatingRoleId'
}

export enum ChappiConversationSortOrder {
  Ascending = 'Ascending',
  Descending = 'Descending'
}

export type ChappiDataDiscrepancyResponse = {
  __typename?: 'ChappiDataDiscrepancyResponse';
  debugString: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ChappiExplainPreviousChartAnalyticsResponse = {
  __typename?: 'ChappiExplainPreviousChartAnalyticsResponse';
  debugString: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ChappiExplainPreviousSingleNumberAnalyticsResponse = {
  __typename?: 'ChappiExplainPreviousSingleNumberAnalyticsResponse';
  debugString: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ChappiExplanationOfCalculationOrDefinitionResponse = {
  __typename?: 'ChappiExplanationOfCalculationOrDefinitionResponse';
  debugString: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ChappiFindingSpecificEmployeesResponse = {
  __typename?: 'ChappiFindingSpecificEmployeesResponse';
  debugString: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ChappiHowToUseChappiResponse = {
  __typename?: 'ChappiHowToUseChappiResponse';
  debugString: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ChappiHowToUseThePanalytAppResponse = {
  __typename?: 'ChappiHowToUseThePanalytAppResponse';
  debugString: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export enum ChappiKpiAlignment {
  ChappiKpiAlignmentColumn = 'ChappiKpiAlignmentColumn',
  ChappiKpiAlignmentRow = 'ChappiKpiAlignmentRow'
}

export type ChappiKpiVisualization = {
  __typename?: 'ChappiKpiVisualization';
  alignment: ChappiKpiAlignment;
  debugString: Scalars['String']['output'];
  filters: Maybe<ChappiCommonFilters>;
  kpiMetric: Array<MetricId>;
  kpiSegmentation: Array<ChappiLineChartSegmentation>;
  kpiTimeSelection: ChappiSingleValueTimeSelection;
  responseForUser: Scalars['String']['output'];
};

export type ChappiLineChartSegmentation = {
  __typename?: 'ChappiLineChartSegmentation';
  datafieldAndDatatype: DatafieldAndDatatype;
};

export enum ChappiLineChartVariant {
  ChappiLineChartVariantAreaChart = 'ChappiLineChartVariantAreaChart',
  ChappiLineChartVariantLineChart = 'ChappiLineChartVariantLineChart',
  ChappiLineChartVariantStackedAreaChart = 'ChappiLineChartVariantStackedAreaChart'
}

export type ChappiLineChartVisualization = {
  __typename?: 'ChappiLineChartVisualization';
  debugString: Scalars['String']['output'];
  filters: Maybe<ChappiCommonFilters>;
  lineChartMetrics: Array<MetricId>;
  lineChartSegmentation: Array<ChappiLineChartSegmentation>;
  lineChartTimeSelection: ChappiMultiValueTimeSelection;
  lineChartVariant: ChappiLineChartVariant;
  responseForUser: Scalars['String']['output'];
};

export type ChappiMessage = {
  __typename?: 'ChappiMessage';
  content: ChappiMessageContent;
  conversationId: Scalars['ID']['output'];
  createdAt: Scalars['Instant']['output'];
  id: Scalars['ID']['output'];
};

export type ChappiMessageContent = QuestionMessage | ResponseMessage | SystemMessage;

export type ChappiMultiValueTimeSelection = CalendarYearMonthlyTimeSelection | CalendarYearQuarterlyTimeSelection | CalendarYearYearlyTimeSelection | FinancialYearQuarterlyTimeSelection | FinancialYearYearlyTimeSelection;

export type ChappiOtherOrUnknownResponse = {
  __typename?: 'ChappiOtherOrUnknownResponse';
  debugString: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ChappiOverTimeBarChartVisualization = {
  __typename?: 'ChappiOverTimeBarChartVisualization';
  barChartMetrics: Array<MetricId>;
  barChartSegmentation: Array<ChappiLineChartSegmentation>;
  barChartTimeSelection: ChappiMultiValueTimeSelection;
  debugString: Scalars['String']['output'];
  filters: Maybe<ChappiCommonFilters>;
  relative: Scalars['Boolean']['output'];
  responseForUser: Scalars['String']['output'];
  stack: Scalars['Boolean']['output'];
};

export type ChappiPanalytAppGeneralQuestionOrProblemResponse = {
  __typename?: 'ChappiPanalytAppGeneralQuestionOrProblemResponse';
  debugString: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ChappiPanalytContractResponse = {
  __typename?: 'ChappiPanalytContractResponse';
  debugString: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ChappiPieChartSegmentation = {
  __typename?: 'ChappiPieChartSegmentation';
  datafieldAndDatatype: DatafieldAndDatatype;
};

export enum ChappiPieChartVariant {
  ChappiPieChartVariantDonut = 'ChappiPieChartVariantDonut',
  ChappiPieChartVariantPie = 'ChappiPieChartVariantPie'
}

export type ChappiPieChartVisualization = {
  __typename?: 'ChappiPieChartVisualization';
  debugString: Scalars['String']['output'];
  filters: Maybe<ChappiCommonFilters>;
  pieChartMetric: MetricId;
  pieChartSegmentation: ChappiPieChartSegmentation;
  pieChartTimeSelection: ChappiSingleValueTimeSelection;
  pieChartVariant: ChappiPieChartVariant;
  responseForUser: Scalars['String']['output'];
};

export type ChappiPredictiveAnalyticsForecastingResponse = {
  __typename?: 'ChappiPredictiveAnalyticsForecastingResponse';
  debugString: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ChappiProblemEncounteredResponse = {
  __typename?: 'ChappiProblemEncounteredResponse';
  debugString: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ChappiRecommendationsSuggestionsResponse = {
  __typename?: 'ChappiRecommendationsSuggestionsResponse';
  debugString: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ChappiResponse = ChappiCategorizationResponse | ChappiCauseInvestigationResponse | ChappiDataDiscrepancyResponse | ChappiExplainPreviousChartAnalyticsResponse | ChappiExplainPreviousSingleNumberAnalyticsResponse | ChappiExplanationOfCalculationOrDefinitionResponse | ChappiFindingSpecificEmployeesResponse | ChappiHowToUseChappiResponse | ChappiHowToUseThePanalytAppResponse | ChappiKpiVisualization | ChappiLineChartVisualization | ChappiOtherOrUnknownResponse | ChappiOverTimeBarChartVisualization | ChappiPanalytAppGeneralQuestionOrProblemResponse | ChappiPanalytContractResponse | ChappiPieChartVisualization | ChappiPredictiveAnalyticsForecastingResponse | ChappiProblemEncounteredResponse | ChappiRecommendationsSuggestionsResponse | ChappiSingleNumberAnalyticsResponse | ChappiTableVisualization | ChappiTimePeriodBarChartVisualization | ChappiVisualizationTypeResponse;

export type ChappiSingleNumberAnalyticsResponse = {
  __typename?: 'ChappiSingleNumberAnalyticsResponse';
  debugString: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ChappiSingleValueTimeSelection = SingleValueByCalendarMonthsTimeSelection | SingleValueByCalendarYearsTimeSelection | SingleValueByFinancialQuartersTimeSelection | SingleValueByFinancialYearsTimeSelection;

export type ChappiTableVisualization = {
  __typename?: 'ChappiTableVisualization';
  debugString: Scalars['String']['output'];
  filters: Maybe<ChappiCommonFilters>;
  responseForUser: Scalars['String']['output'];
  tableMetrics: Array<MetricId>;
  tableSegmentation: Array<ChappiLineChartSegmentation>;
  tableTimeSelection: ChappiMultiValueTimeSelection;
};

export type ChappiTimePeriodBarChartVisualization = {
  __typename?: 'ChappiTimePeriodBarChartVisualization';
  barChartMetrics: Array<MetricId>;
  barChartSegmentation: Array<ChappiLineChartSegmentation>;
  barChartTimeSelection: ChappiSingleValueTimeSelection;
  debugString: Scalars['String']['output'];
  filters: Maybe<ChappiCommonFilters>;
  relative: Scalars['Boolean']['output'];
  responseForUser: Scalars['String']['output'];
  stack: Scalars['Boolean']['output'];
};

export type ChappiVisualizationTypeResponse = {
  __typename?: 'ChappiVisualizationTypeResponse';
  debugString: Scalars['String']['output'];
  visualizationType: Scalars['String']['output'];
};

export type ClientObject = {
  __typename?: 'ClientObject';
  /** When the object was created. */
  createdAt: Scalars['Instant']['output'];
  /** The domain. May be null if domain information is not available. */
  domain: Maybe<Scalars['Domain']['output']>;
  objectName: Scalars['String']['output'];
  /** History of processing events for this object. Will be empty if no processing history is available. */
  processingInfo: Array<ProcessingEvent>;
};

export enum CohortMetricId {
  Pm0157MarudaiComplaintsCount = 'PM0157_MarudaiComplaints_count',
  Pm0158JtKilledAtWorkCount = 'PM0158_JtKilledAtWork_count',
  Pm0159JtOccupationalAccidentsCount = 'PM0159_JtOccupationalAccidents_count',
  Pm0159JtOccupationalAccidentsPercOfHeadcount = 'PM0159_JtOccupationalAccidents_percOfHeadcount',
  Pm0417_2SimulatedHeadcountCount = 'PM0417_2_SimulatedHeadcount_Count',
  Pm0418_2SimulatedLeaversCount = 'PM0418_2_SimulatedLeavers_Count',
  Pm0419_2SimulatedJoinersCount = 'PM0419_2_SimulatedJoiners_Count',
  Pm0420_2SimulatedRetireesCount = 'PM0420_2_SimulatedRetirees_Count',
  Pm0430_1CstmSatSurveyKhncAvgScore = 'PM0430_1_CstmSatSurveyKHNC_AvgScore',
  Pm0430_2CstmSatSurveyKhncNumRespondents = 'PM0430_2_CstmSatSurveyKHNC_NumRespondents',
  Pm0445_1CltFMngJpn0000033CountDef1 = 'PM0445_1_CltFMngJPN0000033_CountDef1',
  Pm0445_2CltFMngJpn0000033PercMngDef1 = 'PM0445_2_CltFMngJPN0000033_PercMngDef1',
  Pm0445_3CltFMngJpn0000033CountDef2 = 'PM0445_3_CltFMngJPN0000033_CountDef2',
  Pm0445_4CltFMngJpn0000033PercMngDef2 = 'PM0445_4_CltFMngJPN0000033_PercMngDef2'
}

export type CohortTypeEntries = {
  __typename?: 'CohortTypeEntries';
  cohortType: Scalars['String']['output'];
  cohortValues: Array<CohortValues>;
};

export type CohortValues = {
  __typename?: 'CohortValues';
  /** This contains the cohort criteria, e.g. the cost-center or the product */
  cohortKey: Scalars['String']['output'];
  /** The list of the distinct values for this cohort criteria, e.g. [costcenter1, costcenter2, ...] */
  cohortValues: Array<SqlLitValue>;
};

export type Confidential = {
  __typename?: 'Confidential';
  reason: Maybe<Scalars['String']['output']>;
};

/** Despite the name, CreateReports currently also controls if reports can be updated or deleted (independent of who created it) */
export type CreateReports = {
  __typename?: 'CreateReports';
  domain: Maybe<Scalars['Domain']['output']>;
};

/** Despite the name, CreateReports currently also controls if reports can be updated or deleted (independent of who created it) */
export type CreateReportsInput = {
  domain: InputMaybe<Scalars['Domain']['input']>;
};

export type CreateRole = {
  __typename?: 'CreateRole';
  domain: Maybe<Scalars['Domain']['output']>;
};

export type CreateRoleInput = {
  domain: InputMaybe<Scalars['Domain']['input']>;
};

export type DashboardDefinition = {
  __typename?: 'DashboardDefinition';
  description: Scalars['String']['output'];
  descriptionKey: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['Dashboard']['output'];
  imagePath: Scalars['String']['output'];
  link: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nameKey: Scalars['String']['output'];
  pages: Array<PageDefinition>;
};

export type DashboardDefinitionInput = {
  description: Scalars['String']['input'];
  descriptionKey: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  id: Scalars['Dashboard']['input'];
  imagePath: Scalars['String']['input'];
  link: Scalars['String']['input'];
  name: Scalars['String']['input'];
  nameKey: Scalars['String']['input'];
  pages: Array<PageDefinitionInput>;
};

export type DashboardPagesAccess = {
  __typename?: 'DashboardPagesAccess';
  dashboard: Scalars['Dashboard']['output'];
  /** Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! */
  pages: Maybe<Array<Scalars['Page']['output']>>;
};

export type DashboardPagesAccessInput = {
  dashboard: Scalars['Dashboard']['input'];
  /** Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! */
  pages: InputMaybe<Array<Scalars['Page']['input']>>;
};

export type DatafieldAccess = {
  __typename?: 'DatafieldAccess';
  datafield: Scalars['Datafield']['output'];
  minPop: Maybe<Scalars['Long']['output']>;
};

export type DatafieldAccessConfig = {
  __typename?: 'DatafieldAccessConfig';
  /** Chooses if all datafields can be read. If set true then only allFieldsMinPop will be used, else only specificFields will be used */
  allDatafields: Scalars['Boolean']['output'];
  allDatafieldsMinPop: Maybe<Scalars['Long']['output']>;
  /** Note that list must not contain the same datafields more than once */
  specificDatafields: Maybe<Array<DatafieldAccess>>;
};

export type DatafieldAccessConfigInput = {
  /** Chooses if all datafields can be read. If set true then only allFieldsMinPop will be used, else only specificFields will be used */
  allDatafields: Scalars['Boolean']['input'];
  allDatafieldsMinPop: InputMaybe<Scalars['Long']['input']>;
  /** Note that list must not contain the same datafields more than once */
  specificDatafields: InputMaybe<Array<DatafieldAccessInput>>;
};

export type DatafieldAccessInput = {
  datafield: Scalars['Datafield']['input'];
  minPop: InputMaybe<Scalars['Long']['input']>;
};

/** datafield and its datatype. Example: EMPLOYEE.AGE */
export type DatafieldAndDatatype = {
  __typename?: 'DatafieldAndDatatype';
  dataField: Scalars['Datafield']['output'];
  dataType: ApiMasterDataType;
};

/** Note that JOINERS_VIEW is treated special in that permissions for EMPLOYEE are applied for queries against JOINERS_VIEW. In other words, don't use JOINERS_VIEW here as it is useless and will be ignored */
export type DatatypeAccess = {
  __typename?: 'DatatypeAccess';
  datatype: Scalars['Datatype']['output'];
  fields: DatafieldAccessConfig;
};

/** Note that JOINERS_VIEW is treated special in that permissions for EMPLOYEE are applied for queries against JOINERS_VIEW. In other words, don't use JOINERS_VIEW here as it is useless and will be ignored */
export type DatatypeAccessInput = {
  datatype: Scalars['Datatype']['input'];
  fields: DatafieldAccessConfigInput;
};

export type DateValue = {
  __typename?: 'DateValue';
  value: Scalars['LocalDate']['output'];
};

export type DeleteClientFile = {
  __typename?: 'DeleteClientFile';
  domain: Maybe<Scalars['Domain']['output']>;
};

export type DeleteClientFileInput = {
  domain: InputMaybe<Scalars['Domain']['input']>;
};

export type DeleteRole = {
  __typename?: 'DeleteRole';
  domain: Maybe<Scalars['Domain']['output']>;
  excludedRoles: Array<Scalars['ID']['output']>;
};

export type DeleteRoleAndPermissionsResponse = {
  __typename?: 'DeleteRoleAndPermissionsResponse';
  deletedRoleId: Scalars['ID']['output'];
  revokedPermissionIds: Array<Scalars['ID']['output']>;
};

export type DeleteRoleInput = {
  domain: InputMaybe<Scalars['Domain']['input']>;
  excludedRoles: Array<Scalars['ID']['input']>;
};

/** This describes a domain, including its ID and all the corresponding data. We already use the type 'Domain' (should be called DomainId) to describe the identifier so call this here DomainInfo. */
export type DomainInfo = {
  __typename?: 'DomainInfo';
  aliases: Maybe<Array<Alias>>;
  allLatestVersions: Maybe<Array<LatestVersionForDataType>>;
  allUsedFields: Maybe<Array<UsedFieldsForDataType>>;
  domain: Scalars['Domain']['output'];
  latestPreferences: Maybe<DomainPreferencesVersion>;
  latestSettings: Maybe<DomainSettingsVersion>;
  metricTree: Maybe<MetricTree>;
  nonUserRoles: Maybe<Array<Role>>;
  usedCohorts: Maybe<Array<CohortTypeEntries>>;
  userRoles: Maybe<Array<Role>>;
};


/** This describes a domain, including its ID and all the corresponding data. We already use the type 'Domain' (should be called DomainId) to describe the identifier so call this here DomainInfo. */
export type DomainInfoAliasesArgs = {
  cacheBehaviour?: CacheBehaviour;
};


/** This describes a domain, including its ID and all the corresponding data. We already use the type 'Domain' (should be called DomainId) to describe the identifier so call this here DomainInfo. */
export type DomainInfoLatestPreferencesArgs = {
  topLevelKeyFilter: InputMaybe<Array<Scalars['String']['input']>>;
};


/** This describes a domain, including its ID and all the corresponding data. We already use the type 'Domain' (should be called DomainId) to describe the identifier so call this here DomainInfo. */
export type DomainInfoLatestSettingsArgs = {
  topLevelKeyFilter: InputMaybe<Array<Scalars['String']['input']>>;
};


/** This describes a domain, including its ID and all the corresponding data. We already use the type 'Domain' (should be called DomainId) to describe the identifier so call this here DomainInfo. */
export type DomainInfoNonUserRolesArgs = {
  cacheBehaviour?: CacheBehaviour;
  domainUnrestrictedOnly?: Scalars['Boolean']['input'];
};


/** This describes a domain, including its ID and all the corresponding data. We already use the type 'Domain' (should be called DomainId) to describe the identifier so call this here DomainInfo. */
export type DomainInfoUserRolesArgs = {
  cacheBehaviour?: CacheBehaviour;
  domainUnrestrictedOnly?: Scalars['Boolean']['input'];
};

export type DomainPreferencesVersion = {
  __typename?: 'DomainPreferencesVersion';
  createdAt: Scalars['Instant']['output'];
  creator: Maybe<Scalars['String']['output']>;
  settings: Scalars['Json']['output'];
  version: Scalars['Long']['output'];
};

export type DomainScopeFilterInput = {
  global: InputMaybe<Scalars['Unit']['input']>;
  none: InputMaybe<Scalars['Unit']['input']>;
  specificDomain: InputMaybe<Scalars['Domain']['input']>;
};

export type DomainSettingsVersion = {
  __typename?: 'DomainSettingsVersion';
  createdAt: Scalars['Instant']['output'];
  creator: Maybe<Scalars['String']['output']>;
  settings: Scalars['Json']['output'];
  version: Scalars['Long']['output'];
};

export type DoubleValue = {
  __typename?: 'DoubleValue';
  value: Scalars['Float']['output'];
};

export type DownloadClientFile = {
  __typename?: 'DownloadClientFile';
  domain: Maybe<Scalars['Domain']['output']>;
};

export type DownloadClientFileInput = {
  domain: InputMaybe<Scalars['Domain']['input']>;
};

/** Allows to edit anything that is in the scope of a role, such as this role's configuration/settings etc. Permissions are not included. */
export type EditRoleScope = {
  __typename?: 'EditRoleScope';
  /** Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! */
  domain: Maybe<Scalars['Domain']['output']>;
  excludedRoles: Array<Scalars['ID']['output']>;
  /** Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! */
  role: Maybe<Scalars['ID']['output']>;
};

/** Allows to edit anything that is in the scope of a role, such as this role's configuration/settings etc. Permissions are not included. */
export type EditRoleScopeInput = {
  /** Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! */
  domain: InputMaybe<Scalars['Domain']['input']>;
  excludedRoles: Array<Scalars['ID']['input']>;
  /** Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! */
  role: InputMaybe<Scalars['ID']['input']>;
};

export enum EmployeeCohortMetricId {
  Pm0286_1PlannedIndividualsCount = 'PM0286_1_PlannedIndividuals_Count',
  Pm0286_2PlannedIndividualsPercHc = 'PM0286_2_PlannedIndividuals_PercHC',
  Pm0287_1PlannedJoinersCount = 'PM0287_1_PlannedJoiners_Count',
  Pm0287_2PlannedJoinersPercJoiners = 'PM0287_2_PlannedJoiners_PercJoiners',
  Pm0417_1SimulatedHeadcountCount = 'PM0417_1_SimulatedHeadcount_Count',
  Pm0418_1SimulatedLeaversCount = 'PM0418_1_SimulatedLeavers_Count',
  Pm0419_1SimulatedJoinersCount = 'PM0419_1_SimulatedJoiners_Count',
  Pm0420_1SimulatedRetireesCount = 'PM0420_1_SimulatedRetirees_Count',
  Pm0421_1RevenueQuarterlyPerIndiv = 'PM0421_1_RevenueQuarterly_PerIndiv',
  Pm0421_2RevenueQuarterlyTotal = 'PM0421_2_RevenueQuarterly_Total',
  Pm0421_3RevenueQuarterlyPerWorkHours = 'PM0421_3_RevenueQuarterly_PerWorkHours',
  Pm0422_1OperatingProfitLossQuarterlyPerIndiv = 'PM0422_1_OperatingProfitLossQuarterly_PerIndiv',
  Pm0422_2OperatingProfitLossQuarterlyTotal = 'PM0422_2_OperatingProfitLossQuarterly_Total',
  Pm0422_3OperatingProfitLossQuarterlyPerWorkHours = 'PM0422_3_OperatingProfitLossQuarterly_PerWorkHours',
  Pm0423_1OrderIntakeQuarterlyPerIndiv = 'PM0423_1_OrderIntakeQuarterly_PerIndiv',
  Pm0423_2OrderIntakeQuarterlyTotal = 'PM0423_2_OrderIntakeQuarterly_Total',
  Pm0423_3OrderIntakeQuarterlyPerWorkHours = 'PM0423_3_OrderIntakeQuarterly_PerWorkHours',
  Pm0426_1RevenueMonthlyPerIndiv = 'PM0426_1_RevenueMonthly_PerIndiv',
  Pm0426_2RevenueMonthlyTotal = 'PM0426_2_RevenueMonthly_Total',
  Pm0426_3RevenueMonthlyPerWorkHours = 'PM0426_3_RevenueMonthly_PerWorkHours',
  Pm0427_1TotalFinanceWorkforceCostMonthlyPerIndiv = 'PM0427_1_TotalFinanceWorkforceCostMonthly_PerIndiv',
  Pm0427_2TotalFinanceWorkforceCostMonthlyTotal = 'PM0427_2_TotalFinanceWorkforceCostMonthly_Total',
  Pm0427_3TotalFinanceWorkforceCostMonthlyPerWorkHours = 'PM0427_3_TotalFinanceWorkforceCostMonthly_PerWorkHours',
  Pm0431_1CstmTrainingHrsauFhHrs = 'PM0431_1_CstmTrainingHrsauFH_Hrs',
  Pm0452_1OrderIntakeMonthlyPerIndiv = 'PM0452_1_OrderIntakeMonthly_PerIndiv',
  Pm0452_2OrderIntakeMonthlyTotal = 'PM0452_2_OrderIntakeMonthly_Total',
  Pm0453_1GrossProfitMonthlyPerIndiv = 'PM0453_1_GrossProfitMonthly_PerIndiv',
  Pm0453_2GrossProfitMonthlyTotal = 'PM0453_2_GrossProfitMonthly_Total',
  Pm0454_1OperatingProfitLossMonthlyPerIndiv = 'PM0454_1_OperatingProfitLossMonthly_PerIndiv',
  Pm0454_2OperatingProfitLossMonthlyTotal = 'PM0454_2_OperatingProfitLossMonthly_Total',
  Pm0455_1TrainingCostMonthlyPerIndiv = 'PM0455_1_TrainingCostMonthly_PerIndiv',
  Pm0455_2TrainingCostMonthlyTotal = 'PM0455_2_TrainingCostMonthly_Total',
  Pm0456_1RevenueMonthlyPerIndiv = 'PM0456_1_RevenueMonthly_PerIndiv',
  Pm0456_2RevenueMonthlyTotal = 'PM0456_2_RevenueMonthly_Total',
  Pm0457_1LaborCostMonthlyPerIndiv = 'PM0457_1_LaborCostMonthly_PerIndiv',
  Pm0457_2LaborCostMonthlyTotal = 'PM0457_2_LaborCostMonthly_Total'
}

export type ExportReports = {
  __typename?: 'ExportReports';
  domain: Maybe<Scalars['Domain']['output']>;
};

export type ExportReportsInput = {
  domain: InputMaybe<Scalars['Domain']['input']>;
};

export type FinancialYearQuarterlySegment = {
  __typename?: 'FinancialYearQuarterlySegment';
  quarter: Quarter;
};

export type FinancialYearQuarterlyTimeSelection = {
  __typename?: 'FinancialYearQuarterlyTimeSelection';
  end: Quarter;
  start: Quarter;
};

export type FinancialYearQuarterlyTimeSelectionInput = {
  end: QuarterInput;
  start: QuarterInput;
};

export type FinancialYearSingleValueByQuartersSegment = {
  __typename?: 'FinancialYearSingleValueByQuartersSegment';
  end: Quarter;
  start: Quarter;
};

export type FinancialYearSingleValueByYearsSegment = {
  __typename?: 'FinancialYearSingleValueByYearsSegment';
  end: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
};

export type FinancialYearYearlySegment = {
  __typename?: 'FinancialYearYearlySegment';
  year: Scalars['Int']['output'];
};

export type FinancialYearYearlyTimeSelection = {
  __typename?: 'FinancialYearYearlyTimeSelection';
  end: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
};

export type FinancialYearYearlyTimeSelectionInput = {
  end: Scalars['Int']['input'];
  start: Scalars['Int']['input'];
};

export type GrantPermissions = {
  __typename?: 'GrantPermissions';
  domain: Maybe<Scalars['Domain']['output']>;
  excludedRoles: Array<Scalars['ID']['output']>;
  permissionTemplates: Maybe<Array<PermissionTemplate>>;
  permissions: Maybe<Array<Permission>>;
  roles: Maybe<Array<Scalars['ID']['output']>>;
};

export type GrantPermissionsSpecificPermissionsInput = {
  permissionTemplateAssumeRoleTemplate: InputMaybe<Array<AssumeRoleTemplateInput>>;
  permissionsAssumeRole: InputMaybe<Array<AssumeRoleInput>>;
  permissionsCreateReports: InputMaybe<Array<CreateReportsInput>>;
  permissionsCreateRole: InputMaybe<Array<CreateRoleInput>>;
  permissionsDeleteClientFile: InputMaybe<Array<DeleteClientFileInput>>;
  permissionsDownloadClientFile: InputMaybe<Array<DownloadClientFileInput>>;
  permissionsEditRoleScope: InputMaybe<Array<EditRoleScopeInput>>;
  permissionsExportReports: InputMaybe<Array<ExportReportsInput>>;
  permissionsLogin: InputMaybe<Array<LoginInput>>;
  permissionsManageCompany: InputMaybe<Array<ManageCompanyInput>>;
  permissionsManageDomain: InputMaybe<Array<ManageDomainInput>>;
  permissionsReadClientFile: InputMaybe<Array<ReadClientFileInput>>;
  permissionsReadData: InputMaybe<Array<ReadDataInput>>;
  permissionsRequestPasswordChange: InputMaybe<Array<RequestPasswordChangeInput>>;
  permissionsRevokePermissions: InputMaybe<Array<RevokePermissionsInput>>;
  permissionsUpdatePassword: InputMaybe<Array<UpdatePasswordInput>>;
  permissionsUpdateRoleName: InputMaybe<Array<UpdateRoleNameInput>>;
  permissionsUseFilters: InputMaybe<Array<UseFiltersInput>>;
  permissionsViewDashboards: InputMaybe<Array<ViewDashboardsInput>>;
  permissionsViewMetrics: InputMaybe<Array<ViewMetricsInput>>;
  permissionsViewPermissions: InputMaybe<Array<ViewPermissionsInput>>;
  permissionsViewReports: InputMaybe<Array<ViewReportsInput>>;
  permissionsViewRoleScope: InputMaybe<Array<ViewRoleScopeInput>>;
  permissionsViewRoles: InputMaybe<Array<ViewRolesInput>>;
  permissionsWriteClientFile: InputMaybe<Array<WriteClientFileInput>>;
};

export type GroupByFieldInput = {
  dataField: Scalars['Datafield']['input'];
  dataType: ApiMasterDataType;
  /** If set then must contain at least one filter */
  filters: InputMaybe<Array<SqlInputValueInput>>;
};

/** Exactly one of the parameters must be set */
export type GroupInput = {
  byField: InputMaybe<GroupByFieldInput>;
  byHierarchicalField: InputMaybe<GroupbyHierarchicalFieldInput>;
};

export type GroupbyHierarchicalFieldInput = {
  /** Must be a hierarchical field e.g. LOCATION or POSITION. Note that the result-segments will contain each concrete level. E.g. when using LOCATION then the result will contain segments for LOCATION_LEVEL_1, LOCATION_LEVEL_2, and so on */
  dataField: Scalars['Datafield']['input'];
  dataType: ApiMasterDataType;
  /** Must not be empty. Each inner list must also not be empty and describes the selected values for each level. E.g.: [[Asia, Tokyo], [Asia, Singapore], [Asia]] will create one result segment for Tokyo, one for Singapore and one for whole Asia */
  filters: Array<Array<SqlInputValueInput>>;
};

export type GroupingInput = {
  /** Must not be empty */
  groups: Array<GroupInput>;
};

export type IntValue = {
  __typename?: 'IntValue';
  value: Scalars['Int']['output'];
};

export type JsonValue = {
  __typename?: 'JsonValue';
  value: Scalars['Json']['output'];
};

export enum Language {
  En = 'en',
  Jp = 'jp'
}

export type LatestVersionForDataType = {
  __typename?: 'LatestVersionForDataType';
  dataType: ApiMasterDataType;
  version: Maybe<Scalars['LocalDate']['output']>;
};

/** Note that both settings are additive. That means, if two restrictions are set then the user can see more than when only one of the two is set. If none of the two is set, the user is unrestricted. */
export type LineHierarchyRestrictions = {
  __typename?: 'LineHierarchyRestrictions';
  /** Setting it to null means no restrictions. If set, then there must be at least one employee id. The user is then restricted to see only the data for the reporting lines of the specified employee ids. */
  employeeSpecific: Maybe<Array<Scalars['String']['output']>>;
  /** If true, the user can only see their own reporting line (that he has at the time when a data query is sent) */
  userSpecific: Scalars['Boolean']['output'];
};

/** Note that both settings are additive. That means, if two restrictions are set then the user can see more than when only one of the two is set. If none of the two is set, the user is unrestricted. */
export type LineHierarchyRestrictionsInput = {
  /** Setting it to null means no restrictions. If set, then there must be at least one employee id. The user is then restricted to see only the data for the reporting lines of the specified employee ids. */
  employeeSpecific: InputMaybe<Array<Scalars['String']['input']>>;
  /** If true, the user can only see their own reporting line (that he has at the time when a data query is sent) */
  userSpecific: Scalars['Boolean']['input'];
};

export type ListUploadedClientObjectsResult = {
  __typename?: 'ListUploadedClientObjectsResult';
  /** List of client objects with their processing history */
  clientObjects: Array<ClientObject>;
};

export type Login = {
  __typename?: 'Login';
  /** Defines the auth-methods that can be used to login to the domain. Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! */
  allowedAuthenticationMethods: Maybe<Array<AuthenticationMethod>>;
  domain: Maybe<Scalars['Domain']['output']>;
  /** This flag tells if the Login-permission is active. It allows to tell if a role got disabled, i.e. had access but now not anymore. If enabled is null then it means the login is enabled (for backward compatibility). Nullability will be removed once frontend always reads and sets this value. */
  enabled: Maybe<Scalars['Boolean']['output']>;
};

export type LoginInput = {
  /** Defines the auth-methods that can be used to login to the domain. Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! */
  allowedAuthenticationMethods: InputMaybe<Array<AuthenticationMethod>>;
  domain: InputMaybe<Scalars['Domain']['input']>;
  /** This flag tells if the Login-permission is active. It allows to tell if a role got disabled, i.e. had access but now not anymore. If enabled is null then it means the login is enabled (for backward compatibility). Nullability will be removed once frontend always reads and sets this value. */
  enabled: InputMaybe<Scalars['Boolean']['input']>;
};

/** Allows to manage a company by accessing/changing billing, aliases, etc. This is what superadmins can do */
export type ManageCompany = {
  __typename?: 'ManageCompany';
  domain: Maybe<Scalars['Domain']['output']>;
};

/** Allows to manage a company by accessing/changing billing, aliases, etc. This is what superadmins can do */
export type ManageCompanyInput = {
  domain: InputMaybe<Scalars['Domain']['input']>;
};

/** Allows to manage a domain and e.g. add dashboards to the domain. This is what panalyt superadmins can do */
export type ManageDomain = {
  __typename?: 'ManageDomain';
  domain: Maybe<Scalars['Domain']['output']>;
};

/** Allows to manage a domain and e.g. add dashboards to the domain. This is what panalyt superadmins can do */
export type ManageDomainInput = {
  domain: InputMaybe<Scalars['Domain']['input']>;
};

/** Allows to access, update, create users' profiles, name, email etc. This is what admins can do */
export type ManageUsers = {
  __typename?: 'ManageUsers';
  domain: Maybe<Scalars['Domain']['output']>;
};

/** Allows to access, update, create users' profiles, name, email etc. This is what admins can do */
export type ManageUsersInput = {
  domain: InputMaybe<Scalars['Domain']['input']>;
};

/** Contains metadata for a specific user (if exists) */
export type MetaData = {
  __typename?: 'MetaData';
  /** Last time the user has logged into the system. Null if they have been created but never logged in yet. */
  lastLogin: Maybe<Scalars['Instant']['output']>;
};

export type MetaDataForRole = {
  __typename?: 'MetaDataForRole';
  metaData: MetaData;
  roleId: Scalars['ID']['output'];
};

export type MetricCategory = {
  __typename?: 'MetricCategory';
  defaultPosition: Scalars['Float']['output'];
  id: MetricCategoryId;
};

export enum MetricCategoryId {
  Pmc001HrBasicCategory = 'PMC001_HRBasicCategory',
  Pmc002Growth = 'PMC002_Growth',
  Pmc003DiversityFairness = 'PMC003_DiversityFairness',
  Pmc004OrgAgility = 'PMC004_OrgAgility',
  Pmc005OrgHealth = 'PMC005_OrgHealth',
  Pmc006FinancialMetrics = 'PMC006_FinancialMetrics',
  Pmc007PeopleProfitability = 'PMC007_PeopleProfitability',
  Pmc008JapanOvertime = 'PMC008_JapanOvertime',
  Pmc009Survey = 'PMC009_Survey',
  Pmc010Recruitment = 'PMC010_Recruitment',
  Pmc011Ona = 'PMC011_ONA',
  Pmc012CstmCategory1 = 'PMC012_CstmCategory1',
  Pmc013CstmCategory2 = 'PMC013_CstmCategory2',
  Pmc014CstmCategory3 = 'PMC014_CstmCategory3',
  Pmc015CstmCategory4 = 'PMC015_CstmCategory4',
  Pmc016CstmCategory5 = 'PMC016_CstmCategory5',
  Pmc017CstmCategory6 = 'PMC017_CstmCategory6',
  Pmc018CstmCategory7 = 'PMC018_CstmCategory7',
  Pmc019CstmCategory8 = 'PMC019_CstmCategory8',
  Pmc020CstmCategory9 = 'PMC020_CstmCategory9',
  Pmc021CstmCategory10 = 'PMC021_CstmCategory10',
  Pmc022HcSimulation = 'PMC022_HCSimulation'
}

export type MetricCategoryTree = {
  __typename?: 'MetricCategoryTree';
  groupTrees: Array<MetricGroupTree>;
  metricCategory: MetricCategory;
  metricCategoryId: MetricCategoryId;
};

/** The definition of a metric. */
export type MetricDef = {
  __typename?: 'MetricDef';
  defaultPosition: Scalars['Float']['output'];
  formatType: MetricFormatType;
  id: MetricId;
  lifecycleStage: MetricLifecycleStage;
  metricGroupId: MetricGroupId;
  metricType: MetricType;
  name: Scalars['String']['output'];
  segmentationPercAllowed: Scalars['Boolean']['output'];
  /** English tooltip HTML content for this metric */
  tooltipEnglish: Maybe<Scalars['String']['output']>;
  /** Japanese tooltip HTML content for this metric */
  tooltipJapanese: Maybe<Scalars['String']['output']>;
  /** Only set for certain metric types. Currently: for regular metrics only */
  underlyingDataFields: Maybe<Array<DatafieldAndDatatype>>;
};

export type MetricFormatType = {
  __typename?: 'MetricFormatType';
  id: MetricFormatTypeId;
};

export enum MetricFormatTypeId {
  Pmft001Salary = 'PMFT001_Salary',
  Pmft002Percentage = 'PMFT002_Percentage',
  Pmft004DaysToYearMonth = 'PMFT004_DaysToYearMonth',
  Pmft005Count = 'PMFT005_Count',
  Pmft006Number = 'PMFT006_Number',
  Pmft007SensitiveNumber = 'PMFT007_SensitiveNumber',
  Pmft008Multiple = 'PMFT008_Multiple',
  Pmft009Leaves = 'PMFT009_Leaves',
  Pmft010Hours = 'PMFT010_Hours',
  Pmft011Fte = 'PMFT011_Fte',
  Pmft012FloatingNumber1 = 'PMFT012_FloatingNumber1',
  Pmft013FloatingNumber2 = 'PMFT013_FloatingNumber2',
  Pmft014FloatingPercentage1 = 'PMFT014_FloatingPercentage1',
  Pmft015FloatingPercentage2 = 'PMFT015_FloatingPercentage2'
}

export type MetricGroup = {
  __typename?: 'MetricGroup';
  defaultCategory: MetricCategory;
  defaultCategoryId: MetricCategoryId;
  defaultPosition: Scalars['Float']['output'];
  id: MetricGroupId;
};

export enum MetricGroupId {
  Pmg0001Individuals = 'PMG0001_Individuals',
  Pmg0003FtEquiv = 'PMG0003_FTEquiv',
  Pmg0006Joiners = 'PMG0006_Joiners',
  Pmg0007LeaversTermDate = 'PMG0007_LeaversTermDate',
  Pmg0010MngCalc = 'PMG0010_MngCalc',
  Pmg0011NewMngCalc = 'PMG0011_NewMngCalc',
  Pmg0012FMngCalc = 'PMG0012_FMngCalc',
  Pmg0014MngDef = 'PMG0014_MngDef',
  Pmg0015NewMngDef = 'PMG0015_NewMngDef',
  Pmg0016FMngDef = 'PMG0016_FMngDef',
  Pmg0019Age = 'PMG0019_Age',
  Pmg0020Fhc = 'PMG0020_FHC',
  Pmg0023Tenure = 'PMG0023_Tenure',
  Pmg0024SpanControl = 'PMG0024_SpanControl',
  Pmg0025DepthControl = 'PMG0025_DepthControl',
  Pmg0026PopPayGap = 'PMG0026_PopPayGap',
  Pmg0028CeoPayGapBaseAvg = 'PMG0028_CEOPayGapBaseAvg',
  Pmg0033InternalMobilityOrgLevel1 = 'PMG0033_InternalMobilityOrgLevel1',
  Pmg0034InternalMobilityOrgLevel2 = 'PMG0034_InternalMobilityOrgLevel2',
  Pmg0037RevenueHcMonthly = 'PMG0037_RevenueHCMonthly',
  Pmg0044GrossProfitHcMonthly = 'PMG0044_GrossProfitHCMonthly',
  Pmg0047SgAndAhcMonthly = 'PMG0047_SGAndAHCMonthly',
  Pmg0050OperatingProfitAndLossHcMonthly = 'PMG0050_OperatingProfitAndLossHCMonthly',
  Pmg0051TrainingCostMonthly = 'PMG0051_TrainingCostMonthly',
  Pmg0054GenderPayGapMedBase = 'PMG0054_GenderPayGapMedBase',
  Pmg0061Ot36YtdHrs = 'PMG0061_OT36YTDHrs',
  Pmg0062Ot36720RuleEmployees = 'PMG0062_OT36720RuleEmployees',
  Pmg0063Ot361Month100RuleEmp = 'PMG0063_OT361Month100RuleEmp',
  Pmg0064Ot362MonthHrs = 'PMG0064_OT362MonthHrs',
  Pmg0065Ot362MonthAvg80RuleEmp = 'PMG0065_OT362MonthAvg80RuleEmp',
  Pmg0066Ot363MonthHrs = 'PMG0066_OT363MonthHrs',
  Pmg0067Ot363MonthAvg80RuleEmp = 'PMG0067_OT363MonthAvg80RuleEmp',
  Pmg0068Ot364MonthHrs = 'PMG0068_OT364MonthHrs',
  Pmg0069Ot364MonthAvg80RuleEmp = 'PMG0069_OT364MonthAvg80RuleEmp',
  Pmg0070Ot365MonthHrs = 'PMG0070_OT365MonthHrs',
  Pmg0071Ot365MonthAvg80RuleEmp = 'PMG0071_OT365MonthAvg80RuleEmp',
  Pmg0072Ot366MonthHrs = 'PMG0072_OT366MonthHrs',
  Pmg0073Ot366MonthAvg80RuleEmp = 'PMG0073_OT366MonthAvg80RuleEmp',
  Pmg0074Ot3645HrsRuleEmp = 'PMG0074_OT3645HrsRuleEmp',
  Pmg0075Ot36EmpTrackingGroup = 'PMG0075_OT36EmpTrackingGroup',
  Pmg0076Attrition = 'PMG0076_Attrition',
  Pmg0077Retention = 'PMG0077_Retention',
  Pmg0078_3MonthAttrition = 'PMG0078_3MonthAttrition',
  Pmg0079_1YearAttrition = 'PMG0079_1YearAttrition',
  Pmg0080RegretAttrition = 'PMG0080_RegretAttrition',
  Pmg0083Icr = 'PMG0083_ICR',
  Pmg0141TotalBonus = 'PMG0141_TotalBonus',
  Pmg0156LaborCost = 'PMG0156_LaborCost',
  Pmg0157MarudaiComplaints = 'PMG0157_MarudaiComplaints',
  Pmg0158JtKilledAtWork = 'PMG0158_JtKilledAtWork',
  Pmg0159JtOccupationalAccidents = 'PMG0159_JtOccupationalAccidents',
  Pmg0161TotalLaborCostToSales = 'PMG0161_TotalLaborCostToSales',
  Pmg0163TenureInJobgrade = 'PMG0163_TenureInJobgrade',
  Pmg0164TenureInOrgL1 = 'PMG0164_TenureInOrgL1',
  Pmg0170DaysinOffice = 'PMG0170_DaysinOffice',
  Pmg0171ParentalLeaveTakenUtilization = 'PMG0171_ParentalLeaveTakenUtilization',
  Pmg0172TrainingTaken = 'PMG0172_TrainingTaken',
  Pmg0173Trainee = 'PMG0173_Trainee',
  Pmg0174DisciplinaryAction = 'PMG0174_DisciplinaryAction',
  Pmg0175TotalWorkforceCost = 'PMG0175_TotalWorkforceCost',
  Pmg0176TotalCashCompensation = 'PMG0176_TotalCashCompensation',
  Pmg0177SgaPayroll = 'PMG0177_SGAPayroll',
  Pmg0178SgaPopulation = 'PMG0178_SGAPopulation',
  Pmg0179CogsPayroll = 'PMG0179_COGSPayroll',
  Pmg0180CogsPopulation = 'PMG0180_COGSPopulation',
  Pmg0182HumanCapitalRoi = 'PMG0182_HumanCapitalROI',
  Pmg0183DaysOfParentalLeaveTaken = 'PMG0183_DaysOfParentalLeaveTaken',
  Pmg0184GenderPayGapTotalCompFte = 'PMG0184_GenderPayGapTotalCompFTE',
  Pmg0185GenderPayGapTotalCompAvg = 'PMG0185_GenderPayGapTotalCompAvg',
  Pmg0196ManagementPromotion = 'PMG0196_ManagementPromotion',
  Pmg0197CustomPaidLeave1Ah = 'PMG0197_CustomPaidLeave1AH',
  Pmg0198DisabilityPopulation = 'PMG0198_DisabilityPopulation',
  Pmg0199NetIncomeHcMonthly = 'PMG0199_NetIncomeHCMonthly',
  Pmg0200GrossProfitHcQuarterly = 'PMG0200_GrossProfitHCQuarterly',
  Pmg0201IndirectInvestmentRatio = 'PMG0201_IndirectInvestmentRatio',
  Pmg0202NetIncomeHcQuarterly = 'PMG0202_NetIncomeHCQuarterly',
  Pmg0203OperatingProfitHcQuarterly = 'PMG0203_OperatingProfitHCQuarterly',
  Pmg0204RevenueHcQuarterly = 'PMG0204_RevenueHCQuarterly',
  Pmg0205SgahcQuarterly = 'PMG0205_SGAHCQuarterly',
  Pmg0206TrainingCostQuarterly = 'PMG0206_TrainingCostQuarterly',
  Pmg0207NonRegEmp = 'PMG0207_NonRegEmp',
  Pmg0208FulltimeEmp = 'PMG0208_FulltimeEmp',
  Pmg0209StartingPopAttrition = 'PMG0209_StartingPopAttrition',
  Pmg0210MedianBase = 'PMG0210_MedianBase',
  Pmg0211Disablity = 'PMG0211_Disablity',
  Pmg0212AbsentDays = 'PMG0212_AbsentDays',
  Pmg0213AvgWorkHoursPerPerson = 'PMG0213_AvgWorkHoursPerPerson',
  Pmg0214AvgEmp45HrsOTperMth = 'PMG0214_AvgEmp45HrsOTperMth',
  Pmg0215MonthlyOt = 'PMG0215_MonthlyOT',
  Pmg0216Jp5AlDayRule = 'PMG0216_JP5ALDayRule',
  Pmg0217StatutoryAnnualPaidLeave = 'PMG0217_StatutoryAnnualPaidLeave',
  Pmg0218Al = 'PMG0218_AL',
  Pmg0219DaysRemote = 'PMG0219_DaysRemote',
  Pmg0220HoursWorkedHoliday = 'PMG0220_HoursWorkedHoliday',
  Pmg0221HoursWorkedLegalHoliday = 'PMG0221_HoursWorkedLegalHoliday',
  Pmg0222OtHours = 'PMG0222_OTHours',
  Pmg0223PlTaken = 'PMG0223_PLTaken',
  Pmg0224TotalHolidayOt = 'PMG0224_TotalHolidayOT',
  Pmg0225TotalOt = 'PMG0225_TotalOT',
  Pmg0226OtPay = 'PMG0226_OTPay',
  Pmg0227TravelCommuting = 'PMG0227_TravelCommuting',
  Pmg0228BonusCoef = 'PMG0228_BonusCoef',
  Pmg0229EmployerStatutoryPayment = 'PMG0229_EmployerStatutoryPayment',
  Pmg0230Ot361Month75RuleEmp = 'PMG0230_OT361Month75RuleEmp',
  Pmg0231Ot36AnnualisedHrs = 'PMG0231_OT36AnnualisedHrs',
  Pmg0232Ot36Ttm = 'PMG0232_OT36TTM',
  Pmg0235TenureInJobgradeL2 = 'PMG0235_TenureInJobgradeL2',
  Pmg0236RegularEmployee = 'PMG0236_RegularEmployee',
  Pmg0237VoluntaryAttrition = 'PMG0237_VoluntaryAttrition',
  Pmg0238LeaversOneyearOpenCase = 'PMG0238_LeaversOneyearOpenCase',
  Pmg0239RecurringPtmCaseWithin1Year = 'PMG0239_RecurringPtmCaseWithin1Year',
  Pmg0240CompanyMoodScore = 'PMG0240_CompanyMoodScore',
  Pmg0241SurveyEngagementScore = 'PMG0241_SurveyEngagementScore',
  Pmg0242Enps = 'PMG0242_ENPS',
  Pmg0243EmployeeWithPtmCases = 'PMG0243_EmployeeWithPTMCases',
  Pmg0244PtmCasesClosed = 'PMG0244_PTMCasesClosed',
  Pmg0245PtmCasesInProgress = 'PMG0245_PTMCasesInProgress',
  Pmg0246PtmCasesOpen = 'PMG0246_PTMCasesOpen',
  Pmg0247PtmCasesUnique = 'PMG0247_PTMCasesUnique',
  Pmg0248TotalVacanciesMpp = 'PMG0248_TotalVacanciesMPP',
  Pmg0252Applications = 'PMG0252_Applications',
  Pmg0253PassThroughatApplied = 'PMG0253_PassThroughatApplied',
  Pmg0254RejectedApplicationsatApplied = 'PMG0254_RejectedApplicationsatApplied',
  Pmg0255WithdrawnApplicationsatApplied = 'PMG0255_WithdrawnApplicationsatApplied',
  Pmg0256ApplicationsatScreening = 'PMG0256_ApplicationsatScreening',
  Pmg0257PassThroughatScreening = 'PMG0257_PassThroughatScreening',
  Pmg0258RejectedApplicationsatScreening = 'PMG0258_RejectedApplicationsatScreening',
  Pmg0259WithdrawnApplicationsatScreening = 'PMG0259_WithdrawnApplicationsatScreening',
  Pmg0260Applicationsat1stInterview = 'PMG0260_Applicationsat1stInterview',
  Pmg0261PassThroughat1stInterview = 'PMG0261_PassThroughat1stInterview',
  Pmg0262RejectedApplicationsat1stInterview = 'PMG0262_RejectedApplicationsat1stInterview',
  Pmg0263WithdrawnApplicationsat1stInterview = 'PMG0263_WithdrawnApplicationsat1stInterview',
  Pmg0264Applicationsat2ndInterview = 'PMG0264_Applicationsat2ndInterview',
  Pmg0265PassThroughat2ndInterview = 'PMG0265_PassThroughat2ndInterview',
  Pmg0266RejectedApplicationsat2ndInterview = 'PMG0266_RejectedApplicationsat2ndInterview',
  Pmg0267WithdrawnApplicationsat2ndInterview = 'PMG0267_WithdrawnApplicationsat2ndInterview',
  Pmg0268ApplicationsatFinalInterview = 'PMG0268_ApplicationsatFinalInterview',
  Pmg0269PassThroughatFinalInterview = 'PMG0269_PassThroughatFinalInterview',
  Pmg0270RejectedApplicationsatFinalInterview = 'PMG0270_RejectedApplicationsatFinalInterview',
  Pmg0271WithdrawnApplicationsatFinalInterview = 'PMG0271_WithdrawnApplicationsatFinalInterview',
  Pmg0272ApplicationsatOffer = 'PMG0272_ApplicationsatOffer',
  Pmg0273PassThroughatOffer = 'PMG0273_PassThroughatOffer',
  Pmg0274RejectedApplicationsatOffer = 'PMG0274_RejectedApplicationsatOffer',
  Pmg0275WithdrawnApplicationsatOffer = 'PMG0275_WithdrawnApplicationsatOffer',
  Pmg0276Applications = 'PMG0276_Applications',
  Pmg0277TenureInOrgL2 = 'PMG0277_TenureInOrgL2',
  Pmg0279DigitalExpertsMsad = 'PMG0279_DigitalExpertsMSAD',
  Pmg0280EmpCompDigitalTrainingMsad = 'PMG0280_EmpCompDigitalTrainingMSAD',
  Pmg0281EmpExExperienceMsad = 'PMG0281_EmpExExperienceMSAD',
  Pmg0282PotentialFLeaderMsad = 'PMG0282_PotentialFLeaderMSAD',
  Pmg0283EngScoreMsad = 'PMG0283_EngScoreMSAD',
  Pmg0284HighStrsEmpMsad = 'PMG0284_HighStrsEmpMSAD',
  Pmg0285ParentalLeaveUtilizationMsad = 'PMG0285_ParentalLeaveUtilizationMSAD',
  Pmg0286PlannedIndividuals = 'PMG0286_PlannedIndividuals',
  Pmg0287PlannedJoiners = 'PMG0287_PlannedJoiners',
  Pmg0288Ot362to6MonthAvg80RuleEmp = 'PMG0288_OT362to6MonthAvg80RuleEmp',
  Pmg0289_3mJoinersAttrition = 'PMG0289_3mJoinersAttrition',
  Pmg0290_1yAttrition = 'PMG0290_1yAttrition',
  Pmg0291_3yAttrition = 'PMG0291_3yAttrition',
  Pmg0292_3rdYearAttrition = 'PMG0292_3rdYearAttrition',
  Pmg0293CustomFemaleIndividuals = 'PMG0293_CustomFemaleIndividuals',
  Pmg0294CustomFemaleManagers = 'PMG0294_CustomFemaleManagers',
  Pmg0295TotalCashCompFinanceYearly = 'PMG0295_TotalCashCompFinanceYearly',
  Pmg0296TotalBonusFinanceYearly = 'PMG0296_TotalBonusFinanceYearly',
  Pmg0297RecruitmentCostYearly = 'PMG0297_RecruitmentCostYearly',
  Pmg0298RetirementAllowanceFinanceYearly = 'PMG0298_RetirementAllowanceFinanceYearly',
  Pmg0299EmployerNonStatutoryPaymentFinanceYearly = 'PMG0299_EmployerNonStatutoryPaymentFinanceYearly',
  Pmg0300EmployerStatutoryPaymentFinanceYearly = 'PMG0300_EmployerStatutoryPaymentFinanceYearly',
  Pmg0301BoardCompensationFinanceYearly = 'PMG0301_BoardCompensationFinanceYearly',
  Pmg0302RevenueHcMonthlyWholeCompany = 'PMG0302_RevenueHCMonthlyWholeCompany',
  Pmg0303GrossProfitHcMonthlyWholeCompany = 'PMG0303_GrossProfitHCMonthlyWholeCompany',
  Pmg0304SgahcMonthlyWholeCompany = 'PMG0304_SGAHCMonthlyWholeCompany',
  Pmg0305OperatingProfitHcMonthlyWholeCompany = 'PMG0305_OperatingProfitHCMonthlyWholeCompany',
  Pmg0306TrainingCostMonthlyWholeCompany = 'PMG0306_TrainingCostMonthlyWholeCompany',
  Pmg0307NetIncomeHcMonthlyWholeCompany = 'PMG0307_NetIncomeHCMonthlyWholeCompany',
  Pmg0308RevenueHcQuarterlyWholeCompany = 'PMG0308_RevenueHCQuarterlyWholeCompany',
  Pmg0309GrossProfitHcQuarterlyWholeCompany = 'PMG0309_GrossProfitHCQuarterlyWholeCompany',
  Pmg0310SgahcQuarterlyWholeCompany = 'PMG0310_SGAHCQuarterlyWholeCompany',
  Pmg0311OperatingProfitHcQuarterlyWholeCompany = 'PMG0311_OperatingProfitHCQuarterlyWholeCompany',
  Pmg0312TrainingCostQuarterlyWholeCompany = 'PMG0312_TrainingCostQuarterlyWholeCompany',
  Pmg0313NetIncomeHcQuarterlyWholeCompany = 'PMG0313_NetIncomeHCQuarterlyWholeCompany',
  Pmg0314TravelCommutingFinanceYearly = 'PMG0314_TravelCommutingFinanceYearly',
  Pmg0315CustomStatutoryAnnualPaidLeaveNec = 'PMG0315_CustomStatutoryAnnualPaidLeaveNEC',
  Pmg0316CustomIndividuals1ProperNec = 'PMG0316_CustomIndividuals1ProperNEC',
  Pmg0317CustomIndividuals2FinancialReportingNec = 'PMG0317_CustomIndividuals2FinancialReportingNEC',
  Pmg0318CustomAttritionNikki = 'PMG0318_CustomAttritionNikki',
  Pmg0319CustomAttritionAuFh = 'PMG0319_CustomAttritionAuFH',
  Pmg0320GenderPayGapTotalCompAvgJpGov = 'PMG0320_GenderPayGapTotalCompAvgJpGov',
  Pmg0321IndividualsGroupCompanies = 'PMG0321_IndividualsGroupCompanies',
  Pmg0322CustomTenureNecnsi = 'PMG0322_CustomTenureNECNSI',
  Pmg0323CstmMidCareerRcrtNecnsi = 'PMG0323_CstmMidCareerRcrtNECNSI',
  Pmg0324DaysAtOtherLocation = 'PMG0324_DaysAtOtherLocation',
  Pmg0325CstmAnnPaidLeave1 = 'PMG0325_CstmAnnPaidLeave1',
  Pmg0376LaborCostHcMthly = 'PMG0376_LaborCostHCMthly',
  Pmg0377LaborCostHcQtrly = 'PMG0377_LaborCostHCQtrly',
  Pmg0378LaborCostHcMthlComp = 'PMG0378_LaborCostHCMthlComp',
  Pmg0379LaborCostHcQtrlyComp = 'PMG0379_LaborCostHCQtrlyComp',
  Pmg0380MidCareerRcrt = 'PMG0380_MidCareerRcrt',
  Pmg0381StryAnlPaidLeavenotemp = 'PMG0381_StryAnlPaidLeavenotemp',
  Pmg0382CstmAnnPaidLeave2 = 'PMG0382_CstmAnnPaidLeave2',
  Pmg0383CstmJoiners1Bs = 'PMG0383_CstmJoiners1BS',
  Pmg0384CstmJoiners2Bs = 'PMG0384_CstmJoiners2BS',
  Pmg0385CstmJoiners3Bs = 'PMG0385_CstmJoiners3BS',
  Pmg0386CstmLeavers1Bs = 'PMG0386_CstmLeavers1BS',
  Pmg0387CstmLeavers2Bs = 'PMG0387_CstmLeavers2BS',
  Pmg0388CstmLeavers3Bs = 'PMG0388_CstmLeavers3BS',
  Pmg0389CstmAttrition1Bs = 'PMG0389_CstmAttrition1BS',
  Pmg0390CstmIndividuals1Bs = 'PMG0390_CstmIndividuals1BS',
  Pmg0391CstmDaysinNecnsi = 'PMG0391_CstmDaysinNECNSI',
  Pmg0392CstmAnnPaidLeaveNecnsi = 'PMG0392_CstmAnnPaidLeaveNECNSI',
  Pmg0393ParentalLeaveTakenUtilizationnotemp = 'PMG0393_ParentalLeaveTakenUtilizationnotemp',
  Pmg0394CstmGenderPayGap1Bs = 'PMG0394_CstmGenderPayGap1BS',
  Pmg0395CstmAllowance1 = 'PMG0395_CstmAllowance1',
  Pmg0396CstmAllowance2 = 'PMG0396_CstmAllowance2',
  Pmg0397CstmAllowance3 = 'PMG0397_CstmAllowance3',
  Pmg0398CstmAllowance4 = 'PMG0398_CstmAllowance4',
  Pmg0399CstmAllowance5 = 'PMG0399_CstmAllowance5',
  Pmg0400CstmAllowance6 = 'PMG0400_CstmAllowance6',
  Pmg0401CstmAllowance7 = 'PMG0401_CstmAllowance7',
  Pmg0402CstmAllowance8 = 'PMG0402_CstmAllowance8',
  Pmg0403CstmAllowance9 = 'PMG0403_CstmAllowance9',
  Pmg0404BoardComp1 = 'PMG0404_BoardComp1',
  Pmg0405BoardComp2 = 'PMG0405_BoardComp2',
  Pmg0406BoardComp3 = 'PMG0406_BoardComp3',
  Pmg0407BoardComp4 = 'PMG0407_BoardComp4',
  Pmg0408BoardComp5 = 'PMG0408_BoardComp5',
  Pmg0409BoardComp6 = 'PMG0409_BoardComp6',
  Pmg0410BoardComp7 = 'PMG0410_BoardComp7',
  Pmg0411BoardComp8 = 'PMG0411_BoardComp8',
  Pmg0412BoardComp9 = 'PMG0412_BoardComp9',
  Pmg0413CstmSurveyMixi = 'PMG0413_CstmSurveyMixi',
  Pmg0414NonStatutoryOvertime = 'PMG0414_NonStatutoryOvertime',
  Pmg0415CstmTenure1 = 'PMG0415_CstmTenure1',
  Pmg0416_1CstmSurveyJtEngmtAvg = 'PMG0416_1_CstmSurveyJT_EngmtAvg',
  Pmg0417SimulatedHeadcount = 'PMG0417_SimulatedHeadcount',
  Pmg0418SimulatedLeavers = 'PMG0418_SimulatedLeavers',
  Pmg0419SimulatedJoiners = 'PMG0419_SimulatedJoiners',
  Pmg0420SimulatedRetirees = 'PMG0420_SimulatedRetirees',
  Pmg0421RevenueQuarterly = 'PMG0421_RevenueQuarterly',
  Pmg0422OperatingprofitlossQuarterly = 'PMG0422_OperatingprofitlossQuarterly',
  Pmg0423OrderintakeQuarterly = 'PMG0423_OrderintakeQuarterly',
  Pmg0424TotalPayrollWorkforceCost = 'PMG0424_TotalPayrollWorkforceCost',
  Pmg0425JobPerformanceComp = 'PMG0425_JobPerformanceComp',
  Pmg0426RevenueMonthly = 'PMG0426_RevenueMonthly',
  Pmg0427TotalFinanceWorkforceCostMonthly = 'PMG0427_TotalFinanceWorkforceCostMonthly',
  Pmg0428CstmPayrollWorkforceCost1 = 'PMG0428_CstmPayrollWorkforceCost1',
  Pmg0429CstmPayrollWorkforceCost2 = 'PMG0429_CstmPayrollWorkforceCost2',
  Pmg0430CstmSatSurveyKhnc = 'PMG0430_CstmSatSurveyKHNC',
  Pmg0431CstmTrainingHrsauFh = 'PMG0431_CstmTrainingHrsauFH',
  Pmg0433CstmBonus1 = 'PMG0433_CstmBonus1',
  Pmg0434CstmBonus2 = 'PMG0434_CstmBonus2',
  Pmg0435CstmBonus3 = 'PMG0435_CstmBonus3',
  Pmg0436CstmBonus4 = 'PMG0436_CstmBonus4',
  Pmg0437CstmBonus5 = 'PMG0437_CstmBonus5',
  Pmg0438CstmBonus6 = 'PMG0438_CstmBonus6',
  Pmg0439CstmBonus7 = 'PMG0439_CstmBonus7',
  Pmg0440CstmBonus8 = 'PMG0440_CstmBonus8',
  Pmg0441CstmBonus9 = 'PMG0441_CstmBonus9',
  Pmg0442CstmBonus10 = 'PMG0442_CstmBonus10',
  Pmg0443MngDef2 = 'PMG0443_MngDef2',
  Pmg0444CltIndividualsJpn0000033 = 'PMG0444_CltIndividualsJPN0000033',
  Pmg0445CltFMngJpn0000033 = 'PMG0445_CltFMngJPN0000033',
  Pmg0446SickLeaveDays = 'PMG0446_SickLeaveDays',
  Pmg0447CltLeaversJpn0000029 = 'PMG0447_CltLeaversJPN0000029',
  Pmg0448Mhc = 'PMG0448_MHC',
  Pmg0449DaysOfParentalLeaveTakenNoTemp = 'PMG0449_DaysOfParentalLeaveTakenNoTemp',
  Pmg0450PrePostNatalLeaveUtilization = 'PMG0450_PrePostNatalLeaveUtilization',
  Pmg0451CaregivLeaveDays = 'PMG0451_CaregivLeaveDays',
  Pmg0452OrderIntakeMonthly = 'PMG0452_OrderIntakeMonthly',
  Pmg0453GrossProfitMonthly = 'PMG0453_GrossProfitMonthly',
  Pmg0454OperatingProfitLossMonthly = 'PMG0454_OperatingProfitLossMonthly',
  Pmg0455TrainingCostMonthly = 'PMG0455_TrainingCostMonthly',
  Pmg0456RevenueMonthly = 'PMG0456_RevenueMonthly',
  Pmg0457LaborCostMonthly = 'PMG0457_LaborCostMonthly'
}

export type MetricGroupSegmentData = {
  __typename?: 'MetricGroupSegmentData';
  data: Maybe<ResponseValue>;
  /** If no grouping was used then this will be empty. There is no guarantee that there will be a result-entry for each requested group if there is no data for certain grouping-values. */
  groupSegment: Array<ByFieldSegment>;
};

export type MetricGroupTree = {
  __typename?: 'MetricGroupTree';
  metricDefs: Array<MetricDef>;
  metricGroup: MetricGroup;
  metricGroupId: MetricGroupId;
};

export enum MetricId {
  Pm0001_1IndividualsCount = 'PM0001_1_Individuals_count',
  Pm0003_1FtEquivTotal = 'PM0003_1_FTEquiv_total',
  Pm0006_1JoinersJoiners = 'PM0006_1_Joiners_joiners',
  Pm0006_2JoinersPercHc = 'PM0006_2_Joiners_percHC',
  Pm0007_1LeaversTermDateLeavers = 'PM0007_1_LeaversTermDate_leavers',
  Pm0007_2LeaversTermDatePercHc = 'PM0007_2_LeaversTermDate_PercHC',
  Pm0010_1MngCalcCount = 'PM0010_1_MngCalc_Count',
  Pm0010_2MngCalcPercHc = 'PM0010_2_MngCalc_PercHC',
  Pm0011_1NewMngCalcCount = 'PM0011_1_NewMngCalc_Count',
  Pm0011_2NewMngCalcPercMng = 'PM0011_2_NewMngCalc_PercMng',
  Pm0011_3NewMngCalcPercHc = 'PM0011_3_NewMngCalc_PercHC',
  Pm0012_1FMngCalcCount = 'PM0012_1_FMngCalc_Count',
  Pm0012_2FMngCalcPercHc = 'PM0012_2_FMngCalc_PercHC',
  Pm0012_3FMngCalcPercMng = 'PM0012_3_FMngCalc_PercMng',
  Pm0014_1MngDefCount = 'PM0014_1_MngDef_Count',
  Pm0014_2MngDefPercHc = 'PM0014_2_MngDef_PercHC',
  Pm0015_1NewMngDefCount = 'PM0015_1_NewMngDef_Count',
  Pm0015_2NewMngDefPercMng = 'PM0015_2_NewMngDef_PercMng',
  Pm0015_3NewMngDefPercHc = 'PM0015_3_NewMngDef_PercHC',
  Pm0016_1FMngDefCount = 'PM0016_1_FMngDef_Count',
  Pm0016_2FMngDefPercHc = 'PM0016_2_FMngDef_PercHC',
  Pm0016_3FMngDefPercMng = 'PM0016_3_FMngDef_PercMng',
  Pm0019_1AgeMedian = 'PM0019_1_Age_Median',
  Pm0019_2AgeAvg = 'PM0019_2_Age_Avg',
  Pm0019_3AgeMax = 'PM0019_3_Age_Max',
  Pm0019_4AgeMin = 'PM0019_4_Age_Min',
  Pm0020_1FhcCount = 'PM0020_1_FHC_Count',
  Pm0020_2FhcPercHc = 'PM0020_2_FHC_PercHC',
  Pm0023_1TenureMedian = 'PM0023_1_Tenure_Median',
  Pm0023_2TenureAvg = 'PM0023_2_Tenure_Avg',
  Pm0023_3TenureMax = 'PM0023_3_Tenure_Max',
  Pm0023_4TenureMin = 'PM0023_4_Tenure_Min',
  Pm0024_1SpanControlMedian = 'PM0024_1_SpanControl_Median',
  Pm0024_2SpanControlAvg = 'PM0024_2_SpanControl_Avg',
  Pm0024_3SpanControlMax = 'PM0024_3_SpanControl_Max',
  Pm0024_4SpanControlMin = 'PM0024_4_SpanControl_Min',
  Pm0025_1DepthControlMax = 'PM0025_1_DepthControl_Max',
  Pm0026_1PopPayGapMultiple = 'PM0026_1_PopPayGap_multiple',
  Pm0028_1CeoPayGapBaseAvgPerc = 'PM0028_1_CEOPayGapBaseAvg_Perc',
  Pm0028_2CeoPayGapBaseAvgMultiple = 'PM0028_2_CEOPayGapBaseAvg_Multiple',
  Pm0033_1InternalMobilityOrgLevel1NumMove = 'PM0033_1_InternalMobilityOrgLevel1_NumMove',
  Pm0033_2InternalMobilityOrgLevel1NumIndvWMove = 'PM0033_2_InternalMobilityOrgLevel1_NumIndvWMove',
  Pm0033_3InternalMobilityOrgLevel1PercHc = 'PM0033_3_InternalMobilityOrgLevel1_PercHC',
  Pm0034_1InternalMobilityOrgLevel2NumMove = 'PM0034_1_InternalMobilityOrgLevel2_NumMove',
  Pm0034_2InternalMobilityOrgLevel2NumIndvWMove = 'PM0034_2_InternalMobilityOrgLevel2_NumIndvWMove',
  Pm0034_3InternalMobilityOrgLevel2PercHc = 'PM0034_3_InternalMobilityOrgLevel2_PercHC',
  Pm0037_1RevenueHcMonthlyPerFte = 'PM0037_1_RevenueHCMonthly_PerFTE',
  Pm0037_2RevenueHcMonthlyPerIndiv = 'PM0037_2_RevenueHCMonthly_PerIndiv',
  Pm0044_1GrossProfitHcMonthlyPerFte = 'PM0044_1_GrossProfitHCMonthly_PerFTE',
  Pm0044_2GrossProfitHcMonthlyPerIndiv = 'PM0044_2_GrossProfitHCMonthly_PerIndiv',
  Pm0047_1SgahcMonthlyPerFte = 'PM0047_1_SGAHCMonthly_PerFTE',
  Pm0047_2SgahcMonthlyPerIndiv = 'PM0047_2_SGAHCMonthly_PerIndiv',
  Pm0050_1OperatingProfitHcMonthlyPerFte = 'PM0050_1_OperatingProfitHCMonthly_PerFTE',
  Pm0050_2OperatingProfitHcMonthlyPerIndiv = 'PM0050_2_OperatingProfitHCMonthly_PerIndiv',
  Pm0051_1TrainingCostMonthlyPerFte = 'PM0051_1_TrainingCostMonthly_PerFTE',
  Pm0051_2TrainingCostMonthlyPerIndiv = 'PM0051_2_TrainingCostMonthly_PerIndiv',
  Pm0054_1GenderPayGapMedBaseFtoMPerc = 'PM0054_1_GenderPayGapMedBase_FtoMPerc',
  Pm0054_2GenderPayGapMedBaseMtoFPerc = 'PM0054_2_GenderPayGapMedBase_MtoFPerc',
  Pm0054_3GenderPayGapMedBaseFtoMCashGap = 'PM0054_3_GenderPayGapMedBase_FtoMCashGap',
  Pm0054_4GenderPayGapMedBaseMtoFCashGap = 'PM0054_4_GenderPayGapMedBase_MtoFCashGap',
  Pm0054_5GenderPayGapMedBaseFMultipleM = 'PM0054_5_GenderPayGapMedBase_FMultipleM',
  Pm0054_6GenderPayGapMedBaseMMultipleF = 'PM0054_6_GenderPayGapMedBase_MMultipleF',
  Pm0061_1Ot36YtdHrsCumAvg = 'PM0061_1_OT36YTDHrs_CumAvg',
  Pm0061_2Ot36YtdHrsMax = 'PM0061_2_OT36YTDHrs_Max',
  Pm0061_3Ot36YtdHrsTotal = 'PM0061_3_OT36YTDHrs_Total',
  Pm0062_1Ot36720RuleEmployeesCount = 'PM0062_1_OT36720RuleEmployees_Count',
  Pm0062_2Ot36720RuleEmployeesPercHc = 'PM0062_2_OT36720RuleEmployees_PercHC',
  Pm0063_1Ot361Month100RuleEmpCount = 'PM0063_1_OT361Month100RuleEmp_Count',
  Pm0063_2Ot361Month100RuleEmpPercHc = 'PM0063_2_OT361Month100RuleEmp_PercHC',
  Pm0064_1Ot362MonthHrsTrailAvg = 'PM0064_1_OT362MonthHrs_TrailAvg',
  Pm0064_2Ot362MonthHrsMax = 'PM0064_2_OT362MonthHrs_Max',
  Pm0064_3Ot362MonthHrsTotal = 'PM0064_3_OT362MonthHrs_Total',
  Pm0065_1Ot362MonthAvg80RuleEmpCount = 'PM0065_1_OT362MonthAvg80RuleEmp_Count',
  Pm0065_2Ot362MonthAvg80RuleEmployeesPercHc = 'PM0065_2_OT362MonthAvg80RuleEmployees_PercHC',
  Pm0066_1Ot363MonthHrsTrailAvg = 'PM0066_1_OT363MonthHrs_TrailAvg',
  Pm0066_2Ot363MonthHrsMax = 'PM0066_2_OT363MonthHrs_Max',
  Pm0066_3Ot363MonthHrsTotal = 'PM0066_3_OT363MonthHrs_Total',
  Pm0067_1Ot363MonthAvg80RuleEmpCount = 'PM0067_1_OT363MonthAvg80RuleEmp_Count',
  Pm0067_2Ot363MonthAvg80RuleEmpPercHc = 'PM0067_2_OT363MonthAvg80RuleEmp_PercHC',
  Pm0068_1Ot364MonthHrsTraiAvg = 'PM0068_1_OT364MonthHrs_TraiAvg',
  Pm0068_2Ot364MonthHrsMax = 'PM0068_2_OT364MonthHrs_Max',
  Pm0068_3Ot364MonthHrsTotal = 'PM0068_3_OT364MonthHrs_Total',
  Pm0069_1Ot364MonthAvg80RuleEmpCount = 'PM0069_1_OT364MonthAvg80RuleEmp_Count',
  Pm0069_2Ot364MonthAvg80RuleEmpPercHc = 'PM0069_2_OT364MonthAvg80RuleEmp_PercHC',
  Pm0070_1Ot365MonthHrsTrailAvg = 'PM0070_1_OT365MonthHrs_TrailAvg',
  Pm0070_2Ot365MonthHrsMax = 'PM0070_2_OT365MonthHrs_Max',
  Pm0070_3Ot365MonthHrsTotal = 'PM0070_3_OT365MonthHrs_Total',
  Pm0071_1Ot365MonthAvg80RuleEmpCount = 'PM0071_1_OT365MonthAvg80RuleEmp_Count',
  Pm0071_2Ot365MonthAvg80RuleEmpPercHc = 'PM0071_2_OT365MonthAvg80RuleEmp_PercHC',
  Pm0072_1Ot366MonthHrsTrailAvg = 'PM0072_1_OT366MonthHrs_TrailAvg',
  Pm0072_2Ot366MonthHrsMax = 'PM0072_2_OT366MonthHrs_Max',
  Pm0072_3Ot366MonthHrsTotal = 'PM0072_3_OT366MonthHrs_Total',
  Pm0073_1Ot366MonthAvg80RuleEmpCount = 'PM0073_1_OT366MonthAvg80RuleEmp_Count',
  Pm0073_2Ot366MonthAvg80RuleEmpPercHc = 'PM0073_2_OT366MonthAvg80RuleEmp_PercHC',
  Pm0074_1Ot3645HrsRuleEmpCount = 'PM0074_1_OT3645HrsRuleEmp_Count',
  Pm0074_2Ot3645HrsRuleEmpPercHc = 'PM0074_2_OT3645HrsRuleEmp_PercHC',
  Pm0075_1Ot36EmpTrackingGroupCount = 'PM0075_1_OT36EmpTrackingGroup_Count',
  Pm0075_2Ot36EmpTrackingGroupPercHc = 'PM0075_2_OT36EmpTrackingGroup_PercHC',
  Pm0076_1AttritionAnnualized = 'PM0076_1_Attrition_Annualized',
  Pm0076_2AttritionMonthly = 'PM0076_2_Attrition_Monthly',
  Pm0076_3AttritionTtm = 'PM0076_3_Attrition_TTM',
  Pm0076_4AttritionLeavers = 'PM0076_4_Attrition_Leavers',
  Pm0077_1RetentionPerc = 'PM0077_1_Retention_Perc',
  Pm0078_1_3MonthAttritionAnnualized = 'PM0078_1_3MonthAttrition_Annualized',
  Pm0078_2_3MonthAttritionMonthly = 'PM0078_2_3MonthAttrition_Monthly',
  Pm0078_3_3MonthAttritionTtm = 'PM0078_3_3MonthAttrition_TTM',
  Pm0078_4_3MonthAttritionLeavers = 'PM0078_4_3MonthAttrition_Leavers',
  Pm0079_1_1YearAttritionAnnualized = 'PM0079_1_1YearAttrition_Annualized',
  Pm0079_2_1YearAttritionMonthly = 'PM0079_2_1YearAttrition_Monthly',
  Pm0079_3_1YearAttritionTtm = 'PM0079_3_1YearAttrition_TTM',
  Pm0079_4_1YearAttritionLeavers = 'PM0079_4_1YearAttrition_Leavers',
  Pm0080_1RegretAttritionAnnualized = 'PM0080_1_RegretAttrition_Annualized',
  Pm0080_2RegretAttritionMonthly = 'PM0080_2_RegretAttrition_Monthly',
  Pm0080_3RegretAttritionTtm = 'PM0080_3_RegretAttrition_TTM',
  Pm0080_4RegretAttritionLeavers = 'PM0080_4_RegretAttrition_Leavers',
  Pm0083_1IcrAvg = 'PM0083_1_ICR_Avg',
  Pm0141_2TotalBonusAvg = 'PM0141_2_TotalBonus_Avg',
  Pm0141_3TotalBonusTotal = 'PM0141_3_TotalBonus_Total',
  Pm0141TotalBonusPercOfTotalCashCompensationRatioOfSums = 'PM0141_TotalBonusPercOfTotalCashCompensation_ratioOfSums',
  Pm0156_2LaborCostPerc = 'PM0156_2_LaborCost_perc',
  Pm0156LaborCostRatio = 'PM0156_LaborCost_ratio',
  Pm0157MarudaiComplaintsCount = 'PM0157_MarudaiComplaints_count',
  Pm0158JtKilledAtWorkCount = 'PM0158_JtKilledAtWork_count',
  Pm0159JtOccupationalAccidentsCount = 'PM0159_JtOccupationalAccidents_count',
  Pm0159JtOccupationalAccidentsPercOfHeadcount = 'PM0159_JtOccupationalAccidents_percOfHeadcount',
  Pm0161TotalLaborCostToSalesRatio = 'PM0161_TotalLaborCostToSales_ratio',
  Pm0163TenureInJobgradeAvg = 'PM0163_TenureInJobgrade_avg',
  Pm0164_1TenureInOrgL1Avg = 'PM0164_1_TenureInOrgL1_avg',
  Pm0170_1DaysInOfficePercWorkingDays = 'PM0170_1_DaysInOffice_PercWorkingDays',
  Pm0170_2DaysInOfficeCount = 'PM0170_2_DaysInOffice_Count',
  Pm0170_3DaysInOfficeAvg = 'PM0170_3_DaysInOffice_Avg',
  Pm0170_4DaysInOfficePerRecord = 'PM0170_4_DaysInOffice_PerRecord',
  Pm0170_5DaysinOfficeEmpRatio = 'PM0170_5_DaysinOffice_EmpRatio',
  Pm0171EligibleForParentalLeaveCount = 'PM0171_EligibleForParentalLeave_count',
  Pm0171ParentalLeaveTakenUtilizationPerc = 'PM0171_ParentalLeaveTakenUtilization_perc',
  Pm0171ParentalLeaveTakenUtilizationRatio = 'PM0171_ParentalLeaveTakenUtilization_ratio',
  Pm0171ParentalLeaveTakenCount = 'PM0171_ParentalLeaveTaken_count',
  Pm0172_1TrainingTakenTotal = 'PM0172_1_TrainingTaken_Total',
  Pm0172_2TrainingTakenAvgTrainingperTrainee = 'PM0172_2_TrainingTaken_AvgTrainingperTrainee',
  Pm0172_3TrainingTakenAvgTrainingperEmp = 'PM0172_3_TrainingTaken_AvgTrainingperEmp',
  Pm0173_1TraineeTotal = 'PM0173_1_Trainee_Total',
  Pm0173_2TraineePercHc = 'PM0173_2_Trainee_PercHC',
  Pm0174_1DisciplinaryActionCount = 'PM0174_1_DisciplinaryAction_count',
  Pm0175_1TotalWorkforceCostTotal = 'PM0175_1_TotalWorkforceCost_Total',
  Pm0175_2TotalWorkforceCostPerPerson = 'PM0175_2_TotalWorkforceCost_PerPerson',
  Pm0176_1TotalCashCompensationPerPerson = 'PM0176_1_TotalCashCompensation_PerPerson',
  Pm0176_2TotalCashCompensationTotal = 'PM0176_2_TotalCashCompensation_Total',
  Pm0176_3TotalCashCompensationPerPersonWtcc = 'PM0176_3_TotalCashCompensation_PerPersonWTCC',
  Pm0177_1SgaPayrollTotal = 'PM0177_1_SGAPayroll_Total',
  Pm0177_2SgaPayrollPercPayrollCost = 'PM0177_2_SGAPayroll_PercPayrollCost',
  Pm0177_3SgaPayrollPerPerson = 'PM0177_3_SGAPayroll_PerPerson',
  Pm0178_1SgaPopulationCount = 'PM0178_1_SGAPopulation_Count',
  Pm0178_2SgaPopulationPercHc = 'PM0178_2_SGAPopulation_PercHC',
  Pm0179_1CogsPayrollTotal = 'PM0179_1_COGSPayroll_Total',
  Pm0179_2CogsPayrollPercPayrollCost = 'PM0179_2_COGSPayroll_PercPayrollCost',
  Pm0179_3CogsPayrollPerPerson = 'PM0179_3_COGSPayroll_PerPerson',
  Pm0180_1CogsPopulationCount = 'PM0180_1_COGSPopulation_Count',
  Pm0180_2CogsPopulationPercHc = 'PM0180_2_COGSPopulation_PercHC',
  Pm0182_1HumanCapitalRoiPerc = 'PM0182_1_HumanCapitalROI_perc',
  Pm0183DaysOfParentalLeaveTakenAvg = 'PM0183_DaysOfParentalLeaveTaken_avg',
  Pm0183DaysOfParentalLeaveTakenSum = 'PM0183_DaysOfParentalLeaveTaken_sum',
  Pm0184_1GenderPayGapFToMTotalCompPerc = 'PM0184_1_GenderPayGapFToMTotalComp_perc',
  Pm0184_2GenderPayGapMToFTotalCompPerc = 'PM0184_2_GenderPayGapMToFTotalComp_perc',
  Pm0184_3GenderPayGapFToMTotalCompDiff = 'PM0184_3_GenderPayGapFToMTotalComp_diff',
  Pm0184_4GenderPayGapMToFTotalCompDiff = 'PM0184_4_GenderPayGapMToFTotalComp_diff',
  Pm0184_5GenderPayGapFToMTotalCompRatio = 'PM0184_5_GenderPayGapFToMTotalComp_ratio',
  Pm0184_6GenderPayGapMToFTotalCompRatio = 'PM0184_6_GenderPayGapMToFTotalComp_ratio',
  Pm0185_1GenderPayGapFToMTotalCompAvgRatio = 'PM0185_1_GenderPayGapFToMTotalCompAvg_ratio',
  Pm0185_2GenderPayGapMToFTotalCompAvgRatio = 'PM0185_2_GenderPayGapMToFTotalCompAvg_ratio',
  Pm0185_3GenderPayGapFToMTotalCompAvgDiff = 'PM0185_3_GenderPayGapFToMTotalCompAvg_diff',
  Pm0185_4GenderPayGapMToFTotalCompAvgDiff = 'PM0185_4_GenderPayGapMToFTotalCompAvg_diff',
  Pm0185_5GenderPayGapFToMTotalCompAvgPerc = 'PM0185_5_GenderPayGapFToMTotalCompAvg_perc',
  Pm0185_6GenderPayGapMToFTotalCompAvgPerc = 'PM0185_6_GenderPayGapMToFTotalCompAvg_perc',
  Pm0196ManagementPromotionPercOfHeadcount = 'PM0196_ManagementPromotion_percOfHeadcount',
  Pm0197_1CustomPaidLeave1AhCumSumPercUtilization = 'PM0197_1_CustomPaidLeave1AH_CumSumPercUtilization',
  Pm0197_2CustomPaidLeave1AhCumSumPerHc = 'PM0197_2_CustomPaidLeave1AH_CumSumPerHC',
  Pm0197_3CustomPaidLeave1AhSumPerHc = 'PM0197_3_CustomPaidLeave1AH_SumPerHC',
  Pm0198_5DisabilityPopulationPercOfHc = 'PM0198_5_DisabilityPopulation_percOfHC',
  Pm0198_6DisabilityPopulationWeightedPercOfHc = 'PM0198_6_DisabilityPopulation_weightedPercOfHC',
  Pm0198DisabilityPopulationCount = 'PM0198_DisabilityPopulation_count',
  Pm0198DisabilityPopulationRatioOfPopulation = 'PM0198_DisabilityPopulation_ratioOfPopulation',
  Pm0198DisabilityPopulationWeightedCount = 'PM0198_DisabilityPopulation_weightedCount',
  Pm0198DisabilityPopulationWeightedRatioOfPopulation = 'PM0198_DisabilityPopulation_weightedRatioOfPopulation',
  Pm0199_1NetIncomeHcMonthlyPerFte = 'PM0199_1_NetIncomeHCMonthly_PerFTE',
  Pm0199_2NetIncomeHcMonthlyPerIndiv = 'PM0199_2_NetIncomeHCMonthly_PerIndiv',
  Pm0200_1GrossProfitHcQuarterlyPerFte = 'PM0200_1_GrossProfitHCQuarterly_PerFTE',
  Pm0200_2GrossProfitHcQuarterlyPerIndv = 'PM0200_2_GrossProfitHCQuarterly_PerIndv',
  Pm0201_1IndirectInvestmentRatioPerc = 'PM0201_1_IndirectInvestmentRatio_Perc',
  Pm0202_1NetIncomeHcQuarterlyPerFte = 'PM0202_1_NetIncomeHCQuarterly_PerFTE',
  Pm0202_2NetIncomeHcQuarterlyPerIndv = 'PM0202_2_NetIncomeHCQuarterly_PerIndv',
  Pm0203_1OperatingProfitHcQuarterlyPerFte = 'PM0203_1_OperatingProfitHCQuarterly_PerFTE',
  Pm0203_2OperatingProfitHcQuarterlyPerIndv = 'PM0203_2_OperatingProfitHCQuarterly_PerIndv',
  Pm0204_1RevenueHcQuarterlyPerFte = 'PM0204_1_RevenueHCQuarterly_PerFTE',
  Pm0204_2RevenueHcQuarterlyPerIndv = 'PM0204_2_RevenueHCQuarterly_PerIndv',
  Pm0205_1SgahcQuarterlyPerFte = 'PM0205_1_SGAHCQuarterly_PerFTE',
  Pm0205_2SgahcQuarterlyPerIndv = 'PM0205_2_SGAHCQuarterly_PerIndv',
  Pm0206_1TrainingCostQuarterlyPerFte = 'PM0206_1_TrainingCostQuarterly_PerFTE',
  Pm0206_2TrainingCostQuarterlyPerIndv = 'PM0206_2_TrainingCostQuarterly_PerIndv',
  Pm0207_1NonRegEmpCount = 'PM0207_1_NonRegEmp_Count',
  Pm0207_2NonRegEmpPercHc = 'PM0207_2_NonRegEmp_PercHC',
  Pm0208_1FulltimeEmpTotal = 'PM0208_1_FulltimeEmp_Total',
  Pm0208_2FulltimeEmpPercHc = 'PM0208_2_FulltimeEmp_PercHC',
  Pm0209_1StartingPopAttritionPerc = 'PM0209_1_StartingPopAttrition_Perc',
  Pm0210_1MedianBaseMedian = 'PM0210_1_MedianBase_Median',
  Pm0210_2MedianBaseAvg = 'PM0210_2_MedianBase_Avg',
  Pm0210_3MedianBaseAvgRaise12month = 'PM0210_3_MedianBase_AvgRaise12month',
  Pm0211_1DisablityTotal = 'PM0211_1_Disablity_Total',
  Pm0211_2DisablityPercHc = 'PM0211_2_Disablity_PercHC',
  Pm0212_1AbsentDaysPerHc = 'PM0212_1_AbsentDays_PerHC',
  Pm0212_2AbsentDaysPercOfWorkingDays = 'PM0212_2_AbsentDays_PercOfWorkingDays',
  Pm0213_1AvgWorkHoursPerPersonAvg = 'PM0213_1_AvgWorkHoursPerPerson_Avg',
  Pm0213_2AvgWorkHoursPerPersonAvgWithWh = 'PM0213_2_AvgWorkHoursPerPerson_AvgWithWH',
  Pm0213_3AvgWorkHoursPerPersonPerRecord = 'PM0213_3_AvgWorkHoursPerPerson_PerRecord',
  Pm0213_4AvgWorkHoursPerPersonMedian = 'PM0213_4_AvgWorkHoursPerPerson_Median',
  Pm0213_5AvgWorkHoursPerPersonMax = 'PM0213_5_AvgWorkHoursPerPerson_Max',
  Pm0213_6AvgWorkHoursPerPersonMin = 'PM0213_6_AvgWorkHoursPerPerson_Min',
  Pm0214_1AvgEmp45HrsOTperMthPercHc = 'PM0214_1_AvgEmp45HrsOTperMth_PercHC',
  Pm0214_2AvgEmp45HrsOTperMthHc = 'PM0214_2_AvgEmp45HrsOTperMth_HC',
  Pm0215_1MonthlyOtSumPerHc = 'PM0215_1_MonthlyOT_SumPerHC',
  Pm0215_2MonthlyOtSumPerHcWithOt = 'PM0215_2_MonthlyOT_SumPerHCWithOT',
  Pm0215_4MonthlyOtMedian = 'PM0215_4_MonthlyOT_Median',
  Pm0215_5MonthlyOtMax = 'PM0215_5_MonthlyOT_Max',
  Pm0215_6MonthlyOtMin = 'PM0215_6_MonthlyOT_Min',
  Pm0216_1Jp5AlDayRuleCount = 'PM0216_1_JP5ALDayRule_Count',
  Pm0216_2Jp5AlDayRulePercHc = 'PM0216_2_JP5ALDayRule_PercHC',
  Pm0217_1StatutoryAnnualPaidLeaveCumSumPercUtilization = 'PM0217_1_StatutoryAnnualPaidLeave_CumSumPercUtilization',
  Pm0217_2StatutoryAnnualPaidLeaveCumSumPerHc = 'PM0217_2_StatutoryAnnualPaidLeave_CumSumPerHC',
  Pm0217_3StatutoryAnnualPaidLeaveSumPerHc = 'PM0217_3_StatutoryAnnualPaidLeave_SumPerHC',
  Pm0218_1AnnualLeaveAvg = 'PM0218_1_AnnualLeave_Avg',
  Pm0218_2AnnualLeaveTotal = 'PM0218_2_AnnualLeave_Total',
  Pm0219_1DaysRemotePercWorkingDays = 'PM0219_1_DaysRemote_PercWorkingDays',
  Pm0219_2DaysRemoteCount = 'PM0219_2_DaysRemote_Count',
  Pm0219_3DaysRemoteAvg = 'PM0219_3_DaysRemote_Avg',
  Pm0219_4DaysRemotePerRecord = 'PM0219_4_DaysRemote_PerRecord',
  Pm0219_5DaysRemoteEmpRatio = 'PM0219_5_DaysRemote_EmpRatio',
  Pm0220_1HoursWorkedHolidayTotal = 'PM0220_1_HoursWorkedHoliday_Total',
  Pm0221_1HoursWorkedLegalHolidayTotal = 'PM0221_1_HoursWorkedLegalHoliday_Total',
  Pm0222_1OtHoursTotal = 'PM0222_1_OTHours_Total',
  Pm0223_1PlTakenAvg = 'PM0223_1_PLTaken_Avg',
  Pm0223_2PlTakenTotal = 'PM0223_2_PLTaken_Total',
  Pm0224_1TotalHolidayOtTotal = 'PM0224_1_TotalHolidayOT_Total',
  Pm0225_1TotalOtTotal = 'PM0225_1_TotalOT_Total',
  Pm0226_1OtPayTotal = 'PM0226_1_OTPay_Total',
  Pm0226_2OtPayAvg = 'PM0226_2_OTPay_Avg',
  Pm0227_1TravelCommutingTotal = 'PM0227_1_TravelCommuting_Total',
  Pm0227_2TravelCommutingAvg = 'PM0227_2_TravelCommuting_Avg',
  Pm0228_1BonusCoefAvg = 'PM0228_1_BonusCoef_Avg',
  Pm0228_2BonusCoefMedian = 'PM0228_2_BonusCoef_Median',
  Pm0229_1EmployerStatutoryPaymentTotal = 'PM0229_1_EmployerStatutoryPayment_Total',
  Pm0230_1Ot361Month75RuleEmpCount = 'PM0230_1_OT361Month75RuleEmp_Count',
  Pm0230_2Ot361Month75RuleEmpPercHc = 'PM0230_2_OT361Month75RuleEmp_PercHC',
  Pm0231_1Ot36AnnualisedHrsAvg = 'PM0231_1_OT36AnnualisedHrs_Avg',
  Pm0231_2Ot36AnnualisedHrsMax = 'PM0231_2_OT36AnnualisedHrs_Max',
  Pm0231_3Ot36AnnualisedHrsTotal = 'PM0231_3_OT36AnnualisedHrs_Total',
  Pm0232_1Ot36TtmCumAvg = 'PM0232_1_OT36TTM_CumAvg',
  Pm0232_2Ot36TtmMax = 'PM0232_2_OT36TTM_Max',
  Pm0232_3Ot36TtmTotal = 'PM0232_3_OT36TTM_Total',
  Pm0235_1TenureInJobgradeL2Avg = 'PM0235_1_TenureInJobgradeL2_avg',
  Pm0236_1RegularEmployeeCount = 'PM0236_1_RegularEmployee_Count',
  Pm0236_2RegularEmployeePercHc = 'PM0236_2_RegularEmployee_PercHC',
  Pm0237_1VoluntaryAttritionAnnualized = 'PM0237_1_VoluntaryAttrition_Annualized',
  Pm0237_2VoluntaryAttritionMonthly = 'PM0237_2_VoluntaryAttrition_Monthly',
  Pm0237_3VoluntaryAttritionTtm = 'PM0237_3_VoluntaryAttrition_TTM',
  Pm0237_4VoluntaryAttritionLeavers = 'PM0237_4_VoluntaryAttrition_Leavers',
  Pm0238TiketLeaversWithPtmCaseWithin1YearAvgTenureSincePtmCase = 'PM0238_TiketLeaversWithPtmCaseWithin1Year_avgTenureSincePtmCase',
  Pm0238TiketLeaversWithPtmCaseWithin1YearCount = 'PM0238_TiketLeaversWithPtmCaseWithin1Year_count',
  Pm0238TiketLeaversWithPtmCaseWithin1YearPercOfAllLeavers = 'PM0238_TiketLeaversWithPtmCaseWithin1Year_percOfAllLeavers',
  Pm0239TiketRecurringPtmCaseWithin1YearCount = 'PM0239_TiketRecurringPtmCaseWithin1Year_count',
  Pm0239TiketRecurringPtmCaseWithin1YearPercOfOpenPtmCases = 'PM0239_TiketRecurringPtmCaseWithin1Year_percOfOpenPtmCases',
  Pm0240_1SurveyCompanyMoodScoreAvgScore = 'PM0240_1_SurveyCompanyMoodScore_avgScore',
  Pm0240_2SurveyCompanyMoodScoreNumRespondents = 'PM0240_2_SurveyCompanyMoodScore_numRespondents',
  Pm0240_3SurveyCompanyMoodScoreNumRespondentsPercOfHc = 'PM0240_3_SurveyCompanyMoodScore_numRespondentsPercOfHC',
  Pm0241_1SurveyEngagementScoreAvgScore = 'PM0241_1_SurveyEngagementScore_avgScore',
  Pm0241_2SurveyEngagementScoreNumRespondents = 'PM0241_2_SurveyEngagementScore_numRespondents',
  Pm0241_3SurveyEngagementScoreNumRespondentsPercOfHc = 'PM0241_3_SurveyEngagementScore_numRespondentsPercOfHC',
  Pm0241_4SurveyEngagementScorePositiveRatio = 'PM0241_4_SurveyEngagementScore_PositiveRatio',
  Pm0242_1EnpsScore = 'PM0242_1_ENPS_score',
  Pm0242_2EnpsNumRespondents = 'PM0242_2_ENPS_numRespondents',
  Pm0242_3EnpsNumRespondentsPercOfHc = 'PM0242_3_ENPS_numRespondentsPercOfHC',
  Pm0243EmployeeWithPtmCasesCumulativeCount = 'PM0243_EmployeeWithPTMCases_cumulativeCount',
  Pm0243EmployeeWithPtmCasesNewCount = 'PM0243_EmployeeWithPTMCases_newCount',
  Pm0243EmployeeWithPtmCasesPercOfHc = 'PM0243_EmployeeWithPTMCases_percOfHC',
  Pm0244EmployeeWithClosedPtmCasesCumulativeCount = 'PM0244_EmployeeWithClosedPTMCases_cumulativeCount',
  Pm0244EmployeeWithClosedPtmCasesNewCount = 'PM0244_EmployeeWithClosedPTMCases_newCount',
  Pm0244EmployeeWithClosedPtmCasesPercOfHc = 'PM0244_EmployeeWithClosedPTMCases_percOfHC',
  Pm0245EmployeeWithInProgressPtmCasesNewCount = 'PM0245_EmployeeWithInProgressPTMCases_newCount',
  Pm0245EmployeeWithInProgressPtmCasesPercOfHc = 'PM0245_EmployeeWithInProgressPTMCases_percOfHC',
  Pm0245EmployeeWithInProgressPtmCasesTotal = 'PM0245_EmployeeWithInProgressPTMCases_total',
  Pm0246EmployeeWithOpenPtmCasesNewCount = 'PM0246_EmployeeWithOpenPTMCases_newCount',
  Pm0246EmployeeWithOpenPtmCasesPercOfHc = 'PM0246_EmployeeWithOpenPTMCases_percOfHC',
  Pm0246EmployeeWithOpenPtmCasesTotal = 'PM0246_EmployeeWithOpenPTMCases_total',
  Pm0247_1PtmCasesUniqueCount = 'PM0247_1_PTMCasesUnique_Count',
  Pm0247_2PtmCasesUniquePercOpenCases = 'PM0247_2_PTMCasesUnique_PercOpenCases',
  Pm0248_1TotalVacanciesMppTotal = 'PM0248_1_TotalVacanciesMPP_Total',
  Pm0248_2TotalVacanciesMppActive = 'PM0248_2_TotalVacanciesMPP_Active',
  Pm0252_1ApplicationsPerc = 'PM0252_1_Applications_Perc',
  Pm0252_2ApplicationsCount = 'PM0252_2_Applications_Count',
  Pm0253_1PassthroughAtAppliedPerc = 'PM0253_1_Passthrough_at_Applied_Perc',
  Pm0253_2PassedApplicationsAtAppliedCount = 'PM0253_2_Passed_Applications_at_Applied_Count',
  Pm0254_1RejectedApplicationsAtAppliedPerc = 'PM0254_1_Rejected_Applications_at_Applied_Perc',
  Pm0254_2RejectedApplicationsAtAppliedCount = 'PM0254_2_Rejected_Applications_at_Applied_Count',
  Pm0255_1WithdrawnApplicationsAtAppliedPerc = 'PM0255_1_Withdrawn_Applications_at_Applied_Perc',
  Pm0255_2WithdrawnApplicationsAtAppliedCount = 'PM0255_2_Withdrawn_Applications_at_Applied_Count',
  Pm0256_1ApplicationsAtScreeningCount = 'PM0256_1_Applications_at_Screening_Count',
  Pm0257_1PassthroughAtScreeningPerc = 'PM0257_1_Passthrough_at_Screening_Perc',
  Pm0257_2PassedApplicationsAtScreeningCount = 'PM0257_2_Passed_Applications_at_Screening_Count',
  Pm0258_1RejectedApplicationsAtScreeningPerc = 'PM0258_1_Rejected_Applications_at_Screening_Perc',
  Pm0258_2RejectedApplicationsAtScreeningCount = 'PM0258_2_Rejected_Applications_at_Screening_Count',
  Pm0259_1WithdrawnApplicationsAtScreeningPerc = 'PM0259_1_Withdrawn_Applications_at_Screening_Perc',
  Pm0259_2WithdrawnApplicationsAtScreeningCount = 'PM0259_2_Withdrawn_Applications_at_Screening_Count',
  Pm0260_1ApplicationsAt_1stInterviewCount = 'PM0260_1_Applications_at_1stInterview_Count',
  Pm0261_1PassthroughAt_1stInterviewPerc = 'PM0261_1_Passthrough_at_1stInterview_Perc',
  Pm0261_2PassedApplicationsAt_1stInterviewCount = 'PM0261_2_Passed_Applications_at_1stInterview_Count',
  Pm0262_1RejectedApplicationsAt_1stInterviewPerc = 'PM0262_1_Rejected_Applications_at_1stInterview_Perc',
  Pm0262_2RejectedApplicationsAt_1stInterviewCount = 'PM0262_2_Rejected_Applications_at_1stInterview_Count',
  Pm0263_1WithdrawnApplicationsAt_1stInterviewPerc = 'PM0263_1_Withdrawn_Applications_at_1stInterview_Perc',
  Pm0263_2WithdrawnApplicationsAt_1stInterviewCount = 'PM0263_2_Withdrawn_Applications_at_1stInterview_Count',
  Pm0264_1ApplicationsAt_2ndInterviewCount = 'PM0264_1_Applications_at_2ndInterview_Count',
  Pm0265_1PassthroughAt_2ndInterviewPerc = 'PM0265_1_Passthrough_at_2ndInterview_Perc',
  Pm0265_2PassedApplicationsAt_2ndInterviewCount = 'PM0265_2_Passed_Applications_at_2ndInterview_Count',
  Pm0266_1RejectedApplicationsAt_2ndInterviewPerc = 'PM0266_1_Rejected_Applications_at_2ndInterview_Perc',
  Pm0266_2RejectedApplicationsAt_2ndInterviewCount = 'PM0266_2_Rejected_Applications_at_2ndInterview_Count',
  Pm0267_1WithdrawnApplicationsAt_2ndInterviewPerc = 'PM0267_1_Withdrawn_Applications_at_2ndInterview_Perc',
  Pm0267_2WithdrawnApplicationsAt_2ndInterviewCount = 'PM0267_2_Withdrawn_Applications_at_2ndInterview_Count',
  Pm0268_1ApplicationsAtFinalInterviewCount = 'PM0268_1_Applications_at_FinalInterview_Count',
  Pm0269_1PassthroughAtFinalInterviewPerc = 'PM0269_1_Passthrough_at_FinalInterview_Perc',
  Pm0269_2PassedApplicationsAtFinalInterviewCount = 'PM0269_2_Passed_Applications_at_FinalInterview_Count',
  Pm0270_1RejectedApplicationsAtFinalInterviewPerc = 'PM0270_1_Rejected_Applications_at_FinalInterview_Perc',
  Pm0270_2RejectedApplicationsAtFinalInterviewCount = 'PM0270_2_Rejected_Applications_at_FinalInterview_Count',
  Pm0271_1WithdrawnApplicationsAtFinalInterviewPerc = 'PM0271_1_Withdrawn_Applications_at_FinalInterview_Perc',
  Pm0271_2WithdrawnApplicationsAtFinalInterviewCount = 'PM0271_2_Withdrawn_Applications_at_FinalInterview_Count',
  Pm0272_1ApplicationsAtOfferCount = 'PM0272_1_Applications_at_Offer_Count',
  Pm0273_1PassthroughAtOfferPerc = 'PM0273_1_Passthrough_at_Offer_Perc',
  Pm0273_2PassedApplicationsAtOfferCount = 'PM0273_2_Passed_Applications_at_Offer_Count',
  Pm0274_1RejectedApplicationsAtOfferPerc = 'PM0274_1_Rejected_Applications_at_Offer_Perc',
  Pm0274_2RejectedApplicationsAtOfferCount = 'PM0274_2_Rejected_Applications_at_Offer_Count',
  Pm0275_1WithdrawnApplicationsAtOfferPerc = 'PM0275_1_Withdrawn_Applications_at_Offer_Perc',
  Pm0275_2WithdrawnApplicationsAtOfferCount = 'PM0275_2_Withdrawn_Applications_at_Offer_Count',
  Pm0276_1ApplicationsAtHiredCount = 'PM0276_1_Applications_at_Hired_Count',
  Pm0277_1TenureInOrgL2Avg = 'PM0277_1_TenureInOrgL2_avg',
  Pm0279_1DigitalExpertsMsadCount = 'PM0279_1_DigitalExpertsMSAD_Count',
  Pm0279_2DigitalExpertsMsadPercHc = 'PM0279_2_DigitalExpertsMSAD_PercHC',
  Pm0280_1EmpCompDigitalTrainingMsadCount = 'PM0280_1_EmpCompDigitalTrainingMSAD_Count',
  Pm0280_2EmpCompDigitalTrainingMsadPercHc = 'PM0280_2_EmpCompDigitalTrainingMSAD_PercHC',
  Pm0281_1EmpExExperienceMsadCount = 'PM0281_1_EmpExExperienceMSAD_Count',
  Pm0281_2EmpExExperienceMsadPercHc = 'PM0281_2_EmpExExperienceMSAD_PercHC',
  Pm0282_1PotentialFLeaderMsadCount = 'PM0282_1_PotentialFLeaderMSAD_Count',
  Pm0282_2PotentialFLeaderMsadPerc = 'PM0282_2_PotentialFLeaderMSAD_Perc',
  Pm0283_1EngScoreMsadPercHc = 'PM0283_1_EngScoreMSAD_PercHC',
  Pm0284_1HighStrsEmpMsadCount = 'PM0284_1_HighStrsEmpMSAD_Count',
  Pm0284_2HighStrsEmpMsadPercHc = 'PM0284_2_HighStrsEmpMSAD_PercHC',
  Pm0285_1ParentalLeaveUtilizationMsadPercHc = 'PM0285_1_ParentalLeaveUtilizationMSAD_PercHC',
  Pm0286_1PlannedIndividualsCount = 'PM0286_1_PlannedIndividuals_Count',
  Pm0286_2PlannedIndividualsPercHc = 'PM0286_2_PlannedIndividuals_PercHC',
  Pm0287_1PlannedJoinersCount = 'PM0287_1_PlannedJoiners_Count',
  Pm0287_2PlannedJoinersPercJoiners = 'PM0287_2_PlannedJoiners_PercJoiners',
  Pm0288_1Ot362to6MonthAvg80RuleEmpCount = 'PM0288_1_OT362to6MonthAvg80RuleEmp_Count',
  Pm0288_2Ot362to6MonthAvg80RuleEmpPercHc = 'PM0288_2_OT362to6MonthAvg80RuleEmp_PercHC',
  Pm0289_1_3mAttritionAttrition = 'PM0289_1_3mAttrition_Attrition',
  Pm0289_2_3mAttritionCountJoiners = 'PM0289_2_3mAttrition_CountJoiners',
  Pm0289_3_3mAttritionCountLeavers = 'PM0289_3_3mAttrition_CountLeavers',
  Pm0290_1_1yAttritionAttrition = 'PM0290_1_1yAttrition_Attrition',
  Pm0290_2_1yAttritionCountJoiners = 'PM0290_2_1yAttrition_CountJoiners',
  Pm0290_3_1yAttritionCountLeavers = 'PM0290_3_1yAttrition_CountLeavers',
  Pm0291_1_3yAttritionAttrition = 'PM0291_1_3yAttrition_Attrition',
  Pm0291_2_3yAttritionCountJoiners = 'PM0291_2_3yAttrition_CountJoiners',
  Pm0291_3_3yAttritionCountLeavers = 'PM0291_3_3yAttrition_CountLeavers',
  Pm0292_1_3rdYearAttritionAttrition = 'PM0292_1_3rdYearAttrition_Attrition',
  Pm0292_2_3rdYearAttritionCountJoiners = 'PM0292_2_3rdYearAttrition_CountJoiners',
  Pm0292_3_3rdYearAttritionCountLeavers = 'PM0292_3_3rdYearAttrition_CountLeavers',
  Pm0293_1CustomFemaleIndividualsCount = 'PM0293_1_CustomFemaleIndividuals_Count',
  Pm0293_2CustomFemaleIndividualsPercFemale = 'PM0293_2_CustomFemaleIndividuals_PercFemale',
  Pm0294_1CustomFemaleManagersCount = 'PM0294_1_CustomFemaleManagers_Count',
  Pm0294_2CustomFemaleManagersPercFemale = 'PM0294_2_CustomFemaleManagers_PercFemale',
  Pm0295_1TotalCashCompFinanceYearlyPerIndv = 'PM0295_1_TotalCashCompFinanceYearly_PerIndv',
  Pm0295_2TotalCashCompFinanceYearlyTotal = 'PM0295_2_TotalCashCompFinanceYearly_Total',
  Pm0296_1TotalBonusFinanceYearlyPerIndv = 'PM0296_1_TotalBonusFinanceYearly_PerIndv',
  Pm0296_2TotalBonusFinanceYearlyTotal = 'PM0296_2_TotalBonusFinanceYearly_Total',
  Pm0297_1RecruitmentCostYearlyPerIndv = 'PM0297_1_RecruitmentCostYearly_PerIndv',
  Pm0297_2RecruitmentCostYearlyTotal = 'PM0297_2_RecruitmentCostYearly_Total',
  Pm0298_1RetirementAllowanceFinanceYearlyPerIndv = 'PM0298_1_RetirementAllowanceFinanceYearly_PerIndv',
  Pm0298_2RetirementAllowanceFinanceYearlyTotal = 'PM0298_2_RetirementAllowanceFinanceYearly_Total',
  Pm0299_1EmployerNonStatutoryPaymentFinanceYearlyPerIndv = 'PM0299_1_EmployerNonStatutoryPaymentFinanceYearly_PerIndv',
  Pm0299_2EmployerNonStatutoryPaymentFinanceYearlyTotal = 'PM0299_2_EmployerNonStatutoryPaymentFinanceYearly_Total',
  Pm0300_1EmployerStatutoryPaymentFinanceYearlyPerIndv = 'PM0300_1_EmployerStatutoryPaymentFinanceYearly_PerIndv',
  Pm0300_2EmployerStatutoryPaymentFinanceYearlyTotal = 'PM0300_2_EmployerStatutoryPaymentFinanceYearly_Total',
  Pm0301_1BoardCompensationFinanceYearlyPerIndv = 'PM0301_1_BoardCompensationFinanceYearly_PerIndv',
  Pm0301_2BoardCompensationFinanceYearlyTotal = 'PM0301_2_BoardCompensationFinanceYearly_Total',
  Pm0302_1RevenueHcMonthlyWholeCompanyPerFte = 'PM0302_1_RevenueHCMonthlyWholeCompany_PerFTE',
  Pm0302_2RevenueHcMonthlyWholeCompanyPerIndiv = 'PM0302_2_RevenueHCMonthlyWholeCompany_PerIndiv',
  Pm0303_1GrossProfitHcMonthlyWholeCompanyPerFte = 'PM0303_1_GrossProfitHCMonthlyWholeCompany_PerFTE',
  Pm0303_2GrossProfitHcMonthlyWholeCompanyPerIndiv = 'PM0303_2_GrossProfitHCMonthlyWholeCompany_PerIndiv',
  Pm0304_1SgahcMonthlyWholeCompanyPerFte = 'PM0304_1_SGAHCMonthlyWholeCompany_PerFTE',
  Pm0304_2SgahcMonthlyWholeCompanyPerIndiv = 'PM0304_2_SGAHCMonthlyWholeCompany_PerIndiv',
  Pm0305_1OperatingProfitHcMonthlyWholeCompanyPerFte = 'PM0305_1_OperatingProfitHCMonthlyWholeCompany_PerFTE',
  Pm0305_2OperatingProfitHcMonthlyWholeCompanyPerIndiv = 'PM0305_2_OperatingProfitHCMonthlyWholeCompany_PerIndiv',
  Pm0306_1TrainingCostMonthlyWholeCompanyPerFte = 'PM0306_1_TrainingCostMonthlyWholeCompany_PerFTE',
  Pm0306_2TrainingCostMonthlyWholeCompanyPerIndiv = 'PM0306_2_TrainingCostMonthlyWholeCompany_PerIndiv',
  Pm0307_1NetIncomeHcMonthlyWholeCompanyPerFte = 'PM0307_1_NetIncomeHCMonthlyWholeCompany_PerFTE',
  Pm0307_2NetIncomeHcMonthlyWholeCompanyPerIndiv = 'PM0307_2_NetIncomeHCMonthlyWholeCompany_PerIndiv',
  Pm0308_1RevenueHcQuarterlyWholeCompanyPerFte = 'PM0308_1_RevenueHCQuarterlyWholeCompany_PerFTE',
  Pm0308_2RevenueHcQuarterlyWholeCompanyPerIndv = 'PM0308_2_RevenueHCQuarterlyWholeCompany_PerIndv',
  Pm0309_1GrossProfitHcQuarterlyWholeCompanyPerFte = 'PM0309_1_GrossProfitHCQuarterlyWholeCompany_PerFTE',
  Pm0309_2GrossProfitHcQuarterlyWholeCompanyPerIndv = 'PM0309_2_GrossProfitHCQuarterlyWholeCompany_PerIndv',
  Pm0310_1SgahcQuarterlyWholeCompanyPerFte = 'PM0310_1_SGAHCQuarterlyWholeCompany_PerFTE',
  Pm0310_2SgahcQuarterlyWholeCompanyPerIndv = 'PM0310_2_SGAHCQuarterlyWholeCompany_PerIndv',
  Pm0311_1OperatingProfitHcQuarterlyWholeCompanyPerFte = 'PM0311_1_OperatingProfitHCQuarterlyWholeCompany_PerFTE',
  Pm0311_2OperatingProfitHcQuarterlyWholeCompanyPerIndv = 'PM0311_2_OperatingProfitHCQuarterlyWholeCompany_PerIndv',
  Pm0312_1TrainingCostQuarterlyWholeCompanyPerFte = 'PM0312_1_TrainingCostQuarterlyWholeCompany_PerFTE',
  Pm0312_2TrainingCostQuarterlyWholeCompanyPerIndv = 'PM0312_2_TrainingCostQuarterlyWholeCompany_PerIndv',
  Pm0313_1NetIncomeHcQuarterlyWholeCompanyPerFte = 'PM0313_1_NetIncomeHCQuarterlyWholeCompany_PerFTE',
  Pm0313_2NetIncomeHcQuarterlyWholeCompanyPerIndv = 'PM0313_2_NetIncomeHCQuarterlyWholeCompany_PerIndv',
  Pm0314_1TravelCommutingFinanceYearlyPerIndv = 'PM0314_1_TravelCommutingFinanceYearly_PerIndv',
  Pm0314_2TravelCommutingFinanceYearlyTotal = 'PM0314_2_TravelCommutingFinanceYearly_Total',
  Pm0315_1CustomStatutoryAnnualPaidLeaveNecCumSumPercUtilization = 'PM0315_1_CustomStatutoryAnnualPaidLeaveNEC_CumSumPercUtilization',
  Pm0315_2CustomStatutoryAnnualPaidLeaveNecCumSumPerHc = 'PM0315_2_CustomStatutoryAnnualPaidLeaveNEC_CumSumPerHC',
  Pm0315_3CustomStatutoryAnnualPaidLeaveNecSumPerHc = 'PM0315_3_CustomStatutoryAnnualPaidLeaveNEC_SumPerHC',
  Pm0316_1CustomIndividuals1ProperNecCount = 'PM0316_1_CustomIndividuals1ProperNEC_Count',
  Pm0317_1CustomIndividuals2FinancialReportingNecCount = 'PM0317_1_CustomIndividuals2FinancialReportingNEC_Count',
  Pm0318_1CustomAttritionNikkiAnnualized = 'PM0318_1_CustomAttritionNikki_Annualized',
  Pm0318_2CustomAttritionNikkiMonthly = 'PM0318_2_CustomAttritionNikki_Monthly',
  Pm0318_3CustomAttritionNikkiTtm = 'PM0318_3_CustomAttritionNikki_TTM',
  Pm0318_4CustomAttritionNikkiLeavers = 'PM0318_4_CustomAttritionNikki_Leavers',
  Pm0319_1CustomAttritionAuFhAnnualized = 'PM0319_1_CustomAttritionAuFH_Annualized',
  Pm0319_2CustomAttritionAuFhMonthly = 'PM0319_2_CustomAttritionAuFH_Monthly',
  Pm0319_3CustomAttritionAuFhTtm = 'PM0319_3_CustomAttritionAuFH_TTM',
  Pm0319_4CustomAttritionAuFhLeavers = 'PM0319_4_CustomAttritionAuFH_Leavers',
  Pm0320_1GenderPayGapFToMTotalCompAvgJpGovPerc = 'PM0320_1_GenderPayGapFToMTotalCompAvgJpGov_perc',
  Pm0320_2GenderPayGapMToFTotalCompAvgJpGovPerc = 'PM0320_2_GenderPayGapMToFTotalCompAvgJpGov_perc',
  Pm0320_3GenderPayGapFToMTotalCompAvgJpGovDiff = 'PM0320_3_GenderPayGapFToMTotalCompAvgJpGov_diff',
  Pm0320_4GenderPayGapMToFTotalCompAvgJpGovDiff = 'PM0320_4_GenderPayGapMToFTotalCompAvgJpGov_diff',
  Pm0321_1IndividualsGroupCompaniesCount = 'PM0321_1_IndividualsGroupCompanies_Count',
  Pm0322_1CustomTenureNecnsiMedian = 'PM0322_1_CustomTenureNECNSI_Median',
  Pm0322_2CustomTenureNecnsiAvg = 'PM0322_2_CustomTenureNECNSI_Avg',
  Pm0322_3CustomTenureNecnsiMax = 'PM0322_3_CustomTenureNECNSI_Max',
  Pm0322_4CustomTenureNecnsiMin = 'PM0322_4_CustomTenureNECNSI_Min',
  Pm0323_1CstmMidCareerRcrtNesicTotal = 'PM0323_1_CstmMidCareerRcrtNESIC_Total',
  Pm0323_2CstmMidCareerRcrtNesicMid = 'PM0323_2_CstmMidCareerRcrtNESIC_Mid',
  Pm0323_3CstmMidCareerRcrtNesicPercHc = 'PM0323_3_CstmMidCareerRcrtNESIC_PercHC',
  Pm0324_1DaysAtOtherLocationPercWorkingDays = 'PM0324_1_DaysAtOtherLocation_PercWorkingDays',
  Pm0324_2DaysAtOtherLocationCount = 'PM0324_2_DaysAtOtherLocation_Count',
  Pm0324_3DaysAtOtherLocationAvg = 'PM0324_3_DaysAtOtherLocation_Avg',
  Pm0324_4DaysAtOtherLocationAvgWithDaysAtOtherLocation = 'PM0324_4_DaysAtOtherLocation_AvgWithDaysAtOtherLocation',
  Pm0325_1CstmAnnPaidLeave1CumSumPercUtil = 'PM0325_1_CstmAnnPaidLeave1_CumSumPercUtil',
  Pm0325_2CstmAnnPaidLeave1CumSumPerHc = 'PM0325_2_CstmAnnPaidLeave1_CumSumPerHC',
  Pm0325_3CstmAnnPaidLeave1SumPerHc = 'PM0325_3_CstmAnnPaidLeave1_SumPerHC',
  Pm0376_1LaborCostHcMthlyPerFte = 'PM0376_1_LaborCostHCMthly_PerFTE',
  Pm0376_2LaborCostHcMthlyPerIndv = 'PM0376_2_LaborCostHCMthly_PerIndv',
  Pm0377_1LaborCostHcQtrlyPerFte = 'PM0377_1_LaborCostHCQtrly_PerFTE',
  Pm0377_2LaborCostHcQtrlyPerIndv = 'PM0377_2_LaborCostHCQtrly_PerIndv',
  Pm0378_1LaborCostHcMthlCompPerFte = 'PM0378_1_LaborCostHCMthlComp_PerFTE',
  Pm0378_2LaborCostHcMthlCompPerIndv = 'PM0378_2_LaborCostHCMthlComp_PerIndv',
  Pm0379_1LaborCostHcQtrlyCompPerFte = 'PM0379_1_LaborCostHCQtrlyComp_PerFTE',
  Pm0379_2LaborCostHcQtrlyCompPerIndv = 'PM0379_2_LaborCostHCQtrlyComp_PerIndv',
  Pm0380_1MidCareerRcrtTotal = 'PM0380_1_MidCareerRcrt_Total',
  Pm0380_2MidCareerRcrtMid = 'PM0380_2_MidCareerRcrt_Mid',
  Pm0380_3MidCareerRcrtPercHc = 'PM0380_3_MidCareerRcrt_PercHC',
  Pm0381_1StryAnlPaidLeavenotempCumSumPercUtilization = 'PM0381_1_StryAnlPaidLeavenotemp_CumSumPercUtilization',
  Pm0381_2StryAnlPaidLeavenotempCumSumPerHc = 'PM0381_2_StryAnlPaidLeavenotemp_CumSumPerHC',
  Pm0381_3StryAnlPaidLeavenotempSumPerHc = 'PM0381_3_StryAnlPaidLeavenotemp_SumPerHC',
  Pm0382_1CstmAnnPaidLeave2CumSumPercUtil = 'PM0382_1_CstmAnnPaidLeave2_CumSumPercUtil',
  Pm0382_2CstmAnnPaidLeave2CumSumPerHc = 'PM0382_2_CstmAnnPaidLeave2_CumSumPerHC',
  Pm0382_3CstmAnnPaidLeave2SumPerHc = 'PM0382_3_CstmAnnPaidLeave2_SumPerHC',
  Pm0383_1CstmJoiners1BsJoiners = 'PM0383_1_CstmJoiners1BS_Joiners',
  Pm0384_1CstmJoiners2BsJoiners = 'PM0384_1_CstmJoiners2BS_Joiners',
  Pm0385_1CstmJoiners3BsJoiners = 'PM0385_1_CstmJoiners3BS_Joiners',
  Pm0386_1CstmLeavers1BsLeavers = 'PM0386_1_CstmLeavers1BS_Leavers',
  Pm0387_1CstmLeavers2BsLeavers = 'PM0387_1_CstmLeavers2BS_Leavers',
  Pm0388_1CstmLeavers3BsLeavers = 'PM0388_1_CstmLeavers3BS_Leavers',
  Pm0389_1CstmAttrition1BsCstmAttrition = 'PM0389_1_CstmAttrition1BS_cstmAttrition',
  Pm0390_1CstmIndividuals1BsCount = 'PM0390_1_CstmIndividuals1BS_Count',
  Pm0391_1CstmDaysInOffNecnsiPercWorkingDays = 'PM0391_1_CstmDaysInOffNECNSI_PercWorkingDays',
  Pm0392_1CstmAnnPaidLeaveNecnsiCumSumPercUtil = 'PM0392_1_CstmAnnPaidLeaveNECNSI_CumSumPercUtil',
  Pm0392_2CstmAnnPaidLeaveNecnsiCumSumPerHc = 'PM0392_2_CstmAnnPaidLeaveNECNSI_CumSumPerHC',
  Pm0392_3CstmAnnPaidLeaveNecnsiSumPerHc = 'PM0392_3_CstmAnnPaidLeaveNECNSI_SumPerHC',
  Pm0393_1EligibleForParentalLeavenotempCount = 'PM0393_1_EligibleForParentalLeavenotemp_count',
  Pm0393_2ParentalLeaveTakenUtilizationnotempPerc = 'PM0393_2_ParentalLeaveTakenUtilizationnotemp_perc',
  Pm0393_3ParentalLeaveTakennotempCount = 'PM0393_3_ParentalLeaveTakennotemp_count',
  Pm0394_1CstmGenderPayGapFToMTotalCompAvg1BsPerc = 'PM0394_1_CstmGenderPayGapFToMTotalCompAvg1BS_perc',
  Pm0394_2CstmGenderPayGapMToFTotalCompAvg1BsPerc = 'PM0394_2_CstmGenderPayGapMToFTotalCompAvg1BS_perc',
  Pm0395_1CstmAllowance1PerPerson = 'PM0395_1_CstmAllowance1_PerPerson',
  Pm0395_2CstmAllowance1Total = 'PM0395_2_CstmAllowance1_Total',
  Pm0395_3CstmAllowance1PerPersonWvalue = 'PM0395_3_CstmAllowance1_PerPersonWvalue',
  Pm0396_1CstmAllowance2PerPerson = 'PM0396_1_CstmAllowance2_PerPerson',
  Pm0396_2CstmAllowance2Total = 'PM0396_2_CstmAllowance2_Total',
  Pm0396_3CstmAllowance2PerPersonWvalue = 'PM0396_3_CstmAllowance2_PerPersonWvalue',
  Pm0397_1CstmAllowance3PerPerson = 'PM0397_1_CstmAllowance3_PerPerson',
  Pm0397_2CstmAllowance3Total = 'PM0397_2_CstmAllowance3_Total',
  Pm0397_3CstmAllowance3PerPersonWvalue = 'PM0397_3_CstmAllowance3_PerPersonWvalue',
  Pm0398_1CstmAllowance4PerPerson = 'PM0398_1_CstmAllowance4_PerPerson',
  Pm0398_2CstmAllowance4Total = 'PM0398_2_CstmAllowance4_Total',
  Pm0398_3CstmAllowance4PerPersonWvalue = 'PM0398_3_CstmAllowance4_PerPersonWvalue',
  Pm0399_1CstmAllowance5PerPerson = 'PM0399_1_CstmAllowance5_PerPerson',
  Pm0399_2CstmAllowance5Total = 'PM0399_2_CstmAllowance5_Total',
  Pm0399_3CstmAllowance5PerPersonWvalue = 'PM0399_3_CstmAllowance5_PerPersonWvalue',
  Pm0400_1CstmAllowance6PerPerson = 'PM0400_1_CstmAllowance6_PerPerson',
  Pm0400_2CstmAllowance6Total = 'PM0400_2_CstmAllowance6_Total',
  Pm0400_3CstmAllowance6PerPersonWvalue = 'PM0400_3_CstmAllowance6_PerPersonWvalue',
  Pm0401_1CstmAllowance7PerPerson = 'PM0401_1_CstmAllowance7_PerPerson',
  Pm0401_2CstmAllowance7Total = 'PM0401_2_CstmAllowance7_Total',
  Pm0401_3CstmAllowance7PerPersonWvalue = 'PM0401_3_CstmAllowance7_PerPersonWvalue',
  Pm0402_1CstmAllowance8PerPerson = 'PM0402_1_CstmAllowance8_PerPerson',
  Pm0402_2CstmAllowance8Total = 'PM0402_2_CstmAllowance8_Total',
  Pm0402_3CstmAllowance8PerPersonWvalue = 'PM0402_3_CstmAllowance8_PerPersonWvalue',
  Pm0403_1CstmAllowance9PerPerson = 'PM0403_1_CstmAllowance9_PerPerson',
  Pm0403_2CstmAllowance9Total = 'PM0403_2_CstmAllowance9_Total',
  Pm0403_3CstmAllowance9PerPersonWvalue = 'PM0403_3_CstmAllowance9_PerPersonWvalue',
  Pm0404_1BoardComp1PerPerson = 'PM0404_1_BoardComp1_PerPerson',
  Pm0404_2BoardComp1Total = 'PM0404_2_BoardComp1_Total',
  Pm0404_3BoardComp1PerPersonWvalue = 'PM0404_3_BoardComp1_PerPersonWvalue',
  Pm0405_1BoardComp2PerPerson = 'PM0405_1_BoardComp2_PerPerson',
  Pm0405_2BoardComp2Total = 'PM0405_2_BoardComp2_Total',
  Pm0405_3BoardComp2PerPersonWvalue = 'PM0405_3_BoardComp2_PerPersonWvalue',
  Pm0406_1BoardComp3PerPerson = 'PM0406_1_BoardComp3_PerPerson',
  Pm0406_2BoardComp3Total = 'PM0406_2_BoardComp3_Total',
  Pm0406_3BoardComp3PerPersonWvalue = 'PM0406_3_BoardComp3_PerPersonWvalue',
  Pm0407_1BoardComp4PerPerson = 'PM0407_1_BoardComp4_PerPerson',
  Pm0407_2BoardComp4Total = 'PM0407_2_BoardComp4_Total',
  Pm0407_3BoardComp4PerPersonWvalue = 'PM0407_3_BoardComp4_PerPersonWvalue',
  Pm0408_1BoardComp5PerPerson = 'PM0408_1_BoardComp5_PerPerson',
  Pm0408_2BoardComp5Total = 'PM0408_2_BoardComp5_Total',
  Pm0408_3BoardComp5PerPersonWvalue = 'PM0408_3_BoardComp5_PerPersonWvalue',
  Pm0409_1BoardComp6PerPerson = 'PM0409_1_BoardComp6_PerPerson',
  Pm0409_2BoardComp6Total = 'PM0409_2_BoardComp6_Total',
  Pm0409_3BoardComp6PerPersonWvalue = 'PM0409_3_BoardComp6_PerPersonWvalue',
  Pm0410_1BoardComp7PerPerson = 'PM0410_1_BoardComp7_PerPerson',
  Pm0410_2BoardComp7Total = 'PM0410_2_BoardComp7_Total',
  Pm0410_3BoardComp7PerPersonWvalue = 'PM0410_3_BoardComp7_PerPersonWvalue',
  Pm0411_1BoardComp8PerPerson = 'PM0411_1_BoardComp8_PerPerson',
  Pm0411_2BoardComp8Total = 'PM0411_2_BoardComp8_Total',
  Pm0411_3BoardComp8PerPersonWvalue = 'PM0411_3_BoardComp8_PerPersonWvalue',
  Pm0412_1BoardComp9PerPerson = 'PM0412_1_BoardComp9_PerPerson',
  Pm0412_2BoardComp9Total = 'PM0412_2_BoardComp9_Total',
  Pm0412_3BoardComp9PerPersonWvalue = 'PM0412_3_BoardComp9_PerPersonWvalue',
  Pm0413_1CstmSurveyMixiPositiveRatio = 'PM0413_1_CstmSurveyMixi_PositiveRatio',
  Pm0414_1NonStatutoryOvertimeSumPerHc = 'PM0414_1_NonStatutoryOvertime_SumPerHC',
  Pm0414_2NonStatutoryOvertimeSumPerHcWithOt = 'PM0414_2_NonStatutoryOvertime_SumPerHCWithOT',
  Pm0414_3NonStatutoryOvertimePerRecord = 'PM0414_3_NonStatutoryOvertime_PerRecord',
  Pm0414_4NonStatutoryOvertimeMedian = 'PM0414_4_NonStatutoryOvertime_Median',
  Pm0414_5NonStatutoryOvertimeMax = 'PM0414_5_NonStatutoryOvertime_Max',
  Pm0414_6NonStatutoryOvertimeMin = 'PM0414_6_NonStatutoryOvertime_Min',
  Pm0415_1CstmTenure1Median = 'PM0415_1_CstmTenure1_Median',
  Pm0415_2CstmTenure1Avg = 'PM0415_2_CstmTenure1_Avg',
  Pm0415_3CstmTenure1Max = 'PM0415_3_CstmTenure1_Max',
  Pm0415_4CstmTenure1Min = 'PM0415_4_CstmTenure1_Min',
  Pm0416_1CstmSurveyJtEngmtAvg = 'PM0416_1_CstmSurveyJT_EngmtAvg',
  Pm0417_1SimulatedHeadcountCount = 'PM0417_1_SimulatedHeadcount_Count',
  Pm0417_2SimulatedHeadcountCount = 'PM0417_2_SimulatedHeadcount_Count',
  Pm0418_1SimulatedLeaversCount = 'PM0418_1_SimulatedLeavers_Count',
  Pm0418_2SimulatedLeaversCount = 'PM0418_2_SimulatedLeavers_Count',
  Pm0419_1SimulatedJoinersCount = 'PM0419_1_SimulatedJoiners_Count',
  Pm0419_2SimulatedJoinersCount = 'PM0419_2_SimulatedJoiners_Count',
  Pm0420_1SimulatedRetireesCount = 'PM0420_1_SimulatedRetirees_Count',
  Pm0420_2SimulatedRetireesCount = 'PM0420_2_SimulatedRetirees_Count',
  Pm0421_1RevenueQuarterlyPerIndiv = 'PM0421_1_RevenueQuarterly_PerIndiv',
  Pm0421_2RevenueQuarterlyTotal = 'PM0421_2_RevenueQuarterly_Total',
  Pm0421_3RevenueQuarterlyPerWorkHours = 'PM0421_3_RevenueQuarterly_PerWorkHours',
  Pm0422_1OperatingProfitLossQuarterlyPerIndiv = 'PM0422_1_OperatingProfitLossQuarterly_PerIndiv',
  Pm0422_2OperatingProfitLossQuarterlyTotal = 'PM0422_2_OperatingProfitLossQuarterly_Total',
  Pm0422_3OperatingProfitLossQuarterlyPerWorkHours = 'PM0422_3_OperatingProfitLossQuarterly_PerWorkHours',
  Pm0423_1OrderIntakeQuarterlyPerIndiv = 'PM0423_1_OrderIntakeQuarterly_PerIndiv',
  Pm0423_2OrderIntakeQuarterlyTotal = 'PM0423_2_OrderIntakeQuarterly_Total',
  Pm0423_3OrderIntakeQuarterlyPerWorkHours = 'PM0423_3_OrderIntakeQuarterly_PerWorkHours',
  Pm0424_1TotalPayrollWorkforceCostTotal = 'PM0424_1_TotalPayrollWorkforceCost_Total',
  Pm0424_2TotalPayrollWorkforceCostPerIndiv = 'PM0424_2_TotalPayrollWorkforceCost_PerIndiv',
  Pm0424_3TotalPayrollWorkforceCostPerPersonWvalue = 'PM0424_3_TotalPayrollWorkforceCost_PerPersonWvalue',
  Pm0425_1JobPerformanceCompTotal = 'PM0425_1_JobPerformanceComp_Total',
  Pm0425_2JobPerformanceCompPerIndiv = 'PM0425_2_JobPerformanceComp_PerIndiv',
  Pm0425_3JobPerformanceCompPerPersonWvalue = 'PM0425_3_JobPerformanceComp_PerPersonWvalue',
  Pm0426_1RevenueMonthlyPerIndiv = 'PM0426_1_RevenueMonthly_PerIndiv',
  Pm0426_2RevenueMonthlyTotal = 'PM0426_2_RevenueMonthly_Total',
  Pm0426_3RevenueMonthlyPerWorkHours = 'PM0426_3_RevenueMonthly_PerWorkHours',
  Pm0427_1TotalFinanceWorkforceCostMonthlyPerIndiv = 'PM0427_1_TotalFinanceWorkforceCostMonthly_PerIndiv',
  Pm0427_2TotalFinanceWorkforceCostMonthlyTotal = 'PM0427_2_TotalFinanceWorkforceCostMonthly_Total',
  Pm0427_3TotalFinanceWorkforceCostMonthlyPerWorkHours = 'PM0427_3_TotalFinanceWorkforceCostMonthly_PerWorkHours',
  Pm0428_1CstmPayrollWorkforceCost1Total = 'PM0428_1_CstmPayrollWorkforceCost1_Total',
  Pm0428_2CstmPayrollWorkforceCost1PerIndiv = 'PM0428_2_CstmPayrollWorkforceCost1_PerIndiv',
  Pm0428_3CstmPayrollWorkforceCost1PerPersonWvalue = 'PM0428_3_CstmPayrollWorkforceCost1_PerPersonWvalue',
  Pm0429_1CstmPayrollWorkforceCost2Total = 'PM0429_1_CstmPayrollWorkforceCost2_Total',
  Pm0429_2CstmPayrollWorkforceCost2PerIndiv = 'PM0429_2_CstmPayrollWorkforceCost2_PerIndiv',
  Pm0429_3CstmPayrollWorkforceCost2PerPersonWvalue = 'PM0429_3_CstmPayrollWorkforceCost2_PerPersonWvalue',
  Pm0430_1CstmSatSurveyKhncAvgScore = 'PM0430_1_CstmSatSurveyKHNC_AvgScore',
  Pm0430_2CstmSatSurveyKhncNumRespondents = 'PM0430_2_CstmSatSurveyKHNC_NumRespondents',
  Pm0431_1CstmTrainingHrsauFhHrs = 'PM0431_1_CstmTrainingHrsauFH_Hrs',
  Pm0433_1CstmBonus1PerPerson = 'PM0433_1_CstmBonus1_PerPerson',
  Pm0433_2CstmBonus1Total = 'PM0433_2_CstmBonus1_Total',
  Pm0433_3CstmBonus1PerPersonWvalue = 'PM0433_3_CstmBonus1_PerPersonWvalue',
  Pm0433_4CstmBonus1CountPersonWvalue = 'PM0433_4_CstmBonus1_CountPersonWvalue',
  Pm0434_1CstmBonus2PerPerson = 'PM0434_1_CstmBonus2_PerPerson',
  Pm0434_2CstmBonus2Total = 'PM0434_2_CstmBonus2_Total',
  Pm0434_3CstmBonus2PerPersonWvalue = 'PM0434_3_CstmBonus2_PerPersonWvalue',
  Pm0434_4CstmBonus2CountPersonWvalue = 'PM0434_4_CstmBonus2_CountPersonWvalue',
  Pm0435_1CstmBonus3PerPerson = 'PM0435_1_CstmBonus3_PerPerson',
  Pm0435_2CstmBonus3Total = 'PM0435_2_CstmBonus3_Total',
  Pm0435_3CstmBonus3PerPersonWvalue = 'PM0435_3_CstmBonus3_PerPersonWvalue',
  Pm0435_4CstmBonus3CountPersonWvalue = 'PM0435_4_CstmBonus3_CountPersonWvalue',
  Pm0436_1CstmBonus4PerPerson = 'PM0436_1_CstmBonus4_PerPerson',
  Pm0436_2CstmBonus4Total = 'PM0436_2_CstmBonus4_Total',
  Pm0436_3CstmBonus4PerPersonWvalue = 'PM0436_3_CstmBonus4_PerPersonWvalue',
  Pm0436_4CstmBonus4CountPersonWvalue = 'PM0436_4_CstmBonus4_CountPersonWvalue',
  Pm0437_1CstmBonus5PerPerson = 'PM0437_1_CstmBonus5_PerPerson',
  Pm0437_2CstmBonus5Total = 'PM0437_2_CstmBonus5_Total',
  Pm0437_3CstmBonus5PerPersonWvalue = 'PM0437_3_CstmBonus5_PerPersonWvalue',
  Pm0437_4CstmBonus5CountPersonWvalue = 'PM0437_4_CstmBonus5_CountPersonWvalue',
  Pm0438_1CstmBonus6PerPerson = 'PM0438_1_CstmBonus6_PerPerson',
  Pm0438_2CstmBonus6Total = 'PM0438_2_CstmBonus6_Total',
  Pm0438_3CstmBonus6PerPersonWvalue = 'PM0438_3_CstmBonus6_PerPersonWvalue',
  Pm0438_4CstmBonus6CountPersonWvalue = 'PM0438_4_CstmBonus6_CountPersonWvalue',
  Pm0439_1CstmBonus7PerPerson = 'PM0439_1_CstmBonus7_PerPerson',
  Pm0439_2CstmBonus7Total = 'PM0439_2_CstmBonus7_Total',
  Pm0439_3CstmBonus7PerPersonWvalue = 'PM0439_3_CstmBonus7_PerPersonWvalue',
  Pm0439_4CstmBonus7CountPersonWvalue = 'PM0439_4_CstmBonus7_CountPersonWvalue',
  Pm0440_1CstmBonus8PerPerson = 'PM0440_1_CstmBonus8_PerPerson',
  Pm0440_2CstmBonus8Total = 'PM0440_2_CstmBonus8_Total',
  Pm0440_3CstmBonus8PerPersonWvalue = 'PM0440_3_CstmBonus8_PerPersonWvalue',
  Pm0440_4CstmBonus8CountPersonWvalue = 'PM0440_4_CstmBonus8_CountPersonWvalue',
  Pm0441_1CstmBonus9PerPerson = 'PM0441_1_CstmBonus9_PerPerson',
  Pm0441_2CstmBonus9Total = 'PM0441_2_CstmBonus9_Total',
  Pm0441_3CstmBonus9PerPersonWvalue = 'PM0441_3_CstmBonus9_PerPersonWvalue',
  Pm0441_4CstmBonus9CountPersonWvalue = 'PM0441_4_CstmBonus9_CountPersonWvalue',
  Pm0442_1CstmBonus10PerPerson = 'PM0442_1_CstmBonus10_PerPerson',
  Pm0442_2CstmBonus10Total = 'PM0442_2_CstmBonus10_Total',
  Pm0442_3CstmBonus10PerPersonWvalue = 'PM0442_3_CstmBonus10_PerPersonWvalue',
  Pm0442_4CstmBonus10CountPersonWvalue = 'PM0442_4_CstmBonus10_CountPersonWvalue',
  Pm0443_1MngDef2Count = 'PM0443_1_MngDef2_Count',
  Pm0443_2MngDef2PercHc = 'PM0443_2_MngDef2_PercHC',
  Pm0444_1CltIndividualsJpn0000033Count = 'PM0444_1_CltIndividualsJPN0000033_Count',
  Pm0445_1CltFMngJpn0000033CountDef1 = 'PM0445_1_CltFMngJPN0000033_CountDef1',
  Pm0445_2CltFMngJpn0000033PercMngDef1 = 'PM0445_2_CltFMngJPN0000033_PercMngDef1',
  Pm0445_3CltFMngJpn0000033CountDef2 = 'PM0445_3_CltFMngJPN0000033_CountDef2',
  Pm0445_4CltFMngJpn0000033PercMngDef2 = 'PM0445_4_CltFMngJPN0000033_PercMngDef2',
  Pm0446_3SickLeaveDaysPerPersonWvalue = 'PM0446_3_SickLeaveDays_PerPersonWvalue',
  Pm0446_4SickLeaveDaysEmpRatio = 'PM0446_4_SickLeaveDays_EmpRatio',
  Pm0446_5SickLeaveDaysEmpCount = 'PM0446_5_SickLeaveDays_EmpCount',
  Pm0447_1CltLeaversJpn0000029Count = 'PM0447_1_CltLeaversJPN0000029_Count',
  Pm0448_1MhcCount = 'PM0448_1_MHC_Count',
  Pm0448_2MhcPerPerson = 'PM0448_2_MHC_PerPerson',
  Pm0449_1DaysOfParentalLeaveTakenNoTempPerPersonWvalue = 'PM0449_1_DaysOfParentalLeaveTakenNoTemp_PerPersonWvalue',
  Pm0449_2DaysOfParentalLeaveTakenNoTempTotal = 'PM0449_2_DaysOfParentalLeaveTakenNoTemp_Total',
  Pm0450_1PrePostNatalLeaveUtilizationCountDenom = 'PM0450_1_PrePostNatalLeaveUtilization_CountDenom',
  Pm0450_2PrePostNatalLeaveUtilizationPerc = 'PM0450_2_PrePostNatalLeaveUtilization_Perc',
  Pm0450_3PrePostNatalLeaveUtilizationCountNum = 'PM0450_3_PrePostNatalLeaveUtilization_CountNum',
  Pm0451_1CaregivLeaveDaysPercWorkingDays = 'PM0451_1_CaregivLeaveDays_PercWorkingDays',
  Pm0451_2CaregivLeaveDaysPerPerson = 'PM0451_2_CaregivLeaveDays_PerPerson',
  Pm0451_3CaregivLeaveDaysPerPersonWvalue = 'PM0451_3_CaregivLeaveDays_PerPersonWvalue',
  Pm0451_4CaregivLeaveDaysEmpRatio = 'PM0451_4_CaregivLeaveDays_EmpRatio',
  Pm0451_5CaregivLeaveDaysEmpCount = 'PM0451_5_CaregivLeaveDays_EmpCount',
  Pm0452_1OrderIntakeMonthlyPerIndiv = 'PM0452_1_OrderIntakeMonthly_PerIndiv',
  Pm0452_2OrderIntakeMonthlyTotal = 'PM0452_2_OrderIntakeMonthly_Total',
  Pm0453_1GrossProfitMonthlyPerIndiv = 'PM0453_1_GrossProfitMonthly_PerIndiv',
  Pm0453_2GrossProfitMonthlyTotal = 'PM0453_2_GrossProfitMonthly_Total',
  Pm0454_1OperatingProfitLossMonthlyPerIndiv = 'PM0454_1_OperatingProfitLossMonthly_PerIndiv',
  Pm0454_2OperatingProfitLossMonthlyTotal = 'PM0454_2_OperatingProfitLossMonthly_Total',
  Pm0455_1TrainingCostMonthlyPerIndiv = 'PM0455_1_TrainingCostMonthly_PerIndiv',
  Pm0455_2TrainingCostMonthlyTotal = 'PM0455_2_TrainingCostMonthly_Total',
  Pm0456_1RevenueMonthlyPerIndiv = 'PM0456_1_RevenueMonthly_PerIndiv',
  Pm0456_2RevenueMonthlyTotal = 'PM0456_2_RevenueMonthly_Total',
  Pm0457_1LaborCostMonthlyPerIndiv = 'PM0457_1_LaborCostMonthly_PerIndiv',
  Pm0457_2LaborCostMonthlyTotal = 'PM0457_2_LaborCostMonthly_Total'
}

export type MetricLifecycleStage = MetricLifecycleStageActive | MetricLifecycleStageDeprecated | MetricLifecycleStageDevelopment | MetricLifecycleStageDisabled;

export type MetricLifecycleStageActive = {
  __typename?: 'MetricLifecycleStageActive';
  /** currently not used */
  reason: Maybe<Scalars['String']['output']>;
};

export type MetricLifecycleStageDeprecated = {
  __typename?: 'MetricLifecycleStageDeprecated';
  /** currently not used */
  reason: Maybe<Scalars['String']['output']>;
};

export type MetricLifecycleStageDevelopment = {
  __typename?: 'MetricLifecycleStageDevelopment';
  /** currently not used */
  reason: Maybe<Scalars['String']['output']>;
};

export type MetricLifecycleStageDisabled = {
  __typename?: 'MetricLifecycleStageDisabled';
  /** currently not used */
  reason: Maybe<Scalars['String']['output']>;
};

export type MetricResult = MetricResultFailure | MetricResultSuccess;

export type MetricResultFailure = {
  __typename?: 'MetricResultFailure';
  errorReference: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  meta: MetricResultMetaData;
  metricId: MetricId;
};

export type MetricResultMetaData = {
  __typename?: 'MetricResultMetaData';
  metricSql: Maybe<Scalars['String']['output']>;
};

export type MetricResultSuccess = {
  __typename?: 'MetricResultSuccess';
  meta: MetricResultMetaData;
  metricId: MetricId;
  /** If no grouping was used at all, then this will only contain one segment */
  segments: Array<MetricTimeSegmentData>;
};

export type MetricResults = {
  __typename?: 'MetricResults';
  results: Array<MetricResult>;
};

export type MetricTimeSegmentData = {
  __typename?: 'MetricTimeSegmentData';
  groupSegments: Array<MetricGroupSegmentData>;
  /** The type will match the requested time-grouping. If there is no data for a time-segment then it will contain a single groupsegment (with no groups) and a null-value. */
  timeSegment: TimeSegment;
};

export type MetricTree = {
  __typename?: 'MetricTree';
  categoryTrees: Array<MetricCategoryTree>;
};

export enum MetricType {
  MetricTypeCohort = 'MetricTypeCohort',
  MetricTypeEmployeeCohort = 'MetricTypeEmployeeCohort',
  MetricTypeRegular = 'MetricTypeRegular'
}

export type Mutations = {
  __typename?: 'Mutations';
  /** Adds common roles such as SUPERADMIN with the appropriate permissions to the domain. This is useful setting up a new domain. */
  addCommonRoles: Maybe<Array<Role>>;
  /** Creates a new domain including common roles for a crexta client and makes the specified user a superadmin of the domain. If the domain already exists then settings are overwritten and the adminUser is fixed in case it is only setup partially. */
  addCrextaDomain: Maybe<Scalars['Unit']['output']>;
  /** Adds a firebase user for an existing app-user (e.g. created with addUserAndDefaultRole endpoint) to use email/password login style. Note that this is discouraged and SSO is preferred when possible! If welcome mail is desired then it must be triggered extra */
  addFirebaseUserForExistingAppUser: Maybe<Scalars['Unit']['output']>;
  addRole: Maybe<Role>;
  addUserAndDefaultRole: Maybe<User>;
  askChappi: Maybe<Array<ChappiResponse>>;
  changeRoleDescription: Maybe<Role>;
  changeRoleDomain: Maybe<Role>;
  changeRoleName: Maybe<Role>;
  /** Clears all data-related caches globally (all domains). This will negatively impact performance for a while, use with care. Note that this request will only clear caches of one backend instance. Send this request multiple time to clear caches of all backend instances. */
  clearAllCaches: Maybe<Scalars['Unit']['output']>;
  /** Clears all data-related caches for the specified domain and then preloads it again. This will negatively impact performance for this domain for a while and put stress on the database during preload, use with care. Note that this request will only clear caches of one backend instance. Send this request multiple time to clear caches of all backend instances. */
  clearAndPreloadCacheForDomain: Maybe<Scalars['Unit']['output']>;
  /**
   * Clears all data-related caches globally (all domains). This will negatively impact performance for a while, use with care.
   * @deprecated Use clearAllCaches instead
   */
  clearCache: Maybe<Scalars['Unit']['output']>;
  /** Clears all data-related caches for the specified domain. This will negatively impact performance for this domain for a while, use with care. Note that this request will only clear caches of one backend instance. Send this request multiple time to clear caches of all backend instances. */
  clearCacheForDomain: Maybe<Scalars['Unit']['output']>;
  createBucketWithDefaultStructure: Maybe<Scalars['Unit']['output']>;
  createDashboard: Maybe<DashboardDefinition>;
  /** Updates the domain preferences for the specified domain to the specified settings by creating a new version which will become the active version. Domain preferences are supposed to be changed by clients (their superadmins) or Panalyt. See also createNewDomainSettings. If the there are no changes in the settings compared to the previous version, no new version will be created and the current version will be returned. */
  createNewDomainPreferences: Maybe<DomainPreferencesVersion>;
  /** Updates the domain settings for the specified domain to the specified settings by creating a new version which will become the active version. Domain settings are only supposed to be changed by Panalyt. See also createNewDomainPreferences. If the there are no changes in the settings compared to the previous version, no new version will be created and the current version will be returned. */
  createNewDomainSettings: Maybe<DomainSettingsVersion>;
  createNewPanaDashboard: Maybe<SavedPanaDashboardVersion>;
  createNewRolePreferences: Maybe<RolePreferencesVersion>;
  deleteAlias: Maybe<Scalars['Unit']['output']>;
  deleteAllDomainSettingsForDomain: Maybe<Scalars['Unit']['output']>;
  deleteDashboard: Maybe<Scalars['Unit']['output']>;
  deleteRoleAndPermissions: Maybe<DeleteRoleAndPermissionsResponse>;
  deleteUploadedFile: Maybe<Scalars['Unit']['output']>;
  deleteUserAndDefaultRole: Maybe<Scalars['String']['output']>;
  grantAssumeRole: Maybe<AssignedPermission>;
  grantCreateReports: Maybe<AssignedPermission>;
  grantCreateRole: Maybe<AssignedPermission>;
  grantDeleteClientFile: Maybe<AssignedPermission>;
  grantDeleteRole: Maybe<AssignedPermission>;
  grantDownloadClientFile: Maybe<AssignedPermission>;
  grantEditRoleScope: Maybe<AssignedPermission>;
  grantExportReports: Maybe<AssignedPermission>;
  grantGrantPermissions: Maybe<AssignedPermission>;
  grantLogin: Maybe<AssignedPermission>;
  grantManageCompany: Maybe<AssignedPermission>;
  grantManageDomain: Maybe<AssignedPermission>;
  grantManageUsers: Maybe<AssignedPermission>;
  grantReadClientFile: Maybe<AssignedPermission>;
  grantReadData: Maybe<AssignedPermission>;
  grantRequestPasswordChange: Maybe<AssignedPermission>;
  grantRevokePermissions: Maybe<AssignedPermission>;
  grantUpdatePassword: Maybe<AssignedPermission>;
  grantUpdateRoleName: Maybe<AssignedPermission>;
  grantUseFilters: Maybe<AssignedPermission>;
  grantViewDashboards: Maybe<AssignedPermission>;
  grantViewMetrics: Maybe<AssignedPermission>;
  grantViewPermissions: Maybe<AssignedPermission>;
  grantViewReports: Maybe<AssignedPermission>;
  grantViewRoleScope: Maybe<AssignedPermission>;
  grantViewRoles: Maybe<AssignedPermission>;
  grantWriteClientFile: Maybe<AssignedPermission>;
  patchDomainPreferences: Maybe<DomainPreferencesVersion>;
  patchDomainSettings: Maybe<DomainSettingsVersion>;
  patchRolePreferences: Maybe<RolePreferencesVersion>;
  /** Realigns the permissions of common roles (currently only the SUPERADMIN role) to match the expected permissions. */
  realignCommonRoles: Maybe<RealignCommonRolesResult>;
  replaceAssumeRole: Maybe<AssignedPermission>;
  replaceCreateReports: Maybe<AssignedPermission>;
  replaceCreateRole: Maybe<AssignedPermission>;
  replaceDeleteClientFile: Maybe<AssignedPermission>;
  replaceDeleteRole: Maybe<AssignedPermission>;
  replaceDownloadClientFile: Maybe<AssignedPermission>;
  replaceEditRoleScope: Maybe<AssignedPermission>;
  replaceExportReports: Maybe<AssignedPermission>;
  replaceGrantPermissions: Maybe<AssignedPermission>;
  replaceLogin: Maybe<AssignedPermission>;
  replaceManageCompany: Maybe<AssignedPermission>;
  replaceManageDomain: Maybe<AssignedPermission>;
  replaceManageUsers: Maybe<AssignedPermission>;
  replaceReadClientFile: Maybe<AssignedPermission>;
  replaceReadData: Maybe<AssignedPermission>;
  replaceRequestPasswordChange: Maybe<AssignedPermission>;
  replaceRevokePermissions: Maybe<AssignedPermission>;
  replaceUpdatePassword: Maybe<AssignedPermission>;
  replaceUpdateRoleName: Maybe<AssignedPermission>;
  replaceUseFilters: Maybe<AssignedPermission>;
  replaceViewDashboards: Maybe<AssignedPermission>;
  replaceViewMetrics: Maybe<AssignedPermission>;
  replaceViewPermissions: Maybe<AssignedPermission>;
  replaceViewReports: Maybe<AssignedPermission>;
  replaceViewRoleScope: Maybe<AssignedPermission>;
  replaceViewRoles: Maybe<AssignedPermission>;
  replaceWriteClientFile: Maybe<AssignedPermission>;
  /** Updates the role preferences for the specified role to the specified settings by creating a new version which will become the active version. If the there are no changes in the settings compared to the previous version, no new version will be created and the current version will be returned. */
  restorePreviousDomainPreferences: Maybe<DomainPreferencesVersion>;
  /** This deletes all settings for the specified domain and will make the domain permanently unavailable/inaccessible. It does not delete the domains data or other configuration. */
  restorePreviousDomainSettings: Maybe<DomainSettingsVersion>;
  restorePreviousPanaDashboard: Maybe<SavedPanaDashboardVersion>;
  restorePreviousRolePreferences: Maybe<RolePreferencesVersion>;
  revokeAssignedPermission: Maybe<Scalars['ID']['output']>;
  /** Sends a password-reset mail to the specified existing receiver. Email-filters apply, e.g. QA is configured to only send emails to *@panalyt.com and other selected email addresses. Talk to the backend team to add your address for testing if needed */
  sendPasswordResetMail: Maybe<Scalars['Unit']['output']>;
  /** Sends a welcome mail with a link to the panalyt-app (to reset their password) to the specified already existing receiver. Email-filters apply, e.g. QA is configured to only send emails to *@panalyt.com and other selected email addresses. Talk to the backend team to add your address for testing if needed */
  sendWelcomeWithPasswordMail: Maybe<Scalars['Unit']['output']>;
  /** Sends a welcome mail with a link to the panalyt-app for SSO login to the specified receiver. Email-filters apply, e.g. QA is configured to only send emails to *@panalyt.com and other selected email addresses. Talk to the backend team to add your address for testing if needed */
  sendWelcomeWithSsoMail: Maybe<Scalars['Unit']['output']>;
  /** Creates a new alias if the domain/key doesn't exist, otherwise updates the existing alias */
  setAlias: Maybe<Scalars['Unit']['output']>;
  startConversation: Maybe<ChappiConversationAndFirstResponse>;
  updateDashboard: Maybe<Scalars['Unit']['output']>;
  updatePanaDashboard: Maybe<SavedPanaDashboardVersion>;
};


export type MutationsAddCommonRolesArgs = {
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsAddCrextaDomainArgs = {
  adminEmail: Scalars['String']['input'];
  domain: Scalars['Domain']['input'];
  domainPreferences: Scalars['Json']['input'];
  domainSettings: Scalars['Json']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsAddFirebaseUserForExistingAppUserArgs = {
  email: Scalars['String']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsAddRoleArgs = {
  description: InputMaybe<Scalars['String']['input']>;
  domain: InputMaybe<Scalars['Domain']['input']>;
  name: Scalars['String']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsAddUserAndDefaultRoleArgs = {
  addDefaultLoginPermission?: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
  roleDomain: InputMaybe<Scalars['Domain']['input']>;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsAskChappiArgs = {
  conversationId: Scalars['ID']['input'];
  prompt: Scalars['String']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsChangeRoleDescriptionArgs = {
  id: Scalars['ID']['input'];
  newDescription: InputMaybe<Scalars['String']['input']>;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsChangeRoleDomainArgs = {
  id: Scalars['ID']['input'];
  newDomain: InputMaybe<Scalars['Domain']['input']>;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsChangeRoleNameArgs = {
  id: Scalars['ID']['input'];
  newName: Scalars['String']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsClearAllCachesArgs = {
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsClearAndPreloadCacheForDomainArgs = {
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsClearCacheArgs = {
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsClearCacheForDomainArgs = {
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsCreateBucketWithDefaultStructureArgs = {
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsCreateDashboardArgs = {
  dashboard: DashboardDefinitionInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsCreateNewDomainPreferencesArgs = {
  domain: Scalars['Domain']['input'];
  preferences: Scalars['Json']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsCreateNewDomainSettingsArgs = {
  domain: Scalars['Domain']['input'];
  settings: Scalars['Json']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsCreateNewPanaDashboardArgs = {
  db: PlainPanaDashboardInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsCreateNewRolePreferencesArgs = {
  preferences: Scalars['Json']['input'];
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsDeleteAliasArgs = {
  aliasKey: Scalars['String']['input'];
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsDeleteAllDomainSettingsForDomainArgs = {
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsDeleteDashboardArgs = {
  dashboardId: Scalars['Dashboard']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsDeleteRoleAndPermissionsArgs = {
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsDeleteUploadedFileArgs = {
  domain: Scalars['Domain']['input'];
  path: Scalars['String']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsDeleteUserAndDefaultRoleArgs = {
  email: Scalars['String']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsGrantAssumeRoleArgs = {
  permission: AssumeRoleInput;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsGrantCreateReportsArgs = {
  permission: CreateReportsInput;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsGrantCreateRoleArgs = {
  permission: CreateRoleInput;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsGrantDeleteClientFileArgs = {
  permission: DeleteClientFileInput;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsGrantDeleteRoleArgs = {
  permission: DeleteRoleInput;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsGrantDownloadClientFileArgs = {
  permission: DownloadClientFileInput;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsGrantEditRoleScopeArgs = {
  permission: EditRoleScopeInput;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsGrantExportReportsArgs = {
  permission: ExportReportsInput;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsGrantGrantPermissionsArgs = {
  domain: InputMaybe<Scalars['Domain']['input']>;
  excludedRoles: Array<Scalars['ID']['input']>;
  permissions: InputMaybe<GrantPermissionsSpecificPermissionsInput>;
  roleId: Scalars['ID']['input'];
  roles: InputMaybe<Array<Scalars['ID']['input']>>;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsGrantLoginArgs = {
  permission: LoginInput;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsGrantManageCompanyArgs = {
  permission: ManageCompanyInput;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsGrantManageDomainArgs = {
  permission: ManageDomainInput;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsGrantManageUsersArgs = {
  permission: ManageUsersInput;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsGrantReadClientFileArgs = {
  permission: ReadClientFileInput;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsGrantReadDataArgs = {
  permission: ReadDataInput;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsGrantRequestPasswordChangeArgs = {
  permission: RequestPasswordChangeInput;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsGrantRevokePermissionsArgs = {
  permission: RevokePermissionsInput;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsGrantUpdatePasswordArgs = {
  permission: UpdatePasswordInput;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsGrantUpdateRoleNameArgs = {
  permission: UpdateRoleNameInput;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsGrantUseFiltersArgs = {
  permission: UseFiltersInput;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsGrantViewDashboardsArgs = {
  permission: ViewDashboardsInput;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsGrantViewMetricsArgs = {
  permission: ViewMetricsInput;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsGrantViewPermissionsArgs = {
  permission: ViewPermissionsInput;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsGrantViewReportsArgs = {
  permission: ViewReportsInput;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsGrantViewRoleScopeArgs = {
  permission: ViewRoleScopeInput;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsGrantViewRolesArgs = {
  permission: ViewRolesInput;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsGrantWriteClientFileArgs = {
  permission: WriteClientFileInput;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsPatchDomainPreferencesArgs = {
  domain: Scalars['Domain']['input'];
  patch: Scalars['Json']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsPatchDomainSettingsArgs = {
  domain: Scalars['Domain']['input'];
  patch: Scalars['Json']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsPatchRolePreferencesArgs = {
  patch: Scalars['Json']['input'];
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsRealignCommonRolesArgs = {
  domain: Scalars['Domain']['input'];
  dryrun: Scalars['Boolean']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsReplaceAssumeRoleArgs = {
  id: Scalars['ID']['input'];
  permission: AssumeRoleInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsReplaceCreateReportsArgs = {
  id: Scalars['ID']['input'];
  permission: CreateReportsInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsReplaceCreateRoleArgs = {
  id: Scalars['ID']['input'];
  permission: CreateRoleInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsReplaceDeleteClientFileArgs = {
  id: Scalars['ID']['input'];
  permission: DeleteClientFileInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsReplaceDeleteRoleArgs = {
  id: Scalars['ID']['input'];
  permission: DeleteRoleInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsReplaceDownloadClientFileArgs = {
  id: Scalars['ID']['input'];
  permission: DownloadClientFileInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsReplaceEditRoleScopeArgs = {
  id: Scalars['ID']['input'];
  permission: EditRoleScopeInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsReplaceExportReportsArgs = {
  id: Scalars['ID']['input'];
  permission: ExportReportsInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsReplaceGrantPermissionsArgs = {
  domain: InputMaybe<Scalars['Domain']['input']>;
  excludedRoles: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  permissions: InputMaybe<GrantPermissionsSpecificPermissionsInput>;
  roles: InputMaybe<Array<Scalars['ID']['input']>>;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsReplaceLoginArgs = {
  id: Scalars['ID']['input'];
  permission: LoginInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsReplaceManageCompanyArgs = {
  id: Scalars['ID']['input'];
  permission: ManageCompanyInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsReplaceManageDomainArgs = {
  id: Scalars['ID']['input'];
  permission: ManageDomainInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsReplaceManageUsersArgs = {
  id: Scalars['ID']['input'];
  permission: ManageUsersInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsReplaceReadClientFileArgs = {
  id: Scalars['ID']['input'];
  permission: ReadClientFileInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsReplaceReadDataArgs = {
  id: Scalars['ID']['input'];
  permission: ReadDataInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsReplaceRequestPasswordChangeArgs = {
  id: Scalars['ID']['input'];
  permission: RequestPasswordChangeInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsReplaceRevokePermissionsArgs = {
  id: Scalars['ID']['input'];
  permission: RevokePermissionsInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsReplaceUpdatePasswordArgs = {
  id: Scalars['ID']['input'];
  permission: UpdatePasswordInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsReplaceUpdateRoleNameArgs = {
  id: Scalars['ID']['input'];
  permission: UpdateRoleNameInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsReplaceUseFiltersArgs = {
  id: Scalars['ID']['input'];
  permission: UseFiltersInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsReplaceViewDashboardsArgs = {
  id: Scalars['ID']['input'];
  permission: ViewDashboardsInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsReplaceViewMetricsArgs = {
  id: Scalars['ID']['input'];
  permission: ViewMetricsInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsReplaceViewPermissionsArgs = {
  id: Scalars['ID']['input'];
  permission: ViewPermissionsInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsReplaceViewReportsArgs = {
  id: Scalars['ID']['input'];
  permission: ViewReportsInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsReplaceViewRoleScopeArgs = {
  id: Scalars['ID']['input'];
  permission: ViewRoleScopeInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsReplaceViewRolesArgs = {
  id: Scalars['ID']['input'];
  permission: ViewRolesInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsReplaceWriteClientFileArgs = {
  id: Scalars['ID']['input'];
  permission: WriteClientFileInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsRestorePreviousDomainPreferencesArgs = {
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsRestorePreviousDomainSettingsArgs = {
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsRestorePreviousPanaDashboardArgs = {
  dashboardId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsRestorePreviousRolePreferencesArgs = {
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsRevokeAssignedPermissionArgs = {
  id: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsSendPasswordResetMailArgs = {
  receiver: Scalars['String']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsSendWelcomeWithPasswordMailArgs = {
  receiver: Scalars['String']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsSendWelcomeWithSsoMailArgs = {
  receiver: Scalars['String']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsSetAliasArgs = {
  alias: AliasInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsStartConversationArgs = {
  domain: Scalars['Domain']['input'];
  firstQuestion: Scalars['String']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsUpdateDashboardArgs = {
  dashboard: DashboardDefinitionInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsUpdatePanaDashboardArgs = {
  dashboardId: Scalars['ID']['input'];
  db: PlainPanaDashboardInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
  versionToUpdate: Scalars['Long']['input'];
};

/** Note that this setting is additive with lineHierarchyRestrictions */
export type OrganizationRestrictions = {
  __typename?: 'OrganizationRestrictions';
  /** If true, the user can only see employees in their own organization and any suborganizations of it. If false, no restrictions are applied (which means the user can see less than before if other additive restrictions are applying). */
  userSpecific: Scalars['Boolean']['output'];
};

/** Note that this setting is additive with lineHierarchyRestrictions */
export type OrganizationRestrictionsInput = {
  /** If true, the user can only see employees in their own organization and any suborganizations of it. If false, no restrictions are applied (which means the user can see less than before if other additive restrictions are applying). */
  userSpecific: Scalars['Boolean']['input'];
};

export type PageDefinition = {
  __typename?: 'PageDefinition';
  description: Scalars['String']['output'];
  descriptionKey: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  imagePath: Scalars['String']['output'];
  link: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nameKey: Scalars['String']['output'];
  pageId: Scalars['Page']['output'];
  pageNumber: Scalars['Int']['output'];
};

export type PageDefinitionInput = {
  description: Scalars['String']['input'];
  descriptionKey: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  imagePath: Scalars['String']['input'];
  link: Scalars['String']['input'];
  name: Scalars['String']['input'];
  nameKey: Scalars['String']['input'];
  pageId: Scalars['Page']['input'];
  pageNumber: Scalars['Int']['input'];
};

export type PanaDashboardLifecycleStage = PanaDashboardLifecycleStageActive | PanaDashboardLifecycleStageDeprecated | PanaDashboardLifecycleStageDisabled | PanaDashboardLifecycleStageDraft;

export type PanaDashboardLifecycleStageActive = {
  __typename?: 'PanaDashboardLifecycleStageActive';
  active: Scalars['Unit']['output'];
};

export type PanaDashboardLifecycleStageDeprecated = {
  __typename?: 'PanaDashboardLifecycleStageDeprecated';
  deprecated: Scalars['Unit']['output'];
};

export type PanaDashboardLifecycleStageDisabled = {
  __typename?: 'PanaDashboardLifecycleStageDisabled';
  disabled: Scalars['Unit']['output'];
};

export type PanaDashboardLifecycleStageDraft = {
  __typename?: 'PanaDashboardLifecycleStageDraft';
  draft: Scalars['Unit']['output'];
};

export type PanaDashboardLifecycleStageInput = {
  active: InputMaybe<Scalars['Unit']['input']>;
  deprecated: InputMaybe<Scalars['Unit']['input']>;
  disabled: InputMaybe<Scalars['Unit']['input']>;
  draft: InputMaybe<Scalars['Unit']['input']>;
};

export type PanaDashboardVersion = {
  __typename?: 'PanaDashboardVersion';
  createdAt: Scalars['Instant']['output'];
  creator: Maybe<Scalars['String']['output']>;
  db: PlainPanaDashboard;
  version: Scalars['Long']['output'];
};

export type Permission = AssumeRole | CreateReports | CreateRole | DeleteClientFile | DeleteRole | DownloadClientFile | EditRoleScope | ExportReports | GrantPermissions | Login | ManageCompany | ManageDomain | ManageUsers | ReadClientFile | ReadData | RequestPasswordChange | RevokePermissions | UpdatePassword | UpdateRoleName | UseFilters | ViewDashboards | ViewMetrics | ViewPermissions | ViewReports | ViewRoleScope | ViewRoles | WriteClientFile;

/** A permissions template is a way of defining a subset of permissions that are allowed to be created / granted to a role */
export type PermissionTemplate = AssumeRoleTemplate;

export type PlainPanaDashboard = {
  __typename?: 'PlainPanaDashboard';
  configuration: Scalars['Json']['output'];
  createdAt: Scalars['Instant']['output'];
  creator: Scalars['String']['output'];
  domainScope: Maybe<Scalars['Domain']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  lifecycleStage: PanaDashboardLifecycleStage;
  owner: Scalars['ID']['output'];
};

export type PlainPanaDashboardInput = {
  configuration: Scalars['Json']['input'];
  createdAt: Scalars['Instant']['input'];
  creator: Scalars['String']['input'];
  domainScope: InputMaybe<Scalars['Domain']['input']>;
  isDeleted: Scalars['Boolean']['input'];
  lifecycleStage: PanaDashboardLifecycleStageInput;
  owner: Scalars['ID']['input'];
};

export type ProcessingEvent = {
  __typename?: 'ProcessingEvent';
  /** Identifier of the data pipeline dag that processed this object */
  dagId: Scalars['String']['output'];
  processedTime: Scalars['Instant']['output'];
};

/** Describes the quarter of a specific year */
export type Quarter = {
  __typename?: 'Quarter';
  /** The quarter of the year: 1, 2, 3 or 4 */
  quarterOfYear: Scalars['Int']['output'];
  /** The year, e.g. 2023 */
  year: Scalars['Int']['output'];
};

/** Describes the quarter of a specific year */
export type QuarterInput = {
  /** The quarter of the year: 1, 2, 3 or 4 */
  quarterOfYear: Scalars['Int']['input'];
  /** The year, e.g. 2023 */
  year: Scalars['Int']['input'];
};

export type Queries = {
  __typename?: 'Queries';
  /** @deprecated Use listAllPermissionsForRole instead */
  allPermissions: Maybe<Array<AssignedPermission>>;
  /** Returns all available data versions for each data type in the domain. Note: ordering is not guaranteed and version IDs can be missing (there may be holes in the sequence). */
  availableDataVersions: Maybe<Array<AvailableDataVersionsForDataType>>;
  /** @deprecated Use availableDataVersions instead */
  availableTimeranges: Maybe<Array<AvailableTimerangesInterpolatedForDataType>>;
  /** @deprecated Use the same one from Mutations instead of Queries */
  createBucketWithDefaultStructure: Maybe<Scalars['Unit']['output']>;
  currentUser: Maybe<User>;
  currentUserAllPermissions: Maybe<Array<AssignedPermission>>;
  currentUserListRoles: Maybe<Array<Role>>;
  currentUserUserInfo: Maybe<UserInfo>;
  currentUserUserRole: Maybe<Role>;
  dashboard: Maybe<DashboardDefinition>;
  /** @deprecated Use the same one from Mutations instead of Queries */
  deleteUploadedFile: Maybe<Scalars['Unit']['output']>;
  directPermissions: Maybe<Array<AssignedPermission>>;
  directPermissionsForRoles: Maybe<Array<AssignedPermissionsForRole>>;
  domainInfo: Maybe<DomainInfo>;
  domainPreferencesAllVersions: Maybe<Array<DomainPreferencesVersion>>;
  domainPreferencesLatestVersion: Maybe<DomainPreferencesVersion>;
  domainPreferencesVersion: Maybe<DomainPreferencesVersion>;
  domainSettingsAllVersions: Maybe<Array<DomainSettingsVersion>>;
  domainSettingsLatestVersion: Maybe<DomainSettingsVersion>;
  domainSettingsVersion: Maybe<DomainSettingsVersion>;
  executeAdvancedQuery: Maybe<Scalars['String']['output']>;
  /** Run a query with limited functionality but custom fields, filters and so on. Confidentiality settings and permissions apply */
  executeCustomSqlQuery: Maybe<SqlQueryResponse>;
  executeMovementQuery: Maybe<Scalars['String']['output']>;
  /** @deprecated Please use executeAdvancedQuery instead */
  executeOldQuery: Maybe<Scalars['String']['output']>;
  /** Run a query that has been whitelisted by the backend. If the query does not match the expected format and content, it will be rejected */
  executeWhitelistedSqlQuery: Maybe<SqlQueryResponse>;
  generateSignedUrl: Maybe<Scalars['String']['output']>;
  getConversation: Maybe<ChappiConversation>;
  /** Returns the latest versionid of the selected domain & datatype. Format is: yyyy-MM-dd */
  latestVersion: Maybe<Scalars['String']['output']>;
  listAliases: Maybe<Array<Alias>>;
  listAllAllowedDomains: Maybe<Array<Scalars['String']['output']>>;
  listAllDashboards: Maybe<Array<DashboardDefinition>>;
  listAllMetricCategories: Maybe<Array<MetricCategory>>;
  listAllMetricDefs: Maybe<Array<MetricDef>>;
  listAllMetricFormatTypes: Maybe<Array<MetricFormatType>>;
  listAllMetricGroups: Maybe<Array<MetricGroup>>;
  /** Lists all permissions in the system */
  listAllPermissions: Maybe<Array<AssignedPermission>>;
  /** Lists all permissions that a role has, both directly and through assuming other roles */
  listAllPermissionsForRole: Maybe<Array<AssignedPermission>>;
  /** Lists all roles that exist, filterable by a specific domain */
  listAllRoles: Maybe<Array<Role>>;
  /** Returns the list of all fields for a specific datatype */
  listAvailableFields: Maybe<Array<Scalars['Datafield']['output']>>;
  listChangelogEventInfos: Maybe<Array<ChangelogEventInfo>>;
  listConversations: Maybe<Array<ChappiConversation>>;
  /** Lists all executor roles (i.e. roles with a dedicated ReadData-permission) that this role can use */
  listExecutorRolesForRole: Maybe<Array<Role>>;
  /** Lists all the roles (accessible to this role) that are not user-roles, i.e. only the ones that are not directly associated with a single user and only used by this user */
  listNonUserRoles: Maybe<Array<Role>>;
  /** Lists all roles that a user can directly and indirectly assume/use */
  listRoles: Maybe<Array<Role>>;
  /** Lists uploaded client objects with their processing history for a domain. Basically replaces listUploadedFiles */
  listUploadedClientObjects: Maybe<ListUploadedClientObjectsResult>;
  listUploadedFiles: Maybe<Array<Scalars['String']['output']>>;
  listUsedCohorts: Maybe<Array<CohortTypeEntries>>;
  listUsedFields: Maybe<Array<Scalars['Datafield']['output']>>;
  /** Lists all the roles (accessible to this role) that are user-roles, i.e. only the ones that are directly associated with a single user and only used by this user. */
  listUserRoles: Maybe<Array<Role>>;
  metaDataByUserEmail: Maybe<Array<MetaData>>;
  /** Returns the metadata for the user that belongs to the specified user-role */
  metaDataByUserRole: Maybe<Array<MetaDataForRole>>;
  /** A helper utility to list the tree of metrics/groups/categories for PBS */
  metricTree: Maybe<MetricTree>;
  panaDashboardAllVersions: Maybe<Array<PanaDashboardVersion>>;
  panaDashboardLatestVersion: Maybe<PanaDashboardVersion>;
  panaDashboardVersion: Maybe<PanaDashboardVersion>;
  panaDashboardsLatestVersions: Maybe<Array<SavedPanaDashboardVersion>>;
  queryCohortMetrics: Maybe<MetricResults>;
  queryEmployeeCohortMetrics: Maybe<MetricResults>;
  queryMetrics: Maybe<MetricResults>;
  rolePreferencesLatestVersion: Maybe<RolePreferencesVersion>;
  rolePreferencesVersion: Maybe<RolePreferencesVersion>;
  /** @deprecated Test query for debugging that can't be done locally */
  testQuery: Maybe<Scalars['String']['output']>;
  userRoleForRoleId: Maybe<Role>;
  userRoleForUser: Maybe<Role>;
};


export type QueriesAllPermissionsArgs = {
  cacheBehaviour?: CacheBehaviour;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
  subsetOnly?: Scalars['Boolean']['input'];
};


export type QueriesAvailableDataVersionsArgs = {
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesAvailableTimerangesArgs = {
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesCreateBucketWithDefaultStructureArgs = {
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesCurrentUserArgs = {
  cacheBehaviour?: CacheBehaviour;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesCurrentUserAllPermissionsArgs = {
  cacheBehaviour?: CacheBehaviour;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
  subsetOnly?: Scalars['Boolean']['input'];
};


export type QueriesCurrentUserListRolesArgs = {
  cacheBehaviour?: CacheBehaviour;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesCurrentUserUserInfoArgs = {
  cacheBehaviour?: CacheBehaviour;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesCurrentUserUserRoleArgs = {
  cacheBehaviour?: CacheBehaviour;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesDashboardArgs = {
  cacheBehaviour?: CacheBehaviour;
  dashboardId: Scalars['Dashboard']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesDeleteUploadedFileArgs = {
  domain: Scalars['Domain']['input'];
  path: Scalars['String']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesDirectPermissionsArgs = {
  cacheBehaviour?: CacheBehaviour;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesDirectPermissionsForRolesArgs = {
  cacheBehaviour?: CacheBehaviour;
  roleIds: Array<Scalars['ID']['input']>;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesDomainInfoArgs = {
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
  topLevelKeyFilter: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueriesDomainPreferencesAllVersionsArgs = {
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
  topLevelKeyFilter: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueriesDomainPreferencesLatestVersionArgs = {
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
  topLevelKeyFilter: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueriesDomainPreferencesVersionArgs = {
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
  topLevelKeyFilter: InputMaybe<Array<Scalars['String']['input']>>;
  version: Scalars['Long']['input'];
};


export type QueriesDomainSettingsAllVersionsArgs = {
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
  topLevelKeyFilter: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueriesDomainSettingsLatestVersionArgs = {
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
  topLevelKeyFilter: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueriesDomainSettingsVersionArgs = {
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
  topLevelKeyFilter: InputMaybe<Array<Scalars['String']['input']>>;
  version: Scalars['Long']['input'];
};


export type QueriesExecuteAdvancedQueryArgs = {
  disableNestLoop: InputMaybe<Scalars['Boolean']['input']>;
  domain: Scalars['Domain']['input'];
  queryJson: Scalars['String']['input'];
  selectedExecutorRole: InputMaybe<Scalars['ID']['input']>;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesExecuteCustomSqlQueryArgs = {
  disableNestLoop: InputMaybe<Scalars['Boolean']['input']>;
  domain: Scalars['Domain']['input'];
  querySql: Scalars['String']['input'];
  selectedExecutorRole: InputMaybe<Scalars['ID']['input']>;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesExecuteMovementQueryArgs = {
  disableNestLoop: InputMaybe<Scalars['Boolean']['input']>;
  domain: Scalars['Domain']['input'];
  queryJson: Scalars['String']['input'];
  selectedExecutorRole: InputMaybe<Scalars['ID']['input']>;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesExecuteOldQueryArgs = {
  disableNestLoop: InputMaybe<Scalars['Boolean']['input']>;
  domain: Scalars['Domain']['input'];
  queryJson: Scalars['String']['input'];
  selectedExecutorRole: InputMaybe<Scalars['ID']['input']>;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesExecuteWhitelistedSqlQueryArgs = {
  domain: Scalars['Domain']['input'];
  querySql: Scalars['String']['input'];
  selectedExecutorRole: InputMaybe<Scalars['ID']['input']>;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesGenerateSignedUrlArgs = {
  domain: Scalars['Domain']['input'];
  objectName: Scalars['String']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesGetConversationArgs = {
  id: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesLatestVersionArgs = {
  datatype: ApiMasterDataType;
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesListAliasesArgs = {
  cacheBehaviour?: CacheBehaviour;
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesListAllAllowedDomainsArgs = {
  cacheBehaviour?: CacheBehaviour;
  partnerDomainFilter: InputMaybe<Scalars['String']['input']>;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesListAllDashboardsArgs = {
  cacheBehaviour?: CacheBehaviour;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesListAllMetricCategoriesArgs = {
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesListAllMetricDefsArgs = {
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesListAllMetricFormatTypesArgs = {
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesListAllMetricGroupsArgs = {
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesListAllPermissionsArgs = {
  cacheBehaviour?: CacheBehaviour;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesListAllPermissionsForRoleArgs = {
  cacheBehaviour?: CacheBehaviour;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
  subsetOnly?: Scalars['Boolean']['input'];
};


export type QueriesListAllRolesArgs = {
  cacheBehaviour?: CacheBehaviour;
  domainFilter: InputMaybe<Scalars['String']['input']>;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesListAvailableFieldsArgs = {
  datatype: ApiMasterDataType;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesListChangelogEventInfosArgs = {
  domainFilter: InputMaybe<Scalars['Domain']['input']>;
  from: Scalars['Instant']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
  to: Scalars['Instant']['input'];
};


export type QueriesListConversationsArgs = {
  conversationId: InputMaybe<Scalars['ID']['input']>;
  createdAfter: InputMaybe<Scalars['Instant']['input']>;
  createdBefore: InputMaybe<Scalars['Instant']['input']>;
  domainFilter: InputMaybe<Scalars['Domain']['input']>;
  initiatingRoleId: InputMaybe<Scalars['ID']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
  sortCriteria?: Array<SortCriteriaInput>;
};


export type QueriesListExecutorRolesForRoleArgs = {
  cacheBehaviour?: CacheBehaviour;
  domainFilter: InputMaybe<Scalars['String']['input']>;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesListNonUserRolesArgs = {
  cacheBehaviour?: CacheBehaviour;
  domain: InputMaybe<Array<Scalars['String']['input']>>;
  domainUnrestrictedOnly?: Scalars['Boolean']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesListRolesArgs = {
  cacheBehaviour?: CacheBehaviour;
  email: Scalars['String']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesListUploadedClientObjectsArgs = {
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesListUploadedFilesArgs = {
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesListUsedCohortsArgs = {
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesListUsedFieldsArgs = {
  datatype: ApiMasterDataType;
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
  versionIdDate: InputMaybe<Scalars['LocalDate']['input']>;
};


export type QueriesListUserRolesArgs = {
  cacheBehaviour?: CacheBehaviour;
  domainFilter: InputMaybe<Array<Scalars['String']['input']>>;
  domainUnrestrictedOnly?: Scalars['Boolean']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesMetaDataByUserEmailArgs = {
  emails: Array<Scalars['String']['input']>;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesMetaDataByUserRoleArgs = {
  roleIds: Array<Scalars['ID']['input']>;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesMetricTreeArgs = {
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesPanaDashboardAllVersionsArgs = {
  panaDashboardId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesPanaDashboardLatestVersionArgs = {
  panaDashboardId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesPanaDashboardVersionArgs = {
  panaDashboardId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
  version: Scalars['Long']['input'];
};


export type QueriesPanaDashboardsLatestVersionsArgs = {
  domainScopeFilter: DomainScopeFilterInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesQueryCohortMetricsArgs = {
  disableNestLoop: InputMaybe<Scalars['Boolean']['input']>;
  domain: Scalars['Domain']['input'];
  grouping: InputMaybe<GroupingInput>;
  metrics: Array<CohortMetricId>;
  selectedExecutorRole: InputMaybe<Scalars['ID']['input']>;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
  timeSelection: TimeSelectionInput;
  userCohortFilters: InputMaybe<Scalars['String']['input']>;
};


export type QueriesQueryEmployeeCohortMetricsArgs = {
  disableNestLoop: InputMaybe<Scalars['Boolean']['input']>;
  domain: Scalars['Domain']['input'];
  grouping: InputMaybe<GroupingInput>;
  metrics: Array<EmployeeCohortMetricId>;
  selectedExecutorRole: InputMaybe<Scalars['ID']['input']>;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
  timeSelection: TimeSelectionInput;
  userCohortFilters: InputMaybe<Scalars['String']['input']>;
  userFilters: InputMaybe<Scalars['String']['input']>;
};


export type QueriesQueryMetricsArgs = {
  disableNestLoop: InputMaybe<Scalars['Boolean']['input']>;
  domain: Scalars['Domain']['input'];
  grouping: InputMaybe<GroupingInput>;
  metrics: Array<RegularMetricId>;
  selectedExecutorRole: InputMaybe<Scalars['ID']['input']>;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
  timeSelection: TimeSelectionInput;
  userFilters: InputMaybe<Scalars['String']['input']>;
};


export type QueriesRolePreferencesLatestVersionArgs = {
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
  topLevelKeyFilter: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueriesRolePreferencesVersionArgs = {
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
  topLevelKeyFilter: InputMaybe<Array<Scalars['String']['input']>>;
  version: Scalars['Long']['input'];
};


export type QueriesTestQueryArgs = {
  simulateRole: InputMaybe<Scalars['ID']['input']>;
  testRun: InputMaybe<Scalars['String']['input']>;
};


export type QueriesUserRoleForRoleIdArgs = {
  cacheBehaviour?: CacheBehaviour;
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};


export type QueriesUserRoleForUserArgs = {
  cacheBehaviour?: CacheBehaviour;
  email: Scalars['String']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
};

export type QuestionMessage = {
  __typename?: 'QuestionMessage';
  debugString: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type ReadClientFile = {
  __typename?: 'ReadClientFile';
  domain: Maybe<Scalars['Domain']['output']>;
};

export type ReadClientFileInput = {
  domain: InputMaybe<Scalars['Domain']['input']>;
};

export type ReadData = {
  __typename?: 'ReadData';
  /** Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! Note that the list must not contain the same datatype more than once */
  access: Maybe<Array<DatatypeAccess>>;
  /** Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! */
  domain: Maybe<Scalars['Domain']['output']>;
  /** Note that this field is additive with organizationRestrictions */
  lineHierarchyRestrictions: LineHierarchyRestrictions;
  /** Note that this field is additive with lineHierarchyRestrictions. Also note that this field is nullable only due to technical reasons. It should never be null in reality and the type should be fixed eventually. */
  organizationRestrictions: Maybe<OrganizationRestrictions>;
  /** Must contain SQL to filter the population */
  popFilter: Maybe<Scalars['String']['output']>;
  restrictionsPopulationTarget: RestrictionsPopulationTarget;
};

export type ReadDataInput = {
  /** Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! Note that the list must not contain the same datatype more than once */
  access: InputMaybe<Array<DatatypeAccessInput>>;
  /** Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! */
  domain: InputMaybe<Scalars['Domain']['input']>;
  /** Note that this field is additive with organizationRestrictions */
  lineHierarchyRestrictions: LineHierarchyRestrictionsInput;
  /** Note that this field is additive with lineHierarchyRestrictions. Also note that this field is nullable only due to technical reasons. It should never be null in reality and the type should be fixed eventually. */
  organizationRestrictions: InputMaybe<OrganizationRestrictionsInput>;
  /** Must contain SQL to filter the population */
  popFilter: InputMaybe<Scalars['String']['input']>;
  restrictionsPopulationTarget: RestrictionsPopulationTarget;
};

export type RealignCommonRolesResult = {
  __typename?: 'RealignCommonRolesResult';
  addedPermissions: Array<AssignedPermission>;
  deletedPermissions: Array<AssignedPermission>;
};

export enum RegularMetricId {
  Pm0001_1IndividualsCount = 'PM0001_1_Individuals_count',
  Pm0003_1FtEquivTotal = 'PM0003_1_FTEquiv_total',
  Pm0006_1JoinersJoiners = 'PM0006_1_Joiners_joiners',
  Pm0006_2JoinersPercHc = 'PM0006_2_Joiners_percHC',
  Pm0007_1LeaversTermDateLeavers = 'PM0007_1_LeaversTermDate_leavers',
  Pm0007_2LeaversTermDatePercHc = 'PM0007_2_LeaversTermDate_PercHC',
  Pm0010_1MngCalcCount = 'PM0010_1_MngCalc_Count',
  Pm0010_2MngCalcPercHc = 'PM0010_2_MngCalc_PercHC',
  Pm0011_1NewMngCalcCount = 'PM0011_1_NewMngCalc_Count',
  Pm0011_2NewMngCalcPercMng = 'PM0011_2_NewMngCalc_PercMng',
  Pm0011_3NewMngCalcPercHc = 'PM0011_3_NewMngCalc_PercHC',
  Pm0012_1FMngCalcCount = 'PM0012_1_FMngCalc_Count',
  Pm0012_2FMngCalcPercHc = 'PM0012_2_FMngCalc_PercHC',
  Pm0012_3FMngCalcPercMng = 'PM0012_3_FMngCalc_PercMng',
  Pm0014_1MngDefCount = 'PM0014_1_MngDef_Count',
  Pm0014_2MngDefPercHc = 'PM0014_2_MngDef_PercHC',
  Pm0015_1NewMngDefCount = 'PM0015_1_NewMngDef_Count',
  Pm0015_2NewMngDefPercMng = 'PM0015_2_NewMngDef_PercMng',
  Pm0015_3NewMngDefPercHc = 'PM0015_3_NewMngDef_PercHC',
  Pm0016_1FMngDefCount = 'PM0016_1_FMngDef_Count',
  Pm0016_2FMngDefPercHc = 'PM0016_2_FMngDef_PercHC',
  Pm0016_3FMngDefPercMng = 'PM0016_3_FMngDef_PercMng',
  Pm0019_1AgeMedian = 'PM0019_1_Age_Median',
  Pm0019_2AgeAvg = 'PM0019_2_Age_Avg',
  Pm0019_3AgeMax = 'PM0019_3_Age_Max',
  Pm0019_4AgeMin = 'PM0019_4_Age_Min',
  Pm0020_1FhcCount = 'PM0020_1_FHC_Count',
  Pm0020_2FhcPercHc = 'PM0020_2_FHC_PercHC',
  Pm0023_1TenureMedian = 'PM0023_1_Tenure_Median',
  Pm0023_2TenureAvg = 'PM0023_2_Tenure_Avg',
  Pm0023_3TenureMax = 'PM0023_3_Tenure_Max',
  Pm0023_4TenureMin = 'PM0023_4_Tenure_Min',
  Pm0024_1SpanControlMedian = 'PM0024_1_SpanControl_Median',
  Pm0024_2SpanControlAvg = 'PM0024_2_SpanControl_Avg',
  Pm0024_3SpanControlMax = 'PM0024_3_SpanControl_Max',
  Pm0024_4SpanControlMin = 'PM0024_4_SpanControl_Min',
  Pm0025_1DepthControlMax = 'PM0025_1_DepthControl_Max',
  Pm0026_1PopPayGapMultiple = 'PM0026_1_PopPayGap_multiple',
  Pm0028_1CeoPayGapBaseAvgPerc = 'PM0028_1_CEOPayGapBaseAvg_Perc',
  Pm0028_2CeoPayGapBaseAvgMultiple = 'PM0028_2_CEOPayGapBaseAvg_Multiple',
  Pm0033_1InternalMobilityOrgLevel1NumMove = 'PM0033_1_InternalMobilityOrgLevel1_NumMove',
  Pm0033_2InternalMobilityOrgLevel1NumIndvWMove = 'PM0033_2_InternalMobilityOrgLevel1_NumIndvWMove',
  Pm0033_3InternalMobilityOrgLevel1PercHc = 'PM0033_3_InternalMobilityOrgLevel1_PercHC',
  Pm0034_1InternalMobilityOrgLevel2NumMove = 'PM0034_1_InternalMobilityOrgLevel2_NumMove',
  Pm0034_2InternalMobilityOrgLevel2NumIndvWMove = 'PM0034_2_InternalMobilityOrgLevel2_NumIndvWMove',
  Pm0034_3InternalMobilityOrgLevel2PercHc = 'PM0034_3_InternalMobilityOrgLevel2_PercHC',
  Pm0037_1RevenueHcMonthlyPerFte = 'PM0037_1_RevenueHCMonthly_PerFTE',
  Pm0037_2RevenueHcMonthlyPerIndiv = 'PM0037_2_RevenueHCMonthly_PerIndiv',
  Pm0044_1GrossProfitHcMonthlyPerFte = 'PM0044_1_GrossProfitHCMonthly_PerFTE',
  Pm0044_2GrossProfitHcMonthlyPerIndiv = 'PM0044_2_GrossProfitHCMonthly_PerIndiv',
  Pm0047_1SgahcMonthlyPerFte = 'PM0047_1_SGAHCMonthly_PerFTE',
  Pm0047_2SgahcMonthlyPerIndiv = 'PM0047_2_SGAHCMonthly_PerIndiv',
  Pm0050_1OperatingProfitHcMonthlyPerFte = 'PM0050_1_OperatingProfitHCMonthly_PerFTE',
  Pm0050_2OperatingProfitHcMonthlyPerIndiv = 'PM0050_2_OperatingProfitHCMonthly_PerIndiv',
  Pm0051_1TrainingCostMonthlyPerFte = 'PM0051_1_TrainingCostMonthly_PerFTE',
  Pm0051_2TrainingCostMonthlyPerIndiv = 'PM0051_2_TrainingCostMonthly_PerIndiv',
  Pm0054_1GenderPayGapMedBaseFtoMPerc = 'PM0054_1_GenderPayGapMedBase_FtoMPerc',
  Pm0054_2GenderPayGapMedBaseMtoFPerc = 'PM0054_2_GenderPayGapMedBase_MtoFPerc',
  Pm0054_3GenderPayGapMedBaseFtoMCashGap = 'PM0054_3_GenderPayGapMedBase_FtoMCashGap',
  Pm0054_4GenderPayGapMedBaseMtoFCashGap = 'PM0054_4_GenderPayGapMedBase_MtoFCashGap',
  Pm0054_5GenderPayGapMedBaseFMultipleM = 'PM0054_5_GenderPayGapMedBase_FMultipleM',
  Pm0054_6GenderPayGapMedBaseMMultipleF = 'PM0054_6_GenderPayGapMedBase_MMultipleF',
  Pm0061_1Ot36YtdHrsCumAvg = 'PM0061_1_OT36YTDHrs_CumAvg',
  Pm0061_2Ot36YtdHrsMax = 'PM0061_2_OT36YTDHrs_Max',
  Pm0061_3Ot36YtdHrsTotal = 'PM0061_3_OT36YTDHrs_Total',
  Pm0062_1Ot36720RuleEmployeesCount = 'PM0062_1_OT36720RuleEmployees_Count',
  Pm0062_2Ot36720RuleEmployeesPercHc = 'PM0062_2_OT36720RuleEmployees_PercHC',
  Pm0063_1Ot361Month100RuleEmpCount = 'PM0063_1_OT361Month100RuleEmp_Count',
  Pm0063_2Ot361Month100RuleEmpPercHc = 'PM0063_2_OT361Month100RuleEmp_PercHC',
  Pm0064_1Ot362MonthHrsTrailAvg = 'PM0064_1_OT362MonthHrs_TrailAvg',
  Pm0064_2Ot362MonthHrsMax = 'PM0064_2_OT362MonthHrs_Max',
  Pm0064_3Ot362MonthHrsTotal = 'PM0064_3_OT362MonthHrs_Total',
  Pm0065_1Ot362MonthAvg80RuleEmpCount = 'PM0065_1_OT362MonthAvg80RuleEmp_Count',
  Pm0065_2Ot362MonthAvg80RuleEmployeesPercHc = 'PM0065_2_OT362MonthAvg80RuleEmployees_PercHC',
  Pm0066_1Ot363MonthHrsTrailAvg = 'PM0066_1_OT363MonthHrs_TrailAvg',
  Pm0066_2Ot363MonthHrsMax = 'PM0066_2_OT363MonthHrs_Max',
  Pm0066_3Ot363MonthHrsTotal = 'PM0066_3_OT363MonthHrs_Total',
  Pm0067_1Ot363MonthAvg80RuleEmpCount = 'PM0067_1_OT363MonthAvg80RuleEmp_Count',
  Pm0067_2Ot363MonthAvg80RuleEmpPercHc = 'PM0067_2_OT363MonthAvg80RuleEmp_PercHC',
  Pm0068_1Ot364MonthHrsTraiAvg = 'PM0068_1_OT364MonthHrs_TraiAvg',
  Pm0068_2Ot364MonthHrsMax = 'PM0068_2_OT364MonthHrs_Max',
  Pm0068_3Ot364MonthHrsTotal = 'PM0068_3_OT364MonthHrs_Total',
  Pm0069_1Ot364MonthAvg80RuleEmpCount = 'PM0069_1_OT364MonthAvg80RuleEmp_Count',
  Pm0069_2Ot364MonthAvg80RuleEmpPercHc = 'PM0069_2_OT364MonthAvg80RuleEmp_PercHC',
  Pm0070_1Ot365MonthHrsTrailAvg = 'PM0070_1_OT365MonthHrs_TrailAvg',
  Pm0070_2Ot365MonthHrsMax = 'PM0070_2_OT365MonthHrs_Max',
  Pm0070_3Ot365MonthHrsTotal = 'PM0070_3_OT365MonthHrs_Total',
  Pm0071_1Ot365MonthAvg80RuleEmpCount = 'PM0071_1_OT365MonthAvg80RuleEmp_Count',
  Pm0071_2Ot365MonthAvg80RuleEmpPercHc = 'PM0071_2_OT365MonthAvg80RuleEmp_PercHC',
  Pm0072_1Ot366MonthHrsTrailAvg = 'PM0072_1_OT366MonthHrs_TrailAvg',
  Pm0072_2Ot366MonthHrsMax = 'PM0072_2_OT366MonthHrs_Max',
  Pm0072_3Ot366MonthHrsTotal = 'PM0072_3_OT366MonthHrs_Total',
  Pm0073_1Ot366MonthAvg80RuleEmpCount = 'PM0073_1_OT366MonthAvg80RuleEmp_Count',
  Pm0073_2Ot366MonthAvg80RuleEmpPercHc = 'PM0073_2_OT366MonthAvg80RuleEmp_PercHC',
  Pm0074_1Ot3645HrsRuleEmpCount = 'PM0074_1_OT3645HrsRuleEmp_Count',
  Pm0074_2Ot3645HrsRuleEmpPercHc = 'PM0074_2_OT3645HrsRuleEmp_PercHC',
  Pm0075_1Ot36EmpTrackingGroupCount = 'PM0075_1_OT36EmpTrackingGroup_Count',
  Pm0075_2Ot36EmpTrackingGroupPercHc = 'PM0075_2_OT36EmpTrackingGroup_PercHC',
  Pm0076_1AttritionAnnualized = 'PM0076_1_Attrition_Annualized',
  Pm0076_2AttritionMonthly = 'PM0076_2_Attrition_Monthly',
  Pm0076_3AttritionTtm = 'PM0076_3_Attrition_TTM',
  Pm0076_4AttritionLeavers = 'PM0076_4_Attrition_Leavers',
  Pm0077_1RetentionPerc = 'PM0077_1_Retention_Perc',
  Pm0078_1_3MonthAttritionAnnualized = 'PM0078_1_3MonthAttrition_Annualized',
  Pm0078_2_3MonthAttritionMonthly = 'PM0078_2_3MonthAttrition_Monthly',
  Pm0078_3_3MonthAttritionTtm = 'PM0078_3_3MonthAttrition_TTM',
  Pm0078_4_3MonthAttritionLeavers = 'PM0078_4_3MonthAttrition_Leavers',
  Pm0079_1_1YearAttritionAnnualized = 'PM0079_1_1YearAttrition_Annualized',
  Pm0079_2_1YearAttritionMonthly = 'PM0079_2_1YearAttrition_Monthly',
  Pm0079_3_1YearAttritionTtm = 'PM0079_3_1YearAttrition_TTM',
  Pm0079_4_1YearAttritionLeavers = 'PM0079_4_1YearAttrition_Leavers',
  Pm0080_1RegretAttritionAnnualized = 'PM0080_1_RegretAttrition_Annualized',
  Pm0080_2RegretAttritionMonthly = 'PM0080_2_RegretAttrition_Monthly',
  Pm0080_3RegretAttritionTtm = 'PM0080_3_RegretAttrition_TTM',
  Pm0080_4RegretAttritionLeavers = 'PM0080_4_RegretAttrition_Leavers',
  Pm0083_1IcrAvg = 'PM0083_1_ICR_Avg',
  Pm0141_2TotalBonusAvg = 'PM0141_2_TotalBonus_Avg',
  Pm0141_3TotalBonusTotal = 'PM0141_3_TotalBonus_Total',
  Pm0141TotalBonusPercOfTotalCashCompensationRatioOfSums = 'PM0141_TotalBonusPercOfTotalCashCompensation_ratioOfSums',
  Pm0156_2LaborCostPerc = 'PM0156_2_LaborCost_perc',
  Pm0156LaborCostRatio = 'PM0156_LaborCost_ratio',
  Pm0161TotalLaborCostToSalesRatio = 'PM0161_TotalLaborCostToSales_ratio',
  Pm0163TenureInJobgradeAvg = 'PM0163_TenureInJobgrade_avg',
  Pm0164_1TenureInOrgL1Avg = 'PM0164_1_TenureInOrgL1_avg',
  Pm0170_1DaysInOfficePercWorkingDays = 'PM0170_1_DaysInOffice_PercWorkingDays',
  Pm0170_2DaysInOfficeCount = 'PM0170_2_DaysInOffice_Count',
  Pm0170_3DaysInOfficeAvg = 'PM0170_3_DaysInOffice_Avg',
  Pm0170_4DaysInOfficePerRecord = 'PM0170_4_DaysInOffice_PerRecord',
  Pm0170_5DaysinOfficeEmpRatio = 'PM0170_5_DaysinOffice_EmpRatio',
  Pm0171EligibleForParentalLeaveCount = 'PM0171_EligibleForParentalLeave_count',
  Pm0171ParentalLeaveTakenUtilizationPerc = 'PM0171_ParentalLeaveTakenUtilization_perc',
  Pm0171ParentalLeaveTakenUtilizationRatio = 'PM0171_ParentalLeaveTakenUtilization_ratio',
  Pm0171ParentalLeaveTakenCount = 'PM0171_ParentalLeaveTaken_count',
  Pm0172_1TrainingTakenTotal = 'PM0172_1_TrainingTaken_Total',
  Pm0172_2TrainingTakenAvgTrainingperTrainee = 'PM0172_2_TrainingTaken_AvgTrainingperTrainee',
  Pm0172_3TrainingTakenAvgTrainingperEmp = 'PM0172_3_TrainingTaken_AvgTrainingperEmp',
  Pm0173_1TraineeTotal = 'PM0173_1_Trainee_Total',
  Pm0173_2TraineePercHc = 'PM0173_2_Trainee_PercHC',
  Pm0174_1DisciplinaryActionCount = 'PM0174_1_DisciplinaryAction_count',
  Pm0175_1TotalWorkforceCostTotal = 'PM0175_1_TotalWorkforceCost_Total',
  Pm0175_2TotalWorkforceCostPerPerson = 'PM0175_2_TotalWorkforceCost_PerPerson',
  Pm0176_1TotalCashCompensationPerPerson = 'PM0176_1_TotalCashCompensation_PerPerson',
  Pm0176_2TotalCashCompensationTotal = 'PM0176_2_TotalCashCompensation_Total',
  Pm0176_3TotalCashCompensationPerPersonWtcc = 'PM0176_3_TotalCashCompensation_PerPersonWTCC',
  Pm0177_1SgaPayrollTotal = 'PM0177_1_SGAPayroll_Total',
  Pm0177_2SgaPayrollPercPayrollCost = 'PM0177_2_SGAPayroll_PercPayrollCost',
  Pm0177_3SgaPayrollPerPerson = 'PM0177_3_SGAPayroll_PerPerson',
  Pm0178_1SgaPopulationCount = 'PM0178_1_SGAPopulation_Count',
  Pm0178_2SgaPopulationPercHc = 'PM0178_2_SGAPopulation_PercHC',
  Pm0179_1CogsPayrollTotal = 'PM0179_1_COGSPayroll_Total',
  Pm0179_2CogsPayrollPercPayrollCost = 'PM0179_2_COGSPayroll_PercPayrollCost',
  Pm0179_3CogsPayrollPerPerson = 'PM0179_3_COGSPayroll_PerPerson',
  Pm0180_1CogsPopulationCount = 'PM0180_1_COGSPopulation_Count',
  Pm0180_2CogsPopulationPercHc = 'PM0180_2_COGSPopulation_PercHC',
  Pm0182_1HumanCapitalRoiPerc = 'PM0182_1_HumanCapitalROI_perc',
  Pm0183DaysOfParentalLeaveTakenAvg = 'PM0183_DaysOfParentalLeaveTaken_avg',
  Pm0183DaysOfParentalLeaveTakenSum = 'PM0183_DaysOfParentalLeaveTaken_sum',
  Pm0184_1GenderPayGapFToMTotalCompPerc = 'PM0184_1_GenderPayGapFToMTotalComp_perc',
  Pm0184_2GenderPayGapMToFTotalCompPerc = 'PM0184_2_GenderPayGapMToFTotalComp_perc',
  Pm0184_3GenderPayGapFToMTotalCompDiff = 'PM0184_3_GenderPayGapFToMTotalComp_diff',
  Pm0184_4GenderPayGapMToFTotalCompDiff = 'PM0184_4_GenderPayGapMToFTotalComp_diff',
  Pm0184_5GenderPayGapFToMTotalCompRatio = 'PM0184_5_GenderPayGapFToMTotalComp_ratio',
  Pm0184_6GenderPayGapMToFTotalCompRatio = 'PM0184_6_GenderPayGapMToFTotalComp_ratio',
  Pm0185_1GenderPayGapFToMTotalCompAvgRatio = 'PM0185_1_GenderPayGapFToMTotalCompAvg_ratio',
  Pm0185_2GenderPayGapMToFTotalCompAvgRatio = 'PM0185_2_GenderPayGapMToFTotalCompAvg_ratio',
  Pm0185_3GenderPayGapFToMTotalCompAvgDiff = 'PM0185_3_GenderPayGapFToMTotalCompAvg_diff',
  Pm0185_4GenderPayGapMToFTotalCompAvgDiff = 'PM0185_4_GenderPayGapMToFTotalCompAvg_diff',
  Pm0185_5GenderPayGapFToMTotalCompAvgPerc = 'PM0185_5_GenderPayGapFToMTotalCompAvg_perc',
  Pm0185_6GenderPayGapMToFTotalCompAvgPerc = 'PM0185_6_GenderPayGapMToFTotalCompAvg_perc',
  Pm0196ManagementPromotionPercOfHeadcount = 'PM0196_ManagementPromotion_percOfHeadcount',
  Pm0197_1CustomPaidLeave1AhCumSumPercUtilization = 'PM0197_1_CustomPaidLeave1AH_CumSumPercUtilization',
  Pm0197_2CustomPaidLeave1AhCumSumPerHc = 'PM0197_2_CustomPaidLeave1AH_CumSumPerHC',
  Pm0197_3CustomPaidLeave1AhSumPerHc = 'PM0197_3_CustomPaidLeave1AH_SumPerHC',
  Pm0198_5DisabilityPopulationPercOfHc = 'PM0198_5_DisabilityPopulation_percOfHC',
  Pm0198_6DisabilityPopulationWeightedPercOfHc = 'PM0198_6_DisabilityPopulation_weightedPercOfHC',
  Pm0198DisabilityPopulationCount = 'PM0198_DisabilityPopulation_count',
  Pm0198DisabilityPopulationRatioOfPopulation = 'PM0198_DisabilityPopulation_ratioOfPopulation',
  Pm0198DisabilityPopulationWeightedCount = 'PM0198_DisabilityPopulation_weightedCount',
  Pm0198DisabilityPopulationWeightedRatioOfPopulation = 'PM0198_DisabilityPopulation_weightedRatioOfPopulation',
  Pm0199_1NetIncomeHcMonthlyPerFte = 'PM0199_1_NetIncomeHCMonthly_PerFTE',
  Pm0199_2NetIncomeHcMonthlyPerIndiv = 'PM0199_2_NetIncomeHCMonthly_PerIndiv',
  Pm0200_1GrossProfitHcQuarterlyPerFte = 'PM0200_1_GrossProfitHCQuarterly_PerFTE',
  Pm0200_2GrossProfitHcQuarterlyPerIndv = 'PM0200_2_GrossProfitHCQuarterly_PerIndv',
  Pm0201_1IndirectInvestmentRatioPerc = 'PM0201_1_IndirectInvestmentRatio_Perc',
  Pm0202_1NetIncomeHcQuarterlyPerFte = 'PM0202_1_NetIncomeHCQuarterly_PerFTE',
  Pm0202_2NetIncomeHcQuarterlyPerIndv = 'PM0202_2_NetIncomeHCQuarterly_PerIndv',
  Pm0203_1OperatingProfitHcQuarterlyPerFte = 'PM0203_1_OperatingProfitHCQuarterly_PerFTE',
  Pm0203_2OperatingProfitHcQuarterlyPerIndv = 'PM0203_2_OperatingProfitHCQuarterly_PerIndv',
  Pm0204_1RevenueHcQuarterlyPerFte = 'PM0204_1_RevenueHCQuarterly_PerFTE',
  Pm0204_2RevenueHcQuarterlyPerIndv = 'PM0204_2_RevenueHCQuarterly_PerIndv',
  Pm0205_1SgahcQuarterlyPerFte = 'PM0205_1_SGAHCQuarterly_PerFTE',
  Pm0205_2SgahcQuarterlyPerIndv = 'PM0205_2_SGAHCQuarterly_PerIndv',
  Pm0206_1TrainingCostQuarterlyPerFte = 'PM0206_1_TrainingCostQuarterly_PerFTE',
  Pm0206_2TrainingCostQuarterlyPerIndv = 'PM0206_2_TrainingCostQuarterly_PerIndv',
  Pm0207_1NonRegEmpCount = 'PM0207_1_NonRegEmp_Count',
  Pm0207_2NonRegEmpPercHc = 'PM0207_2_NonRegEmp_PercHC',
  Pm0208_1FulltimeEmpTotal = 'PM0208_1_FulltimeEmp_Total',
  Pm0208_2FulltimeEmpPercHc = 'PM0208_2_FulltimeEmp_PercHC',
  Pm0209_1StartingPopAttritionPerc = 'PM0209_1_StartingPopAttrition_Perc',
  Pm0210_1MedianBaseMedian = 'PM0210_1_MedianBase_Median',
  Pm0210_2MedianBaseAvg = 'PM0210_2_MedianBase_Avg',
  Pm0210_3MedianBaseAvgRaise12month = 'PM0210_3_MedianBase_AvgRaise12month',
  Pm0211_1DisablityTotal = 'PM0211_1_Disablity_Total',
  Pm0211_2DisablityPercHc = 'PM0211_2_Disablity_PercHC',
  Pm0212_1AbsentDaysPerHc = 'PM0212_1_AbsentDays_PerHC',
  Pm0212_2AbsentDaysPercOfWorkingDays = 'PM0212_2_AbsentDays_PercOfWorkingDays',
  Pm0213_1AvgWorkHoursPerPersonAvg = 'PM0213_1_AvgWorkHoursPerPerson_Avg',
  Pm0213_2AvgWorkHoursPerPersonAvgWithWh = 'PM0213_2_AvgWorkHoursPerPerson_AvgWithWH',
  Pm0213_3AvgWorkHoursPerPersonPerRecord = 'PM0213_3_AvgWorkHoursPerPerson_PerRecord',
  Pm0213_4AvgWorkHoursPerPersonMedian = 'PM0213_4_AvgWorkHoursPerPerson_Median',
  Pm0213_5AvgWorkHoursPerPersonMax = 'PM0213_5_AvgWorkHoursPerPerson_Max',
  Pm0213_6AvgWorkHoursPerPersonMin = 'PM0213_6_AvgWorkHoursPerPerson_Min',
  Pm0214_1AvgEmp45HrsOTperMthPercHc = 'PM0214_1_AvgEmp45HrsOTperMth_PercHC',
  Pm0214_2AvgEmp45HrsOTperMthHc = 'PM0214_2_AvgEmp45HrsOTperMth_HC',
  Pm0215_1MonthlyOtSumPerHc = 'PM0215_1_MonthlyOT_SumPerHC',
  Pm0215_2MonthlyOtSumPerHcWithOt = 'PM0215_2_MonthlyOT_SumPerHCWithOT',
  Pm0215_4MonthlyOtMedian = 'PM0215_4_MonthlyOT_Median',
  Pm0215_5MonthlyOtMax = 'PM0215_5_MonthlyOT_Max',
  Pm0215_6MonthlyOtMin = 'PM0215_6_MonthlyOT_Min',
  Pm0216_1Jp5AlDayRuleCount = 'PM0216_1_JP5ALDayRule_Count',
  Pm0216_2Jp5AlDayRulePercHc = 'PM0216_2_JP5ALDayRule_PercHC',
  Pm0217_1StatutoryAnnualPaidLeaveCumSumPercUtilization = 'PM0217_1_StatutoryAnnualPaidLeave_CumSumPercUtilization',
  Pm0217_2StatutoryAnnualPaidLeaveCumSumPerHc = 'PM0217_2_StatutoryAnnualPaidLeave_CumSumPerHC',
  Pm0217_3StatutoryAnnualPaidLeaveSumPerHc = 'PM0217_3_StatutoryAnnualPaidLeave_SumPerHC',
  Pm0218_1AnnualLeaveAvg = 'PM0218_1_AnnualLeave_Avg',
  Pm0218_2AnnualLeaveTotal = 'PM0218_2_AnnualLeave_Total',
  Pm0219_1DaysRemotePercWorkingDays = 'PM0219_1_DaysRemote_PercWorkingDays',
  Pm0219_2DaysRemoteCount = 'PM0219_2_DaysRemote_Count',
  Pm0219_3DaysRemoteAvg = 'PM0219_3_DaysRemote_Avg',
  Pm0219_4DaysRemotePerRecord = 'PM0219_4_DaysRemote_PerRecord',
  Pm0219_5DaysRemoteEmpRatio = 'PM0219_5_DaysRemote_EmpRatio',
  Pm0220_1HoursWorkedHolidayTotal = 'PM0220_1_HoursWorkedHoliday_Total',
  Pm0221_1HoursWorkedLegalHolidayTotal = 'PM0221_1_HoursWorkedLegalHoliday_Total',
  Pm0222_1OtHoursTotal = 'PM0222_1_OTHours_Total',
  Pm0223_1PlTakenAvg = 'PM0223_1_PLTaken_Avg',
  Pm0223_2PlTakenTotal = 'PM0223_2_PLTaken_Total',
  Pm0224_1TotalHolidayOtTotal = 'PM0224_1_TotalHolidayOT_Total',
  Pm0225_1TotalOtTotal = 'PM0225_1_TotalOT_Total',
  Pm0226_1OtPayTotal = 'PM0226_1_OTPay_Total',
  Pm0226_2OtPayAvg = 'PM0226_2_OTPay_Avg',
  Pm0227_1TravelCommutingTotal = 'PM0227_1_TravelCommuting_Total',
  Pm0227_2TravelCommutingAvg = 'PM0227_2_TravelCommuting_Avg',
  Pm0228_1BonusCoefAvg = 'PM0228_1_BonusCoef_Avg',
  Pm0228_2BonusCoefMedian = 'PM0228_2_BonusCoef_Median',
  Pm0229_1EmployerStatutoryPaymentTotal = 'PM0229_1_EmployerStatutoryPayment_Total',
  Pm0230_1Ot361Month75RuleEmpCount = 'PM0230_1_OT361Month75RuleEmp_Count',
  Pm0230_2Ot361Month75RuleEmpPercHc = 'PM0230_2_OT361Month75RuleEmp_PercHC',
  Pm0231_1Ot36AnnualisedHrsAvg = 'PM0231_1_OT36AnnualisedHrs_Avg',
  Pm0231_2Ot36AnnualisedHrsMax = 'PM0231_2_OT36AnnualisedHrs_Max',
  Pm0231_3Ot36AnnualisedHrsTotal = 'PM0231_3_OT36AnnualisedHrs_Total',
  Pm0232_1Ot36TtmCumAvg = 'PM0232_1_OT36TTM_CumAvg',
  Pm0232_2Ot36TtmMax = 'PM0232_2_OT36TTM_Max',
  Pm0232_3Ot36TtmTotal = 'PM0232_3_OT36TTM_Total',
  Pm0235_1TenureInJobgradeL2Avg = 'PM0235_1_TenureInJobgradeL2_avg',
  Pm0236_1RegularEmployeeCount = 'PM0236_1_RegularEmployee_Count',
  Pm0236_2RegularEmployeePercHc = 'PM0236_2_RegularEmployee_PercHC',
  Pm0237_1VoluntaryAttritionAnnualized = 'PM0237_1_VoluntaryAttrition_Annualized',
  Pm0237_2VoluntaryAttritionMonthly = 'PM0237_2_VoluntaryAttrition_Monthly',
  Pm0237_3VoluntaryAttritionTtm = 'PM0237_3_VoluntaryAttrition_TTM',
  Pm0237_4VoluntaryAttritionLeavers = 'PM0237_4_VoluntaryAttrition_Leavers',
  Pm0238TiketLeaversWithPtmCaseWithin1YearAvgTenureSincePtmCase = 'PM0238_TiketLeaversWithPtmCaseWithin1Year_avgTenureSincePtmCase',
  Pm0238TiketLeaversWithPtmCaseWithin1YearCount = 'PM0238_TiketLeaversWithPtmCaseWithin1Year_count',
  Pm0238TiketLeaversWithPtmCaseWithin1YearPercOfAllLeavers = 'PM0238_TiketLeaversWithPtmCaseWithin1Year_percOfAllLeavers',
  Pm0239TiketRecurringPtmCaseWithin1YearCount = 'PM0239_TiketRecurringPtmCaseWithin1Year_count',
  Pm0239TiketRecurringPtmCaseWithin1YearPercOfOpenPtmCases = 'PM0239_TiketRecurringPtmCaseWithin1Year_percOfOpenPtmCases',
  Pm0240_1SurveyCompanyMoodScoreAvgScore = 'PM0240_1_SurveyCompanyMoodScore_avgScore',
  Pm0240_2SurveyCompanyMoodScoreNumRespondents = 'PM0240_2_SurveyCompanyMoodScore_numRespondents',
  Pm0240_3SurveyCompanyMoodScoreNumRespondentsPercOfHc = 'PM0240_3_SurveyCompanyMoodScore_numRespondentsPercOfHC',
  Pm0241_1SurveyEngagementScoreAvgScore = 'PM0241_1_SurveyEngagementScore_avgScore',
  Pm0241_2SurveyEngagementScoreNumRespondents = 'PM0241_2_SurveyEngagementScore_numRespondents',
  Pm0241_3SurveyEngagementScoreNumRespondentsPercOfHc = 'PM0241_3_SurveyEngagementScore_numRespondentsPercOfHC',
  Pm0241_4SurveyEngagementScorePositiveRatio = 'PM0241_4_SurveyEngagementScore_PositiveRatio',
  Pm0242_1EnpsScore = 'PM0242_1_ENPS_score',
  Pm0242_2EnpsNumRespondents = 'PM0242_2_ENPS_numRespondents',
  Pm0242_3EnpsNumRespondentsPercOfHc = 'PM0242_3_ENPS_numRespondentsPercOfHC',
  Pm0243EmployeeWithPtmCasesCumulativeCount = 'PM0243_EmployeeWithPTMCases_cumulativeCount',
  Pm0243EmployeeWithPtmCasesNewCount = 'PM0243_EmployeeWithPTMCases_newCount',
  Pm0243EmployeeWithPtmCasesPercOfHc = 'PM0243_EmployeeWithPTMCases_percOfHC',
  Pm0244EmployeeWithClosedPtmCasesCumulativeCount = 'PM0244_EmployeeWithClosedPTMCases_cumulativeCount',
  Pm0244EmployeeWithClosedPtmCasesNewCount = 'PM0244_EmployeeWithClosedPTMCases_newCount',
  Pm0244EmployeeWithClosedPtmCasesPercOfHc = 'PM0244_EmployeeWithClosedPTMCases_percOfHC',
  Pm0245EmployeeWithInProgressPtmCasesNewCount = 'PM0245_EmployeeWithInProgressPTMCases_newCount',
  Pm0245EmployeeWithInProgressPtmCasesPercOfHc = 'PM0245_EmployeeWithInProgressPTMCases_percOfHC',
  Pm0245EmployeeWithInProgressPtmCasesTotal = 'PM0245_EmployeeWithInProgressPTMCases_total',
  Pm0246EmployeeWithOpenPtmCasesNewCount = 'PM0246_EmployeeWithOpenPTMCases_newCount',
  Pm0246EmployeeWithOpenPtmCasesPercOfHc = 'PM0246_EmployeeWithOpenPTMCases_percOfHC',
  Pm0246EmployeeWithOpenPtmCasesTotal = 'PM0246_EmployeeWithOpenPTMCases_total',
  Pm0247_1PtmCasesUniqueCount = 'PM0247_1_PTMCasesUnique_Count',
  Pm0247_2PtmCasesUniquePercOpenCases = 'PM0247_2_PTMCasesUnique_PercOpenCases',
  Pm0248_1TotalVacanciesMppTotal = 'PM0248_1_TotalVacanciesMPP_Total',
  Pm0248_2TotalVacanciesMppActive = 'PM0248_2_TotalVacanciesMPP_Active',
  Pm0252_1ApplicationsPerc = 'PM0252_1_Applications_Perc',
  Pm0252_2ApplicationsCount = 'PM0252_2_Applications_Count',
  Pm0253_1PassthroughAtAppliedPerc = 'PM0253_1_Passthrough_at_Applied_Perc',
  Pm0253_2PassedApplicationsAtAppliedCount = 'PM0253_2_Passed_Applications_at_Applied_Count',
  Pm0254_1RejectedApplicationsAtAppliedPerc = 'PM0254_1_Rejected_Applications_at_Applied_Perc',
  Pm0254_2RejectedApplicationsAtAppliedCount = 'PM0254_2_Rejected_Applications_at_Applied_Count',
  Pm0255_1WithdrawnApplicationsAtAppliedPerc = 'PM0255_1_Withdrawn_Applications_at_Applied_Perc',
  Pm0255_2WithdrawnApplicationsAtAppliedCount = 'PM0255_2_Withdrawn_Applications_at_Applied_Count',
  Pm0256_1ApplicationsAtScreeningCount = 'PM0256_1_Applications_at_Screening_Count',
  Pm0257_1PassthroughAtScreeningPerc = 'PM0257_1_Passthrough_at_Screening_Perc',
  Pm0257_2PassedApplicationsAtScreeningCount = 'PM0257_2_Passed_Applications_at_Screening_Count',
  Pm0258_1RejectedApplicationsAtScreeningPerc = 'PM0258_1_Rejected_Applications_at_Screening_Perc',
  Pm0258_2RejectedApplicationsAtScreeningCount = 'PM0258_2_Rejected_Applications_at_Screening_Count',
  Pm0259_1WithdrawnApplicationsAtScreeningPerc = 'PM0259_1_Withdrawn_Applications_at_Screening_Perc',
  Pm0259_2WithdrawnApplicationsAtScreeningCount = 'PM0259_2_Withdrawn_Applications_at_Screening_Count',
  Pm0260_1ApplicationsAt_1stInterviewCount = 'PM0260_1_Applications_at_1stInterview_Count',
  Pm0261_1PassthroughAt_1stInterviewPerc = 'PM0261_1_Passthrough_at_1stInterview_Perc',
  Pm0261_2PassedApplicationsAt_1stInterviewCount = 'PM0261_2_Passed_Applications_at_1stInterview_Count',
  Pm0262_1RejectedApplicationsAt_1stInterviewPerc = 'PM0262_1_Rejected_Applications_at_1stInterview_Perc',
  Pm0262_2RejectedApplicationsAt_1stInterviewCount = 'PM0262_2_Rejected_Applications_at_1stInterview_Count',
  Pm0263_1WithdrawnApplicationsAt_1stInterviewPerc = 'PM0263_1_Withdrawn_Applications_at_1stInterview_Perc',
  Pm0263_2WithdrawnApplicationsAt_1stInterviewCount = 'PM0263_2_Withdrawn_Applications_at_1stInterview_Count',
  Pm0264_1ApplicationsAt_2ndInterviewCount = 'PM0264_1_Applications_at_2ndInterview_Count',
  Pm0265_1PassthroughAt_2ndInterviewPerc = 'PM0265_1_Passthrough_at_2ndInterview_Perc',
  Pm0265_2PassedApplicationsAt_2ndInterviewCount = 'PM0265_2_Passed_Applications_at_2ndInterview_Count',
  Pm0266_1RejectedApplicationsAt_2ndInterviewPerc = 'PM0266_1_Rejected_Applications_at_2ndInterview_Perc',
  Pm0266_2RejectedApplicationsAt_2ndInterviewCount = 'PM0266_2_Rejected_Applications_at_2ndInterview_Count',
  Pm0267_1WithdrawnApplicationsAt_2ndInterviewPerc = 'PM0267_1_Withdrawn_Applications_at_2ndInterview_Perc',
  Pm0267_2WithdrawnApplicationsAt_2ndInterviewCount = 'PM0267_2_Withdrawn_Applications_at_2ndInterview_Count',
  Pm0268_1ApplicationsAtFinalInterviewCount = 'PM0268_1_Applications_at_FinalInterview_Count',
  Pm0269_1PassthroughAtFinalInterviewPerc = 'PM0269_1_Passthrough_at_FinalInterview_Perc',
  Pm0269_2PassedApplicationsAtFinalInterviewCount = 'PM0269_2_Passed_Applications_at_FinalInterview_Count',
  Pm0270_1RejectedApplicationsAtFinalInterviewPerc = 'PM0270_1_Rejected_Applications_at_FinalInterview_Perc',
  Pm0270_2RejectedApplicationsAtFinalInterviewCount = 'PM0270_2_Rejected_Applications_at_FinalInterview_Count',
  Pm0271_1WithdrawnApplicationsAtFinalInterviewPerc = 'PM0271_1_Withdrawn_Applications_at_FinalInterview_Perc',
  Pm0271_2WithdrawnApplicationsAtFinalInterviewCount = 'PM0271_2_Withdrawn_Applications_at_FinalInterview_Count',
  Pm0272_1ApplicationsAtOfferCount = 'PM0272_1_Applications_at_Offer_Count',
  Pm0273_1PassthroughAtOfferPerc = 'PM0273_1_Passthrough_at_Offer_Perc',
  Pm0273_2PassedApplicationsAtOfferCount = 'PM0273_2_Passed_Applications_at_Offer_Count',
  Pm0274_1RejectedApplicationsAtOfferPerc = 'PM0274_1_Rejected_Applications_at_Offer_Perc',
  Pm0274_2RejectedApplicationsAtOfferCount = 'PM0274_2_Rejected_Applications_at_Offer_Count',
  Pm0275_1WithdrawnApplicationsAtOfferPerc = 'PM0275_1_Withdrawn_Applications_at_Offer_Perc',
  Pm0275_2WithdrawnApplicationsAtOfferCount = 'PM0275_2_Withdrawn_Applications_at_Offer_Count',
  Pm0276_1ApplicationsAtHiredCount = 'PM0276_1_Applications_at_Hired_Count',
  Pm0277_1TenureInOrgL2Avg = 'PM0277_1_TenureInOrgL2_avg',
  Pm0279_1DigitalExpertsMsadCount = 'PM0279_1_DigitalExpertsMSAD_Count',
  Pm0279_2DigitalExpertsMsadPercHc = 'PM0279_2_DigitalExpertsMSAD_PercHC',
  Pm0280_1EmpCompDigitalTrainingMsadCount = 'PM0280_1_EmpCompDigitalTrainingMSAD_Count',
  Pm0280_2EmpCompDigitalTrainingMsadPercHc = 'PM0280_2_EmpCompDigitalTrainingMSAD_PercHC',
  Pm0281_1EmpExExperienceMsadCount = 'PM0281_1_EmpExExperienceMSAD_Count',
  Pm0281_2EmpExExperienceMsadPercHc = 'PM0281_2_EmpExExperienceMSAD_PercHC',
  Pm0282_1PotentialFLeaderMsadCount = 'PM0282_1_PotentialFLeaderMSAD_Count',
  Pm0282_2PotentialFLeaderMsadPerc = 'PM0282_2_PotentialFLeaderMSAD_Perc',
  Pm0283_1EngScoreMsadPercHc = 'PM0283_1_EngScoreMSAD_PercHC',
  Pm0284_1HighStrsEmpMsadCount = 'PM0284_1_HighStrsEmpMSAD_Count',
  Pm0284_2HighStrsEmpMsadPercHc = 'PM0284_2_HighStrsEmpMSAD_PercHC',
  Pm0285_1ParentalLeaveUtilizationMsadPercHc = 'PM0285_1_ParentalLeaveUtilizationMSAD_PercHC',
  Pm0288_1Ot362to6MonthAvg80RuleEmpCount = 'PM0288_1_OT362to6MonthAvg80RuleEmp_Count',
  Pm0288_2Ot362to6MonthAvg80RuleEmpPercHc = 'PM0288_2_OT362to6MonthAvg80RuleEmp_PercHC',
  Pm0289_1_3mAttritionAttrition = 'PM0289_1_3mAttrition_Attrition',
  Pm0289_2_3mAttritionCountJoiners = 'PM0289_2_3mAttrition_CountJoiners',
  Pm0289_3_3mAttritionCountLeavers = 'PM0289_3_3mAttrition_CountLeavers',
  Pm0290_1_1yAttritionAttrition = 'PM0290_1_1yAttrition_Attrition',
  Pm0290_2_1yAttritionCountJoiners = 'PM0290_2_1yAttrition_CountJoiners',
  Pm0290_3_1yAttritionCountLeavers = 'PM0290_3_1yAttrition_CountLeavers',
  Pm0291_1_3yAttritionAttrition = 'PM0291_1_3yAttrition_Attrition',
  Pm0291_2_3yAttritionCountJoiners = 'PM0291_2_3yAttrition_CountJoiners',
  Pm0291_3_3yAttritionCountLeavers = 'PM0291_3_3yAttrition_CountLeavers',
  Pm0292_1_3rdYearAttritionAttrition = 'PM0292_1_3rdYearAttrition_Attrition',
  Pm0292_2_3rdYearAttritionCountJoiners = 'PM0292_2_3rdYearAttrition_CountJoiners',
  Pm0292_3_3rdYearAttritionCountLeavers = 'PM0292_3_3rdYearAttrition_CountLeavers',
  Pm0293_1CustomFemaleIndividualsCount = 'PM0293_1_CustomFemaleIndividuals_Count',
  Pm0293_2CustomFemaleIndividualsPercFemale = 'PM0293_2_CustomFemaleIndividuals_PercFemale',
  Pm0294_1CustomFemaleManagersCount = 'PM0294_1_CustomFemaleManagers_Count',
  Pm0294_2CustomFemaleManagersPercFemale = 'PM0294_2_CustomFemaleManagers_PercFemale',
  Pm0295_1TotalCashCompFinanceYearlyPerIndv = 'PM0295_1_TotalCashCompFinanceYearly_PerIndv',
  Pm0295_2TotalCashCompFinanceYearlyTotal = 'PM0295_2_TotalCashCompFinanceYearly_Total',
  Pm0296_1TotalBonusFinanceYearlyPerIndv = 'PM0296_1_TotalBonusFinanceYearly_PerIndv',
  Pm0296_2TotalBonusFinanceYearlyTotal = 'PM0296_2_TotalBonusFinanceYearly_Total',
  Pm0297_1RecruitmentCostYearlyPerIndv = 'PM0297_1_RecruitmentCostYearly_PerIndv',
  Pm0297_2RecruitmentCostYearlyTotal = 'PM0297_2_RecruitmentCostYearly_Total',
  Pm0298_1RetirementAllowanceFinanceYearlyPerIndv = 'PM0298_1_RetirementAllowanceFinanceYearly_PerIndv',
  Pm0298_2RetirementAllowanceFinanceYearlyTotal = 'PM0298_2_RetirementAllowanceFinanceYearly_Total',
  Pm0299_1EmployerNonStatutoryPaymentFinanceYearlyPerIndv = 'PM0299_1_EmployerNonStatutoryPaymentFinanceYearly_PerIndv',
  Pm0299_2EmployerNonStatutoryPaymentFinanceYearlyTotal = 'PM0299_2_EmployerNonStatutoryPaymentFinanceYearly_Total',
  Pm0300_1EmployerStatutoryPaymentFinanceYearlyPerIndv = 'PM0300_1_EmployerStatutoryPaymentFinanceYearly_PerIndv',
  Pm0300_2EmployerStatutoryPaymentFinanceYearlyTotal = 'PM0300_2_EmployerStatutoryPaymentFinanceYearly_Total',
  Pm0301_1BoardCompensationFinanceYearlyPerIndv = 'PM0301_1_BoardCompensationFinanceYearly_PerIndv',
  Pm0301_2BoardCompensationFinanceYearlyTotal = 'PM0301_2_BoardCompensationFinanceYearly_Total',
  Pm0302_1RevenueHcMonthlyWholeCompanyPerFte = 'PM0302_1_RevenueHCMonthlyWholeCompany_PerFTE',
  Pm0302_2RevenueHcMonthlyWholeCompanyPerIndiv = 'PM0302_2_RevenueHCMonthlyWholeCompany_PerIndiv',
  Pm0303_1GrossProfitHcMonthlyWholeCompanyPerFte = 'PM0303_1_GrossProfitHCMonthlyWholeCompany_PerFTE',
  Pm0303_2GrossProfitHcMonthlyWholeCompanyPerIndiv = 'PM0303_2_GrossProfitHCMonthlyWholeCompany_PerIndiv',
  Pm0304_1SgahcMonthlyWholeCompanyPerFte = 'PM0304_1_SGAHCMonthlyWholeCompany_PerFTE',
  Pm0304_2SgahcMonthlyWholeCompanyPerIndiv = 'PM0304_2_SGAHCMonthlyWholeCompany_PerIndiv',
  Pm0305_1OperatingProfitHcMonthlyWholeCompanyPerFte = 'PM0305_1_OperatingProfitHCMonthlyWholeCompany_PerFTE',
  Pm0305_2OperatingProfitHcMonthlyWholeCompanyPerIndiv = 'PM0305_2_OperatingProfitHCMonthlyWholeCompany_PerIndiv',
  Pm0306_1TrainingCostMonthlyWholeCompanyPerFte = 'PM0306_1_TrainingCostMonthlyWholeCompany_PerFTE',
  Pm0306_2TrainingCostMonthlyWholeCompanyPerIndiv = 'PM0306_2_TrainingCostMonthlyWholeCompany_PerIndiv',
  Pm0307_1NetIncomeHcMonthlyWholeCompanyPerFte = 'PM0307_1_NetIncomeHCMonthlyWholeCompany_PerFTE',
  Pm0307_2NetIncomeHcMonthlyWholeCompanyPerIndiv = 'PM0307_2_NetIncomeHCMonthlyWholeCompany_PerIndiv',
  Pm0308_1RevenueHcQuarterlyWholeCompanyPerFte = 'PM0308_1_RevenueHCQuarterlyWholeCompany_PerFTE',
  Pm0308_2RevenueHcQuarterlyWholeCompanyPerIndv = 'PM0308_2_RevenueHCQuarterlyWholeCompany_PerIndv',
  Pm0309_1GrossProfitHcQuarterlyWholeCompanyPerFte = 'PM0309_1_GrossProfitHCQuarterlyWholeCompany_PerFTE',
  Pm0309_2GrossProfitHcQuarterlyWholeCompanyPerIndv = 'PM0309_2_GrossProfitHCQuarterlyWholeCompany_PerIndv',
  Pm0310_1SgahcQuarterlyWholeCompanyPerFte = 'PM0310_1_SGAHCQuarterlyWholeCompany_PerFTE',
  Pm0310_2SgahcQuarterlyWholeCompanyPerIndv = 'PM0310_2_SGAHCQuarterlyWholeCompany_PerIndv',
  Pm0311_1OperatingProfitHcQuarterlyWholeCompanyPerFte = 'PM0311_1_OperatingProfitHCQuarterlyWholeCompany_PerFTE',
  Pm0311_2OperatingProfitHcQuarterlyWholeCompanyPerIndv = 'PM0311_2_OperatingProfitHCQuarterlyWholeCompany_PerIndv',
  Pm0312_1TrainingCostQuarterlyWholeCompanyPerFte = 'PM0312_1_TrainingCostQuarterlyWholeCompany_PerFTE',
  Pm0312_2TrainingCostQuarterlyWholeCompanyPerIndv = 'PM0312_2_TrainingCostQuarterlyWholeCompany_PerIndv',
  Pm0313_1NetIncomeHcQuarterlyWholeCompanyPerFte = 'PM0313_1_NetIncomeHCQuarterlyWholeCompany_PerFTE',
  Pm0313_2NetIncomeHcQuarterlyWholeCompanyPerIndv = 'PM0313_2_NetIncomeHCQuarterlyWholeCompany_PerIndv',
  Pm0314_1TravelCommutingFinanceYearlyPerIndv = 'PM0314_1_TravelCommutingFinanceYearly_PerIndv',
  Pm0314_2TravelCommutingFinanceYearlyTotal = 'PM0314_2_TravelCommutingFinanceYearly_Total',
  Pm0315_1CustomStatutoryAnnualPaidLeaveNecCumSumPercUtilization = 'PM0315_1_CustomStatutoryAnnualPaidLeaveNEC_CumSumPercUtilization',
  Pm0315_2CustomStatutoryAnnualPaidLeaveNecCumSumPerHc = 'PM0315_2_CustomStatutoryAnnualPaidLeaveNEC_CumSumPerHC',
  Pm0315_3CustomStatutoryAnnualPaidLeaveNecSumPerHc = 'PM0315_3_CustomStatutoryAnnualPaidLeaveNEC_SumPerHC',
  Pm0316_1CustomIndividuals1ProperNecCount = 'PM0316_1_CustomIndividuals1ProperNEC_Count',
  Pm0317_1CustomIndividuals2FinancialReportingNecCount = 'PM0317_1_CustomIndividuals2FinancialReportingNEC_Count',
  Pm0318_1CustomAttritionNikkiAnnualized = 'PM0318_1_CustomAttritionNikki_Annualized',
  Pm0318_2CustomAttritionNikkiMonthly = 'PM0318_2_CustomAttritionNikki_Monthly',
  Pm0318_3CustomAttritionNikkiTtm = 'PM0318_3_CustomAttritionNikki_TTM',
  Pm0318_4CustomAttritionNikkiLeavers = 'PM0318_4_CustomAttritionNikki_Leavers',
  Pm0319_1CustomAttritionAuFhAnnualized = 'PM0319_1_CustomAttritionAuFH_Annualized',
  Pm0319_2CustomAttritionAuFhMonthly = 'PM0319_2_CustomAttritionAuFH_Monthly',
  Pm0319_3CustomAttritionAuFhTtm = 'PM0319_3_CustomAttritionAuFH_TTM',
  Pm0319_4CustomAttritionAuFhLeavers = 'PM0319_4_CustomAttritionAuFH_Leavers',
  Pm0320_1GenderPayGapFToMTotalCompAvgJpGovPerc = 'PM0320_1_GenderPayGapFToMTotalCompAvgJpGov_perc',
  Pm0320_2GenderPayGapMToFTotalCompAvgJpGovPerc = 'PM0320_2_GenderPayGapMToFTotalCompAvgJpGov_perc',
  Pm0320_3GenderPayGapFToMTotalCompAvgJpGovDiff = 'PM0320_3_GenderPayGapFToMTotalCompAvgJpGov_diff',
  Pm0320_4GenderPayGapMToFTotalCompAvgJpGovDiff = 'PM0320_4_GenderPayGapMToFTotalCompAvgJpGov_diff',
  Pm0321_1IndividualsGroupCompaniesCount = 'PM0321_1_IndividualsGroupCompanies_Count',
  Pm0322_1CustomTenureNecnsiMedian = 'PM0322_1_CustomTenureNECNSI_Median',
  Pm0322_2CustomTenureNecnsiAvg = 'PM0322_2_CustomTenureNECNSI_Avg',
  Pm0322_3CustomTenureNecnsiMax = 'PM0322_3_CustomTenureNECNSI_Max',
  Pm0322_4CustomTenureNecnsiMin = 'PM0322_4_CustomTenureNECNSI_Min',
  Pm0323_1CstmMidCareerRcrtNesicTotal = 'PM0323_1_CstmMidCareerRcrtNESIC_Total',
  Pm0323_2CstmMidCareerRcrtNesicMid = 'PM0323_2_CstmMidCareerRcrtNESIC_Mid',
  Pm0323_3CstmMidCareerRcrtNesicPercHc = 'PM0323_3_CstmMidCareerRcrtNESIC_PercHC',
  Pm0324_1DaysAtOtherLocationPercWorkingDays = 'PM0324_1_DaysAtOtherLocation_PercWorkingDays',
  Pm0324_2DaysAtOtherLocationCount = 'PM0324_2_DaysAtOtherLocation_Count',
  Pm0324_3DaysAtOtherLocationAvg = 'PM0324_3_DaysAtOtherLocation_Avg',
  Pm0324_4DaysAtOtherLocationAvgWithDaysAtOtherLocation = 'PM0324_4_DaysAtOtherLocation_AvgWithDaysAtOtherLocation',
  Pm0325_1CstmAnnPaidLeave1CumSumPercUtil = 'PM0325_1_CstmAnnPaidLeave1_CumSumPercUtil',
  Pm0325_2CstmAnnPaidLeave1CumSumPerHc = 'PM0325_2_CstmAnnPaidLeave1_CumSumPerHC',
  Pm0325_3CstmAnnPaidLeave1SumPerHc = 'PM0325_3_CstmAnnPaidLeave1_SumPerHC',
  Pm0376_1LaborCostHcMthlyPerFte = 'PM0376_1_LaborCostHCMthly_PerFTE',
  Pm0376_2LaborCostHcMthlyPerIndv = 'PM0376_2_LaborCostHCMthly_PerIndv',
  Pm0377_1LaborCostHcQtrlyPerFte = 'PM0377_1_LaborCostHCQtrly_PerFTE',
  Pm0377_2LaborCostHcQtrlyPerIndv = 'PM0377_2_LaborCostHCQtrly_PerIndv',
  Pm0378_1LaborCostHcMthlCompPerFte = 'PM0378_1_LaborCostHCMthlComp_PerFTE',
  Pm0378_2LaborCostHcMthlCompPerIndv = 'PM0378_2_LaborCostHCMthlComp_PerIndv',
  Pm0379_1LaborCostHcQtrlyCompPerFte = 'PM0379_1_LaborCostHCQtrlyComp_PerFTE',
  Pm0379_2LaborCostHcQtrlyCompPerIndv = 'PM0379_2_LaborCostHCQtrlyComp_PerIndv',
  Pm0380_1MidCareerRcrtTotal = 'PM0380_1_MidCareerRcrt_Total',
  Pm0380_2MidCareerRcrtMid = 'PM0380_2_MidCareerRcrt_Mid',
  Pm0380_3MidCareerRcrtPercHc = 'PM0380_3_MidCareerRcrt_PercHC',
  Pm0381_1StryAnlPaidLeavenotempCumSumPercUtilization = 'PM0381_1_StryAnlPaidLeavenotemp_CumSumPercUtilization',
  Pm0381_2StryAnlPaidLeavenotempCumSumPerHc = 'PM0381_2_StryAnlPaidLeavenotemp_CumSumPerHC',
  Pm0381_3StryAnlPaidLeavenotempSumPerHc = 'PM0381_3_StryAnlPaidLeavenotemp_SumPerHC',
  Pm0382_1CstmAnnPaidLeave2CumSumPercUtil = 'PM0382_1_CstmAnnPaidLeave2_CumSumPercUtil',
  Pm0382_2CstmAnnPaidLeave2CumSumPerHc = 'PM0382_2_CstmAnnPaidLeave2_CumSumPerHC',
  Pm0382_3CstmAnnPaidLeave2SumPerHc = 'PM0382_3_CstmAnnPaidLeave2_SumPerHC',
  Pm0383_1CstmJoiners1BsJoiners = 'PM0383_1_CstmJoiners1BS_Joiners',
  Pm0384_1CstmJoiners2BsJoiners = 'PM0384_1_CstmJoiners2BS_Joiners',
  Pm0385_1CstmJoiners3BsJoiners = 'PM0385_1_CstmJoiners3BS_Joiners',
  Pm0386_1CstmLeavers1BsLeavers = 'PM0386_1_CstmLeavers1BS_Leavers',
  Pm0387_1CstmLeavers2BsLeavers = 'PM0387_1_CstmLeavers2BS_Leavers',
  Pm0388_1CstmLeavers3BsLeavers = 'PM0388_1_CstmLeavers3BS_Leavers',
  Pm0389_1CstmAttrition1BsCstmAttrition = 'PM0389_1_CstmAttrition1BS_cstmAttrition',
  Pm0390_1CstmIndividuals1BsCount = 'PM0390_1_CstmIndividuals1BS_Count',
  Pm0391_1CstmDaysInOffNecnsiPercWorkingDays = 'PM0391_1_CstmDaysInOffNECNSI_PercWorkingDays',
  Pm0392_1CstmAnnPaidLeaveNecnsiCumSumPercUtil = 'PM0392_1_CstmAnnPaidLeaveNECNSI_CumSumPercUtil',
  Pm0392_2CstmAnnPaidLeaveNecnsiCumSumPerHc = 'PM0392_2_CstmAnnPaidLeaveNECNSI_CumSumPerHC',
  Pm0392_3CstmAnnPaidLeaveNecnsiSumPerHc = 'PM0392_3_CstmAnnPaidLeaveNECNSI_SumPerHC',
  Pm0393_1EligibleForParentalLeavenotempCount = 'PM0393_1_EligibleForParentalLeavenotemp_count',
  Pm0393_2ParentalLeaveTakenUtilizationnotempPerc = 'PM0393_2_ParentalLeaveTakenUtilizationnotemp_perc',
  Pm0393_3ParentalLeaveTakennotempCount = 'PM0393_3_ParentalLeaveTakennotemp_count',
  Pm0394_1CstmGenderPayGapFToMTotalCompAvg1BsPerc = 'PM0394_1_CstmGenderPayGapFToMTotalCompAvg1BS_perc',
  Pm0394_2CstmGenderPayGapMToFTotalCompAvg1BsPerc = 'PM0394_2_CstmGenderPayGapMToFTotalCompAvg1BS_perc',
  Pm0395_1CstmAllowance1PerPerson = 'PM0395_1_CstmAllowance1_PerPerson',
  Pm0395_2CstmAllowance1Total = 'PM0395_2_CstmAllowance1_Total',
  Pm0395_3CstmAllowance1PerPersonWvalue = 'PM0395_3_CstmAllowance1_PerPersonWvalue',
  Pm0396_1CstmAllowance2PerPerson = 'PM0396_1_CstmAllowance2_PerPerson',
  Pm0396_2CstmAllowance2Total = 'PM0396_2_CstmAllowance2_Total',
  Pm0396_3CstmAllowance2PerPersonWvalue = 'PM0396_3_CstmAllowance2_PerPersonWvalue',
  Pm0397_1CstmAllowance3PerPerson = 'PM0397_1_CstmAllowance3_PerPerson',
  Pm0397_2CstmAllowance3Total = 'PM0397_2_CstmAllowance3_Total',
  Pm0397_3CstmAllowance3PerPersonWvalue = 'PM0397_3_CstmAllowance3_PerPersonWvalue',
  Pm0398_1CstmAllowance4PerPerson = 'PM0398_1_CstmAllowance4_PerPerson',
  Pm0398_2CstmAllowance4Total = 'PM0398_2_CstmAllowance4_Total',
  Pm0398_3CstmAllowance4PerPersonWvalue = 'PM0398_3_CstmAllowance4_PerPersonWvalue',
  Pm0399_1CstmAllowance5PerPerson = 'PM0399_1_CstmAllowance5_PerPerson',
  Pm0399_2CstmAllowance5Total = 'PM0399_2_CstmAllowance5_Total',
  Pm0399_3CstmAllowance5PerPersonWvalue = 'PM0399_3_CstmAllowance5_PerPersonWvalue',
  Pm0400_1CstmAllowance6PerPerson = 'PM0400_1_CstmAllowance6_PerPerson',
  Pm0400_2CstmAllowance6Total = 'PM0400_2_CstmAllowance6_Total',
  Pm0400_3CstmAllowance6PerPersonWvalue = 'PM0400_3_CstmAllowance6_PerPersonWvalue',
  Pm0401_1CstmAllowance7PerPerson = 'PM0401_1_CstmAllowance7_PerPerson',
  Pm0401_2CstmAllowance7Total = 'PM0401_2_CstmAllowance7_Total',
  Pm0401_3CstmAllowance7PerPersonWvalue = 'PM0401_3_CstmAllowance7_PerPersonWvalue',
  Pm0402_1CstmAllowance8PerPerson = 'PM0402_1_CstmAllowance8_PerPerson',
  Pm0402_2CstmAllowance8Total = 'PM0402_2_CstmAllowance8_Total',
  Pm0402_3CstmAllowance8PerPersonWvalue = 'PM0402_3_CstmAllowance8_PerPersonWvalue',
  Pm0403_1CstmAllowance9PerPerson = 'PM0403_1_CstmAllowance9_PerPerson',
  Pm0403_2CstmAllowance9Total = 'PM0403_2_CstmAllowance9_Total',
  Pm0403_3CstmAllowance9PerPersonWvalue = 'PM0403_3_CstmAllowance9_PerPersonWvalue',
  Pm0404_1BoardComp1PerPerson = 'PM0404_1_BoardComp1_PerPerson',
  Pm0404_2BoardComp1Total = 'PM0404_2_BoardComp1_Total',
  Pm0404_3BoardComp1PerPersonWvalue = 'PM0404_3_BoardComp1_PerPersonWvalue',
  Pm0405_1BoardComp2PerPerson = 'PM0405_1_BoardComp2_PerPerson',
  Pm0405_2BoardComp2Total = 'PM0405_2_BoardComp2_Total',
  Pm0405_3BoardComp2PerPersonWvalue = 'PM0405_3_BoardComp2_PerPersonWvalue',
  Pm0406_1BoardComp3PerPerson = 'PM0406_1_BoardComp3_PerPerson',
  Pm0406_2BoardComp3Total = 'PM0406_2_BoardComp3_Total',
  Pm0406_3BoardComp3PerPersonWvalue = 'PM0406_3_BoardComp3_PerPersonWvalue',
  Pm0407_1BoardComp4PerPerson = 'PM0407_1_BoardComp4_PerPerson',
  Pm0407_2BoardComp4Total = 'PM0407_2_BoardComp4_Total',
  Pm0407_3BoardComp4PerPersonWvalue = 'PM0407_3_BoardComp4_PerPersonWvalue',
  Pm0408_1BoardComp5PerPerson = 'PM0408_1_BoardComp5_PerPerson',
  Pm0408_2BoardComp5Total = 'PM0408_2_BoardComp5_Total',
  Pm0408_3BoardComp5PerPersonWvalue = 'PM0408_3_BoardComp5_PerPersonWvalue',
  Pm0409_1BoardComp6PerPerson = 'PM0409_1_BoardComp6_PerPerson',
  Pm0409_2BoardComp6Total = 'PM0409_2_BoardComp6_Total',
  Pm0409_3BoardComp6PerPersonWvalue = 'PM0409_3_BoardComp6_PerPersonWvalue',
  Pm0410_1BoardComp7PerPerson = 'PM0410_1_BoardComp7_PerPerson',
  Pm0410_2BoardComp7Total = 'PM0410_2_BoardComp7_Total',
  Pm0410_3BoardComp7PerPersonWvalue = 'PM0410_3_BoardComp7_PerPersonWvalue',
  Pm0411_1BoardComp8PerPerson = 'PM0411_1_BoardComp8_PerPerson',
  Pm0411_2BoardComp8Total = 'PM0411_2_BoardComp8_Total',
  Pm0411_3BoardComp8PerPersonWvalue = 'PM0411_3_BoardComp8_PerPersonWvalue',
  Pm0412_1BoardComp9PerPerson = 'PM0412_1_BoardComp9_PerPerson',
  Pm0412_2BoardComp9Total = 'PM0412_2_BoardComp9_Total',
  Pm0412_3BoardComp9PerPersonWvalue = 'PM0412_3_BoardComp9_PerPersonWvalue',
  Pm0413_1CstmSurveyMixiPositiveRatio = 'PM0413_1_CstmSurveyMixi_PositiveRatio',
  Pm0414_1NonStatutoryOvertimeSumPerHc = 'PM0414_1_NonStatutoryOvertime_SumPerHC',
  Pm0414_2NonStatutoryOvertimeSumPerHcWithOt = 'PM0414_2_NonStatutoryOvertime_SumPerHCWithOT',
  Pm0414_3NonStatutoryOvertimePerRecord = 'PM0414_3_NonStatutoryOvertime_PerRecord',
  Pm0414_4NonStatutoryOvertimeMedian = 'PM0414_4_NonStatutoryOvertime_Median',
  Pm0414_5NonStatutoryOvertimeMax = 'PM0414_5_NonStatutoryOvertime_Max',
  Pm0414_6NonStatutoryOvertimeMin = 'PM0414_6_NonStatutoryOvertime_Min',
  Pm0415_1CstmTenure1Median = 'PM0415_1_CstmTenure1_Median',
  Pm0415_2CstmTenure1Avg = 'PM0415_2_CstmTenure1_Avg',
  Pm0415_3CstmTenure1Max = 'PM0415_3_CstmTenure1_Max',
  Pm0415_4CstmTenure1Min = 'PM0415_4_CstmTenure1_Min',
  Pm0416_1CstmSurveyJtEngmtAvg = 'PM0416_1_CstmSurveyJT_EngmtAvg',
  Pm0424_1TotalPayrollWorkforceCostTotal = 'PM0424_1_TotalPayrollWorkforceCost_Total',
  Pm0424_2TotalPayrollWorkforceCostPerIndiv = 'PM0424_2_TotalPayrollWorkforceCost_PerIndiv',
  Pm0424_3TotalPayrollWorkforceCostPerPersonWvalue = 'PM0424_3_TotalPayrollWorkforceCost_PerPersonWvalue',
  Pm0425_1JobPerformanceCompTotal = 'PM0425_1_JobPerformanceComp_Total',
  Pm0425_2JobPerformanceCompPerIndiv = 'PM0425_2_JobPerformanceComp_PerIndiv',
  Pm0425_3JobPerformanceCompPerPersonWvalue = 'PM0425_3_JobPerformanceComp_PerPersonWvalue',
  Pm0428_1CstmPayrollWorkforceCost1Total = 'PM0428_1_CstmPayrollWorkforceCost1_Total',
  Pm0428_2CstmPayrollWorkforceCost1PerIndiv = 'PM0428_2_CstmPayrollWorkforceCost1_PerIndiv',
  Pm0428_3CstmPayrollWorkforceCost1PerPersonWvalue = 'PM0428_3_CstmPayrollWorkforceCost1_PerPersonWvalue',
  Pm0429_1CstmPayrollWorkforceCost2Total = 'PM0429_1_CstmPayrollWorkforceCost2_Total',
  Pm0429_2CstmPayrollWorkforceCost2PerIndiv = 'PM0429_2_CstmPayrollWorkforceCost2_PerIndiv',
  Pm0429_3CstmPayrollWorkforceCost2PerPersonWvalue = 'PM0429_3_CstmPayrollWorkforceCost2_PerPersonWvalue',
  Pm0433_1CstmBonus1PerPerson = 'PM0433_1_CstmBonus1_PerPerson',
  Pm0433_2CstmBonus1Total = 'PM0433_2_CstmBonus1_Total',
  Pm0433_3CstmBonus1PerPersonWvalue = 'PM0433_3_CstmBonus1_PerPersonWvalue',
  Pm0433_4CstmBonus1CountPersonWvalue = 'PM0433_4_CstmBonus1_CountPersonWvalue',
  Pm0434_1CstmBonus2PerPerson = 'PM0434_1_CstmBonus2_PerPerson',
  Pm0434_2CstmBonus2Total = 'PM0434_2_CstmBonus2_Total',
  Pm0434_3CstmBonus2PerPersonWvalue = 'PM0434_3_CstmBonus2_PerPersonWvalue',
  Pm0434_4CstmBonus2CountPersonWvalue = 'PM0434_4_CstmBonus2_CountPersonWvalue',
  Pm0435_1CstmBonus3PerPerson = 'PM0435_1_CstmBonus3_PerPerson',
  Pm0435_2CstmBonus3Total = 'PM0435_2_CstmBonus3_Total',
  Pm0435_3CstmBonus3PerPersonWvalue = 'PM0435_3_CstmBonus3_PerPersonWvalue',
  Pm0435_4CstmBonus3CountPersonWvalue = 'PM0435_4_CstmBonus3_CountPersonWvalue',
  Pm0436_1CstmBonus4PerPerson = 'PM0436_1_CstmBonus4_PerPerson',
  Pm0436_2CstmBonus4Total = 'PM0436_2_CstmBonus4_Total',
  Pm0436_3CstmBonus4PerPersonWvalue = 'PM0436_3_CstmBonus4_PerPersonWvalue',
  Pm0436_4CstmBonus4CountPersonWvalue = 'PM0436_4_CstmBonus4_CountPersonWvalue',
  Pm0437_1CstmBonus5PerPerson = 'PM0437_1_CstmBonus5_PerPerson',
  Pm0437_2CstmBonus5Total = 'PM0437_2_CstmBonus5_Total',
  Pm0437_3CstmBonus5PerPersonWvalue = 'PM0437_3_CstmBonus5_PerPersonWvalue',
  Pm0437_4CstmBonus5CountPersonWvalue = 'PM0437_4_CstmBonus5_CountPersonWvalue',
  Pm0438_1CstmBonus6PerPerson = 'PM0438_1_CstmBonus6_PerPerson',
  Pm0438_2CstmBonus6Total = 'PM0438_2_CstmBonus6_Total',
  Pm0438_3CstmBonus6PerPersonWvalue = 'PM0438_3_CstmBonus6_PerPersonWvalue',
  Pm0438_4CstmBonus6CountPersonWvalue = 'PM0438_4_CstmBonus6_CountPersonWvalue',
  Pm0439_1CstmBonus7PerPerson = 'PM0439_1_CstmBonus7_PerPerson',
  Pm0439_2CstmBonus7Total = 'PM0439_2_CstmBonus7_Total',
  Pm0439_3CstmBonus7PerPersonWvalue = 'PM0439_3_CstmBonus7_PerPersonWvalue',
  Pm0439_4CstmBonus7CountPersonWvalue = 'PM0439_4_CstmBonus7_CountPersonWvalue',
  Pm0440_1CstmBonus8PerPerson = 'PM0440_1_CstmBonus8_PerPerson',
  Pm0440_2CstmBonus8Total = 'PM0440_2_CstmBonus8_Total',
  Pm0440_3CstmBonus8PerPersonWvalue = 'PM0440_3_CstmBonus8_PerPersonWvalue',
  Pm0440_4CstmBonus8CountPersonWvalue = 'PM0440_4_CstmBonus8_CountPersonWvalue',
  Pm0441_1CstmBonus9PerPerson = 'PM0441_1_CstmBonus9_PerPerson',
  Pm0441_2CstmBonus9Total = 'PM0441_2_CstmBonus9_Total',
  Pm0441_3CstmBonus9PerPersonWvalue = 'PM0441_3_CstmBonus9_PerPersonWvalue',
  Pm0441_4CstmBonus9CountPersonWvalue = 'PM0441_4_CstmBonus9_CountPersonWvalue',
  Pm0442_1CstmBonus10PerPerson = 'PM0442_1_CstmBonus10_PerPerson',
  Pm0442_2CstmBonus10Total = 'PM0442_2_CstmBonus10_Total',
  Pm0442_3CstmBonus10PerPersonWvalue = 'PM0442_3_CstmBonus10_PerPersonWvalue',
  Pm0442_4CstmBonus10CountPersonWvalue = 'PM0442_4_CstmBonus10_CountPersonWvalue',
  Pm0443_1MngDef2Count = 'PM0443_1_MngDef2_Count',
  Pm0443_2MngDef2PercHc = 'PM0443_2_MngDef2_PercHC',
  Pm0444_1CltIndividualsJpn0000033Count = 'PM0444_1_CltIndividualsJPN0000033_Count',
  Pm0446_3SickLeaveDaysPerPersonWvalue = 'PM0446_3_SickLeaveDays_PerPersonWvalue',
  Pm0446_4SickLeaveDaysEmpRatio = 'PM0446_4_SickLeaveDays_EmpRatio',
  Pm0446_5SickLeaveDaysEmpCount = 'PM0446_5_SickLeaveDays_EmpCount',
  Pm0447_1CltLeaversJpn0000029Count = 'PM0447_1_CltLeaversJPN0000029_Count',
  Pm0448_1MhcCount = 'PM0448_1_MHC_Count',
  Pm0448_2MhcPerPerson = 'PM0448_2_MHC_PerPerson',
  Pm0449_1DaysOfParentalLeaveTakenNoTempPerPersonWvalue = 'PM0449_1_DaysOfParentalLeaveTakenNoTemp_PerPersonWvalue',
  Pm0449_2DaysOfParentalLeaveTakenNoTempTotal = 'PM0449_2_DaysOfParentalLeaveTakenNoTemp_Total',
  Pm0450_1PrePostNatalLeaveUtilizationCountDenom = 'PM0450_1_PrePostNatalLeaveUtilization_CountDenom',
  Pm0450_2PrePostNatalLeaveUtilizationPerc = 'PM0450_2_PrePostNatalLeaveUtilization_Perc',
  Pm0450_3PrePostNatalLeaveUtilizationCountNum = 'PM0450_3_PrePostNatalLeaveUtilization_CountNum',
  Pm0451_1CaregivLeaveDaysPercWorkingDays = 'PM0451_1_CaregivLeaveDays_PercWorkingDays',
  Pm0451_2CaregivLeaveDaysPerPerson = 'PM0451_2_CaregivLeaveDays_PerPerson',
  Pm0451_3CaregivLeaveDaysPerPersonWvalue = 'PM0451_3_CaregivLeaveDays_PerPersonWvalue',
  Pm0451_4CaregivLeaveDaysEmpRatio = 'PM0451_4_CaregivLeaveDays_EmpRatio',
  Pm0451_5CaregivLeaveDaysEmpCount = 'PM0451_5_CaregivLeaveDays_EmpCount'
}

export type RequestPasswordChange = {
  __typename?: 'RequestPasswordChange';
  domain: Maybe<Scalars['Domain']['output']>;
  excludedRoles: Array<Scalars['ID']['output']>;
  roles: Maybe<Array<Scalars['ID']['output']>>;
};

export type RequestPasswordChangeInput = {
  domain: InputMaybe<Scalars['Domain']['input']>;
  excludedRoles: Array<Scalars['ID']['input']>;
  roles: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ResponseMessage = {
  __typename?: 'ResponseMessage';
  debugString: Scalars['String']['output'];
  response: ChappiResponse;
};

export type ResponseValue = BigDecimalValue | BooleanValue | Confidential | DateValue | DoubleValue | IntValue | JsonValue | StringValue | TimestampValue;

/** The target population that should be used to apply restrictions for the reporting line, attributes and own-org. */
export enum RestrictionsPopulationTarget {
  /** Means that we apply restrictions for every versionid based on the employee-data for that respective versionid */
  AttributeHistory = 'AttributeHistory',
  /** Means that we apply restrictions for every versionid based on the latest employee versionid */
  IndividualHistory = 'IndividualHistory'
}

export type RevokePermissions = {
  __typename?: 'RevokePermissions';
  domain: Maybe<Scalars['Domain']['output']>;
  excludedRoles: Array<Scalars['ID']['output']>;
  roles: Maybe<Array<Scalars['ID']['output']>>;
};

export type RevokePermissionsInput = {
  domain: InputMaybe<Scalars['Domain']['input']>;
  excludedRoles: Array<Scalars['ID']['input']>;
  roles: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** A role can either be a grouping element (think, recruiting-team role) or the role that defines a user. In that sense users are just roles that have specific properties, e.g. the ability to login to the system */
export type Role = {
  __typename?: 'Role';
  allPermissions: Maybe<Array<AssignedPermission>>;
  allowedDomains: Maybe<Array<DomainInfo>>;
  directPermissions: Maybe<Array<AssignedPermission>>;
  directRoles: Maybe<Array<Role>>;
  domain: Maybe<Scalars['Domain']['output']>;
  executorRoles: Maybe<Array<Role>>;
  id: Scalars['ID']['output'];
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  preferencesLatestVersion: Maybe<RolePreferencesVersion>;
};


/** A role can either be a grouping element (think, recruiting-team role) or the role that defines a user. In that sense users are just roles that have specific properties, e.g. the ability to login to the system */
export type RoleAllPermissionsArgs = {
  cacheBehaviour?: CacheBehaviour;
  subsetOnly?: Scalars['Boolean']['input'];
};


/** A role can either be a grouping element (think, recruiting-team role) or the role that defines a user. In that sense users are just roles that have specific properties, e.g. the ability to login to the system */
export type RoleAllowedDomainsArgs = {
  cacheBehaviour?: CacheBehaviour;
  partnerDomainFilter: InputMaybe<Scalars['String']['input']>;
};


/** A role can either be a grouping element (think, recruiting-team role) or the role that defines a user. In that sense users are just roles that have specific properties, e.g. the ability to login to the system */
export type RoleDirectRolesArgs = {
  cacheBehaviour?: CacheBehaviour;
  includeOwnRole?: Scalars['Boolean']['input'];
};


/** A role can either be a grouping element (think, recruiting-team role) or the role that defines a user. In that sense users are just roles that have specific properties, e.g. the ability to login to the system */
export type RoleExecutorRolesArgs = {
  cacheBehaviour?: CacheBehaviour;
  domainFilter: InputMaybe<Scalars['Domain']['input']>;
};


/** A role can either be a grouping element (think, recruiting-team role) or the role that defines a user. In that sense users are just roles that have specific properties, e.g. the ability to login to the system */
export type RoleIsEnabledArgs = {
  domain: Scalars['Domain']['input'];
};


/** A role can either be a grouping element (think, recruiting-team role) or the role that defines a user. In that sense users are just roles that have specific properties, e.g. the ability to login to the system */
export type RolePreferencesLatestVersionArgs = {
  topLevelKeyFilter?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RolePreferencesVersion = {
  __typename?: 'RolePreferencesVersion';
  createdAt: Scalars['Instant']['output'];
  creator: Maybe<Scalars['String']['output']>;
  settings: Scalars['Json']['output'];
  version: Scalars['Long']['output'];
};

export type SavedPanaDashboardVersion = {
  __typename?: 'SavedPanaDashboardVersion';
  db: PanaDashboardVersion;
  id: Scalars['ID']['output'];
};

export type SingleValueByCalendarMonthsTimeSelection = {
  __typename?: 'SingleValueByCalendarMonthsTimeSelection';
  end: Scalars['LocalDate']['output'];
  start: Scalars['LocalDate']['output'];
};

export type SingleValueByCalendarMonthsTimeSelectionInput = {
  end: Scalars['LocalDate']['input'];
  start: Scalars['LocalDate']['input'];
};

export type SingleValueByCalendarYearsTimeSelection = {
  __typename?: 'SingleValueByCalendarYearsTimeSelection';
  end: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
};

export type SingleValueByCalendarYearsTimeSelectionInput = {
  end: Scalars['Int']['input'];
  start: Scalars['Int']['input'];
};

export type SingleValueByFinancialQuartersTimeSelection = {
  __typename?: 'SingleValueByFinancialQuartersTimeSelection';
  end: Quarter;
  start: Quarter;
};

export type SingleValueByFinancialQuartersTimeSelectionInput = {
  end: QuarterInput;
  start: QuarterInput;
};

export type SingleValueByFinancialYearsTimeSelection = {
  __typename?: 'SingleValueByFinancialYearsTimeSelection';
  end: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
};

export type SingleValueByFinancialYearsTimeSelectionInput = {
  end: Scalars['Int']['input'];
  start: Scalars['Int']['input'];
};

export type SingleValueTimeSegment = {
  __typename?: 'SingleValueTimeSegment';
  end: Scalars['LocalDate']['output'];
  start: Scalars['LocalDate']['output'];
};

export type SingleValueTimeSelectionInput = {
  end: Scalars['LocalDate']['input'];
  start: Scalars['LocalDate']['input'];
};

export type SortCriteriaInput = {
  field: ChappiConversationSortField;
  order: ChappiConversationSortOrder;
};

/** Exactly one of the parameters must be set */
export type SqlInputValueInput = {
  bigDecimal: InputMaybe<Scalars['BigDecimal']['input']>;
  date: InputMaybe<Scalars['LocalDate']['input']>;
  double: InputMaybe<Scalars['Float']['input']>;
  int: InputMaybe<Scalars['Int']['input']>;
  json: InputMaybe<Scalars['Json']['input']>;
  long: InputMaybe<Scalars['Long']['input']>;
  null: InputMaybe<Scalars['Unit']['input']>;
  string: InputMaybe<Scalars['String']['input']>;
};

export type SqlLitValue = BigDecimalValue | BooleanValue | DateValue | DoubleValue | IntValue | JsonValue | StringValue | TimestampValue;

export type SqlQueryResponse = {
  __typename?: 'SqlQueryResponse';
  data: Array<Array<Maybe<ResponseValue>>>;
};

export type StringValue = {
  __typename?: 'StringValue';
  value: Scalars['String']['output'];
};

export type SystemMessage = {
  __typename?: 'SystemMessage';
  content: Scalars['String']['output'];
  debugString: Scalars['String']['output'];
};

export type TimeSegment = CalendarYearMonthlySegment | CalendarYearQuarterlySegment | CalendarYearSingleValueByMonthsSegment | CalendarYearSingleValueByYearsSegment | CalendarYearYearlySegment | FinancialYearQuarterlySegment | FinancialYearSingleValueByQuartersSegment | FinancialYearSingleValueByYearsSegment | FinancialYearYearlySegment | SingleValueTimeSegment;

/** Exactly one of the parameters must be set */
export type TimeSelectionInput = {
  calendarYearMonthly: InputMaybe<CalendarYearMonthlyTimeSelectionInput>;
  calendarYearQuarterly: InputMaybe<CalendarYearQuarterlyTimeSelectionInput>;
  calendarYearYearly: InputMaybe<CalendarYearYearlyTimeSelectionInput>;
  financialYearQuarterly: InputMaybe<FinancialYearQuarterlyTimeSelectionInput>;
  financialYearYearly: InputMaybe<FinancialYearYearlyTimeSelectionInput>;
  singleValue: InputMaybe<SingleValueTimeSelectionInput>;
  singleValueByCalendarMonths: InputMaybe<SingleValueByCalendarMonthsTimeSelectionInput>;
  singleValueByCalendarYears: InputMaybe<SingleValueByCalendarYearsTimeSelectionInput>;
  singleValueByFinancialQuarters: InputMaybe<SingleValueByFinancialQuartersTimeSelectionInput>;
  singleValueByFinancialYears: InputMaybe<SingleValueByFinancialYearsTimeSelectionInput>;
};

export type TimestampValue = {
  __typename?: 'TimestampValue';
  value: Scalars['LocalDateTime']['output'];
};

export type UpdatePassword = {
  __typename?: 'UpdatePassword';
  domain: Maybe<Scalars['Domain']['output']>;
  excludedRoles: Array<Scalars['ID']['output']>;
  roles: Maybe<Array<Scalars['ID']['output']>>;
};

export type UpdatePasswordInput = {
  domain: InputMaybe<Scalars['Domain']['input']>;
  excludedRoles: Array<Scalars['ID']['input']>;
  roles: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateRoleName = {
  __typename?: 'UpdateRoleName';
  domain: Maybe<Scalars['Domain']['output']>;
};

export type UpdateRoleNameInput = {
  domain: InputMaybe<Scalars['Domain']['input']>;
};

export type UseFilters = {
  __typename?: 'UseFilters';
  /** Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! */
  allowedTags: Maybe<Array<Scalars['String']['output']>>;
  /** Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! */
  domain: Maybe<Scalars['Domain']['output']>;
};

export type UseFiltersInput = {
  /** Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! */
  allowedTags: InputMaybe<Array<Scalars['String']['input']>>;
  /** Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! */
  domain: InputMaybe<Scalars['Domain']['input']>;
};

export type UsedFieldsForDataType = {
  __typename?: 'UsedFieldsForDataType';
  dataType: ApiMasterDataType;
  datafields: Array<Scalars['Datafield']['output']>;
};

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  roleId: Scalars['ID']['output'];
  userInfo: UserInfo;
  userRole: Maybe<Role>;
};

export type UserInfo = {
  __typename?: 'UserInfo';
  email: Scalars['String']['output'];
};

export type ViewDashboards = {
  __typename?: 'ViewDashboards';
  /** Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! */
  dashboardPages: Maybe<Array<DashboardPagesAccess>>;
  domain: Maybe<Scalars['Domain']['output']>;
  /** Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! */
  exportChartView: Maybe<Array<Scalars['Dashboard']['output']>>;
  /** Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! */
  exportDataView: Maybe<Array<Scalars['Dashboard']['output']>>;
  /** Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! */
  viewDataView: Maybe<Array<Scalars['Dashboard']['output']>>;
};

export type ViewDashboardsInput = {
  /** Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! */
  dashboardPages: InputMaybe<Array<DashboardPagesAccessInput>>;
  domain: InputMaybe<Scalars['Domain']['input']>;
  /** Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! */
  exportChartView: InputMaybe<Array<Scalars['Dashboard']['input']>>;
  /** Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! */
  exportDataView: InputMaybe<Array<Scalars['Dashboard']['input']>>;
  /** Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! */
  viewDataView: InputMaybe<Array<Scalars['Dashboard']['input']>>;
};

export type ViewMetrics = {
  __typename?: 'ViewMetrics';
  /** The list of tags that specify which metrics are allowed. Format of the tags must be 'metric:$id', e.g. 'metric:PM0163_TenureInJobgrade_avg'. Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! */
  allowedTags: Maybe<Array<Scalars['String']['output']>>;
  /** Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! */
  domain: Maybe<Scalars['Domain']['output']>;
};

export type ViewMetricsInput = {
  /** The list of tags that specify which metrics are allowed. Format of the tags must be 'metric:$id', e.g. 'metric:PM0163_TenureInJobgrade_avg'. Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! */
  allowedTags: InputMaybe<Array<Scalars['String']['input']>>;
  /** Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! */
  domain: InputMaybe<Scalars['Domain']['input']>;
};

export type ViewPermissions = {
  __typename?: 'ViewPermissions';
  domain: Maybe<Scalars['Domain']['output']>;
  excludedRoles: Array<Scalars['ID']['output']>;
  roles: Maybe<Array<Scalars['ID']['output']>>;
};

export type ViewPermissionsInput = {
  domain: InputMaybe<Scalars['Domain']['input']>;
  excludedRoles: Array<Scalars['ID']['input']>;
  roles: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ViewReports = {
  __typename?: 'ViewReports';
  domain: Maybe<Scalars['Domain']['output']>;
  reports: Maybe<Array<Scalars['String']['output']>>;
};

export type ViewReportsInput = {
  domain: InputMaybe<Scalars['Domain']['input']>;
  reports: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Allows to view anything that is in the scope of a role, such as this role's permissions, configuration/settings etc. */
export type ViewRoleScope = {
  __typename?: 'ViewRoleScope';
  /** Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! */
  domain: Maybe<Scalars['Domain']['output']>;
  excludedRoles: Array<Scalars['ID']['output']>;
  /** Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! */
  role: Maybe<Scalars['ID']['output']>;
};

/** Allows to view anything that is in the scope of a role, such as this role's permissions, configuration/settings etc. */
export type ViewRoleScopeInput = {
  /** Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! */
  domain: InputMaybe<Scalars['Domain']['input']>;
  excludedRoles: Array<Scalars['ID']['input']>;
  /** Restricts access to the specified value(s). Note that not setting a value (null) means unrestricted access! */
  role: InputMaybe<Scalars['ID']['input']>;
};

export type ViewRoles = {
  __typename?: 'ViewRoles';
  domain: Maybe<Scalars['Domain']['output']>;
  excludedRoles: Array<Scalars['ID']['output']>;
  roles: Maybe<Array<Scalars['ID']['output']>>;
};

export type ViewRolesInput = {
  domain: InputMaybe<Scalars['Domain']['input']>;
  excludedRoles: Array<Scalars['ID']['input']>;
  roles: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type WriteClientFile = {
  __typename?: 'WriteClientFile';
  domain: Maybe<Scalars['Domain']['output']>;
};

export type WriteClientFileInput = {
  domain: InputMaybe<Scalars['Domain']['input']>;
};

export type AvailableTimeRangesQueryVariables = Exact<{
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type AvailableTimeRangesQuery = { __typename?: 'Queries', availableTimeranges: Array<{ __typename?: 'AvailableTimerangesInterpolatedForDataType', dataType: ApiMasterDataType, availableTimerange: { __typename?: 'AvailableTimerangesInterpolated', calendarYearMonthly: Array<any> | null, calendarYearYearly: Array<number> | null, financialYearYearly: Array<number> | null, financialYearQuarterly: Array<{ __typename?: 'Quarter', quarterOfYear: number, year: number }> | null } }> | null };

export type MetricResultsDataFragment = { __typename?: 'MetricResults', results: Array<{ __typename: 'MetricResultFailure', message: string, errorReference: string | null, meta: { __typename?: 'MetricResultMetaData', metricSql: string | null } } | { __typename: 'MetricResultSuccess', metricId: MetricId, segments: Array<{ __typename?: 'MetricTimeSegmentData', groupSegments: Array<{ __typename?: 'MetricGroupSegmentData', data: { __typename: 'BigDecimalValue', bigDecimal: any } | { __typename: 'BooleanValue', boolean: boolean } | { __typename: 'Confidential', reason: string | null } | { __typename: 'DateValue', date: any } | { __typename: 'DoubleValue', double: number } | { __typename: 'IntValue', int: number } | { __typename: 'JsonValue', json: any } | { __typename: 'StringValue', string: string } | { __typename: 'TimestampValue', timestamp: any } | null, groupSegment: Array<{ __typename?: 'ByFieldSegment', dataField: any, dataType: any, value: { __typename: 'BigDecimalValue', bigDecimal: any } | { __typename: 'BooleanValue', boolean: boolean } | { __typename: 'Confidential', reason: string | null } | { __typename: 'DateValue', date: any } | { __typename: 'DoubleValue', double: number } | { __typename: 'IntValue', int: number } | { __typename: 'JsonValue', json: any } | { __typename: 'StringValue', string: string } | { __typename: 'TimestampValue', timestamp: any } | null }> }>, timeSegment: { __typename: 'CalendarYearMonthlySegment', date: any } | { __typename: 'CalendarYearQuarterlySegment', quarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'CalendarYearSingleValueByMonthsSegment' } | { __typename: 'CalendarYearSingleValueByYearsSegment' } | { __typename: 'CalendarYearYearlySegment', year: number } | { __typename: 'FinancialYearQuarterlySegment', quarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'FinancialYearSingleValueByQuartersSegment' } | { __typename: 'FinancialYearSingleValueByYearsSegment' } | { __typename: 'FinancialYearYearlySegment', year: number } | { __typename: 'SingleValueTimeSegment', end: any, start: any } }>, meta: { __typename?: 'MetricResultMetaData', metricSql: string | null } }> };

export type QueryCohortMetricsQueryVariables = Exact<{
  domain: Scalars['Domain']['input'];
  metrics: Array<CohortMetricId> | CohortMetricId;
  disableNestLoop: InputMaybe<Scalars['Boolean']['input']>;
  grouping: InputMaybe<GroupingInput>;
  timeSelection: TimeSelectionInput;
  userCohortFilters: InputMaybe<Scalars['String']['input']>;
  selectedExecutorRole: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type QueryCohortMetricsQuery = { __typename?: 'Queries', queryCohortMetrics: { __typename?: 'MetricResults', results: Array<{ __typename: 'MetricResultFailure', message: string, errorReference: string | null, meta: { __typename?: 'MetricResultMetaData', metricSql: string | null } } | { __typename: 'MetricResultSuccess', metricId: MetricId, segments: Array<{ __typename?: 'MetricTimeSegmentData', groupSegments: Array<{ __typename?: 'MetricGroupSegmentData', data: { __typename: 'BigDecimalValue', bigDecimal: any } | { __typename: 'BooleanValue', boolean: boolean } | { __typename: 'Confidential', reason: string | null } | { __typename: 'DateValue', date: any } | { __typename: 'DoubleValue', double: number } | { __typename: 'IntValue', int: number } | { __typename: 'JsonValue', json: any } | { __typename: 'StringValue', string: string } | { __typename: 'TimestampValue', timestamp: any } | null, groupSegment: Array<{ __typename?: 'ByFieldSegment', dataField: any, dataType: any, value: { __typename: 'BigDecimalValue', bigDecimal: any } | { __typename: 'BooleanValue', boolean: boolean } | { __typename: 'Confidential', reason: string | null } | { __typename: 'DateValue', date: any } | { __typename: 'DoubleValue', double: number } | { __typename: 'IntValue', int: number } | { __typename: 'JsonValue', json: any } | { __typename: 'StringValue', string: string } | { __typename: 'TimestampValue', timestamp: any } | null }> }>, timeSegment: { __typename: 'CalendarYearMonthlySegment', date: any } | { __typename: 'CalendarYearQuarterlySegment', quarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'CalendarYearSingleValueByMonthsSegment' } | { __typename: 'CalendarYearSingleValueByYearsSegment' } | { __typename: 'CalendarYearYearlySegment', year: number } | { __typename: 'FinancialYearQuarterlySegment', quarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'FinancialYearSingleValueByQuartersSegment' } | { __typename: 'FinancialYearSingleValueByYearsSegment' } | { __typename: 'FinancialYearYearlySegment', year: number } | { __typename: 'SingleValueTimeSegment', end: any, start: any } }>, meta: { __typename?: 'MetricResultMetaData', metricSql: string | null } }> } | null };

export type QueryMetricsQueryVariables = Exact<{
  domain: Scalars['Domain']['input'];
  metrics: Array<RegularMetricId> | RegularMetricId;
  disableNestLoop: InputMaybe<Scalars['Boolean']['input']>;
  grouping: InputMaybe<GroupingInput>;
  timeSelection: TimeSelectionInput;
  userFilters: InputMaybe<Scalars['String']['input']>;
  selectedExecutorRole: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type QueryMetricsQuery = { __typename?: 'Queries', queryMetrics: { __typename?: 'MetricResults', results: Array<{ __typename: 'MetricResultFailure', message: string, errorReference: string | null, meta: { __typename?: 'MetricResultMetaData', metricSql: string | null } } | { __typename: 'MetricResultSuccess', metricId: MetricId, segments: Array<{ __typename?: 'MetricTimeSegmentData', groupSegments: Array<{ __typename?: 'MetricGroupSegmentData', data: { __typename: 'BigDecimalValue', bigDecimal: any } | { __typename: 'BooleanValue', boolean: boolean } | { __typename: 'Confidential', reason: string | null } | { __typename: 'DateValue', date: any } | { __typename: 'DoubleValue', double: number } | { __typename: 'IntValue', int: number } | { __typename: 'JsonValue', json: any } | { __typename: 'StringValue', string: string } | { __typename: 'TimestampValue', timestamp: any } | null, groupSegment: Array<{ __typename?: 'ByFieldSegment', dataField: any, dataType: any, value: { __typename: 'BigDecimalValue', bigDecimal: any } | { __typename: 'BooleanValue', boolean: boolean } | { __typename: 'Confidential', reason: string | null } | { __typename: 'DateValue', date: any } | { __typename: 'DoubleValue', double: number } | { __typename: 'IntValue', int: number } | { __typename: 'JsonValue', json: any } | { __typename: 'StringValue', string: string } | { __typename: 'TimestampValue', timestamp: any } | null }> }>, timeSegment: { __typename: 'CalendarYearMonthlySegment', date: any } | { __typename: 'CalendarYearQuarterlySegment', quarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'CalendarYearSingleValueByMonthsSegment' } | { __typename: 'CalendarYearSingleValueByYearsSegment' } | { __typename: 'CalendarYearYearlySegment', year: number } | { __typename: 'FinancialYearQuarterlySegment', quarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'FinancialYearSingleValueByQuartersSegment' } | { __typename: 'FinancialYearSingleValueByYearsSegment' } | { __typename: 'FinancialYearYearlySegment', year: number } | { __typename: 'SingleValueTimeSegment', end: any, start: any } }>, meta: { __typename?: 'MetricResultMetaData', metricSql: string | null } }> } | null };

export type QueryEmployeeCohortMetricsQueryVariables = Exact<{
  domain: Scalars['Domain']['input'];
  metrics: Array<EmployeeCohortMetricId> | EmployeeCohortMetricId;
  disableNestLoop: InputMaybe<Scalars['Boolean']['input']>;
  grouping: InputMaybe<GroupingInput>;
  timeSelection: TimeSelectionInput;
  userFilters: InputMaybe<Scalars['String']['input']>;
  userCohortFilters: InputMaybe<Scalars['String']['input']>;
  selectedExecutorRole: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type QueryEmployeeCohortMetricsQuery = { __typename?: 'Queries', queryEmployeeCohortMetrics: { __typename?: 'MetricResults', results: Array<{ __typename: 'MetricResultFailure', message: string, errorReference: string | null, meta: { __typename?: 'MetricResultMetaData', metricSql: string | null } } | { __typename: 'MetricResultSuccess', metricId: MetricId, segments: Array<{ __typename?: 'MetricTimeSegmentData', groupSegments: Array<{ __typename?: 'MetricGroupSegmentData', data: { __typename: 'BigDecimalValue', bigDecimal: any } | { __typename: 'BooleanValue', boolean: boolean } | { __typename: 'Confidential', reason: string | null } | { __typename: 'DateValue', date: any } | { __typename: 'DoubleValue', double: number } | { __typename: 'IntValue', int: number } | { __typename: 'JsonValue', json: any } | { __typename: 'StringValue', string: string } | { __typename: 'TimestampValue', timestamp: any } | null, groupSegment: Array<{ __typename?: 'ByFieldSegment', dataField: any, dataType: any, value: { __typename: 'BigDecimalValue', bigDecimal: any } | { __typename: 'BooleanValue', boolean: boolean } | { __typename: 'Confidential', reason: string | null } | { __typename: 'DateValue', date: any } | { __typename: 'DoubleValue', double: number } | { __typename: 'IntValue', int: number } | { __typename: 'JsonValue', json: any } | { __typename: 'StringValue', string: string } | { __typename: 'TimestampValue', timestamp: any } | null }> }>, timeSegment: { __typename: 'CalendarYearMonthlySegment', date: any } | { __typename: 'CalendarYearQuarterlySegment', quarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'CalendarYearSingleValueByMonthsSegment' } | { __typename: 'CalendarYearSingleValueByYearsSegment' } | { __typename: 'CalendarYearYearlySegment', year: number } | { __typename: 'FinancialYearQuarterlySegment', quarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'FinancialYearSingleValueByQuartersSegment' } | { __typename: 'FinancialYearSingleValueByYearsSegment' } | { __typename: 'FinancialYearYearlySegment', year: number } | { __typename: 'SingleValueTimeSegment', end: any, start: any } }>, meta: { __typename?: 'MetricResultMetaData', metricSql: string | null } }> } | null };

export type ListAllMetricDefsQueryVariables = Exact<{
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type ListAllMetricDefsQuery = { __typename?: 'Queries', listAllMetricDefs: Array<{ __typename?: 'MetricDef', id: MetricId, name: string, tooltipJapanese: string | null, tooltipEnglish: string | null }> | null };

export type ExecuteCustomSqlQueryQueryVariables = Exact<{
  domain: Scalars['Domain']['input'];
  querySql: Scalars['String']['input'];
  selectedExecutorRole: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
  disableNestLoop: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ExecuteCustomSqlQueryQuery = { __typename?: 'Queries', executeCustomSqlQuery: { __typename?: 'SqlQueryResponse', data: Array<Array<{ __typename: 'BigDecimalValue', bigDecimal: any } | { __typename: 'BooleanValue', boolean: boolean } | { __typename: 'Confidential', reason: string | null } | { __typename: 'DateValue', date: any } | { __typename: 'DoubleValue', double: number } | { __typename: 'IntValue', int: number } | { __typename: 'JsonValue', json: any } | { __typename: 'StringValue', string: string } | { __typename: 'TimestampValue', timestamp: any } | null>> } | null };

export type ExecuteWhitelistedSqlQueryQueryVariables = Exact<{
  domain: Scalars['Domain']['input'];
  querySql: Scalars['String']['input'];
  selectedExecutorRole: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type ExecuteWhitelistedSqlQueryQuery = { __typename?: 'Queries', executeWhitelistedSqlQuery: { __typename?: 'SqlQueryResponse', data: Array<Array<{ __typename: 'BigDecimalValue', bigDecimal: any } | { __typename: 'BooleanValue', boolean: boolean } | { __typename: 'Confidential', reason: string | null } | { __typename: 'DateValue', date: any } | { __typename: 'DoubleValue', double: number } | { __typename: 'IntValue', int: number } | { __typename: 'JsonValue', json: any } | { __typename: 'StringValue', string: string } | { __typename: 'TimestampValue', timestamp: any } | null>> } | null };

export type ExecuteAdvancedQueryQueryVariables = Exact<{
  domain: Scalars['Domain']['input'];
  queryJson: Scalars['String']['input'];
  selectedExecutorRole: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type ExecuteAdvancedQueryQuery = { __typename?: 'Queries', executeAdvancedQuery: string | null };

export type ExecuteOldQueryQueryVariables = Exact<{
  domain: Scalars['Domain']['input'];
  queryJson: Scalars['String']['input'];
  selectedExecutorRole: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type ExecuteOldQueryQuery = { __typename?: 'Queries', executeOldQuery: string | null };

export type ExecuteMovementQueryQueryVariables = Exact<{
  domain: Scalars['Domain']['input'];
  queryJson: Scalars['String']['input'];
  selectedExecutorRole: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type ExecuteMovementQueryQuery = { __typename?: 'Queries', executeMovementQuery: string | null };

export type LatestVersionQueryVariables = Exact<{
  domain: Scalars['Domain']['input'];
  datatype: ApiMasterDataType;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type LatestVersionQuery = { __typename?: 'Queries', latestVersion: string | null };

export type ListUsedFieldsQueryVariables = Exact<{
  domain: Scalars['Domain']['input'];
  datatype: ApiMasterDataType;
  versionIdDate: InputMaybe<Scalars['LocalDate']['input']>;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type ListUsedFieldsQuery = { __typename?: 'Queries', listUsedFields: Array<any> | null };

export type ListAvailableFieldsQueryVariables = Exact<{
  datatype: ApiMasterDataType;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type ListAvailableFieldsQuery = { __typename?: 'Queries', listAvailableFields: Array<any> | null };

export type ListUsedCohortsQueryVariables = Exact<{
  domain: Scalars['Domain']['input'];
}>;


export type ListUsedCohortsQuery = { __typename?: 'Queries', listUsedCohorts: Array<{ __typename?: 'CohortTypeEntries', cohortType: string, cohortValues: Array<{ __typename?: 'CohortValues', cohortKey: string, cohortValues: Array<{ __typename: 'BigDecimalValue', bigDecimal: any } | { __typename: 'BooleanValue', boolean: boolean } | { __typename: 'DateValue', date: any } | { __typename: 'DoubleValue', double: number } | { __typename: 'IntValue', int: number } | { __typename: 'JsonValue', json: any } | { __typename: 'StringValue', string: string } | { __typename: 'TimestampValue', timestamp: any }> }> }> | null };

export type ListRolesQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ListRolesQuery = { __typename?: 'Queries', listRoles: Array<{ __typename?: 'Role', id: string, name: string, domain: any | null }> | null };

export type ListAllRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListAllRolesQuery = { __typename?: 'Queries', listAllRoles: Array<{ __typename?: 'Role', id: string, name: string, domain: any | null }> | null };

export type CurrentUserUserRoleQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserUserRoleQuery = { __typename?: 'Queries', currentUserUserRole: { __typename?: 'Role', id: string, name: string, domain: any | null, executorRoles: Array<{ __typename?: 'Role', id: string, name: string, domain: any | null }> | null } | null };

export type CurrentUserListRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserListRolesQuery = { __typename?: 'Queries', currentUserListRoles: Array<{ __typename?: 'Role', id: string, name: string, domain: any | null }> | null };

export type CurrentUserUserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserUserInfoQuery = { __typename?: 'Queries', currentUserUserInfo: { __typename?: 'UserInfo', email: string } | null };

export type ListNonUserRolesQueryVariables = Exact<{
  domain: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type ListNonUserRolesQuery = { __typename?: 'Queries', listNonUserRoles: Array<{ __typename?: 'Role', id: string, name: string, domain: any | null }> | null };

export type ListUserRolesQueryVariables = Exact<{
  domainFilter: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type ListUserRolesQuery = { __typename?: 'Queries', listUserRoles: Array<{ __typename?: 'Role', id: string, name: string, domain: any | null }> | null };

export type ListAllAllowedDomainsQueryVariables = Exact<{
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type ListAllAllowedDomainsQuery = { __typename?: 'Queries', listAllAllowedDomains: Array<string> | null };

export type AllPermissionsQueryVariables = Exact<{
  roleId: Scalars['ID']['input'];
}>;


export type AllPermissionsQuery = { __typename?: 'Queries', allPermissions: Array<{ __typename?: 'AssignedPermission', id: string, roleId: string, permission: { __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string>, permissions: Array<{ __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions' } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null }> | null } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, restrictionsPopulationTarget: RestrictionsPopulationTarget, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null } }> | null };

export type CurrentUserAllPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserAllPermissionsQuery = { __typename?: 'Queries', currentUserAllPermissions: Array<{ __typename?: 'AssignedPermission', id: string, roleId: string, permission: { __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string>, permissions: Array<{ __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions' } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null }> | null } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, restrictionsPopulationTarget: RestrictionsPopulationTarget, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null } }> | null };

export type DirectPermissionsQueryVariables = Exact<{
  roleId: Scalars['ID']['input'];
}>;


export type DirectPermissionsQuery = { __typename?: 'Queries', directPermissions: Array<{ __typename?: 'AssignedPermission', id: string, roleId: string, permission: { __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string>, permissions: Array<{ __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions' } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null }> | null } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, restrictionsPopulationTarget: RestrictionsPopulationTarget, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null } }> | null };

export type DirectPermissionsForRolesQueryVariables = Exact<{
  roleIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DirectPermissionsForRolesQuery = { __typename?: 'Queries', directPermissionsForRoles: Array<{ __typename?: 'AssignedPermissionsForRole', roleId: string, permissions: Array<{ __typename?: 'AssignedPermission', id: string, roleId: string, permission: { __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string>, permissions: Array<{ __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions' } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null }> | null } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, restrictionsPopulationTarget: RestrictionsPopulationTarget, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null } }> }> | null };

export type ListExecutorRolesForRoleQueryVariables = Exact<{
  roleId: Scalars['ID']['input'];
  domainFilter: Scalars['String']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type ListExecutorRolesForRoleQuery = { __typename?: 'Queries', listExecutorRolesForRole: Array<{ __typename: 'Role', id: string, name: string, domain: any | null }> | null };

export type MetaDataByUserEmailQueryVariables = Exact<{
  emails: Array<Scalars['String']['input']> | Scalars['String']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type MetaDataByUserEmailQuery = { __typename?: 'Queries', metaDataByUserEmail: Array<{ __typename?: 'MetaData', lastLogin: any | null }> | null };

export type MetaDataByUserRoleQueryVariables = Exact<{
  roleIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type MetaDataByUserRoleQuery = { __typename?: 'Queries', metaDataByUserRole: Array<{ __typename?: 'MetaDataForRole', roleId: string, metaData: { __typename?: 'MetaData', lastLogin: any | null } }> | null };

type SqlLitValueAll_BigDecimalValue_Fragment = { __typename: 'BigDecimalValue', bigDecimal: any };

type SqlLitValueAll_BooleanValue_Fragment = { __typename: 'BooleanValue', boolean: boolean };

type SqlLitValueAll_DateValue_Fragment = { __typename: 'DateValue', date: any };

type SqlLitValueAll_DoubleValue_Fragment = { __typename: 'DoubleValue', double: number };

type SqlLitValueAll_IntValue_Fragment = { __typename: 'IntValue', int: number };

type SqlLitValueAll_JsonValue_Fragment = { __typename: 'JsonValue', json: any };

type SqlLitValueAll_StringValue_Fragment = { __typename: 'StringValue', string: string };

type SqlLitValueAll_TimestampValue_Fragment = { __typename: 'TimestampValue', timestamp: any };

export type SqlLitValueAllFragment = SqlLitValueAll_BigDecimalValue_Fragment | SqlLitValueAll_BooleanValue_Fragment | SqlLitValueAll_DateValue_Fragment | SqlLitValueAll_DoubleValue_Fragment | SqlLitValueAll_IntValue_Fragment | SqlLitValueAll_JsonValue_Fragment | SqlLitValueAll_StringValue_Fragment | SqlLitValueAll_TimestampValue_Fragment;

type ResponseValueAll_BigDecimalValue_Fragment = { __typename: 'BigDecimalValue', bigDecimal: any };

type ResponseValueAll_BooleanValue_Fragment = { __typename: 'BooleanValue', boolean: boolean };

type ResponseValueAll_Confidential_Fragment = { __typename: 'Confidential', reason: string | null };

type ResponseValueAll_DateValue_Fragment = { __typename: 'DateValue', date: any };

type ResponseValueAll_DoubleValue_Fragment = { __typename: 'DoubleValue', double: number };

type ResponseValueAll_IntValue_Fragment = { __typename: 'IntValue', int: number };

type ResponseValueAll_JsonValue_Fragment = { __typename: 'JsonValue', json: any };

type ResponseValueAll_StringValue_Fragment = { __typename: 'StringValue', string: string };

type ResponseValueAll_TimestampValue_Fragment = { __typename: 'TimestampValue', timestamp: any };

export type ResponseValueAllFragment = ResponseValueAll_BigDecimalValue_Fragment | ResponseValueAll_BooleanValue_Fragment | ResponseValueAll_Confidential_Fragment | ResponseValueAll_DateValue_Fragment | ResponseValueAll_DoubleValue_Fragment | ResponseValueAll_IntValue_Fragment | ResponseValueAll_JsonValue_Fragment | ResponseValueAll_StringValue_Fragment | ResponseValueAll_TimestampValue_Fragment;

export type PermissionDataFragment = { __typename?: 'AssignedPermission', id: string, roleId: string, permission: { __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string>, permissions: Array<{ __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions' } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null }> | null } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, restrictionsPopulationTarget: RestrictionsPopulationTarget, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null } };

export type AddUserAndDefaultRoleMutationVariables = Exact<{
  email: Scalars['String']['input'];
  roleDomain: Scalars['Domain']['input'];
  addDefaultLoginPermission: Scalars['Boolean']['input'];
}>;


export type AddUserAndDefaultRoleMutation = { __typename?: 'Mutations', addUserAndDefaultRole: { __typename?: 'User', email: string, roleId: string, userRole: { __typename?: 'Role', domain: any | null } | null } | null };

export type AddRoleMutationVariables = Exact<{
  name: Scalars['String']['input'];
  domain: Scalars['Domain']['input'];
}>;


export type AddRoleMutation = { __typename?: 'Mutations', addRole: { __typename?: 'Role', id: string, name: string, domain: any | null } | null };

export type DeleteRoleAndPermissionsMutationVariables = Exact<{
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type DeleteRoleAndPermissionsMutation = { __typename?: 'Mutations', deleteRoleAndPermissions: { __typename?: 'DeleteRoleAndPermissionsResponse', deletedRoleId: string, revokedPermissionIds: Array<string> } | null };

export type GrantAssumeRoleMutationVariables = Exact<{
  roleId: Scalars['ID']['input'];
  domain: Scalars['Domain']['input'];
  roles: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  excludedRoles: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GrantAssumeRoleMutation = { __typename?: 'Mutations', grantAssumeRole: { __typename?: 'AssignedPermission', id: string, roleId: string, permission: { __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string>, permissions: Array<{ __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions' } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null }> | null } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, restrictionsPopulationTarget: RestrictionsPopulationTarget, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null } } | null };

export type GrantLoginMutationVariables = Exact<{
  roleId: Scalars['ID']['input'];
  domain: InputMaybe<Scalars['Domain']['input']>;
  allowedAuthenticationMethods: InputMaybe<Array<AuthenticationMethod> | AuthenticationMethod>;
}>;


export type GrantLoginMutation = { __typename?: 'Mutations', grantLogin: { __typename?: 'AssignedPermission', id: string, roleId: string, permission: { __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string>, permissions: Array<{ __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions' } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null }> | null } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, restrictionsPopulationTarget: RestrictionsPopulationTarget, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null } } | null };

export type GrantViewDashboardsMutationVariables = Exact<{
  roleId: Scalars['ID']['input'];
  domain: Scalars['Domain']['input'];
  dashboardPages: InputMaybe<Array<DashboardPagesAccessInput> | DashboardPagesAccessInput>;
  exportChartView: InputMaybe<Array<Scalars['Dashboard']['input']> | Scalars['Dashboard']['input']>;
  exportDataView: InputMaybe<Array<Scalars['Dashboard']['input']> | Scalars['Dashboard']['input']>;
  viewDataView: InputMaybe<Array<Scalars['Dashboard']['input']> | Scalars['Dashboard']['input']>;
}>;


export type GrantViewDashboardsMutation = { __typename?: 'Mutations', grantViewDashboards: { __typename?: 'AssignedPermission', id: string, roleId: string, permission: { __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string>, permissions: Array<{ __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions' } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null }> | null } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, restrictionsPopulationTarget: RestrictionsPopulationTarget, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null } } | null };

export type GrantExportReportsMutationVariables = Exact<{
  roleId: Scalars['ID']['input'];
  domain: Scalars['Domain']['input'];
}>;


export type GrantExportReportsMutation = { __typename?: 'Mutations', grantExportReports: { __typename?: 'AssignedPermission', id: string, roleId: string, permission: { __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string>, permissions: Array<{ __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions' } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null }> | null } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, restrictionsPopulationTarget: RestrictionsPopulationTarget, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null } } | null };

export type GrantReadDataMutationVariables = Exact<{
  roleId: Scalars['ID']['input'];
  domain: Scalars['Domain']['input'];
  access: InputMaybe<Array<DatatypeAccessInput> | DatatypeAccessInput>;
  popFilter: InputMaybe<Scalars['String']['input']>;
  lineHierarchyRestrictions: LineHierarchyRestrictionsInput;
}>;


export type GrantReadDataMutation = { __typename?: 'Mutations', grantReadData: { __typename?: 'AssignedPermission', id: string, roleId: string, permission: { __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string>, permissions: Array<{ __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions' } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null }> | null } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, restrictionsPopulationTarget: RestrictionsPopulationTarget, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null } } | null };

export type GrantUseFiltersMutationVariables = Exact<{
  roleId: Scalars['ID']['input'];
  domain: Scalars['Domain']['input'];
  allowedTags: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GrantUseFiltersMutation = { __typename?: 'Mutations', grantUseFilters: { __typename?: 'AssignedPermission', id: string, roleId: string, permission: { __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string>, permissions: Array<{ __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions' } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null }> | null } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, restrictionsPopulationTarget: RestrictionsPopulationTarget, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null } } | null };

export type GrantViewMetricsMutationVariables = Exact<{
  roleId: Scalars['ID']['input'];
  domain: Scalars['Domain']['input'];
  allowedTags: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GrantViewMetricsMutation = { __typename?: 'Mutations', grantViewMetrics: { __typename?: 'AssignedPermission', id: string, roleId: string, permission: { __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string>, permissions: Array<{ __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions' } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null }> | null } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, restrictionsPopulationTarget: RestrictionsPopulationTarget, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null } } | null };

export type RevokeAssignedPermissionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RevokeAssignedPermissionMutation = { __typename?: 'Mutations', revokeAssignedPermission: string | null };

export type ReplaceReadDataMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  permission: ReadDataInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type ReplaceReadDataMutation = { __typename?: 'Mutations', replaceReadData: { __typename?: 'AssignedPermission', id: string, roleId: string, permission: { __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string>, permissions: Array<{ __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions' } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null }> | null } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, restrictionsPopulationTarget: RestrictionsPopulationTarget, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null } } | null };

export type ReplaceViewDashboardsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  permission: ViewDashboardsInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type ReplaceViewDashboardsMutation = { __typename?: 'Mutations', replaceViewDashboards: { __typename?: 'AssignedPermission', id: string, roleId: string, permission: { __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string>, permissions: Array<{ __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions' } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null }> | null } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, restrictionsPopulationTarget: RestrictionsPopulationTarget, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null } } | null };

export type ReplaceLoginMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  permission: LoginInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type ReplaceLoginMutation = { __typename?: 'Mutations', replaceLogin: { __typename?: 'AssignedPermission', id: string, roleId: string, permission: { __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string>, permissions: Array<{ __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions' } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null }> | null } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, restrictionsPopulationTarget: RestrictionsPopulationTarget, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null } } | null };

export type ReplaceUseFiltersMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  permission: UseFiltersInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type ReplaceUseFiltersMutation = { __typename?: 'Mutations', replaceUseFilters: { __typename?: 'AssignedPermission', id: string, roleId: string, permission: { __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string>, permissions: Array<{ __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions' } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null }> | null } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, restrictionsPopulationTarget: RestrictionsPopulationTarget, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null } } | null };

export type ReplaceViewMetricsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  permission: ViewMetricsInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type ReplaceViewMetricsMutation = { __typename?: 'Mutations', replaceViewMetrics: { __typename?: 'AssignedPermission', id: string, roleId: string, permission: { __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string>, permissions: Array<{ __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions' } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null }> | null } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, restrictionsPopulationTarget: RestrictionsPopulationTarget, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null } } | null };

export type ListUploadedFilesQueryVariables = Exact<{
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type ListUploadedFilesQuery = { __typename?: 'Queries', listUploadedFiles: Array<string> | null };

export type ListUploadedClientObjectsQueryVariables = Exact<{
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type ListUploadedClientObjectsQuery = { __typename?: 'Queries', listUploadedClientObjects: { __typename?: 'ListUploadedClientObjectsResult', clientObjects: Array<{ __typename?: 'ClientObject', objectName: string, createdAt: any, domain: any | null, processingInfo: Array<{ __typename?: 'ProcessingEvent', dagId: string, processedTime: any }> }> } | null };

export type GenerateSignedUrlQueryVariables = Exact<{
  domain: Scalars['Domain']['input'];
  objectName: Scalars['String']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type GenerateSignedUrlQuery = { __typename?: 'Queries', generateSignedUrl: string | null };

export type CreateBucketWithDefaultStructureQueryVariables = Exact<{
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateBucketWithDefaultStructureQuery = { __typename?: 'Queries', createBucketWithDefaultStructure: any | null };

export type DeleteUploadedFileQueryVariables = Exact<{
  domain: Scalars['Domain']['input'];
  path: Scalars['String']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type DeleteUploadedFileQuery = { __typename?: 'Queries', deleteUploadedFile: any | null };

export type DomainSettingsLatestVersionQueryVariables = Exact<{
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type DomainSettingsLatestVersionQuery = { __typename?: 'Queries', domainSettingsLatestVersion: { __typename?: 'DomainSettingsVersion', version: any, createdAt: any, creator: string | null, settings: any } | null };

export type CreateNewDomainSettingsMutationVariables = Exact<{
  domain: Scalars['Domain']['input'];
  settings: Scalars['Json']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateNewDomainSettingsMutation = { __typename?: 'Mutations', createNewDomainSettings: { __typename?: 'DomainSettingsVersion', version: any, createdAt: any, creator: string | null, settings: any } | null };

export type DomainPreferencesLatestVersionQueryVariables = Exact<{
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type DomainPreferencesLatestVersionQuery = { __typename?: 'Queries', domainPreferencesLatestVersion: { __typename?: 'DomainPreferencesVersion', version: any, createdAt: any, creator: string | null, settings: any } | null };

export type CreateNewDomainPreferencesMutationVariables = Exact<{
  domain: Scalars['Domain']['input'];
  preferences: Scalars['Json']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateNewDomainPreferencesMutation = { __typename?: 'Mutations', createNewDomainPreferences: { __typename?: 'DomainPreferencesVersion', version: any, createdAt: any, creator: string | null, settings: any } | null };

export type ChangeRoleNameMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  newName: Scalars['String']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type ChangeRoleNameMutation = { __typename?: 'Mutations', changeRoleName: { __typename?: 'Role', id: string, name: string } | null };

export type AddFirebaseUserForExistingAppUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type AddFirebaseUserForExistingAppUserMutation = { __typename?: 'Mutations', addFirebaseUserForExistingAppUser: any | null };

export type GetMultiDomainAuthInfoQueryVariables = Exact<{
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetMultiDomainAuthInfoQuery = { __typename?: 'Queries', currentUserUserRole: { __typename?: 'Role', allowedDomains: Array<{ __typename?: 'DomainInfo', domain: any, nonUserRoles: Array<{ __typename?: 'Role', id: string, name: string, domain: any | null }> | null }> | null } | null, listUserRoles: Array<{ __typename?: 'Role', id: string, name: string, directPermissions: Array<{ __typename?: 'AssignedPermission', id: string, roleId: string, permission: { __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string>, permissions: Array<{ __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions' } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null }> | null } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, restrictionsPopulationTarget: RestrictionsPopulationTarget, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null } }> | null, directRoles: Array<{ __typename?: 'Role', id: string, name: string, domain: any | null }> | null }> | null };

export type AddUserAndDefaultRoleWithRoleAndPermissionsMutationVariables = Exact<{
  email: Scalars['String']['input'];
  roleDomain: Scalars['Domain']['input'];
}>;


export type AddUserAndDefaultRoleWithRoleAndPermissionsMutation = { __typename?: 'Mutations', addUserAndDefaultRole: { __typename?: 'User', email: string, roleId: string, userRole: { __typename?: 'Role', directRoles: Array<{ __typename?: 'Role', id: string, name: string, domain: any | null }> | null, directPermissions: Array<{ __typename?: 'AssignedPermission', id: string, roleId: string, permission: { __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string>, permissions: Array<{ __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions' } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null }> | null } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, restrictionsPopulationTarget: RestrictionsPopulationTarget, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null } }> | null } | null } | null };

export type SendWelcomeWithSsoMailMutationVariables = Exact<{
  receiver: Scalars['String']['input'];
}>;


export type SendWelcomeWithSsoMailMutation = { __typename?: 'Mutations', sendWelcomeWithSsoMail: any | null };

export type SendWelcomeWithPasswordMailMutationVariables = Exact<{
  receiver: Scalars['String']['input'];
}>;


export type SendWelcomeWithPasswordMailMutation = { __typename?: 'Mutations', sendWelcomeWithPasswordMail: any | null };

export type SendPasswordResetMailMutationVariables = Exact<{
  receiver: Scalars['String']['input'];
}>;


export type SendPasswordResetMailMutation = { __typename?: 'Mutations', sendPasswordResetMail: any | null };

export type ListAllDashboardsQueryVariables = Exact<{
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type ListAllDashboardsQuery = { __typename?: 'Queries', listAllDashboards: Array<{ __typename?: 'DashboardDefinition', description: string, descriptionKey: string, enabled: boolean, id: any, imagePath: string, link: string, name: string, nameKey: string, pages: Array<{ __typename?: 'PageDefinition', description: string, descriptionKey: string, enabled: boolean, imagePath: string, link: string, name: string, nameKey: string, pageId: any, pageNumber: number }> }> | null };

export type CreateNewRolePreferencesMutationVariables = Exact<{
  roleId: Scalars['ID']['input'];
  preferences: Scalars['Json']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateNewRolePreferencesMutation = { __typename?: 'Mutations', createNewRolePreferences: { __typename?: 'RolePreferencesVersion', settings: any, version: any, createdAt: any } | null };

export type RolePreferencesVersionQueryVariables = Exact<{
  roleId: Scalars['ID']['input'];
  version: Scalars['Long']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type RolePreferencesVersionQuery = { __typename?: 'Queries', rolePreferencesVersion: { __typename?: 'RolePreferencesVersion', settings: any, version: any, createdAt: any } | null };

export type RolePreferencesLatestVersionQueryVariables = Exact<{
  roleId: Scalars['ID']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type RolePreferencesLatestVersionQuery = { __typename?: 'Queries', rolePreferencesLatestVersion: { __typename?: 'RolePreferencesVersion', settings: any, version: any, createdAt: any } | null };

export type ListAliasesQueryVariables = Exact<{
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type ListAliasesQuery = { __typename?: 'Queries', listAliases: Array<{ __typename?: 'Alias', key: string, type: string, translations: Array<{ __typename?: 'AliasTranslation', language: Language, text: string }> }> | null };

export type SetAliasMutationVariables = Exact<{
  domain: Scalars['Domain']['input'];
  key: Scalars['String']['input'];
  type: Scalars['String']['input'];
  translations: Array<AliasTranslationInput> | AliasTranslationInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type SetAliasMutation = { __typename?: 'Mutations', setAlias: any | null };

export type DeleteAliasMutationVariables = Exact<{
  domain: Scalars['Domain']['input'];
  aliasKey: Scalars['String']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type DeleteAliasMutation = { __typename?: 'Mutations', deleteAlias: any | null };

export type FrontendStartupQueryVariables = Exact<{
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type FrontendStartupQuery = { __typename?: 'Queries', currentUser: { __typename?: 'User', email: string, roleId: string, userRole: { __typename?: 'Role', preferencesLatestVersion: { __typename: 'RolePreferencesVersion', settings: any, version: any, createdAt: any } | null, allowedDomains: Array<{ __typename?: 'DomainInfo', domain: any, latestPreferences: { __typename?: 'DomainPreferencesVersion', version: any, createdAt: any, creator: string | null, settings: any } | null, latestSettings: { __typename?: 'DomainSettingsVersion', version: any, createdAt: any, creator: string | null, settings: any } | null }> | null, executorRoles: Array<{ __typename?: 'Role', id: string, name: string, domain: any | null }> | null, directPermissions: Array<{ __typename?: 'AssignedPermission', id: string, roleId: string, permission: { __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string>, permissions: Array<{ __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions' } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null }> | null } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, restrictionsPopulationTarget: RestrictionsPopulationTarget, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null } }> | null, allPermissions: Array<{ __typename?: 'AssignedPermission', id: string, roleId: string, permission: { __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string>, permissions: Array<{ __typename: 'AssumeRole', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'CreateReports', domain: any | null } | { __typename: 'CreateRole', domain: any | null } | { __typename: 'DeleteClientFile', domain: any | null } | { __typename: 'DeleteRole', domain: any | null, excludedRoles: Array<string> } | { __typename: 'DownloadClientFile', domain: any | null } | { __typename: 'EditRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ExportReports', domain: any | null } | { __typename: 'GrantPermissions' } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null }> | null } | { __typename: 'Login', domain: any | null, enabled: boolean | null, allowedAuthenticationMethods: Array<AuthenticationMethod> | null } | { __typename: 'ManageCompany', domain: any | null } | { __typename: 'ManageDomain', domain: any | null } | { __typename: 'ManageUsers', domain: any | null } | { __typename: 'ReadClientFile', domain: any | null } | { __typename: 'ReadData', domain: any | null, popFilter: string | null, restrictionsPopulationTarget: RestrictionsPopulationTarget, access: Array<{ __typename?: 'DatatypeAccess', datatype: any, fields: { __typename?: 'DatafieldAccessConfig', allDatafields: boolean, allDatafieldsMinPop: any | null, specificDatafields: Array<{ __typename?: 'DatafieldAccess', datafield: any, minPop: any | null }> | null } }> | null, lineHierarchyRestrictions: { __typename?: 'LineHierarchyRestrictions', userSpecific: boolean, employeeSpecific: Array<string> | null }, organizationRestrictions: { __typename?: 'OrganizationRestrictions', userSpecific: boolean } | null } | { __typename: 'RequestPasswordChange', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'RevokePermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdatePassword', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'UpdateRoleName', domain: any | null } | { __typename: 'UseFilters', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewDashboards', domain: any | null, viewDataView: Array<any> | null, exportDataView: Array<any> | null, exportChartView: Array<any> | null, dashboardPages: Array<{ __typename?: 'DashboardPagesAccess', dashboard: any, pages: Array<any> | null }> | null } | { __typename: 'ViewMetrics', domain: any | null, allowedTags: Array<string> | null } | { __typename: 'ViewPermissions', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'ViewReports', domain: any | null, reports: Array<string> | null } | { __typename: 'ViewRoleScope', domain: any | null, role: string | null, excludedRoles: Array<string> } | { __typename: 'ViewRoles', domain: any | null, roles: Array<string> | null, excludedRoles: Array<string> } | { __typename: 'WriteClientFile', domain: any | null } }> | null } | null } | null, listAllDashboards: Array<{ __typename?: 'DashboardDefinition', description: string, descriptionKey: string, enabled: boolean, id: any, imagePath: string, link: string, name: string, nameKey: string, pages: Array<{ __typename?: 'PageDefinition', description: string, descriptionKey: string, enabled: boolean, imagePath: string, link: string, name: string, nameKey: string, pageId: any, pageNumber: number }> }> | null };

export type DomainDependenciesQueryVariables = Exact<{
  domain: Scalars['Domain']['input'];
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type DomainDependenciesQuery = { __typename?: 'Queries', domainInfo: { __typename?: 'DomainInfo', latestPreferences: { __typename?: 'DomainPreferencesVersion', settings: any, version: any, createdAt: any, creator: string | null } | null, latestSettings: { __typename?: 'DomainSettingsVersion', settings: any, version: any, createdAt: any, creator: string | null } | null, userRoles: Array<{ __typename?: 'Role', id: string, name: string, domain: any | null }> | null, nonUserRoles: Array<{ __typename?: 'Role', id: string, name: string, domain: any | null }> | null, allLatestVersions: Array<{ __typename?: 'LatestVersionForDataType', dataType: ApiMasterDataType, version: any | null }> | null, allUsedFields: Array<{ __typename?: 'UsedFieldsForDataType', dataType: ApiMasterDataType, datafields: Array<any> }> | null, usedCohorts: Array<{ __typename?: 'CohortTypeEntries', cohortType: string, cohortValues: Array<{ __typename?: 'CohortValues', cohortKey: string, cohortValues: Array<{ __typename: 'BigDecimalValue', bigDecimal: any } | { __typename: 'BooleanValue', boolean: boolean } | { __typename: 'DateValue', date: any } | { __typename: 'DoubleValue', double: number } | { __typename: 'IntValue', int: number } | { __typename: 'JsonValue', json: any } | { __typename: 'StringValue', string: string } | { __typename: 'TimestampValue', timestamp: any }> }> }> | null, aliases: Array<{ __typename?: 'Alias', key: string, type: string, translations: Array<{ __typename?: 'AliasTranslation', language: Language, text: string }> }> | null, metricTree: { __typename?: 'MetricTree', categoryTrees: Array<{ __typename?: 'MetricCategoryTree', metricCategoryId: MetricCategoryId, groupTrees: Array<{ __typename?: 'MetricGroupTree', metricGroupId: MetricGroupId, metricDefs: Array<{ __typename?: 'MetricDef', id: MetricId, metricGroupId: MetricGroupId, metricType: MetricType, name: string, defaultPosition: number, segmentationPercAllowed: boolean, tooltipJapanese: string | null, tooltipEnglish: string | null, formatType: { __typename?: 'MetricFormatType', id: MetricFormatTypeId }, underlyingDataFields: Array<{ __typename?: 'DatafieldAndDatatype', dataType: ApiMasterDataType, dataField: any }> | null, lifecycleStage: { __typename: 'MetricLifecycleStageActive', reason: string | null } | { __typename: 'MetricLifecycleStageDeprecated', reason: string | null } | { __typename: 'MetricLifecycleStageDevelopment', reason: string | null } | { __typename: 'MetricLifecycleStageDisabled', reason: string | null } }>, metricGroup: { __typename?: 'MetricGroup', id: MetricGroupId, defaultCategoryId: MetricCategoryId, defaultPosition: number, defaultCategory: { __typename?: 'MetricCategory', id: MetricCategoryId, defaultPosition: number } } }>, metricCategory: { __typename?: 'MetricCategory', id: MetricCategoryId, defaultPosition: number } }> } | null } | null };

type SingleValueTimeSelection_SingleValueByCalendarMonthsTimeSelection_Fragment = { __typename: 'SingleValueByCalendarMonthsTimeSelection', startDate: any, endDate: any };

type SingleValueTimeSelection_SingleValueByCalendarYearsTimeSelection_Fragment = { __typename: 'SingleValueByCalendarYearsTimeSelection', startYear: number, endYear: number };

type SingleValueTimeSelection_SingleValueByFinancialQuartersTimeSelection_Fragment = { __typename: 'SingleValueByFinancialQuartersTimeSelection', startQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number }, endQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } };

type SingleValueTimeSelection_SingleValueByFinancialYearsTimeSelection_Fragment = { __typename: 'SingleValueByFinancialYearsTimeSelection', startYear: number, endYear: number };

export type SingleValueTimeSelectionFragment = SingleValueTimeSelection_SingleValueByCalendarMonthsTimeSelection_Fragment | SingleValueTimeSelection_SingleValueByCalendarYearsTimeSelection_Fragment | SingleValueTimeSelection_SingleValueByFinancialQuartersTimeSelection_Fragment | SingleValueTimeSelection_SingleValueByFinancialYearsTimeSelection_Fragment;

type OverTimeTimeSelection_CalendarYearMonthlyTimeSelection_Fragment = { __typename: 'CalendarYearMonthlyTimeSelection', startDate: any, endDate: any };

type OverTimeTimeSelection_CalendarYearQuarterlyTimeSelection_Fragment = { __typename: 'CalendarYearQuarterlyTimeSelection', startQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number }, endQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } };

type OverTimeTimeSelection_CalendarYearYearlyTimeSelection_Fragment = { __typename: 'CalendarYearYearlyTimeSelection', startYear: number, endYear: number };

type OverTimeTimeSelection_FinancialYearQuarterlyTimeSelection_Fragment = { __typename: 'FinancialYearQuarterlyTimeSelection', startQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number }, endQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } };

type OverTimeTimeSelection_FinancialYearYearlyTimeSelection_Fragment = { __typename: 'FinancialYearYearlyTimeSelection', startYear: number, endYear: number };

export type OverTimeTimeSelectionFragment = OverTimeTimeSelection_CalendarYearMonthlyTimeSelection_Fragment | OverTimeTimeSelection_CalendarYearQuarterlyTimeSelection_Fragment | OverTimeTimeSelection_CalendarYearYearlyTimeSelection_Fragment | OverTimeTimeSelection_FinancialYearQuarterlyTimeSelection_Fragment | OverTimeTimeSelection_FinancialYearYearlyTimeSelection_Fragment;

export type AskChappiMutationVariables = Exact<{
  prompt: Scalars['String']['input'];
  conversationId: Scalars['ID']['input'];
}>;


export type AskChappiMutation = { __typename?: 'Mutations', askChappi: Array<{ __typename: 'ChappiCategorizationResponse', questionCategory: string } | { __typename: 'ChappiCauseInvestigationResponse', message: string } | { __typename: 'ChappiDataDiscrepancyResponse', message: string } | { __typename: 'ChappiExplainPreviousChartAnalyticsResponse', message: string } | { __typename: 'ChappiExplainPreviousSingleNumberAnalyticsResponse', message: string } | { __typename: 'ChappiExplanationOfCalculationOrDefinitionResponse', message: string } | { __typename: 'ChappiFindingSpecificEmployeesResponse', message: string } | { __typename: 'ChappiHowToUseChappiResponse', message: string } | { __typename: 'ChappiHowToUseThePanalytAppResponse', message: string } | { __typename: 'ChappiKpiVisualization', kpiMetric: Array<MetricId>, alignment: ChappiKpiAlignment, responseForUser: string, kpiTimeSelection: { __typename: 'SingleValueByCalendarMonthsTimeSelection', startDate: any, endDate: any } | { __typename: 'SingleValueByCalendarYearsTimeSelection', startYear: number, endYear: number } | { __typename: 'SingleValueByFinancialQuartersTimeSelection', startQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number }, endQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'SingleValueByFinancialYearsTimeSelection', startYear: number, endYear: number }, kpiSegmentation: Array<{ __typename?: 'ChappiLineChartSegmentation', datafieldAndDatatype: { __typename?: 'DatafieldAndDatatype', dataField: any, dataType: ApiMasterDataType } }>, filters: { __typename?: 'ChappiCommonFilters', sql: string } | null } | { __typename: 'ChappiLineChartVisualization', lineChartMetrics: Array<MetricId>, lineChartVariant: ChappiLineChartVariant, responseForUser: string, lineChartTimeSelection: { __typename: 'CalendarYearMonthlyTimeSelection', startDate: any, endDate: any } | { __typename: 'CalendarYearQuarterlyTimeSelection', startQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number }, endQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'CalendarYearYearlyTimeSelection', startYear: number, endYear: number } | { __typename: 'FinancialYearQuarterlyTimeSelection', startQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number }, endQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'FinancialYearYearlyTimeSelection', startYear: number, endYear: number }, lineChartSegmentation: Array<{ __typename?: 'ChappiLineChartSegmentation', datafieldAndDatatype: { __typename?: 'DatafieldAndDatatype', dataField: any, dataType: ApiMasterDataType } }>, filters: { __typename?: 'ChappiCommonFilters', sql: string } | null } | { __typename: 'ChappiOtherOrUnknownResponse', message: string } | { __typename: 'ChappiOverTimeBarChartVisualization', barChartMetrics: Array<MetricId>, stack: boolean, relative: boolean, responseForUser: string, barChartTimeSelection: { __typename: 'CalendarYearMonthlyTimeSelection', startDate: any, endDate: any } | { __typename: 'CalendarYearQuarterlyTimeSelection', startQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number }, endQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'CalendarYearYearlyTimeSelection', startYear: number, endYear: number } | { __typename: 'FinancialYearQuarterlyTimeSelection', startQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number }, endQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'FinancialYearYearlyTimeSelection', startYear: number, endYear: number }, barChartSegmentation: Array<{ __typename?: 'ChappiLineChartSegmentation', datafieldAndDatatype: { __typename?: 'DatafieldAndDatatype', dataField: any, dataType: ApiMasterDataType } }>, filters: { __typename?: 'ChappiCommonFilters', sql: string } | null } | { __typename: 'ChappiPanalytAppGeneralQuestionOrProblemResponse', message: string } | { __typename: 'ChappiPanalytContractResponse', message: string } | { __typename: 'ChappiPieChartVisualization', pieChartMetric: MetricId, pieChartVariant: ChappiPieChartVariant, responseForUser: string, pieChartTimeSelection: { __typename: 'SingleValueByCalendarMonthsTimeSelection', startDate: any, endDate: any } | { __typename: 'SingleValueByCalendarYearsTimeSelection', startYear: number, endYear: number } | { __typename: 'SingleValueByFinancialQuartersTimeSelection', startQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number }, endQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'SingleValueByFinancialYearsTimeSelection', startYear: number, endYear: number }, pieChartSegmentation: { __typename?: 'ChappiPieChartSegmentation', datafieldAndDatatype: { __typename?: 'DatafieldAndDatatype', dataField: any, dataType: ApiMasterDataType } }, filters: { __typename?: 'ChappiCommonFilters', sql: string } | null } | { __typename: 'ChappiPredictiveAnalyticsForecastingResponse', message: string } | { __typename: 'ChappiProblemEncounteredResponse', message: string } | { __typename: 'ChappiRecommendationsSuggestionsResponse', message: string } | { __typename: 'ChappiSingleNumberAnalyticsResponse', message: string } | { __typename: 'ChappiTableVisualization', tableMetrics: Array<MetricId>, responseForUser: string, tableTimeSelection: { __typename: 'CalendarYearMonthlyTimeSelection', startDate: any, endDate: any } | { __typename: 'CalendarYearQuarterlyTimeSelection', startQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number }, endQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'CalendarYearYearlyTimeSelection', startYear: number, endYear: number } | { __typename: 'FinancialYearQuarterlyTimeSelection', startQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number }, endQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'FinancialYearYearlyTimeSelection', startYear: number, endYear: number }, tableSegmentation: Array<{ __typename?: 'ChappiLineChartSegmentation', datafieldAndDatatype: { __typename?: 'DatafieldAndDatatype', dataField: any, dataType: ApiMasterDataType } }>, filters: { __typename?: 'ChappiCommonFilters', sql: string } | null } | { __typename: 'ChappiTimePeriodBarChartVisualization', barChartMetrics: Array<MetricId>, stack: boolean, relative: boolean, responseForUser: string, barChartTimeSelection: { __typename: 'SingleValueByCalendarMonthsTimeSelection', startDate: any, endDate: any } | { __typename: 'SingleValueByCalendarYearsTimeSelection', startYear: number, endYear: number } | { __typename: 'SingleValueByFinancialQuartersTimeSelection', startQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number }, endQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'SingleValueByFinancialYearsTimeSelection', startYear: number, endYear: number }, barChartSegmentation: Array<{ __typename?: 'ChappiLineChartSegmentation', datafieldAndDatatype: { __typename?: 'DatafieldAndDatatype', dataField: any, dataType: ApiMasterDataType } }>, filters: { __typename?: 'ChappiCommonFilters', sql: string } | null } | { __typename: 'ChappiVisualizationTypeResponse', visualizationType: string }> | null };

export type StartConversationMutationVariables = Exact<{
  firstQuestion: Scalars['String']['input'];
  domain: Scalars['Domain']['input'];
}>;


export type StartConversationMutation = { __typename?: 'Mutations', startConversation: { __typename?: 'ChappiConversationAndFirstResponse', conversation: { __typename?: 'ChappiConversation', id: string }, firstResponse: Array<{ __typename: 'ChappiCategorizationResponse', questionCategory: string } | { __typename: 'ChappiCauseInvestigationResponse', message: string } | { __typename: 'ChappiDataDiscrepancyResponse', message: string } | { __typename: 'ChappiExplainPreviousChartAnalyticsResponse', message: string } | { __typename: 'ChappiExplainPreviousSingleNumberAnalyticsResponse', message: string } | { __typename: 'ChappiExplanationOfCalculationOrDefinitionResponse', message: string } | { __typename: 'ChappiFindingSpecificEmployeesResponse', message: string } | { __typename: 'ChappiHowToUseChappiResponse', message: string } | { __typename: 'ChappiHowToUseThePanalytAppResponse', message: string } | { __typename: 'ChappiKpiVisualization', kpiMetric: Array<MetricId>, alignment: ChappiKpiAlignment, responseForUser: string, kpiTimeSelection: { __typename: 'SingleValueByCalendarMonthsTimeSelection', startDate: any, endDate: any } | { __typename: 'SingleValueByCalendarYearsTimeSelection', startYear: number, endYear: number } | { __typename: 'SingleValueByFinancialQuartersTimeSelection', startQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number }, endQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'SingleValueByFinancialYearsTimeSelection', startYear: number, endYear: number }, kpiSegmentation: Array<{ __typename?: 'ChappiLineChartSegmentation', datafieldAndDatatype: { __typename?: 'DatafieldAndDatatype', dataField: any, dataType: ApiMasterDataType } }>, filters: { __typename?: 'ChappiCommonFilters', sql: string } | null } | { __typename: 'ChappiLineChartVisualization', lineChartMetrics: Array<MetricId>, lineChartVariant: ChappiLineChartVariant, responseForUser: string, lineChartTimeSelection: { __typename: 'CalendarYearMonthlyTimeSelection', startDate: any, endDate: any } | { __typename: 'CalendarYearQuarterlyTimeSelection', startQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number }, endQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'CalendarYearYearlyTimeSelection', startYear: number, endYear: number } | { __typename: 'FinancialYearQuarterlyTimeSelection', startQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number }, endQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'FinancialYearYearlyTimeSelection', startYear: number, endYear: number }, lineChartSegmentation: Array<{ __typename?: 'ChappiLineChartSegmentation', datafieldAndDatatype: { __typename?: 'DatafieldAndDatatype', dataField: any, dataType: ApiMasterDataType } }>, filters: { __typename?: 'ChappiCommonFilters', sql: string } | null } | { __typename: 'ChappiOtherOrUnknownResponse', message: string } | { __typename: 'ChappiOverTimeBarChartVisualization', barChartMetrics: Array<MetricId>, stack: boolean, relative: boolean, responseForUser: string, barChartTimeSelection: { __typename: 'CalendarYearMonthlyTimeSelection', startDate: any, endDate: any } | { __typename: 'CalendarYearQuarterlyTimeSelection', startQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number }, endQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'CalendarYearYearlyTimeSelection', startYear: number, endYear: number } | { __typename: 'FinancialYearQuarterlyTimeSelection', startQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number }, endQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'FinancialYearYearlyTimeSelection', startYear: number, endYear: number }, barChartSegmentation: Array<{ __typename?: 'ChappiLineChartSegmentation', datafieldAndDatatype: { __typename?: 'DatafieldAndDatatype', dataField: any, dataType: ApiMasterDataType } }>, filters: { __typename?: 'ChappiCommonFilters', sql: string } | null } | { __typename: 'ChappiPanalytAppGeneralQuestionOrProblemResponse', message: string } | { __typename: 'ChappiPanalytContractResponse', message: string } | { __typename: 'ChappiPieChartVisualization', pieChartMetric: MetricId, pieChartVariant: ChappiPieChartVariant, responseForUser: string, pieChartTimeSelection: { __typename: 'SingleValueByCalendarMonthsTimeSelection', startDate: any, endDate: any } | { __typename: 'SingleValueByCalendarYearsTimeSelection', startYear: number, endYear: number } | { __typename: 'SingleValueByFinancialQuartersTimeSelection', startQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number }, endQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'SingleValueByFinancialYearsTimeSelection', startYear: number, endYear: number }, pieChartSegmentation: { __typename?: 'ChappiPieChartSegmentation', datafieldAndDatatype: { __typename?: 'DatafieldAndDatatype', dataField: any, dataType: ApiMasterDataType } }, filters: { __typename?: 'ChappiCommonFilters', sql: string } | null } | { __typename: 'ChappiPredictiveAnalyticsForecastingResponse', message: string } | { __typename: 'ChappiProblemEncounteredResponse', message: string } | { __typename: 'ChappiRecommendationsSuggestionsResponse', message: string } | { __typename: 'ChappiSingleNumberAnalyticsResponse', message: string } | { __typename: 'ChappiTableVisualization', tableMetrics: Array<MetricId>, responseForUser: string, tableTimeSelection: { __typename: 'CalendarYearMonthlyTimeSelection', startDate: any, endDate: any } | { __typename: 'CalendarYearQuarterlyTimeSelection', startQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number }, endQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'CalendarYearYearlyTimeSelection', startYear: number, endYear: number } | { __typename: 'FinancialYearQuarterlyTimeSelection', startQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number }, endQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'FinancialYearYearlyTimeSelection', startYear: number, endYear: number }, tableSegmentation: Array<{ __typename?: 'ChappiLineChartSegmentation', datafieldAndDatatype: { __typename?: 'DatafieldAndDatatype', dataField: any, dataType: ApiMasterDataType } }>, filters: { __typename?: 'ChappiCommonFilters', sql: string } | null } | { __typename: 'ChappiTimePeriodBarChartVisualization', barChartMetrics: Array<MetricId>, stack: boolean, relative: boolean, responseForUser: string, barChartTimeSelection: { __typename: 'SingleValueByCalendarMonthsTimeSelection', startDate: any, endDate: any } | { __typename: 'SingleValueByCalendarYearsTimeSelection', startYear: number, endYear: number } | { __typename: 'SingleValueByFinancialQuartersTimeSelection', startQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number }, endQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'SingleValueByFinancialYearsTimeSelection', startYear: number, endYear: number }, barChartSegmentation: Array<{ __typename?: 'ChappiLineChartSegmentation', datafieldAndDatatype: { __typename?: 'DatafieldAndDatatype', dataField: any, dataType: ApiMasterDataType } }>, filters: { __typename?: 'ChappiCommonFilters', sql: string } | null } | { __typename: 'ChappiVisualizationTypeResponse', visualizationType: string }> } | null };

export type ListConversationsQueryVariables = Exact<{
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  domainFilter: InputMaybe<Scalars['Domain']['input']>;
  conversationId: InputMaybe<Scalars['ID']['input']>;
  initiatingRoleId: InputMaybe<Scalars['ID']['input']>;
  createdBefore: InputMaybe<Scalars['Instant']['input']>;
  createdAfter: InputMaybe<Scalars['Instant']['input']>;
  sortCriteria?: Array<SortCriteriaInput> | SortCriteriaInput;
  simulateRole: InputMaybe<Scalars['ID']['input']>;
}>;


export type ListConversationsQuery = { __typename?: 'Queries', listConversations: Array<{ __typename?: 'ChappiConversation', id: string, initiatingRoleId: string, initialCreator: string, createdAt: any, domainScope: any | null, messages: Array<{ __typename?: 'ChappiMessage', id: string, createdAt: any, content: { __typename: 'QuestionMessage', question: string } | { __typename: 'ResponseMessage', response: { __typename: 'ChappiCategorizationResponse', questionCategory: string } | { __typename: 'ChappiCauseInvestigationResponse', message: string } | { __typename: 'ChappiDataDiscrepancyResponse', message: string } | { __typename: 'ChappiExplainPreviousChartAnalyticsResponse', message: string } | { __typename: 'ChappiExplainPreviousSingleNumberAnalyticsResponse', message: string } | { __typename: 'ChappiExplanationOfCalculationOrDefinitionResponse', message: string } | { __typename: 'ChappiFindingSpecificEmployeesResponse', message: string } | { __typename: 'ChappiHowToUseChappiResponse', message: string } | { __typename: 'ChappiHowToUseThePanalytAppResponse', message: string } | { __typename: 'ChappiKpiVisualization', kpiMetric: Array<MetricId>, alignment: ChappiKpiAlignment, responseForUser: string, kpiTimeSelection: { __typename: 'SingleValueByCalendarMonthsTimeSelection', startDate: any, endDate: any } | { __typename: 'SingleValueByCalendarYearsTimeSelection', startYear: number, endYear: number } | { __typename: 'SingleValueByFinancialQuartersTimeSelection', startQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number }, endQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'SingleValueByFinancialYearsTimeSelection', startYear: number, endYear: number }, kpiSegmentation: Array<{ __typename?: 'ChappiLineChartSegmentation', datafieldAndDatatype: { __typename?: 'DatafieldAndDatatype', dataField: any, dataType: ApiMasterDataType } }>, filters: { __typename?: 'ChappiCommonFilters', sql: string } | null } | { __typename: 'ChappiLineChartVisualization', lineChartMetrics: Array<MetricId>, lineChartVariant: ChappiLineChartVariant, responseForUser: string, lineChartTimeSelection: { __typename: 'CalendarYearMonthlyTimeSelection', startDate: any, endDate: any } | { __typename: 'CalendarYearQuarterlyTimeSelection', startQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number }, endQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'CalendarYearYearlyTimeSelection', startYear: number, endYear: number } | { __typename: 'FinancialYearQuarterlyTimeSelection', startQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number }, endQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'FinancialYearYearlyTimeSelection', startYear: number, endYear: number }, lineChartSegmentation: Array<{ __typename?: 'ChappiLineChartSegmentation', datafieldAndDatatype: { __typename?: 'DatafieldAndDatatype', dataField: any, dataType: ApiMasterDataType } }>, filters: { __typename?: 'ChappiCommonFilters', sql: string } | null } | { __typename: 'ChappiOtherOrUnknownResponse', message: string } | { __typename: 'ChappiOverTimeBarChartVisualization', barChartMetrics: Array<MetricId>, stack: boolean, relative: boolean, responseForUser: string, barChartTimeSelection: { __typename: 'CalendarYearMonthlyTimeSelection', startDate: any, endDate: any } | { __typename: 'CalendarYearQuarterlyTimeSelection', startQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number }, endQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'CalendarYearYearlyTimeSelection', startYear: number, endYear: number } | { __typename: 'FinancialYearQuarterlyTimeSelection', startQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number }, endQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'FinancialYearYearlyTimeSelection', startYear: number, endYear: number }, barChartSegmentation: Array<{ __typename?: 'ChappiLineChartSegmentation', datafieldAndDatatype: { __typename?: 'DatafieldAndDatatype', dataField: any, dataType: ApiMasterDataType } }>, filters: { __typename?: 'ChappiCommonFilters', sql: string } | null } | { __typename: 'ChappiPanalytAppGeneralQuestionOrProblemResponse', message: string } | { __typename: 'ChappiPanalytContractResponse', message: string } | { __typename: 'ChappiPieChartVisualization', pieChartMetric: MetricId, pieChartVariant: ChappiPieChartVariant, responseForUser: string, pieChartTimeSelection: { __typename: 'SingleValueByCalendarMonthsTimeSelection', startDate: any, endDate: any } | { __typename: 'SingleValueByCalendarYearsTimeSelection', startYear: number, endYear: number } | { __typename: 'SingleValueByFinancialQuartersTimeSelection', startQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number }, endQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'SingleValueByFinancialYearsTimeSelection', startYear: number, endYear: number }, pieChartSegmentation: { __typename?: 'ChappiPieChartSegmentation', datafieldAndDatatype: { __typename?: 'DatafieldAndDatatype', dataField: any, dataType: ApiMasterDataType } }, filters: { __typename?: 'ChappiCommonFilters', sql: string } | null } | { __typename: 'ChappiPredictiveAnalyticsForecastingResponse', message: string } | { __typename: 'ChappiProblemEncounteredResponse', message: string } | { __typename: 'ChappiRecommendationsSuggestionsResponse', message: string } | { __typename: 'ChappiSingleNumberAnalyticsResponse', message: string } | { __typename: 'ChappiTableVisualization', tableMetrics: Array<MetricId>, responseForUser: string, tableTimeSelection: { __typename: 'CalendarYearMonthlyTimeSelection', startDate: any, endDate: any } | { __typename: 'CalendarYearQuarterlyTimeSelection', startQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number }, endQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'CalendarYearYearlyTimeSelection', startYear: number, endYear: number } | { __typename: 'FinancialYearQuarterlyTimeSelection', startQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number }, endQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'FinancialYearYearlyTimeSelection', startYear: number, endYear: number }, tableSegmentation: Array<{ __typename?: 'ChappiLineChartSegmentation', datafieldAndDatatype: { __typename?: 'DatafieldAndDatatype', dataField: any, dataType: ApiMasterDataType } }>, filters: { __typename?: 'ChappiCommonFilters', sql: string } | null } | { __typename: 'ChappiTimePeriodBarChartVisualization', barChartMetrics: Array<MetricId>, stack: boolean, relative: boolean, responseForUser: string, barChartTimeSelection: { __typename: 'SingleValueByCalendarMonthsTimeSelection', startDate: any, endDate: any } | { __typename: 'SingleValueByCalendarYearsTimeSelection', startYear: number, endYear: number } | { __typename: 'SingleValueByFinancialQuartersTimeSelection', startQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number }, endQuarter: { __typename?: 'Quarter', quarterOfYear: number, year: number } } | { __typename: 'SingleValueByFinancialYearsTimeSelection', startYear: number, endYear: number }, barChartSegmentation: Array<{ __typename?: 'ChappiLineChartSegmentation', datafieldAndDatatype: { __typename?: 'DatafieldAndDatatype', dataField: any, dataType: ApiMasterDataType } }>, filters: { __typename?: 'ChappiCommonFilters', sql: string } | null } | { __typename: 'ChappiVisualizationTypeResponse', visualizationType: string } } | { __typename: 'SystemMessage', content: string } }> }> | null };

export const ResponseValueAllFragmentDoc = gql`
    fragment ResponseValueAll on ResponseValue {
  __typename
  ... on BigDecimalValue {
    bigDecimal: value
  }
  ... on BooleanValue {
    boolean: value
  }
  ... on DateValue {
    date: value
  }
  ... on DoubleValue {
    double: value
  }
  ... on IntValue {
    int: value
  }
  ... on StringValue {
    string: value
  }
  ... on TimestampValue {
    timestamp: value
  }
  ... on JsonValue {
    json: value
  }
  ... on Confidential {
    reason
  }
}
    `;
export const MetricResultsDataFragmentDoc = gql`
    fragment MetricResultsData on MetricResults {
  results {
    ... on MetricResultSuccess {
      __typename
      metricId
      segments {
        groupSegments {
          data {
            ...ResponseValueAll
          }
          groupSegment {
            dataField
            dataType
            value {
              ...ResponseValueAll
            }
          }
        }
        timeSegment {
          __typename
          ... on CalendarYearYearlySegment {
            year
          }
          ... on CalendarYearQuarterlySegment {
            quarter {
              quarterOfYear
              year
            }
          }
          ... on CalendarYearMonthlySegment {
            date
          }
          ... on FinancialYearYearlySegment {
            year
          }
          ... on FinancialYearQuarterlySegment {
            quarter {
              quarterOfYear
              year
            }
          }
          ... on SingleValueTimeSegment {
            end
            start
          }
        }
      }
      meta {
        metricSql
      }
    }
    ... on MetricResultFailure {
      __typename
      message
      errorReference
      meta {
        metricSql
      }
    }
  }
}
    ${ResponseValueAllFragmentDoc}`;
export const SqlLitValueAllFragmentDoc = gql`
    fragment SqlLitValueAll on SqlLitValue {
  __typename
  ... on BigDecimalValue {
    bigDecimal: value
  }
  ... on BooleanValue {
    boolean: value
  }
  ... on DateValue {
    date: value
  }
  ... on DoubleValue {
    double: value
  }
  ... on IntValue {
    int: value
  }
  ... on StringValue {
    string: value
  }
  ... on TimestampValue {
    timestamp: value
  }
  ... on JsonValue {
    json: value
  }
}
    `;
export const PermissionDataFragmentDoc = gql`
    fragment PermissionData on AssignedPermission {
  id
  roleId
  permission {
    __typename
    ... on ReadData {
      domain
      access {
        datatype
        fields {
          allDatafields
          specificDatafields {
            datafield
            minPop
          }
          allDatafieldsMinPop
        }
      }
      popFilter
      lineHierarchyRestrictions {
        userSpecific
        employeeSpecific
      }
      organizationRestrictions {
        userSpecific
      }
      restrictionsPopulationTarget
    }
    ... on UseFilters {
      domain
      allowedTags
    }
    ... on ViewMetrics {
      domain
      allowedTags
    }
    ... on ViewDashboards {
      domain
      dashboardPages {
        dashboard
        pages
      }
      viewDataView
      exportDataView
      exportChartView
    }
    ... on Login {
      domain
      enabled
      allowedAuthenticationMethods
    }
    ... on AssumeRole {
      domain
      roles
      excludedRoles
    }
    ... on CreateRole {
      domain
    }
    ... on DeleteRole {
      domain
      excludedRoles
    }
    ... on UpdateRoleName {
      domain
    }
    ... on GrantPermissions {
      domain
      roles
      excludedRoles
      permissions {
        __typename
        ... on ReadData {
          domain
          access {
            datatype
            fields {
              allDatafields
              specificDatafields {
                datafield
                minPop
              }
              allDatafieldsMinPop
            }
          }
          popFilter
          lineHierarchyRestrictions {
            userSpecific
            employeeSpecific
          }
          organizationRestrictions {
            userSpecific
          }
        }
        ... on UseFilters {
          domain
          allowedTags
        }
        ... on ViewDashboards {
          domain
          dashboardPages {
            dashboard
            pages
          }
          viewDataView
          exportDataView
          exportChartView
        }
        ... on Login {
          domain
          enabled
          allowedAuthenticationMethods
        }
        ... on AssumeRole {
          domain
          roles
          excludedRoles
        }
        ... on CreateRole {
          domain
        }
        ... on DeleteRole {
          domain
          excludedRoles
        }
        ... on UpdateRoleName {
          domain
        }
        ... on RevokePermissions {
          domain
          roles
          excludedRoles
        }
        ... on ViewRoles {
          domain
          roles
          excludedRoles
        }
        ... on ViewPermissions {
          domain
          roles
          excludedRoles
        }
        ... on UpdatePassword {
          domain
          roles
          excludedRoles
        }
        ... on RequestPasswordChange {
          domain
          roles
          excludedRoles
        }
        ... on ManageDomain {
          domain
        }
        ... on ManageCompany {
          domain
        }
        ... on ManageUsers {
          domain
        }
        ... on ViewReports {
          domain
          reports
        }
        ... on CreateReports {
          domain
        }
        ... on ExportReports {
          domain
        }
        ... on ReadClientFile {
          domain
        }
        ... on DownloadClientFile {
          domain
        }
        ... on WriteClientFile {
          domain
        }
        ... on DeleteClientFile {
          domain
        }
        ... on ViewRoleScope {
          domain
          role
          excludedRoles
        }
        ... on EditRoleScope {
          domain
          role
          excludedRoles
        }
        ... on ViewMetrics {
          domain
          allowedTags
        }
      }
    }
    ... on RevokePermissions {
      domain
      roles
      excludedRoles
    }
    ... on ViewRoles {
      domain
      roles
      excludedRoles
    }
    ... on ViewPermissions {
      domain
      roles
      excludedRoles
    }
    ... on UpdatePassword {
      domain
      roles
      excludedRoles
    }
    ... on RequestPasswordChange {
      domain
      roles
      excludedRoles
    }
    ... on ManageDomain {
      domain
    }
    ... on ManageCompany {
      domain
    }
    ... on ManageUsers {
      domain
    }
    ... on ViewReports {
      domain
      reports
    }
    ... on CreateReports {
      domain
    }
    ... on ExportReports {
      domain
    }
    ... on ReadClientFile {
      domain
    }
    ... on DownloadClientFile {
      domain
    }
    ... on WriteClientFile {
      domain
    }
    ... on DeleteClientFile {
      domain
    }
    ... on ViewRoleScope {
      domain
      role
      excludedRoles
    }
    ... on EditRoleScope {
      domain
      role
      excludedRoles
    }
    ... on ViewMetrics {
      domain
      allowedTags
    }
  }
}
    `;
export const SingleValueTimeSelectionFragmentDoc = gql`
    fragment SingleValueTimeSelection on ChappiSingleValueTimeSelection {
  __typename
  ... on SingleValueByCalendarMonthsTimeSelection {
    startDate: start
    endDate: end
  }
  ... on SingleValueByCalendarYearsTimeSelection {
    startYear: start
    endYear: end
  }
  ... on SingleValueByFinancialQuartersTimeSelection {
    startQuarter: start {
      quarterOfYear
      year
    }
    endQuarter: end {
      quarterOfYear
      year
    }
  }
  ... on SingleValueByFinancialYearsTimeSelection {
    startYear: start
    endYear: end
  }
}
    `;
export const OverTimeTimeSelectionFragmentDoc = gql`
    fragment OverTimeTimeSelection on ChappiMultiValueTimeSelection {
  __typename
  ... on CalendarYearYearlyTimeSelection {
    startYear: start
    endYear: end
  }
  ... on CalendarYearQuarterlyTimeSelection {
    startQuarter: start {
      quarterOfYear
      year
    }
    endQuarter: end {
      quarterOfYear
      year
    }
  }
  ... on CalendarYearMonthlyTimeSelection {
    startDate: start
    endDate: end
  }
  ... on FinancialYearYearlyTimeSelection {
    startYear: start
    endYear: end
  }
  ... on FinancialYearQuarterlyTimeSelection {
    startQuarter: start {
      quarterOfYear
      year
    }
    endQuarter: end {
      quarterOfYear
      year
    }
  }
}
    `;
export const AvailableTimeRangesDocument = gql`
    query availableTimeRanges($domain: Domain!, $simulateRole: ID) {
  availableTimeranges(domain: $domain, simulateRole: $simulateRole) {
    dataType
    availableTimerange {
      calendarYearMonthly
      calendarYearYearly
      financialYearYearly
      financialYearQuarterly {
        quarterOfYear
        year
      }
    }
  }
}
    `;
export const QueryCohortMetricsDocument = gql`
    query queryCohortMetrics($domain: Domain!, $metrics: [CohortMetricId!]!, $disableNestLoop: Boolean, $grouping: GroupingInput, $timeSelection: TimeSelectionInput!, $userCohortFilters: String, $selectedExecutorRole: ID!, $simulateRole: ID) {
  queryCohortMetrics(
    disableNestLoop: $disableNestLoop
    domain: $domain
    grouping: $grouping
    metrics: $metrics
    selectedExecutorRole: $selectedExecutorRole
    simulateRole: $simulateRole
    timeSelection: $timeSelection
    userCohortFilters: $userCohortFilters
  ) {
    ...MetricResultsData
  }
}
    ${MetricResultsDataFragmentDoc}`;
export const QueryMetricsDocument = gql`
    query queryMetrics($domain: Domain!, $metrics: [RegularMetricId!]!, $disableNestLoop: Boolean, $grouping: GroupingInput, $timeSelection: TimeSelectionInput!, $userFilters: String, $selectedExecutorRole: ID!, $simulateRole: ID) {
  queryMetrics(
    disableNestLoop: $disableNestLoop
    domain: $domain
    grouping: $grouping
    metrics: $metrics
    selectedExecutorRole: $selectedExecutorRole
    simulateRole: $simulateRole
    timeSelection: $timeSelection
    userFilters: $userFilters
  ) {
    ...MetricResultsData
  }
}
    ${MetricResultsDataFragmentDoc}`;
export const QueryEmployeeCohortMetricsDocument = gql`
    query queryEmployeeCohortMetrics($domain: Domain!, $metrics: [EmployeeCohortMetricId!]!, $disableNestLoop: Boolean, $grouping: GroupingInput, $timeSelection: TimeSelectionInput!, $userFilters: String, $userCohortFilters: String, $selectedExecutorRole: ID!, $simulateRole: ID) {
  queryEmployeeCohortMetrics(
    disableNestLoop: $disableNestLoop
    domain: $domain
    grouping: $grouping
    metrics: $metrics
    selectedExecutorRole: $selectedExecutorRole
    simulateRole: $simulateRole
    timeSelection: $timeSelection
    userFilters: $userFilters
    userCohortFilters: $userCohortFilters
  ) {
    ...MetricResultsData
  }
}
    ${MetricResultsDataFragmentDoc}`;
export const ListAllMetricDefsDocument = gql`
    query listAllMetricDefs($domain: Domain!, $simulateRole: ID) {
  listAllMetricDefs(domain: $domain, simulateRole: $simulateRole) {
    id
    name
    tooltipJapanese
    tooltipEnglish
  }
}
    `;
export const ExecuteCustomSqlQueryDocument = gql`
    query executeCustomSqlQuery($domain: Domain!, $querySql: String!, $selectedExecutorRole: ID!, $simulateRole: ID, $disableNestLoop: Boolean) {
  executeCustomSqlQuery(
    domain: $domain
    querySql: $querySql
    selectedExecutorRole: $selectedExecutorRole
    simulateRole: $simulateRole
    disableNestLoop: $disableNestLoop
  ) {
    data {
      ...ResponseValueAll
    }
  }
}
    ${ResponseValueAllFragmentDoc}`;
export const ExecuteWhitelistedSqlQueryDocument = gql`
    query executeWhitelistedSqlQuery($domain: Domain!, $querySql: String!, $selectedExecutorRole: ID!, $simulateRole: ID) {
  executeWhitelistedSqlQuery(
    domain: $domain
    querySql: $querySql
    selectedExecutorRole: $selectedExecutorRole
    simulateRole: $simulateRole
  ) {
    data {
      ...ResponseValueAll
    }
  }
}
    ${ResponseValueAllFragmentDoc}`;
export const ExecuteAdvancedQueryDocument = gql`
    query executeAdvancedQuery($domain: Domain!, $queryJson: String!, $selectedExecutorRole: ID!, $simulateRole: ID) {
  executeAdvancedQuery(
    domain: $domain
    queryJson: $queryJson
    selectedExecutorRole: $selectedExecutorRole
    simulateRole: $simulateRole
  )
}
    `;
export const ExecuteOldQueryDocument = gql`
    query executeOldQuery($domain: Domain!, $queryJson: String!, $selectedExecutorRole: ID!, $simulateRole: ID) {
  executeOldQuery(
    domain: $domain
    queryJson: $queryJson
    selectedExecutorRole: $selectedExecutorRole
    simulateRole: $simulateRole
  )
}
    `;
export const ExecuteMovementQueryDocument = gql`
    query executeMovementQuery($domain: Domain!, $queryJson: String!, $selectedExecutorRole: ID!, $simulateRole: ID) {
  executeMovementQuery(
    domain: $domain
    queryJson: $queryJson
    selectedExecutorRole: $selectedExecutorRole
    simulateRole: $simulateRole
  )
}
    `;
export const LatestVersionDocument = gql`
    query latestVersion($domain: Domain!, $datatype: ApiMasterDataType!, $simulateRole: ID) {
  latestVersion(domain: $domain, datatype: $datatype, simulateRole: $simulateRole)
}
    `;
export const ListUsedFieldsDocument = gql`
    query listUsedFields($domain: Domain!, $datatype: ApiMasterDataType!, $versionIdDate: LocalDate, $simulateRole: ID) {
  listUsedFields(
    domain: $domain
    datatype: $datatype
    versionIdDate: $versionIdDate
    simulateRole: $simulateRole
  )
}
    `;
export const ListAvailableFieldsDocument = gql`
    query listAvailableFields($datatype: ApiMasterDataType!, $simulateRole: ID) {
  listAvailableFields(datatype: $datatype, simulateRole: $simulateRole)
}
    `;
export const ListUsedCohortsDocument = gql`
    query listUsedCohorts($domain: Domain!) {
  listUsedCohorts(domain: $domain) {
    cohortType
    cohortValues {
      cohortKey
      cohortValues {
        ...SqlLitValueAll
      }
    }
  }
}
    ${SqlLitValueAllFragmentDoc}`;
export const ListRolesDocument = gql`
    query listRoles($email: String!) {
  listRoles(email: $email) {
    id
    name
    domain
  }
}
    `;
export const ListAllRolesDocument = gql`
    query listAllRoles {
  listAllRoles {
    id
    name
    domain
  }
}
    `;
export const CurrentUserUserRoleDocument = gql`
    query currentUserUserRole {
  currentUserUserRole {
    id
    name
    domain
    executorRoles {
      id
      name
      domain
    }
  }
}
    `;
export const CurrentUserListRolesDocument = gql`
    query currentUserListRoles {
  currentUserListRoles {
    id
    name
    domain
  }
}
    `;
export const CurrentUserUserInfoDocument = gql`
    query currentUserUserInfo {
  currentUserUserInfo {
    email
  }
}
    `;
export const ListNonUserRolesDocument = gql`
    query listNonUserRoles($domain: [String!], $simulateRole: ID) {
  listNonUserRoles(domain: $domain, simulateRole: $simulateRole) {
    id
    name
    domain
  }
}
    `;
export const ListUserRolesDocument = gql`
    query listUserRoles($domainFilter: [String!], $simulateRole: ID) {
  listUserRoles(domainFilter: $domainFilter, simulateRole: $simulateRole) {
    id
    name
    domain
  }
}
    `;
export const ListAllAllowedDomainsDocument = gql`
    query listAllAllowedDomains($roleId: ID!, $simulateRole: ID) {
  listAllAllowedDomains(roleId: $roleId, simulateRole: $simulateRole)
}
    `;
export const AllPermissionsDocument = gql`
    query allPermissions($roleId: ID!) {
  allPermissions(roleId: $roleId) {
    ...PermissionData
  }
}
    ${PermissionDataFragmentDoc}`;
export const CurrentUserAllPermissionsDocument = gql`
    query currentUserAllPermissions {
  currentUserAllPermissions {
    ...PermissionData
  }
}
    ${PermissionDataFragmentDoc}`;
export const DirectPermissionsDocument = gql`
    query directPermissions($roleId: ID!) {
  directPermissions(roleId: $roleId) {
    ...PermissionData
  }
}
    ${PermissionDataFragmentDoc}`;
export const DirectPermissionsForRolesDocument = gql`
    query directPermissionsForRoles($roleIds: [ID!]!) {
  directPermissionsForRoles(roleIds: $roleIds) {
    roleId
    permissions {
      ...PermissionData
    }
  }
}
    ${PermissionDataFragmentDoc}`;
export const ListExecutorRolesForRoleDocument = gql`
    query listExecutorRolesForRole($roleId: ID!, $domainFilter: String!, $simulateRole: ID) {
  listExecutorRolesForRole(
    roleId: $roleId
    domainFilter: $domainFilter
    simulateRole: $simulateRole
  ) {
    id
    name
    domain
    __typename
  }
}
    `;
export const MetaDataByUserEmailDocument = gql`
    query metaDataByUserEmail($emails: [String!]!, $simulateRole: ID) {
  metaDataByUserEmail(emails: $emails, simulateRole: $simulateRole) {
    lastLogin
  }
}
    `;
export const MetaDataByUserRoleDocument = gql`
    query metaDataByUserRole($roleIds: [ID!]!, $simulateRole: ID) {
  metaDataByUserRole(roleIds: $roleIds, simulateRole: $simulateRole) {
    roleId
    metaData {
      lastLogin
    }
  }
}
    `;
export const AddUserAndDefaultRoleDocument = gql`
    mutation addUserAndDefaultRole($email: String!, $roleDomain: Domain!, $addDefaultLoginPermission: Boolean!) {
  addUserAndDefaultRole(
    email: $email
    roleDomain: $roleDomain
    addDefaultLoginPermission: $addDefaultLoginPermission
  ) {
    email
    roleId
    userRole {
      domain
    }
  }
}
    `;
export const AddRoleDocument = gql`
    mutation addRole($name: String!, $domain: Domain!) {
  addRole(name: $name, domain: $domain) {
    id
    name
    domain
  }
}
    `;
export const DeleteRoleAndPermissionsDocument = gql`
    mutation deleteRoleAndPermissions($roleId: ID!, $simulateRole: ID) {
  deleteRoleAndPermissions(roleId: $roleId, simulateRole: $simulateRole) {
    deletedRoleId
    revokedPermissionIds
  }
}
    `;
export const GrantAssumeRoleDocument = gql`
    mutation grantAssumeRole($roleId: ID!, $domain: Domain!, $roles: [ID!], $excludedRoles: [ID!]!) {
  grantAssumeRole(
    roleId: $roleId
    permission: {domain: $domain, roles: $roles, excludedRoles: $excludedRoles}
  ) {
    ...PermissionData
  }
}
    ${PermissionDataFragmentDoc}`;
export const GrantLoginDocument = gql`
    mutation grantLogin($roleId: ID!, $domain: Domain, $allowedAuthenticationMethods: [AuthenticationMethod!]) {
  grantLogin(
    roleId: $roleId
    permission: {domain: $domain, allowedAuthenticationMethods: $allowedAuthenticationMethods}
  ) {
    ...PermissionData
  }
}
    ${PermissionDataFragmentDoc}`;
export const GrantViewDashboardsDocument = gql`
    mutation grantViewDashboards($roleId: ID!, $domain: Domain!, $dashboardPages: [DashboardPagesAccessInput!], $exportChartView: [Dashboard!], $exportDataView: [Dashboard!], $viewDataView: [Dashboard!]) {
  grantViewDashboards(
    roleId: $roleId
    permission: {domain: $domain, dashboardPages: $dashboardPages, exportChartView: $exportChartView, exportDataView: $exportDataView, viewDataView: $viewDataView}
  ) {
    ...PermissionData
  }
}
    ${PermissionDataFragmentDoc}`;
export const GrantExportReportsDocument = gql`
    mutation grantExportReports($roleId: ID!, $domain: Domain!) {
  grantExportReports(roleId: $roleId, permission: {domain: $domain}) {
    ...PermissionData
  }
}
    ${PermissionDataFragmentDoc}`;
export const GrantReadDataDocument = gql`
    mutation grantReadData($roleId: ID!, $domain: Domain!, $access: [DatatypeAccessInput!], $popFilter: String, $lineHierarchyRestrictions: LineHierarchyRestrictionsInput!) {
  grantReadData(
    roleId: $roleId
    permission: {domain: $domain, access: $access, popFilter: $popFilter, lineHierarchyRestrictions: $lineHierarchyRestrictions, organizationRestrictions: {userSpecific: false}}
  ) {
    ...PermissionData
  }
}
    ${PermissionDataFragmentDoc}`;
export const GrantUseFiltersDocument = gql`
    mutation grantUseFilters($roleId: ID!, $domain: Domain!, $allowedTags: [String!]) {
  grantUseFilters(
    roleId: $roleId
    permission: {domain: $domain, allowedTags: $allowedTags}
  ) {
    ...PermissionData
  }
}
    ${PermissionDataFragmentDoc}`;
export const GrantViewMetricsDocument = gql`
    mutation grantViewMetrics($roleId: ID!, $domain: Domain!, $allowedTags: [String!]) {
  grantViewMetrics(
    roleId: $roleId
    permission: {domain: $domain, allowedTags: $allowedTags}
  ) {
    ...PermissionData
  }
}
    ${PermissionDataFragmentDoc}`;
export const RevokeAssignedPermissionDocument = gql`
    mutation revokeAssignedPermission($id: ID!) {
  revokeAssignedPermission(id: $id)
}
    `;
export const ReplaceReadDataDocument = gql`
    mutation replaceReadData($id: ID!, $permission: ReadDataInput!, $simulateRole: ID) {
  replaceReadData(id: $id, permission: $permission, simulateRole: $simulateRole) {
    ...PermissionData
  }
}
    ${PermissionDataFragmentDoc}`;
export const ReplaceViewDashboardsDocument = gql`
    mutation replaceViewDashboards($id: ID!, $permission: ViewDashboardsInput!, $simulateRole: ID) {
  replaceViewDashboards(
    id: $id
    permission: $permission
    simulateRole: $simulateRole
  ) {
    ...PermissionData
  }
}
    ${PermissionDataFragmentDoc}`;
export const ReplaceLoginDocument = gql`
    mutation replaceLogin($id: ID!, $permission: LoginInput!, $simulateRole: ID) {
  replaceLogin(id: $id, permission: $permission, simulateRole: $simulateRole) {
    ...PermissionData
  }
}
    ${PermissionDataFragmentDoc}`;
export const ReplaceUseFiltersDocument = gql`
    mutation replaceUseFilters($id: ID!, $permission: UseFiltersInput!, $simulateRole: ID) {
  replaceUseFilters(id: $id, permission: $permission, simulateRole: $simulateRole) {
    ...PermissionData
  }
}
    ${PermissionDataFragmentDoc}`;
export const ReplaceViewMetricsDocument = gql`
    mutation replaceViewMetrics($id: ID!, $permission: ViewMetricsInput!, $simulateRole: ID) {
  replaceViewMetrics(
    id: $id
    permission: $permission
    simulateRole: $simulateRole
  ) {
    ...PermissionData
  }
}
    ${PermissionDataFragmentDoc}`;
export const ListUploadedFilesDocument = gql`
    query listUploadedFiles($domain: Domain!, $simulateRole: ID) {
  listUploadedFiles(domain: $domain, simulateRole: $simulateRole)
}
    `;
export const ListUploadedClientObjectsDocument = gql`
    query listUploadedClientObjects($domain: Domain!, $simulateRole: ID) {
  listUploadedClientObjects(domain: $domain, simulateRole: $simulateRole) {
    clientObjects {
      objectName
      createdAt
      domain
      processingInfo {
        dagId
        processedTime
      }
    }
  }
}
    `;
export const GenerateSignedUrlDocument = gql`
    query generateSignedUrl($domain: Domain!, $objectName: String!, $simulateRole: ID) {
  generateSignedUrl(
    domain: $domain
    objectName: $objectName
    simulateRole: $simulateRole
  )
}
    `;
export const CreateBucketWithDefaultStructureDocument = gql`
    query createBucketWithDefaultStructure($domain: Domain!, $simulateRole: ID) {
  createBucketWithDefaultStructure(domain: $domain, simulateRole: $simulateRole)
}
    `;
export const DeleteUploadedFileDocument = gql`
    query deleteUploadedFile($domain: Domain!, $path: String!, $simulateRole: ID) {
  deleteUploadedFile(domain: $domain, path: $path, simulateRole: $simulateRole)
}
    `;
export const DomainSettingsLatestVersionDocument = gql`
    query domainSettingsLatestVersion($domain: Domain!, $simulateRole: ID) {
  domainSettingsLatestVersion(domain: $domain, simulateRole: $simulateRole) {
    version
    createdAt
    creator
    settings
  }
}
    `;
export const CreateNewDomainSettingsDocument = gql`
    mutation createNewDomainSettings($domain: Domain!, $settings: Json!, $simulateRole: ID) {
  createNewDomainSettings(
    domain: $domain
    settings: $settings
    simulateRole: $simulateRole
  ) {
    version
    createdAt
    creator
    settings
  }
}
    `;
export const DomainPreferencesLatestVersionDocument = gql`
    query domainPreferencesLatestVersion($domain: Domain!, $simulateRole: ID) {
  domainPreferencesLatestVersion(domain: $domain, simulateRole: $simulateRole) {
    version
    createdAt
    creator
    settings
  }
}
    `;
export const CreateNewDomainPreferencesDocument = gql`
    mutation createNewDomainPreferences($domain: Domain!, $preferences: Json!, $simulateRole: ID) {
  createNewDomainPreferences(
    domain: $domain
    preferences: $preferences
    simulateRole: $simulateRole
  ) {
    version
    createdAt
    creator
    settings
  }
}
    `;
export const ChangeRoleNameDocument = gql`
    mutation changeRoleName($id: ID!, $newName: String!, $simulateRole: ID) {
  changeRoleName(id: $id, newName: $newName, simulateRole: $simulateRole) {
    id
    name
  }
}
    `;
export const AddFirebaseUserForExistingAppUserDocument = gql`
    mutation addFirebaseUserForExistingAppUser($email: String!) {
  addFirebaseUserForExistingAppUser(email: $email)
}
    `;
export const GetMultiDomainAuthInfoDocument = gql`
    query getMultiDomainAuthInfo($simulateRole: ID) {
  currentUserUserRole(simulateRole: $simulateRole) {
    allowedDomains {
      domain
      nonUserRoles {
        id
        name
        domain
      }
    }
  }
  listUserRoles(domainUnrestrictedOnly: true, simulateRole: $simulateRole) {
    id
    name
    directPermissions {
      ...PermissionData
    }
    directRoles {
      id
      name
      domain
    }
  }
}
    ${PermissionDataFragmentDoc}`;
export const AddUserAndDefaultRoleWithRoleAndPermissionsDocument = gql`
    mutation addUserAndDefaultRoleWithRoleAndPermissions($email: String!, $roleDomain: Domain!) {
  addUserAndDefaultRole(
    email: $email
    roleDomain: $roleDomain
    addDefaultLoginPermission: false
  ) {
    email
    roleId
    userRole {
      directRoles {
        id
        name
        domain
      }
      directPermissions {
        ...PermissionData
      }
    }
  }
}
    ${PermissionDataFragmentDoc}`;
export const SendWelcomeWithSsoMailDocument = gql`
    mutation sendWelcomeWithSsoMail($receiver: String!) {
  sendWelcomeWithSsoMail(receiver: $receiver)
}
    `;
export const SendWelcomeWithPasswordMailDocument = gql`
    mutation sendWelcomeWithPasswordMail($receiver: String!) {
  sendWelcomeWithPasswordMail(receiver: $receiver)
}
    `;
export const SendPasswordResetMailDocument = gql`
    mutation sendPasswordResetMail($receiver: String!) {
  sendPasswordResetMail(receiver: $receiver)
}
    `;
export const ListAllDashboardsDocument = gql`
    query listAllDashboards($simulateRole: ID) {
  listAllDashboards(simulateRole: $simulateRole) {
    description
    descriptionKey
    enabled
    id
    imagePath
    link
    name
    nameKey
    pages {
      description
      descriptionKey
      enabled
      imagePath
      link
      name
      nameKey
      pageId
      pageNumber
    }
  }
}
    `;
export const CreateNewRolePreferencesDocument = gql`
    mutation createNewRolePreferences($roleId: ID!, $preferences: Json!, $simulateRole: ID) {
  createNewRolePreferences(
    roleId: $roleId
    preferences: $preferences
    simulateRole: $simulateRole
  ) {
    settings
    version
    createdAt
  }
}
    `;
export const RolePreferencesVersionDocument = gql`
    query rolePreferencesVersion($roleId: ID!, $version: Long!, $simulateRole: ID) {
  rolePreferencesVersion(
    roleId: $roleId
    version: $version
    simulateRole: $simulateRole
  ) {
    settings
    version
    createdAt
  }
}
    `;
export const RolePreferencesLatestVersionDocument = gql`
    query rolePreferencesLatestVersion($roleId: ID!, $simulateRole: ID) {
  rolePreferencesLatestVersion(roleId: $roleId, simulateRole: $simulateRole) {
    settings
    version
    createdAt
  }
}
    `;
export const ListAliasesDocument = gql`
    query listAliases($domain: Domain!, $simulateRole: ID) {
  listAliases(domain: $domain, simulateRole: $simulateRole) {
    key
    type
    translations {
      language
      text
    }
  }
}
    `;
export const SetAliasDocument = gql`
    mutation setAlias($domain: Domain!, $key: String!, $type: String!, $translations: [AliasTranslationInput!]!, $simulateRole: ID) {
  setAlias(
    alias: {domain: $domain, key: $key, type: $type, translations: $translations}
    simulateRole: $simulateRole
  )
}
    `;
export const DeleteAliasDocument = gql`
    mutation deleteAlias($domain: Domain!, $aliasKey: String!, $simulateRole: ID) {
  deleteAlias(domain: $domain, aliasKey: $aliasKey, simulateRole: $simulateRole)
}
    `;
export const FrontendStartupDocument = gql`
    query frontendStartup($simulateRole: ID) {
  currentUser(simulateRole: $simulateRole) {
    email
    roleId
    userRole {
      preferencesLatestVersion {
        __typename
        settings
        version
        createdAt
      }
      allowedDomains {
        domain
        latestPreferences {
          version
          createdAt
          creator
          settings
        }
        latestSettings {
          version
          createdAt
          creator
          settings
        }
      }
      executorRoles {
        id
        name
        domain
      }
      directPermissions {
        ...PermissionData
      }
      allPermissions {
        ...PermissionData
      }
    }
  }
  listAllDashboards(simulateRole: $simulateRole) {
    description
    descriptionKey
    enabled
    id
    imagePath
    link
    name
    nameKey
    pages {
      description
      descriptionKey
      enabled
      imagePath
      link
      name
      nameKey
      pageId
      pageNumber
    }
  }
}
    ${PermissionDataFragmentDoc}`;
export const DomainDependenciesDocument = gql`
    query domainDependencies($domain: Domain!, $simulateRole: ID) {
  domainInfo(domain: $domain, simulateRole: $simulateRole) {
    latestPreferences {
      settings
      version
      createdAt
      creator
    }
    latestSettings {
      settings
      version
      createdAt
      creator
    }
    userRoles {
      id
      name
      domain
    }
    nonUserRoles {
      id
      name
      domain
    }
    allLatestVersions {
      dataType
      version
    }
    allUsedFields {
      dataType
      datafields
    }
    usedCohorts {
      cohortType
      cohortValues {
        cohortKey
        cohortValues {
          ...SqlLitValueAll
        }
      }
    }
    aliases {
      key
      type
      translations {
        language
        text
      }
    }
    metricTree {
      categoryTrees {
        metricCategoryId
        groupTrees {
          metricGroupId
          metricDefs {
            id
            metricGroupId
            metricType
            name
            formatType {
              id
            }
            underlyingDataFields {
              dataType
              dataField
            }
            defaultPosition
            lifecycleStage {
              ... on MetricLifecycleStageActive {
                __typename
                reason
              }
              ... on MetricLifecycleStageDeprecated {
                __typename
                reason
              }
              ... on MetricLifecycleStageDevelopment {
                __typename
                reason
              }
              ... on MetricLifecycleStageDisabled {
                __typename
                reason
              }
            }
            segmentationPercAllowed
            tooltipJapanese
            tooltipEnglish
          }
          metricGroup {
            id
            defaultCategoryId
            defaultPosition
            defaultCategory {
              id
              defaultPosition
            }
          }
        }
        metricCategory {
          id
          defaultPosition
        }
      }
    }
  }
}
    ${SqlLitValueAllFragmentDoc}`;
export const AskChappiDocument = gql`
    mutation askChappi($prompt: String!, $conversationId: ID!) {
  askChappi(prompt: $prompt, conversationId: $conversationId) {
    ... on ChappiCategorizationResponse {
      __typename
      questionCategory
    }
    ... on ChappiCauseInvestigationResponse {
      __typename
      message
    }
    ... on ChappiDataDiscrepancyResponse {
      __typename
      message
    }
    ... on ChappiExplainPreviousChartAnalyticsResponse {
      __typename
      message
    }
    ... on ChappiExplainPreviousSingleNumberAnalyticsResponse {
      __typename
      message
    }
    ... on ChappiExplanationOfCalculationOrDefinitionResponse {
      __typename
      message
    }
    ... on ChappiFindingSpecificEmployeesResponse {
      __typename
      message
    }
    ... on ChappiHowToUseChappiResponse {
      __typename
      message
    }
    ... on ChappiHowToUseThePanalytAppResponse {
      __typename
      message
    }
    ... on ChappiKpiVisualization {
      __typename
      kpiMetric
      kpiTimeSelection {
        ...SingleValueTimeSelection
      }
      kpiSegmentation {
        datafieldAndDatatype {
          dataField
          dataType
        }
      }
      alignment
      filters {
        sql
      }
      responseForUser
    }
    ... on ChappiLineChartVisualization {
      __typename
      lineChartMetrics
      lineChartTimeSelection {
        ...OverTimeTimeSelection
      }
      lineChartSegmentation {
        datafieldAndDatatype {
          dataField
          dataType
        }
      }
      lineChartVariant
      filters {
        sql
      }
      responseForUser
    }
    ... on ChappiOtherOrUnknownResponse {
      __typename
      message
    }
    ... on ChappiOverTimeBarChartVisualization {
      __typename
      barChartMetrics
      barChartTimeSelection {
        ...OverTimeTimeSelection
      }
      barChartSegmentation {
        datafieldAndDatatype {
          dataField
          dataType
        }
      }
      stack
      relative
      filters {
        sql
      }
      responseForUser
    }
    ... on ChappiPanalytAppGeneralQuestionOrProblemResponse {
      __typename
      message
    }
    ... on ChappiPanalytContractResponse {
      __typename
      message
    }
    ... on ChappiPieChartVisualization {
      __typename
      pieChartMetric
      pieChartTimeSelection {
        ...SingleValueTimeSelection
      }
      pieChartSegmentation {
        datafieldAndDatatype {
          dataField
          dataType
        }
      }
      pieChartVariant
      filters {
        sql
      }
      responseForUser
    }
    ... on ChappiPredictiveAnalyticsForecastingResponse {
      __typename
      message
    }
    ... on ChappiProblemEncounteredResponse {
      __typename
      message
    }
    ... on ChappiRecommendationsSuggestionsResponse {
      __typename
      message
    }
    ... on ChappiSingleNumberAnalyticsResponse {
      __typename
      message
    }
    ... on ChappiTableVisualization {
      __typename
      tableMetrics
      tableTimeSelection {
        ...OverTimeTimeSelection
      }
      tableSegmentation {
        datafieldAndDatatype {
          dataField
          dataType
        }
      }
      filters {
        sql
      }
      responseForUser
    }
    ... on ChappiTimePeriodBarChartVisualization {
      __typename
      barChartMetrics
      barChartTimeSelection {
        ...SingleValueTimeSelection
      }
      barChartSegmentation {
        datafieldAndDatatype {
          dataField
          dataType
        }
      }
      stack
      relative
      filters {
        sql
      }
      responseForUser
    }
    ... on ChappiVisualizationTypeResponse {
      __typename
      visualizationType
    }
  }
}
    ${SingleValueTimeSelectionFragmentDoc}
${OverTimeTimeSelectionFragmentDoc}`;
export const StartConversationDocument = gql`
    mutation startConversation($firstQuestion: String!, $domain: Domain!) {
  startConversation(firstQuestion: $firstQuestion, domain: $domain) {
    conversation {
      id
    }
    firstResponse {
      ... on ChappiCategorizationResponse {
        __typename
        questionCategory
      }
      ... on ChappiCauseInvestigationResponse {
        __typename
        message
      }
      ... on ChappiDataDiscrepancyResponse {
        __typename
        message
      }
      ... on ChappiExplainPreviousChartAnalyticsResponse {
        __typename
        message
      }
      ... on ChappiExplainPreviousSingleNumberAnalyticsResponse {
        __typename
        message
      }
      ... on ChappiExplanationOfCalculationOrDefinitionResponse {
        __typename
        message
      }
      ... on ChappiFindingSpecificEmployeesResponse {
        __typename
        message
      }
      ... on ChappiHowToUseChappiResponse {
        __typename
        message
      }
      ... on ChappiHowToUseThePanalytAppResponse {
        __typename
        message
      }
      ... on ChappiKpiVisualization {
        __typename
        kpiMetric
        kpiTimeSelection {
          ...SingleValueTimeSelection
        }
        kpiSegmentation {
          datafieldAndDatatype {
            dataField
            dataType
          }
        }
        alignment
        filters {
          sql
        }
        responseForUser
      }
      ... on ChappiLineChartVisualization {
        __typename
        lineChartMetrics
        lineChartTimeSelection {
          ...OverTimeTimeSelection
        }
        lineChartSegmentation {
          datafieldAndDatatype {
            dataField
            dataType
          }
        }
        lineChartVariant
        filters {
          sql
        }
        responseForUser
      }
      ... on ChappiOtherOrUnknownResponse {
        __typename
        message
      }
      ... on ChappiOverTimeBarChartVisualization {
        __typename
        barChartMetrics
        barChartTimeSelection {
          ...OverTimeTimeSelection
        }
        barChartSegmentation {
          datafieldAndDatatype {
            dataField
            dataType
          }
        }
        stack
        relative
        filters {
          sql
        }
        responseForUser
      }
      ... on ChappiPanalytAppGeneralQuestionOrProblemResponse {
        __typename
        message
      }
      ... on ChappiPanalytContractResponse {
        __typename
        message
      }
      ... on ChappiPieChartVisualization {
        __typename
        pieChartMetric
        pieChartTimeSelection {
          ...SingleValueTimeSelection
        }
        pieChartSegmentation {
          datafieldAndDatatype {
            dataField
            dataType
          }
        }
        pieChartVariant
        filters {
          sql
        }
        responseForUser
      }
      ... on ChappiPredictiveAnalyticsForecastingResponse {
        __typename
        message
      }
      ... on ChappiProblemEncounteredResponse {
        __typename
        message
      }
      ... on ChappiRecommendationsSuggestionsResponse {
        __typename
        message
      }
      ... on ChappiSingleNumberAnalyticsResponse {
        __typename
        message
      }
      ... on ChappiTableVisualization {
        __typename
        tableMetrics
        tableTimeSelection {
          ...OverTimeTimeSelection
        }
        tableSegmentation {
          datafieldAndDatatype {
            dataField
            dataType
          }
        }
        filters {
          sql
        }
        responseForUser
      }
      ... on ChappiTimePeriodBarChartVisualization {
        __typename
        barChartMetrics
        barChartTimeSelection {
          ...SingleValueTimeSelection
        }
        barChartSegmentation {
          datafieldAndDatatype {
            dataField
            dataType
          }
        }
        stack
        relative
        filters {
          sql
        }
        responseForUser
      }
      ... on ChappiVisualizationTypeResponse {
        __typename
        visualizationType
      }
    }
  }
}
    ${SingleValueTimeSelectionFragmentDoc}
${OverTimeTimeSelectionFragmentDoc}`;
export const ListConversationsDocument = gql`
    query listConversations($limit: Int, $offset: Int, $domainFilter: Domain, $conversationId: ID, $initiatingRoleId: ID, $createdBefore: Instant, $createdAfter: Instant, $sortCriteria: [SortCriteriaInput!]! = [], $simulateRole: ID) {
  listConversations(
    limit: $limit
    offset: $offset
    domainFilter: $domainFilter
    conversationId: $conversationId
    initiatingRoleId: $initiatingRoleId
    createdBefore: $createdBefore
    createdAfter: $createdAfter
    sortCriteria: $sortCriteria
    simulateRole: $simulateRole
  ) {
    id
    initiatingRoleId
    initialCreator
    createdAt
    domainScope
    messages {
      id
      createdAt
      content {
        ... on QuestionMessage {
          __typename
          question
        }
        ... on ResponseMessage {
          __typename
          response {
            ... on ChappiCategorizationResponse {
              __typename
              questionCategory
            }
            ... on ChappiCauseInvestigationResponse {
              __typename
              message
            }
            ... on ChappiDataDiscrepancyResponse {
              __typename
              message
            }
            ... on ChappiExplainPreviousChartAnalyticsResponse {
              __typename
              message
            }
            ... on ChappiExplainPreviousSingleNumberAnalyticsResponse {
              __typename
              message
            }
            ... on ChappiExplanationOfCalculationOrDefinitionResponse {
              __typename
              message
            }
            ... on ChappiFindingSpecificEmployeesResponse {
              __typename
              message
            }
            ... on ChappiHowToUseChappiResponse {
              __typename
              message
            }
            ... on ChappiHowToUseThePanalytAppResponse {
              __typename
              message
            }
            ... on ChappiKpiVisualization {
              __typename
              kpiMetric
              kpiTimeSelection {
                ...SingleValueTimeSelection
              }
              kpiSegmentation {
                datafieldAndDatatype {
                  dataField
                  dataType
                }
              }
              alignment
              filters {
                sql
              }
              responseForUser
            }
            ... on ChappiLineChartVisualization {
              __typename
              lineChartMetrics
              lineChartTimeSelection {
                ...OverTimeTimeSelection
              }
              lineChartSegmentation {
                datafieldAndDatatype {
                  dataField
                  dataType
                }
              }
              lineChartVariant
              filters {
                sql
              }
              responseForUser
            }
            ... on ChappiOtherOrUnknownResponse {
              __typename
              message
            }
            ... on ChappiOverTimeBarChartVisualization {
              __typename
              barChartMetrics
              barChartTimeSelection {
                ...OverTimeTimeSelection
              }
              barChartSegmentation {
                datafieldAndDatatype {
                  dataField
                  dataType
                }
              }
              stack
              relative
              filters {
                sql
              }
              responseForUser
            }
            ... on ChappiPanalytAppGeneralQuestionOrProblemResponse {
              __typename
              message
            }
            ... on ChappiPanalytContractResponse {
              __typename
              message
            }
            ... on ChappiPieChartVisualization {
              __typename
              pieChartMetric
              pieChartTimeSelection {
                ...SingleValueTimeSelection
              }
              pieChartSegmentation {
                datafieldAndDatatype {
                  dataField
                  dataType
                }
              }
              pieChartVariant
              filters {
                sql
              }
              responseForUser
            }
            ... on ChappiPredictiveAnalyticsForecastingResponse {
              __typename
              message
            }
            ... on ChappiProblemEncounteredResponse {
              __typename
              message
            }
            ... on ChappiRecommendationsSuggestionsResponse {
              __typename
              message
            }
            ... on ChappiSingleNumberAnalyticsResponse {
              __typename
              message
            }
            ... on ChappiTableVisualization {
              __typename
              tableMetrics
              tableTimeSelection {
                ...OverTimeTimeSelection
              }
              tableSegmentation {
                datafieldAndDatatype {
                  dataField
                  dataType
                }
              }
              filters {
                sql
              }
              responseForUser
            }
            ... on ChappiTimePeriodBarChartVisualization {
              __typename
              barChartMetrics
              barChartTimeSelection {
                ...SingleValueTimeSelection
              }
              barChartSegmentation {
                datafieldAndDatatype {
                  dataField
                  dataType
                }
              }
              stack
              relative
              filters {
                sql
              }
              responseForUser
            }
            ... on ChappiVisualizationTypeResponse {
              __typename
              visualizationType
            }
          }
        }
        ... on SystemMessage {
          __typename
          content
        }
      }
    }
  }
}
    ${SingleValueTimeSelectionFragmentDoc}
${OverTimeTimeSelectionFragmentDoc}`;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    availableTimeRanges(variables: AvailableTimeRangesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AvailableTimeRangesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AvailableTimeRangesQuery>(AvailableTimeRangesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'availableTimeRanges', 'query');
    },
    queryCohortMetrics(variables: QueryCohortMetricsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QueryCohortMetricsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QueryCohortMetricsQuery>(QueryCohortMetricsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'queryCohortMetrics', 'query');
    },
    queryMetrics(variables: QueryMetricsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QueryMetricsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QueryMetricsQuery>(QueryMetricsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'queryMetrics', 'query');
    },
    queryEmployeeCohortMetrics(variables: QueryEmployeeCohortMetricsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QueryEmployeeCohortMetricsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QueryEmployeeCohortMetricsQuery>(QueryEmployeeCohortMetricsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'queryEmployeeCohortMetrics', 'query');
    },
    listAllMetricDefs(variables: ListAllMetricDefsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ListAllMetricDefsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ListAllMetricDefsQuery>(ListAllMetricDefsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'listAllMetricDefs', 'query');
    },
    executeCustomSqlQuery(variables: ExecuteCustomSqlQueryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExecuteCustomSqlQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExecuteCustomSqlQueryQuery>(ExecuteCustomSqlQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'executeCustomSqlQuery', 'query');
    },
    executeWhitelistedSqlQuery(variables: ExecuteWhitelistedSqlQueryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExecuteWhitelistedSqlQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExecuteWhitelistedSqlQueryQuery>(ExecuteWhitelistedSqlQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'executeWhitelistedSqlQuery', 'query');
    },
    executeAdvancedQuery(variables: ExecuteAdvancedQueryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExecuteAdvancedQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExecuteAdvancedQueryQuery>(ExecuteAdvancedQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'executeAdvancedQuery', 'query');
    },
    executeOldQuery(variables: ExecuteOldQueryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExecuteOldQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExecuteOldQueryQuery>(ExecuteOldQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'executeOldQuery', 'query');
    },
    executeMovementQuery(variables: ExecuteMovementQueryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExecuteMovementQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExecuteMovementQueryQuery>(ExecuteMovementQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'executeMovementQuery', 'query');
    },
    latestVersion(variables: LatestVersionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LatestVersionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LatestVersionQuery>(LatestVersionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'latestVersion', 'query');
    },
    listUsedFields(variables: ListUsedFieldsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ListUsedFieldsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ListUsedFieldsQuery>(ListUsedFieldsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'listUsedFields', 'query');
    },
    listAvailableFields(variables: ListAvailableFieldsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ListAvailableFieldsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ListAvailableFieldsQuery>(ListAvailableFieldsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'listAvailableFields', 'query');
    },
    listUsedCohorts(variables: ListUsedCohortsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ListUsedCohortsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ListUsedCohortsQuery>(ListUsedCohortsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'listUsedCohorts', 'query');
    },
    listRoles(variables: ListRolesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ListRolesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ListRolesQuery>(ListRolesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'listRoles', 'query');
    },
    listAllRoles(variables?: ListAllRolesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ListAllRolesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ListAllRolesQuery>(ListAllRolesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'listAllRoles', 'query');
    },
    currentUserUserRole(variables?: CurrentUserUserRoleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CurrentUserUserRoleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CurrentUserUserRoleQuery>(CurrentUserUserRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'currentUserUserRole', 'query');
    },
    currentUserListRoles(variables?: CurrentUserListRolesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CurrentUserListRolesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CurrentUserListRolesQuery>(CurrentUserListRolesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'currentUserListRoles', 'query');
    },
    currentUserUserInfo(variables?: CurrentUserUserInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CurrentUserUserInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CurrentUserUserInfoQuery>(CurrentUserUserInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'currentUserUserInfo', 'query');
    },
    listNonUserRoles(variables?: ListNonUserRolesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ListNonUserRolesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ListNonUserRolesQuery>(ListNonUserRolesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'listNonUserRoles', 'query');
    },
    listUserRoles(variables?: ListUserRolesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ListUserRolesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ListUserRolesQuery>(ListUserRolesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'listUserRoles', 'query');
    },
    listAllAllowedDomains(variables: ListAllAllowedDomainsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ListAllAllowedDomainsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ListAllAllowedDomainsQuery>(ListAllAllowedDomainsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'listAllAllowedDomains', 'query');
    },
    allPermissions(variables: AllPermissionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AllPermissionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AllPermissionsQuery>(AllPermissionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'allPermissions', 'query');
    },
    currentUserAllPermissions(variables?: CurrentUserAllPermissionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CurrentUserAllPermissionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CurrentUserAllPermissionsQuery>(CurrentUserAllPermissionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'currentUserAllPermissions', 'query');
    },
    directPermissions(variables: DirectPermissionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DirectPermissionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DirectPermissionsQuery>(DirectPermissionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'directPermissions', 'query');
    },
    directPermissionsForRoles(variables: DirectPermissionsForRolesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DirectPermissionsForRolesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DirectPermissionsForRolesQuery>(DirectPermissionsForRolesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'directPermissionsForRoles', 'query');
    },
    listExecutorRolesForRole(variables: ListExecutorRolesForRoleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ListExecutorRolesForRoleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ListExecutorRolesForRoleQuery>(ListExecutorRolesForRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'listExecutorRolesForRole', 'query');
    },
    metaDataByUserEmail(variables: MetaDataByUserEmailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MetaDataByUserEmailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MetaDataByUserEmailQuery>(MetaDataByUserEmailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'metaDataByUserEmail', 'query');
    },
    metaDataByUserRole(variables: MetaDataByUserRoleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MetaDataByUserRoleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MetaDataByUserRoleQuery>(MetaDataByUserRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'metaDataByUserRole', 'query');
    },
    addUserAndDefaultRole(variables: AddUserAndDefaultRoleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddUserAndDefaultRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddUserAndDefaultRoleMutation>(AddUserAndDefaultRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addUserAndDefaultRole', 'mutation');
    },
    addRole(variables: AddRoleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddRoleMutation>(AddRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addRole', 'mutation');
    },
    deleteRoleAndPermissions(variables: DeleteRoleAndPermissionsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteRoleAndPermissionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteRoleAndPermissionsMutation>(DeleteRoleAndPermissionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteRoleAndPermissions', 'mutation');
    },
    grantAssumeRole(variables: GrantAssumeRoleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GrantAssumeRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GrantAssumeRoleMutation>(GrantAssumeRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'grantAssumeRole', 'mutation');
    },
    grantLogin(variables: GrantLoginMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GrantLoginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GrantLoginMutation>(GrantLoginDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'grantLogin', 'mutation');
    },
    grantViewDashboards(variables: GrantViewDashboardsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GrantViewDashboardsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GrantViewDashboardsMutation>(GrantViewDashboardsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'grantViewDashboards', 'mutation');
    },
    grantExportReports(variables: GrantExportReportsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GrantExportReportsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GrantExportReportsMutation>(GrantExportReportsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'grantExportReports', 'mutation');
    },
    grantReadData(variables: GrantReadDataMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GrantReadDataMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GrantReadDataMutation>(GrantReadDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'grantReadData', 'mutation');
    },
    grantUseFilters(variables: GrantUseFiltersMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GrantUseFiltersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GrantUseFiltersMutation>(GrantUseFiltersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'grantUseFilters', 'mutation');
    },
    grantViewMetrics(variables: GrantViewMetricsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GrantViewMetricsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GrantViewMetricsMutation>(GrantViewMetricsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'grantViewMetrics', 'mutation');
    },
    revokeAssignedPermission(variables: RevokeAssignedPermissionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RevokeAssignedPermissionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RevokeAssignedPermissionMutation>(RevokeAssignedPermissionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'revokeAssignedPermission', 'mutation');
    },
    replaceReadData(variables: ReplaceReadDataMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReplaceReadDataMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReplaceReadDataMutation>(ReplaceReadDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'replaceReadData', 'mutation');
    },
    replaceViewDashboards(variables: ReplaceViewDashboardsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReplaceViewDashboardsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReplaceViewDashboardsMutation>(ReplaceViewDashboardsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'replaceViewDashboards', 'mutation');
    },
    replaceLogin(variables: ReplaceLoginMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReplaceLoginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReplaceLoginMutation>(ReplaceLoginDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'replaceLogin', 'mutation');
    },
    replaceUseFilters(variables: ReplaceUseFiltersMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReplaceUseFiltersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReplaceUseFiltersMutation>(ReplaceUseFiltersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'replaceUseFilters', 'mutation');
    },
    replaceViewMetrics(variables: ReplaceViewMetricsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReplaceViewMetricsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReplaceViewMetricsMutation>(ReplaceViewMetricsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'replaceViewMetrics', 'mutation');
    },
    listUploadedFiles(variables: ListUploadedFilesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ListUploadedFilesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ListUploadedFilesQuery>(ListUploadedFilesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'listUploadedFiles', 'query');
    },
    listUploadedClientObjects(variables: ListUploadedClientObjectsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ListUploadedClientObjectsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ListUploadedClientObjectsQuery>(ListUploadedClientObjectsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'listUploadedClientObjects', 'query');
    },
    generateSignedUrl(variables: GenerateSignedUrlQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateSignedUrlQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateSignedUrlQuery>(GenerateSignedUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateSignedUrl', 'query');
    },
    createBucketWithDefaultStructure(variables: CreateBucketWithDefaultStructureQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateBucketWithDefaultStructureQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateBucketWithDefaultStructureQuery>(CreateBucketWithDefaultStructureDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createBucketWithDefaultStructure', 'query');
    },
    deleteUploadedFile(variables: DeleteUploadedFileQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteUploadedFileQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteUploadedFileQuery>(DeleteUploadedFileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteUploadedFile', 'query');
    },
    domainSettingsLatestVersion(variables: DomainSettingsLatestVersionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DomainSettingsLatestVersionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DomainSettingsLatestVersionQuery>(DomainSettingsLatestVersionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'domainSettingsLatestVersion', 'query');
    },
    createNewDomainSettings(variables: CreateNewDomainSettingsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateNewDomainSettingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateNewDomainSettingsMutation>(CreateNewDomainSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createNewDomainSettings', 'mutation');
    },
    domainPreferencesLatestVersion(variables: DomainPreferencesLatestVersionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DomainPreferencesLatestVersionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DomainPreferencesLatestVersionQuery>(DomainPreferencesLatestVersionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'domainPreferencesLatestVersion', 'query');
    },
    createNewDomainPreferences(variables: CreateNewDomainPreferencesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateNewDomainPreferencesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateNewDomainPreferencesMutation>(CreateNewDomainPreferencesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createNewDomainPreferences', 'mutation');
    },
    changeRoleName(variables: ChangeRoleNameMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ChangeRoleNameMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChangeRoleNameMutation>(ChangeRoleNameDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'changeRoleName', 'mutation');
    },
    addFirebaseUserForExistingAppUser(variables: AddFirebaseUserForExistingAppUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddFirebaseUserForExistingAppUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddFirebaseUserForExistingAppUserMutation>(AddFirebaseUserForExistingAppUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addFirebaseUserForExistingAppUser', 'mutation');
    },
    getMultiDomainAuthInfo(variables?: GetMultiDomainAuthInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetMultiDomainAuthInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMultiDomainAuthInfoQuery>(GetMultiDomainAuthInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getMultiDomainAuthInfo', 'query');
    },
    addUserAndDefaultRoleWithRoleAndPermissions(variables: AddUserAndDefaultRoleWithRoleAndPermissionsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddUserAndDefaultRoleWithRoleAndPermissionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddUserAndDefaultRoleWithRoleAndPermissionsMutation>(AddUserAndDefaultRoleWithRoleAndPermissionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addUserAndDefaultRoleWithRoleAndPermissions', 'mutation');
    },
    sendWelcomeWithSsoMail(variables: SendWelcomeWithSsoMailMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SendWelcomeWithSsoMailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendWelcomeWithSsoMailMutation>(SendWelcomeWithSsoMailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sendWelcomeWithSsoMail', 'mutation');
    },
    sendWelcomeWithPasswordMail(variables: SendWelcomeWithPasswordMailMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SendWelcomeWithPasswordMailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendWelcomeWithPasswordMailMutation>(SendWelcomeWithPasswordMailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sendWelcomeWithPasswordMail', 'mutation');
    },
    sendPasswordResetMail(variables: SendPasswordResetMailMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SendPasswordResetMailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendPasswordResetMailMutation>(SendPasswordResetMailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sendPasswordResetMail', 'mutation');
    },
    listAllDashboards(variables?: ListAllDashboardsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ListAllDashboardsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ListAllDashboardsQuery>(ListAllDashboardsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'listAllDashboards', 'query');
    },
    createNewRolePreferences(variables: CreateNewRolePreferencesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateNewRolePreferencesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateNewRolePreferencesMutation>(CreateNewRolePreferencesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createNewRolePreferences', 'mutation');
    },
    rolePreferencesVersion(variables: RolePreferencesVersionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RolePreferencesVersionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RolePreferencesVersionQuery>(RolePreferencesVersionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'rolePreferencesVersion', 'query');
    },
    rolePreferencesLatestVersion(variables: RolePreferencesLatestVersionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RolePreferencesLatestVersionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RolePreferencesLatestVersionQuery>(RolePreferencesLatestVersionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'rolePreferencesLatestVersion', 'query');
    },
    listAliases(variables: ListAliasesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ListAliasesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ListAliasesQuery>(ListAliasesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'listAliases', 'query');
    },
    setAlias(variables: SetAliasMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetAliasMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetAliasMutation>(SetAliasDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setAlias', 'mutation');
    },
    deleteAlias(variables: DeleteAliasMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteAliasMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteAliasMutation>(DeleteAliasDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteAlias', 'mutation');
    },
    frontendStartup(variables?: FrontendStartupQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FrontendStartupQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FrontendStartupQuery>(FrontendStartupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'frontendStartup', 'query');
    },
    domainDependencies(variables: DomainDependenciesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DomainDependenciesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DomainDependenciesQuery>(DomainDependenciesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'domainDependencies', 'query');
    },
    askChappi(variables: AskChappiMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AskChappiMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AskChappiMutation>(AskChappiDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'askChappi', 'mutation');
    },
    startConversation(variables: StartConversationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StartConversationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<StartConversationMutation>(StartConversationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'startConversation', 'mutation');
    },
    listConversations(variables?: ListConversationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ListConversationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ListConversationsQuery>(ListConversationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'listConversations', 'query');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;